export const ko = {
  app: {
    home: '홈',
    playerScout: '선수 스카우트',
    playerComparison: '선수 비교',
    playerRecruitment: '레이더',
    collections: '컬렉션',
    favoritePlayers: '즐겨찾기 선수',
    teamAnalytics: '팀 분석',
    gameAnalysis: '경기 분석',
    seasonStats: '시즌 통계',
    leagueTable: '리그 순위표',
    scoresAndFixtures: '경기 결과 및 일정',
    notifications: '알림',
    administration: '관리',
    inbox: '받은편지함',
    teamStats: '팀 통계',
    blog: '블로그',
    leagues: '리그',
    squadBuilder: '스쿼드 빌더',
    playerAlerts: '선수 알림',
    searchAlerts: '검색 알림',
    videoUploadTool: '동영상 업로드 도구',
    videoPlaylists: '재생목록',
    uploadedGames: '업로드된 경기',
    favoriteTeams: '즐겨찾기 팀',
    arrigo: '아리고',
    validateEvents: '이벤트 검증'
  },
  playerRecruitment: {
    title: '선수 시트',
    subtitle: '선수의 특성과 통계를 더 깊이 살펴보세요',
    league: '리그',
    selectedSeason: '선택된 시즌',
    year: '연도',
    radar: '레이더',
    positions: '포지션',
    numberOfPlayers: '선수 수',
    template: '템플릿',
    compareWith: '비교 대상',
    previousPerformance: '이전 성과',
    xGames: '{0}경기',
    average: '평균',
    leagueAverage: '리그 평균',
    selectSeason: '시즌 선택',
    positionsPlayed: '출전 포지션',
    minMax: '최소 & 최대',
    top5Leagues: '상위 5개 리그',
    infoMessage: '시즌 최소 & 최대를 활성화하려면 시즌을 하나만 선택하세요',
    infoMessage2: '두 선수 모두 같은 시즌을 선택하세요',
    dataPer90MinText: '90분당 데이터',
    adjustToPossessionText: '* 점유율 기준 조정',
    text: '텍스트',
    lollipop: '롤리팝',
    polar: '극좌표',
    noGamesBetweenDates: '선택한 날짜 사이에 경기가 없습니다',
    radarTemplates: {
      Goalkeeper: '골키퍼',
      GoalkeeperCustom: '골키퍼 커스텀',
      GoalkeeperCustom1: '골키퍼 커스텀 1',
      GoalkeeperCustom2: '골키퍼 커스텀 2',
      GoalkeeperCustom3: '골키퍼 커스텀 3',
      GoalkeeperCustom4: '골키퍼 커스텀 4',
      GoalkeeperCustom5: '골키퍼 커스텀 5',
      GoalkeeperCustom6: '골키퍼 커스텀 6',
      Defender: '수비수',
      DefenderCustom: '수비수 커스텀',
      DefenderCustom1: '수비수 커스텀 1',
      DefenderCustom2: '수비수 커스텀 2',
      DefenderCustom3: '수비수 커스텀 3',
      DefenderCustom4: '수비수 커스텀 4',
      DefenderCustom5: '수비수 커스텀 5',
      DefenderCustom6: '수비수 커스텀 6',
      FullBack: '풀백',
      FullBackCustom: '풀백 커스텀',
      FullBackCustom1: '풀백 커스텀 1',
      FullBackCustom2: '풀백 커스텀 2',
      FullBackCustom3: '풀백 커스텀 3',
      FullBackCustom4: '풀백 커스텀 4',
      FullBackCustom5: '풀백 커스텀 5',
      FullBackCustom6: '풀백 커스텀 6',
      FullBackPredictive: '풀백',
      Midfielder: '미드필더',
      MidfielderCustom: '미드필더 커스텀',
      MidfielderCustom1: '미드필더 커스텀 1',
      MidfielderCustom2: '미드필더 커스텀 2',
      MidfielderCustom3: '미드필더 커스텀 3',
      MidfielderCustom4: '미드필더 커스텀 4',
      MidfielderCustom5: '미드필더 커스텀 5',
      MidfielderCustom6: '미드필더 커스텀 6',
      MidfielderPredictive: '미드필더',
      MidfielderDefensive: '수비형 미드필더',
      MidfielderOffensive: '공격형 미드필더',
      AttackingMidfielder: '공격형 미드필더',
      MidfielderWing: '윙 미드필더',
      Winger: '윙어',
      WingerCustom: '윙어 커스텀',
      WingerCustom1: '윙어 커스텀 1',
      WingerCustom2: '윙어 커스텀 2',
      WingerCustom3: '윙어 커스텀 3',
      WingerCustom4: '윙어 커스텀 4',
      WingerCustom5: '윙어 커스텀 5',
      WingerCustom6: '윙어 커스텀 6',
      WingerOffensive: '공격형 윙어',
      Forward: '공격수',
      ForwardCustom: '공격수 커스텀',
      ForwardCustom1: '공격수 커스텀 1',
      ForwardCustom2: '공격수 커스텀 2',
      ForwardCustom3: '공격수 커스텀 3',
      ForwardCustom4: '공격수 커스텀 4',
      ForwardCustom5: '공격수 커스텀 5',
      ForwardCustom6: '공격수 커스텀 6',
      ForwardPredictive: '공격수',
      WingBack: '윙백',
      WingBackCustom: '윙백 커스텀',
      WingBackCustom1: '윙백 커스텀 1',
      WingBackCustom2: '윙백 커스텀 2',
      WingBackCustom3: '윙백 커스텀 3',
      WingBackCustom4: '윙백 커스텀 4',
      WingBackCustom5: '윙백 커스텀 5',
      WingBackCustom6: '윙백 커스텀 6',
      WingBackMedia: '윙백 (소셜미디어)',
      FullBackMedia: '풀백 (소셜미디어)',
      MidfielderMedia: '미드필더 (소셜미디어)',
      WingerMedia: '윙어 (소셜미디어)',
      ForwardMedia: '공격수 (소셜미디어)',
      PhysicalWingBack: '피지컬 윙백',
      PhysicalForward: '피지컬 공격수',
      PhysicalWinger: '피지컬 윙어',
      PhysicalMidfielder: '피지컬 미드필더',
      PhysicalFullBack: '피지컬 풀백',
      PhysicalDefender: '피지컬 수비수',
      PhysicalWingBackLMO: '피지컬 윙백',
      PhysicalForwardLMO: '피지컬 공격수',
      PhysicalWingerLMO: '피지컬 윙어',
      PhysicalMidfielderLMO: '피지컬 미드필더',
      PhysicalFullBackLMO: '피지컬 풀백',
      PhysicalDefenderLMO: '피지컬 수비수'
    },
    radarTemplatesWomen: {
      Goalkeeper: '골키퍼',
      Defender: '수비수',
      FullBack: '풀백',
      FullBackPredictive: '풀백',
      Midfielder: '미드필더',
      MidfielderPredictive: '미드필더',
      MidfielderDefensive: '수비형 미드필더',
      MidfielderOffensive: '공격형 미드필더',
      AttackingMidfielder: '공격형 미드필더',
      MidfielderWing: '윙 미드필더',
      Winger: '윙어',
      WingerOffensive: '공격형 윙어',
      Forward: '공격수',
      ForwardPredictive: '공격수',
      WingBack: '윙백',
      WingBackMedia: '윙백 (소셜미디어)',
      FullBackMedia: '풀백 (소셜미디어)',
      MidfielderMedia: '미드필더 (소셜미디어)',
      WingerMedia: '윙어 (소셜미디어)',
      ForwardMedia: '공격수 (소셜미디어)',
      PhysicalWingBack: '피지컬 윙백',
      PhysicalForward: '피지컬 공격수',
      PhysicalWinger: '피지컬 윙어',
      PhysicalMidfielder: '피지컬 미드필더',
      PhysicalFullBack: '피지컬 풀백',
      PhysicalDefender: '피지컬 수비수',
      PhysicalWingBackLMO: '피지컬 윙백',
      PhysicalForwardLMO: '피지컬 공격수',
      PhysicalWingerLMO: '피지컬 윙어',
      PhysicalMidfielderLMO: '피지컬 미드필더',
      PhysicalFullBackLMO: '피지컬 풀백',
      PhysicalDefenderLMO: '피지컬 수비수'
    },
    radarDescription: {
      basicStatistics: {
        title: '기본 통계',
        minutes: '분',
        goals: '골',
        assists: '어시스트',
        redCards: '레드카드',
        yellowCards: '옐로카드',
        games: '경기',
        goalsReceived: '페널티 제외 실점',
        xGFaced: '대면 xG'
      },
      profiles: {
        3: {
          1: '짧은 패스와 긴 패스 모두에서 발 기술이 뛰어난 골키퍼.',
          2: '발로 플레이할 수 있는 능력과 짧은 패스와 긴 패스 모두에서 좋은 패스 비율로 게임 시작에 중요한 역할을 합니다.',
          3: '통과 지표로 인해 이 프로필을 흥미로운 옵션으로 만드는 좋은 발놀림입니다.',
          4: '자신의 필드에서든 상대 필드에서든 패스가 돋보이는 프로필.',
          5: '그의 발에 공이 있다는 점과 높은 패스 능력으로 뛰어난 보안력을 자랑합니다.',
          6: '좋은 발놀림으로 공을 던질 때 안정성을 제공하고 짧은 패스와 긴 패스의 높은 비율을 완료합니다.',
          7: '짧은 패스와 긴 패스 모두 완료된 패스의 높은 비율로 순환의 질을 제공합니다.'
        },
        5: {
          1: '1대1 상황에서 강하고 태클과 인터셉트를 많이 수행하는 수비수.',
          2: '위와 태클 모두에서 개인 결투에서 매우 효과적인 중앙 수비수이며 예상할 수 있는 좋은 판독력을 갖추고 있습니다.',
          3: '개인 수비 결투에서 좋은 성적을 내는 중앙 수비로 회복량이 많다.',
          4: '태클과 인터셉트를 통해 많은 양의 볼을 회수할 수 있는 높은 수비력을 갖춘 프로필입니다.',
          5: '태클에서 매우 효과적인 수비와 많은 수의 차단으로 개인 대결에서 두각을 나타냅니다.',
          6: '게임당 높은 회수율을 갖춘 센터백, 상대 게임을 읽고 커팅하는 데 능숙하며 태클의 정확성과 빈도가 높습니다.',
          7: '태클의 효율성과 빈도, 예측할 수 있는 좋은 읽기 덕분에 높은 회복량을 갖춘 수비 프로필입니다.'
        },
        6: {
          1: '기회 창출에 큰 기여를 하며 경기 읽기가 좋은 수비수.'
        },
        7: {
          1: '공격("xG 빌드업"에서 큰 기여)과 수비(높은 볼 회수량) 사이에서 균형 잡힌 활약을 보이는 선수.'
        },
        8: {
          1: '수비 1대1에서 견고하며 태클과 인터셉트 모두에서 높은 볼 회수량을 보이는 선수.'
        },
        9: {
          1: '위험한 액션을 만들어내고 기회를 창출하는 데 큰 공격 기여를 하는 선수.'
        },
        10: {
          1: '넓은 공간을 커버할 수 있는 완전한 선수로, 볼 회수에 기여할 뿐만 아니라 팀이 만들어내는 전체 대비 "xG 빌드업"에서 관련 비율을 차지함.'
        },
        11: {
          1: '공격에 대한 영향력은 적지만 수비 성과가 높고 패스 효율성이 뛰어난 미드필더.'
        },
        12: {
          1: '기회 창출에 높은 기여를 하며 공중볼 효율이 좋고, 인터셉트와 태클을 많이 수행하는 완전한 미드필더.'
        },
        15: {
          1: '1대1 기술이 뛰어나고 크로스 성공률이 높으며, 슛보다 예상 어시스트를 더 많이 만들어내는 윙어.'
        },
        16: {
          1: '스루패스와 볼 진행량이 많고 기회를 창출하며, 일반 윙어보다 중앙에서의 점유 영향력이 큰 선수.'
        },
        17: {
          1: '드리블 기술이 좋은 선수로, 안쪽으로 파고들어 키패스(xA)보다 슛(xG)을 더 많이 만들어내는 움직임을 보임.'
        },
        18: {
          1: '볼 없이 뛰는 움직임이 뛰어나며, 슛으로 마무리할지 패스할지 잘 판단하는 공격수.'
        },
        22: {
          1: '스루패스 수신 능력이 뛰어나고 윙으로 내려오며 기회 창출 수준이 높은 공격수. 경기당 총 터치 대비 박스 밖 터치 비율이 높음.'
        }
      },
      description: '설명',
      conjuction: ' 및 ',
      conjuction2: ' 및 ',
      over: '초과',
      under: '미만',
      respectively: ', 각각',
      Defending1: {
        1: '상위 5개 리그에서 수비 성과가 최악에 가까운 수준'
      },
      Defending2: {
        1: '수비 성과가 평균 이하로 수비에서 좋은 활약을 보이지 않음'
      },
      Defending3: {
        1: '중간 수준의 성과를 보이며, 평균보다 약간 초과_미만 수준'
      },
      Defending4: {
        1: '평균 이상의 수비 성과로 수비 임무에서 뛰어난 활약'
      },
      Defending5: {
        1: '수비 임무에서 뛰어나며, 상위 5개 리그의 최고 player_positions와 유사한 성과를 보임'
      },
      Saving1: {
        1: '성과가 매우 낮은 골키퍼로, 공을 막는 데 많은 어려움을 겪음'
      },
      Saving2: {
        1: '수준이 평균 이하로 골키퍼로서 좋은 성과를 보이지 않음'
      },
      Saving3: {
        1: '수용 가능한 성과를 보이는 골키퍼로, 상위 5개 리그 평균 수준이며 metric_name 개선이 필요함'
      },
      Saving4: {
        1: '상위 5개 리그 평균보다 좋은 수준의 골키퍼로, 특히 metric_name에서 두각을 나타냄'
      },
      Saving5: {
        1: '매우 완전한 선수로, 모든 지표가 유럽 상위 5개 리그의 골키퍼들과 비교했을 때 상위 20%에 위치함'
      },
      Passing1: {
        1: '볼을 다루는 능력이 최악에 가까운 선수들 중 하나'
      },
      Passing2: {
        1: '패스 측면에서 성과가 평균 이하'
      },
      Passing3: {
        1: '패스 수준이 수용 가능하며, 평균보다 약간 초과_미만'
      },
      Passing4: {
        1: '볼을 패스하는 능력이 매우 좋으며, 평균보다 훨씬 높음'
      },
      Passing5: {
        1: '볼을 패스하는 데 뛰어난 효율성을 보이며, 대부분의 선수들보다 높은 성과'
      },
      Aerial1: {
        1: '공중볼 경기에서 매우 약하며, 이 측면에서 포지션 내 최악에 가까움'
      },
      Aerial2: {
        1: '공중볼 경합에서 선수가 잘하지 못하며, 평균 이하'
      },
      Aerial3: {
        1: '공중볼 경기에서 수용 가능한 수준이며, 평균보다 약간 초과_미만'
      },
      Aerial4: {
        1: '공중볼 경기에서 뛰어난 성과를 보이며, 이 측면에서 높은 효율성'
      },
      Aerial5: {
        1: '공중볼 경기 지표가 최고 수준에 위치함'
      },
      Shooting1: {
        1: '골 앞에서 매우 부진한 통계로, 이 측면에서 최악의 선수들 중 하나'
      },
      Shooting2: {
        1: '슛팅 수준이 개선이 매우 필요하며, 평균 이하'
      },
      Shooting3: {
        1: '공격 작업에서 수용 가능한 성과를 보이며, 평균보다 약간 초과_미만'
      },
      Shooting4: {
        1: '박스 안에서 매우 잘 활약하며, 선수들의 60% 이상의 성과'
      },
      Shooting5: {
        1: '공격 임무에서 뛰어난 기술을 보이며, 화려한 성과로 이 측면에서 최고 수준에 위치함'
      },
      Association1: {
        1: '볼과의 연계 성과가 매우 낮으며, 상위 5개 리그에서 최악에 가까움'
      },
      Association2: {
        1: '발 밑 볼 처리에서 개선이 많이 필요하며, 이 측면에서 평균 성과 이하'
      },
      Association3: {
        1: '볼과 잘 연계하며, 평균보다 약간 초과_미만'
      },
      Association4: {
        1: '볼과 매우 잘 연계하며, 매우 뛰어난 수준을 보임'
      },
      Association5: {
        1: '발 밑 볼 처리에서 비범한 연계 능력을 보이며, 최고 선수들 중 하나'
      },
      BallHandling1: {
        1: '볼 핸들링 성과가 최악이며, 상위 5개 리그와 비교했을 때 최악에 가까움'
      },
      BallHandling2: {
        1: '볼 핸들링 측면에서 수준이 평균 이하'
      },
      BallHandling3: {
        1: '볼을 다루는 수준이 수용 가능하며, 평균보다 약간 초과_미만'
      },
      BallHandling4: {
        1: '볼 핸들링 측면에서 높은 수준을 보이며, 이 측면에서 최고 수준에 가까운 수치'
      },
      BallHandling5: {
        1: '예외적인 볼 핸들링 능력을 보이며, 상위 5개 리그에서 최고 수준'
      },
      Crosses1: {
        1: '박스 안으로 크로스를 넣는 성과가 낮음. 크로스 지표에서 최악의 선수들 중 하나'
      },
      Crosses2: {
        1: '크로스로 위험을 만드는 성과가 평균 이하'
      },
      Crosses3: {
        1: '박스 안으로 크로스를 보내는 수준이 수용 가능하며, 약간 초과_미만'
      },
      Crosses4: {
        1: '볼을 크로스하는 좋은 통계로, 평균보다 상당히 높음'
      },
      Crosses5: {
        1: '박스 안으로 크로스를 넣는 성과가 매우 높으며, 특히 이 카테고리에서 가장 효과적인 프로필 상위 20%에 위치함'
      },
      Carries1: {
        1: '볼 운반 측면에서 최악의 수치를 보이는 선수 상위 20% 중 하나'
      },
      Carries2: {
        1: '볼 운반 성과가 포지션 내 평균과 거리가 멀음'
      },
      Carries3: {
        1: '볼 운반 측면에서 평균에 가까운 성과를 보이며, 약간 초과_미만'
      },
      Carries4: {
        1: '깊이와 볼 운반 수치가 매우 좋은 뛰어난 선수'
      },
      Carries5: {
        1: '볼 운반에 매우 재능이 있으며, 볼 운반 카테고리 지표에서 높은 성과'
      },
      Turnovers1: {
        1: '볼 소유권 이탈이 많아 상대가 위험을 만들기 쉽게 하는 매우 부정적인 성과. 이 지표에서 최악에 가까움'
      },
      Turnovers2: {
        1: '많고 위험한 볼 소유권 이탈로 상대에게 유리하게 작용하며, 많이 개선하고 볼 소유권 이탈을 줄여야 함'
      },
      Turnovers3: {
        1: '이 선수는 볼 소유권 이탈 측면에서 약간 초과_미만 수준이므로, 성과 개선 여지가 있음'
      },
      Turnovers4: {
        1: '볼 소유권 이탈에서 뛰어난 성과를 보이며, 가장 적게 볼을 잃는 선수들의 60% 이상'
      },
      Turnovers5: {
        1: '볼 소유권 이탈이 적어 팀 내 볼 소유에서 최고 선수들 중 하나에 위치함'
      },
      SequenceInvolvement1: {
        1: '볼 소유 측면에서 이 선수에 대한 수치가 좋지 않으며, 액션을 슛으로 마무리하는 경우가 거의 없음'
      },
      SequenceInvolvement2: {
        1: '소유 마무리가 개선이 많이 필요하며, 거의 슛으로 마무리하지 않아 평균보다 훨씬 낮은 위치'
      },
      SequenceInvolvement3: {
        1: '골 앞에서 소유를 마무리하는 측면에서 수용 가능한 수준이며, 평균보다 약간 초과_미만의 백분위수로 개선 가능성이 큼'
      },
      SequenceInvolvement4: {
        1: '팀의 소유를 슛으로 마무리하는 좋은 능력을 보이며, 그 중 일부는 골로 연결되어 이 카테고리에서 뛰어난 성과'
      },
      SequenceInvolvement5: {
        1: '팀의 소유를 마무리하는 측면에서 최고 선수들 중 하나로, 위험을 만들어내는 슛으로 마무리함'
      },
      OutPlay1: {
        1: '수비 구조를 교란하는 측면에서 선수의 영향이 최소임을 확인할 수 있음'
      },
      OutPlay2: {
        1: '진행과 수비 파괴에 대한 기여가 포지션 기준 이하'
      },
      OutPlay3: {
        1: '가끔 이점을 만들어낼 수 있으며, 포지션 내 평균 수준의 성과'
      },
      OutPlay4: {
        1: '수비 라인을 자주 파괴하고 불균형을 만들어내는 데 기여함'
      },
      OutPlay5: {
        1: '상대를 제거하고 진행을 만들어내는 측면에서 포지션 내 최고 성과자들 중 하나에 위치함'
      },
      LineBreakingPasses1: {
        1: '수비 라인을 파괴하는 패스를 시도하거나 완료하는 경우가 거의 없으며, 그러한 액션에서 기여가 매우 부족함'
      },
      LineBreakingPasses2: {
        1: '라인 사이나 압박 뒤에서 동료를 일관되게 찾는 데 어려움을 겪으며, 포지션 기준 이하의 기여'
      },
      LineBreakingPasses3: {
        1: '선수가 가끔 라인을 파괴하는 패스를 제공하며, 이러한 측면에서 포지션 내 평균 수준에 위치함'
      },
      LineBreakingPasses4: {
        1: '선수가 패스로 자주 라인을 파괴하고 상대 블록의 불균형을 만드는 데 도움을 준다는 것을 확인할 수 있음'
      },
      LineBreakingPasses5: {
        1: '라인을 파괴하고 압박을 풀어내는 측면에서 리그 내 가장 효과적인 패서들 중 하나. 이것이 선수로서의 주요 강점 중 하나'
      },
      PassUnderPressure1: {
        1: '상대가 압박할 때 침착하거나 효과적으로 플레이하는 데 어려움을 겪는 것을 확인할 수 있음'
      },
      PassUnderPressure2: {
        1: '높은 압박 상황에서 패스 정확도를 유지하는 데 어려움을 겪는 선수'
      },
      PassUnderPressure3: {
        1: '압박 하에서 패스 측면에서 선수가 평균 수준에 위치함. 압박을 합리적으로 잘 처리하지만, 일관되게 깔끔한 실행은 보이지 않음'
      },
      PassUnderPressure4: {
        1: '압박을 받고 있음에도 불구하고 자주 동료를 찾는 데 성공하며, 그러한 종류의 패스에서 평균 이상의 성과'
      },
      PassUnderPressure5: {
        1: '강한 압박 하에서 패스할 때 뛰어난 침착성과 정확성을 보임. 이 측면에서 포지션 내 최고 성과자들 중 하나에 위치함'
      },
      BallReceived1: {
        1: '전진 지역에서 매우 적은 패스를 받음; 라인 사이에서 정기적으로 활동하는 선수가 아님'
      },
      BallReceived2: {
        1: '상대 진영에서 마크되지 않은 리셉션을 일부 수집하지만, 일관성이 부족함'
      },
      BallReceived3: {
        1: '공격 지역에서 방해받지 않은 리셉션을 중간 정도 기록함'
      },
      BallReceived4: {
        1: '라인 사이와 압박이 없는 지역에서 자주 리셉션함'
      },
      BallReceived5: {
        1: '라인 사이에서 많은 리셉션을 축적하며, 수비수로부터 자유롭고 주요 지역일 가능성이 높은 곳에서'
      },
      OnBallPressure1: {
        1: '압박을 거의 하지 않으며, 볼 소유자 근처에서 거의 압박하지 않음. 강도가 높지 않은 선수'
      },
      OnBallPressure2: {
        1: '강한 압박을 가끔 수행하지만 자주는 아님. 전체적인 강도가 다소 낮음'
      },
      OnBallPressure3: {
        1: '볼 소유 상대 근처에서 중간 정도의 압박을 기록함'
      },
      OnBallPressure4: {
        1: '볼 소유자에게 정기적으로 접근하는 규율 있는 압박 선수'
      },
      OnBallPressure5: {
        1: '볼 없이 매우 강렬하며, 매우 규율 있고 상대를 압박하는 데 열심히 노력함'
      },
      SpatialCoverage1: {
        1: '선수는 공간 점유와 통제에 매우 제한적인 기여를 보이며, 팀의 포메이션과 전술 구조에 최소한의 관여만 함. 볼 소유 시와 비소유 시 모두 공간 커버리지가 부족하며, 집단 조직과 압축에 대한 영향이 적음'
      },
      SpatialCoverage2: {
        1: '선수는 평균 이하의 공간 커버리지를 제공하며, 필드 점유에 일부 참여하지만 포지션 연속성과 팀의 나머지와의 결속에 공백이 있음. 전술 구조에 대한 영향이 간헐적이며 상위 선수들보다 일관성이 낮음'
      },
      SpatialCoverage3: {
        1: '선수는 평균 수준의 공간 커버리지를 보이며, 공간 점유와 통제에 꾸준히 기여함. 포지셔닝이 일반적으로 정확하고 기능적이며, 공격과 수비 단계 모두에서 중간 정도의 영향으로 팀의 전술 구조에 참여함'
      },
      SpatialCoverage4: {
        1: '선수는 평균 이상의 공간 커버리지를 제공하며, 필드 점유와 팀의 포지셔널 구조에 높은 관여를 보임. 형태 유지와 전환 적응 능력이 압축과 주요 공간 통제에 상당히 기여함'
      },
      SpatialCoverage5: {
        1: '선수는 훌륭한 수준의 공간 커버리지에 도달하며, 포지셔닝을 최적화하여 팀의 포메이션과 전술 구조에 결정적인 영향을 미침. 경기 이해도와 블록의 나머지와의 동기화가 공격과 수비 모두에서 전략적 공간 점유를 극대화함'
      },
      OffBallPressure1: {
        1: '선수는 볼 없이 매우 제한적인 수비 압박을 가하며, 상대의 액션을 교란하거나 실수를 유도하기 위해 상대를 거의 압박하지 않음. 프레싱과 수비 구조에 대한 기여가 최소임'
      },
      OffBallPressure2: {
        1: '선수는 평균 이하의 볼 없이 수비 압박을 제공하며, 가끔 상대를 압박하지만 타이밍이나 포지셔닝이 일관되지 않음. 노력이 볼 회수나 상대 빌드업 교란에 제한적인 영향만 미침'
      },
      OffBallPressure3: {
        1: '선수는 평균 수준의 볼 없이 압박을 보이며, 팀의 수비 노력에 꾸준히 기여함. 포지셔닝과 타이밍이 일반적으로 효과적이며, 상대의 옵션을 늦추거나 제한하기 위해 적절한 압박을 가함'
      },
      OffBallPressure4: {
        1: '선수는 평균 이상의 볼 없이 수비 압박을 제공하며, 자주 상대의 액션을 교란하고 시간과 공간을 줄임. 노력이 잘 타이밍이 맞고 조율되어 팀이 강한 수비 구조를 유지하는 데 도움을 줌'
      },
      OffBallPressure5: {
        1: '선수는 볼 없이 수비 압박을 가하는 데 뛰어나며, 일관되게 상대를 괴롭히고 볼 소유권 이탈을 강요하며 패스 라인을 제한함. 강도, 포지셔닝, 예측이 팀의 수비 효과를 크게 향상시킴'
      },
      Distance1: {
        1: '평균보다 훨씬 적은 거리를 커버함 (필드에서의 움직임이 매우 제한적)'
      },
      Distance2: {
        1: '경기당 커버한 거리가 최상위 축구에서 일반적으로 보이는 것보다 낮음 (평균만큼 활발하지 않음)'
      },
      Distance3: {
        1: '합리적인 거리를 커버하며, 리그 평균 수준의 수치 (신체적 관여가 균형적)'
      },
      Distance4: {
        1: '일관되게 높은 거리를 커버하며, 강한 지구력을 반영하는 수치 (견고한 신체적 출력을 보임)'
      },
      Distance5: {
        1: '신체적 볼륨이 뛰어남. 커버한 거리 측면에서 상위 5개 리그에서 가장 활발한 선수들 중 하나'
      },
      Sprint1: {
        1: '평균에 비해 매우 적은 고속 런을 수행함 (경기 전반에 걸쳐 최소한의 스프린트 노력만 포함)'
      },
      Sprint2: {
        1: '스프린트 빈도가 포지션 평균보다 낮음 (고속 움직임 측면에서 폭발력이 제한적)'
      },
      Sprint3: {
        1: '경기당 중간 정도의 스프린트를 제공하며, 예상 평균 내 (리그 평균 수준의 값)'
      },
      Sprint4: {
        1: '스프린트 빈도로 두각을 나타내며, 평균보다 훨씬 높음. 일관된 폭발력을 보이며, 경기 전반에 걸쳐 고속 런에 기여함'
      },
      Sprint5: {
        1: '90분당 가장 높은 스프린트 볼륨을 보이는 선수 상위 20%에 위치함. 반복적인 고속 노력 측면에서 최고의 신체적 성과'
      },
      Acceleration1: {
        1: '속도 변화 능력이 평균보다 명확히 낮으며, 경기 중 매우 적은 폭발적인 가속을 수행함'
      },
      Acceleration2: {
        1: '유사한 선수들과 비교했을 때 가속 출력이 평균 이하이며, 단거리 폭발의 빈도가 제한적이기 때문'
      },
      Acceleration3: {
        1: '공정한 수의 가속을 기록하며, 리그 평균에 가까움. 속도 변화가 두각을 나타내지 않지만, 이 지표 내에서 수치는 정확함'
      },
      Acceleration4: {
        1: '빠르고 반복적으로 가속하는 강한 능력을 보이며, 가속률이 평균보다 명확히 높고 자주 단거리 폭발을 보이기 때문'
      },
      Acceleration5: {
        1: '반복적인 가속 측면에서 가장 폭발적인 선수 상위 20%에 위치하며, 빠른 스타트와 속도 변화에서 평균보다 훨씬 높은 수치를 유지하기 때문'
      },
      Speed1: {
        1: '신체적으로 느린 선수이거나 경기 중 고강도 노력을 절약하는 선수일 가능성'
      },
      Speed2: {
        1: '경쟁 평균보다 약간 낮은 최고 속도를 기록함'
      },
      Speed3: {
        1: '경기 전반에 걸쳐 평균 최고 속도 값을 유지함'
      },
      Speed4: {
        1: '자주 높은 속도에 도달하며, 빠르고 강력한 선수임을 시사함'
      },
      Speed5: {
        1: '매우 높은 최고 속도에 도달함. 속도 측면에서 차이를 만드는 선수일 가능성'
      },
      LineBreakingCarries1: {
        1: '볼 운반을 통해 라인을 파괴하는 경우가 거의 없음. 볼과 함께 전진하는 데 주도성이 부족함'
      },
      LineBreakingCarries2: {
        1: '라인을 파괴하는 볼 운반을 일부 완료하지만, 규칙성이 부족함'
      },
      LineBreakingCarries3: {
        1: '성공적인 라인 파괴 볼 운반을 중간 정도 기록함'
      },
      LineBreakingCarries4: {
        1: '자주 라인을 넘어 볼을 운반하고 진행을 지원하여 빌드업에 기여함'
      },
      LineBreakingCarries5: {
        1: '진정한 볼 운반 전문가. 일관되게 볼과 함께 라인을 파괴하며 높은 볼륨을 보임'
      },
      LineBreakingActions1: {
        1: '매우 적은 라인 파괴 액션(패스와 볼 운반)을 기록함. 거의 위험을 감수하지 않음'
      },
      LineBreakingActions2: {
        1: '일부 진행 액션(패스와 볼 운반)을 만들어내지만 드물게. 더 수평적으로 플레이하는 경향'
      },
      LineBreakingActions3: {
        1: '라인을 파괴하는 패스와 볼 운반을 정기적으로 결합함. 진행에 기여함'
      },
      LineBreakingActions4: {
        1: '기술적으로 숙련되고 지능적이어서 상대 라인을 파괴하는 많은 액션(패스와 볼 운반)을 만들어냄'
      },
      LineBreakingActions5: {
        1: '진정한 진행 전문가. 팀에 큰 영향을 미치며, 패스와 볼 운반을 통해 볼과 함께 지속적으로 라인을 파괴함'
      },
      OffBallRuns1: {
        1: '선수는 볼 없이 목적 있는 움직임을 매우 적게 하며, 공격 단계에 제한적인 지원만 제공함. 볼 없이 움직임이 공간 창출, 수비 라인 교란, 또는 볼 소유 시 팀 조율 개선에 거의 기여하지 않음'
      },
      OffBallRuns2: {
        1: '선수는 평균 이하의 볼 없이 움직임을 제공하며, 가끔 공격을 지원하지만 타이밍, 방향, 또는 전술적 의도에서 일관성이 부족함. 움직임이 공간을 열거나 공격 구조를 향상시키는 데 제한적인 영향만 미침'
      },
      OffBallRuns3: {
        1: '선수는 평균 수준의 목적 있는 볼 없이 움직임을 보이며, 공격 단계에 꾸준히 기여함. 움직임이 일반적으로 잘 타이밍이 맞고 기능적이며, 중간 정도의 영향으로 공간을 만들고 팀 플레이를 지원함'
      },
      OffBallRuns4: {
        1: '선수는 평균 이상의 볼 없이 활동을 보이며, 자주 수비 구조를 교란하고 패스 옵션을 만들며 공격 공간을 여는 목적 있는 움직임을 함. 움직임 패턴이 볼 소유 시 팀 조율에 상당히 기여함'
      },
      OffBallRuns5: {
        1: '선수는 목적 있는 볼 없이 움직임에서 뛰어나며, 일관되게 플레이를 예측하고 공격 기회를 극대화하는 지능적인 움직임을 함. 타이밍, 포지셔닝, 공간 인식이 지속적인 위협을 만들고 볼 소유 시 팀 유동성을 향상시킴'
      },
      OverMaxValue: {
        1: 'over_max_metric_name에서 극도의 능력을 보이며, 최대값을 초과하는 성과로, 이 선수가 그 측면에서 상위 5개 리그의 상위 10%에 위치함'
      },
      OverAverageSeason: {
        1: 'over_average_metric_name에서의 성과에 관해 league_name 리그 평균보다 높음 (over_average_metric_value vs average_metric_value)',
        2: 'league_name 리그의 수치와 비교하면, over_average_metric_name에서 성과가 평균 이상이라고 말할 수 있음 (over_average_metric_value vs average_metric_value)'
      },
      UnderMinValue: {
        1: 'under_min_metric_name에 관해서는, 상위 5개 리그의 최하위 percent_metric_name에 위치하므로 성과를 크게 개선해야 함'
      },
      Over70Percent: {
        1: ', 특히 over_70_metric_name에서 각각 90분당 over_70_metric_value로 두각을 나타냄',
        2: ', over_70_metric_name에서 각각 90분당 over_70_metric_value로 70% 이상',
        3: ', over_70_metric_name에서 각각 90분당 over_70_metric_value로 매우 뛰어난 활약을 보임'
      },
      Under30Percent: {
        1: ', under_30_metric_name에서 더 노력해야 하며, 각각 90분당 under_30_metric_value로 성과가 낮음',
        2: ', under_30_metric_name에서 크게 개선해야 하며, 각각 90분당 under_30_metric_value로 성과가 예상보다 낮음',
        3: ', under_30_metric_name에 관해서는 각각 90분당 under_30_metric_value로 더 나은 수치를 얻기 위해 더 노력해야 함'
      },
      OverAverageSeasonMoreThanOne: {
        1: 'league_name 리그 평균을 초과하는 성과를 강조하는 것이 좋습니다 '
      },
      OverAverageStats: {
        1: 'over_average_metric_name (평균 over_average_metric_value vs average_metric_value)'
      },
      Over70PercentIndividualPressure: {
        1: ', 볼을 회수하기 위한 매우 좋은 개인 압박을 가함',
        2: ', 볼을 되찾기 위해 상대에게 높은 압박을 가함'
      },
      Under30PercentIndividualPressure: {
        1: ', 볼을 회수하기 위해 압박을 더 강화해야 함',
        2: ', 상대를 압박하는 측면에서 더 노력해야 함'
      }
    },
    himSelf: '자신',
    ownSeason: '자신의 시즌',
    minMaxTooltip: '레이더의 최소값과 최대값에 맞춤',
    infoMessage3: 'This option is only available from matchday 6'
  },
  login: {
    login: '로그인',
    latestBlogPosts: '최신 블로그 게시물',
    signIn: '로그인',
    username: '사용자 이름',
    password: '비밀번호',
    passwordForgotten: '비밀번호 찾기',
    signUp: '회원가입',
    enter: '입장',
    forceTitle: '계정 사용 중',
    forceMessage: '계정이 다른 기기에서 이미 연결되어 있습니다. 해당 기기에서 연결을 끊고 이 기기에서 연결하시겠습니까?',
    forgotMyPassword: '비밀번호를 잊었습니다',
    firstLogin: '첫 로그인',
    firstLoginMessage: '보안상의 이유로 첫 로그인 시 새 비밀번호를 설정해야 합니다. 또한 앱을 보기 위한 선호 언어를 설정해야 합니다',
    firstLoginOverview: '계정, 접근 가능한 리그 및 제품에 대한 개요입니다.',
    passwordConfirmation: '비밀번호 확인',
    forgotPasswordMessage: '이메일을 입력하세요. 이메일과 연결된 유효한 계정이 있으면 받은편지함에서 비밀번호 재설정을 위한 다음 단계를 받게 됩니다',
    resetPassword: '비밀번호 재설정',
    resetPasswordLinkInvalid: '이 링크는 유효하지 않거나 만료되었습니다. 로그인 페이지에서 비밀번호 재설정을 다시 요청하세요.',
    skipSettings: '설정 건너뛰기',
    contact: '연락처',
    cookiesText: '이 사이트는 서비스를 제공하고 트래픽을 분석하여 서비스 품질을 보장하고 사용 통계를 생성하며 남용을 감지하고 해결하기 위해 Google 쿠키를 사용합니다.',
    contactUs: '문의하기',
    newsTitle: '신규: 피지컬 점수!',
    newsText: '기존 이벤트 데이터 기반 점수에 더해 두 가지 새로운 피지컬 퍼포먼스 점수를 추가했습니다: 지구력 점수와 스피드 & 파워 점수입니다. 지구력은 꾸준히 넓은 범위를 커버하고 높은 활동량을 유지하는 선수를 강조하며, 스피드 & 파워는 최고 속도, 스프린트, 폭발적인 가속에 초점을 맞춥니다. 두 점수 모두 0부터 100까지이며, 리그 및 포지션별 백분위를 포함해 유사 선수와 직접 비교할 수 있습니다.'
  },
  settings: {
    pageSubtitle: '애플리케이션 경험 설정',
    language: '언어',
    availableLeagues: '사용 가능한 리그',
    availableSeasons: '사용 가능한 시즌',
    availableProducts: '사용 가능한 제품',
    organization: '회사',
    changePassword: '비밀번호 변경',
    seasonTemplates: '시즌 템플릿',
    seasonTemplatesSubtitle: '나중에 선수 순위 및 선수 스카우트에서 선택할 수 있는 자신만의 시즌 템플릿을 만드세요',
    templateName: '템플릿 이름',
    selectTemplate: '편집할 기존 템플릿 선택',
    radarDefault: '기본 레이더',
    default: '기본값',
    tabs: {
      options: '옵션',
      templates: '템플릿',
      availableLeagues: '사용 가능한 리그',
      contactData: 'GBE 연락처 데이터'
    },
    contactData: {
      userDetails: '사용자 세부정보',
      firstName: '이름',
      lastName: '성',
      contactDetails: 'GBE 연락처 세부정보',
      name: '이름',
      phone: '전화',
      mobile: '휴대폰',
      email: '이메일',
      representativeDetails: 'GBE 대표 세부정보'
    },
    currency: '통화',
    fieldPreferences: '필드 설정',
    visualizationsPreferences: '시각화 설정',
    fieldColor: '필드 색상',
    fieldColors: {
      green: '녹색',
      blue: '파란색',
      white: '흰색',
      black: '검은색',
      grey: '회색'
    },
    defaultPlayerVisualization: '기본 선수 시각화',
    appPreferences: '애플리케이션 설정',
    darkMode: '다크 모드',
    showTour: '가이드 투어 표시',
    customStats: '사용자 지정 통계',
    radarTemplates: '레이더 템플릿',
    radarTemplatesSubtitle: '나중에 레이더 및 순위에서 선택할 수 있는 자신만의 지표 템플릿을 만드세요',
    radarCategories: {
      Custom1: '커스텀 1',
      Custom2: '커스텀 2',
      Custom3: '커스텀 3',
      Custom4: '커스텀 4',
      Custom5: '커스텀 5',
      Custom6: '커스텀 6',
      Physical: '신체',
      CustomPhysical1: '커스텀 신체 1',
      CustomPhysical2: '커스텀 신체 2',
      CustomPhysical3: '커스텀 신체 3',
      CustomPhysical4: '커스텀 신체 4',
      CustomPhysical5: '커스텀 신체 5',
      CustomPhysical6: '커스텀 신체 6'
    },
    templateRemoveTitle: '템플릿 제거',
    templateRemoveMsg: '이 템플릿을 제거하시겠습니까?',
    templateEditTitle: '템플릿 저장',
    templateEditMsg: '저장되지 않은 템플릿이 있습니다. 다른 템플릿을 로드하기 전에 저장하시겠습니까?',
    category: '카테고리',
    playerRadar: '선수 레이더',
    teamRadar: '팀 레이더',
    statsAlert: '저장하려면 최소 하나의 통계를 입력하세요',
    recommended: '추천',
    warning: '허용된 최대 레이더 수에 도달한 포지션이 있습니다. 템플릿을 삭제하거나 편집하세요',
    fieldPositions: {
      default: '드리블랩',
      fifa: 'FIFA',
      spanish: '스페인어',
      numeric: '숫자'
    },
    showMediaMode: '미디어 모드 표시',
    statTemplates: '통계 템플릿',
    statTemplatesSubtitle: '여러 지표 중에서 선택하여 자신만의 통계 템플릿을 만드세요',
    ratingFormat: {
      ratingFormat: '평가 형식',
      numbers: '숫자',
      letters: '편지 A-F'
    }
  },
  playerDetail: {
    passport: '여권',
    secondPassport: '두 번째 여권',
    age: '나이',
    dateOfBirth: '생년월일',
    height: '키',
    weight: '몸무게',
    wage: '연봉',
    history: '이력',
    positions: '포지션',
    injuries: '부상',
    transfers: '이적',
    nationalTeam: '국가대표',
    addFavorite: '즐겨찾기에 추가',
    removeFavorite: '즐겨찾기에서 제거',
    contractEnd: '계약 종료',
    yearsOld: '세',
    playerAvailability: '가용성',
    playerUsage: '출전 시간',
    usage: '사용률',
    addToCollection: '컬렉션에 추가',
    performance: '성과',
    info: '정보',
    career: '경력',
    playerStyle: '선수 스타일',
    radar: '레이더',
    finishingMap: '피니싱 맵',
    threatMap: '위협 맵',
    keyPassMap: '키패스 맵',
    beeswarm: '순위',
    allGames: '모든 경기',
    eventsMap: '이벤트 맵',
    lbpMap: '라인 브레이킹 패스',
    obpMap: '볼 압력에 대하여',
    pupMap: '압박감 속에서 패스',
    obrMap: '볼 영수증',
    fullName: '전체 이름',
    academy: '아카데미',
    name: '이름',
    lastName: '성',
    playerAvailabilityLong: '부상이나 징계 없이 보낸 시즌 비율',
    playerUsageLong: '출전 시간',
    playerAvailability1: '부상이나 징계 없이 보낸 경기',
    playerAvailability2: '이번 시즌 경기',
    playerUsage1: '출전 시간',
    playerUsage2: '팀 총 출전 시간',
    notMinutesThisSeason: '이번 시즌 출전 시간이 없음',
    seasonPlaceholder: '활성 시즌이 없음',
    inactivePlayer: '비활성 선수',
    inactivePlayerMessage: '더 많은 정보가 필요하면 리포트를 요청할 수 있습니다',
    goRequest: '요청으로 이동',
    warningMinutes: '주의: 450분 미만 출전, 분석이 대표적이지 않을 수 있음',
    scoreWarningMinutes: '총 450분 이상 출전한 선수',
    pdScoreWarningMinutes: '총 450분 이상 출전한 선수 (경기당 최소 60분)',
    warningSeasonGames: '시즌 경기 수가 5경기 미만이므로 최소 & 최대는 \'상위 5개 리그\' 기준입니다',
    warningStatsRemoved: '선택한 시즌에 사용할 수 없어 일부 통계가 표시되지 않습니다',
    warningBeeswarm: '선택한 시즌에 이 통계 데이터가 없어 선수가 표시되지 않습니다',
    warningPlayersZeroValue: '0 값을 가진 {x}명의 선수는 표시하지 않음',
    onlyPlayersThatFit: '레이더 템플릿에 맞는 선수만',
    gamesPlayedNotEnough: '경기 수가 부족하여 옵션이 비활성화됨',
    gbe: 'GBE',
    analysis: '분석',
    documents: '문서',
    rankDefensive: '수비',
    rankBallHandling: '볼 핸들링',
    rankGoal: '골 기여',
    rankXt: '위협',
    rankIndex: '지수',
    visitHistory: '방문 기록',
    placer: '필드',
    touchesMap: '터치 맵',
    heatMap: '히트맵',
    ageProfile: '나이 프로필',
    strongFoot: '주발',
    player: '선수',
    outOf: '중',
    in: '내',
    radius: '반경',
    blur: '흐림',
    careerTable: {
      nationalTeamCareer: '국가대표 경력',
      nationalTeamCompetitions: '국가대표 대회'
    },
    physicalProgression: '신체 진행',
    gpi: '글로벌 선수 지수',
    warningGPI: '과거 30일 동안 ELO 리그에서 활성화된 선수만 사용 가능',
    diffGPI: '마지막 경기 대비 변화',
    rankingInTheWorld: '세계 #{0}위',
    rankingInTheLeague: '{1}에서 #{0}위',
    max: '최대',
    gpiChart: '최근 {0}경기의 글로벌 선수 지수 값을 기반으로 한 차트',
    percentileRange: '백분위수 {0} ~ {1}',
    months: '개월',
    month: '월',
    contractExpOver4Years: '계약 만료일:',
    contractExpSoon: '계약이 곧 만료됩니다',
    contractFinalYear: '계약 마지막 해',
    freeAgent: '자유계약',
    gpiDescription: 'GPI(Global Player Index)는 팀 전력, 상대 전력, 경기 성과 및 가용성을 기준으로 축구 선수를 평가하는 표준화된 선수 평가 시스템입니다. Elo 등급 시스템에서 영감을 받아 플레이어 등급이 임의의 기준이 아닌 실제 경쟁 환경을 반영하도록 보장합니다.',
    turnoversMap: '회전율 및 회복 지도',
    playerProfiles: {
      24: {
        label: 'Libero',
        abbreviation: 'LIB'
      },
      25: {
        label: 'Box Goalkeeper',
        abbreviation: 'PAR'
      },
      26: {
        label: 'Line',
        abbreviation: 'LIN'
      },
      27: {
        label: 'Initiator',
        abbreviation: 'INI'
      },
      28: {
        label: 'Ball Carrier',
        abbreviation: 'CON'
      },
      29: {
        label: 'Anticipator',
        abbreviation: 'ANT'
      },
      30: {
        label: 'Cover',
        abbreviation: 'COB'
      },
      31: {
        label: 'Box Defender',
        abbreviation: 'DAR'
      },
      32: {
        label: 'Deep Forward',
        abbreviation: 'DPR'
      },
      33: {
        label: 'Inside',
        abbreviation: 'INT'
      },
      34: {
        label: 'Playmaker',
        abbreviation: 'PLY'
      },
      35: {
        label: 'Defensive',
        abbreviation: 'DEF'
      },
      36: {
        label: 'Central',
        abbreviation: 'CEN'
      },
      37: {
        label: 'Ball Winner',
        abbreviation: 'REC'
      },
      38: {
        label: 'Regista',
        abbreviation: 'REG'
      },
      39: {
        label: 'Pressing',
        abbreviation: 'PRS'
      },
      40: {
        label: 'Progressive',
        abbreviation: 'PRG'
      },
      41: {
        label: 'Box-to-box',
        abbreviation: 'B2B'
      },
      42: {
        label: 'Attacking Regista',
        abbreviation: 'ROF'
      },
      43: {
        label: 'Final Third',
        abbreviation: 'ULT'
      },
      44: {
        label: 'Workhorse',
        abbreviation: 'CAB'
      },
      45: {
        label: 'Late Runner',
        abbreviation: 'LLE'
      },
      46: {
        label: 'Difference Maker',
        abbreviation: 'DES'
      },
      47: {
        label: 'Inverted Scorer',
        abbreviation: 'ING'
      },
      48: {
        label: 'Creator',
        abbreviation: 'CRE'
      },
      49: {
        label: 'Deep Midfielder',
        abbreviation: 'MPR'
      },
      50: {
        label: 'Target',
        abbreviation: 'REF'
      },
      51: {
        label: 'Link-up',
        abbreviation: 'ASO'
      },
      52: {
        label: 'Runner',
        abbreviation: 'RUP'
      },
      53: {
        label: 'Finisher',
        abbreviation: 'FIN'
      }
    },
    sucessfulTouch: '성공적인 터치',
    unsuccessfulTouch: '실패한 터치',
    showLegend: '범례 표시'
  },
  finishingMap: {
    typesOfShot: '슛 유형',
    shotStrategy: '슛 전략',
    strategiesCount: '{count}개 전략',
    areas: '지역',
    bodyPart: '신체 부위',
    more: '더보기',
    selectAll: '전체 선택',
    minutes: '분',
    circles: '원',
    boxes: '페널티 박스 히트맵',
    lines: '라인',
    games: '경기',
    perShot: '슛당',
    goal: '골',
    missedShot: '빗나간 슛',
    savedShot: '막힌 슛',
    shotOnPost: '골대 맞춘 슛',
    missedChance: '놓친 기회',
    openPlay: '오픈 플레이',
    regularPlay: '일반 플레이',
    fastBreak: '빠른 역습',
    individualPlay: '개인 플레이',
    setPiece: '세트피스',
    fromCorner: '코너킥',
    freeKick: '프리킥',
    indirectFreeKick: '간접 프리킥',
    throwInSetPiece: '스로인 세트피스',
    inBox: '박스 안',
    goalArea: '6야드 박스',
    boxLeft: '박스 왼쪽',
    boxCenter: '박스 중앙',
    boxRight: '박스 오른쪽',
    outOfBox: '박스 밖',
    outBoxDeepLeft: '박스 밖 깊은 왼쪽',
    outBoxDeepRight: '박스 밖 깊은 오른쪽',
    outBoxLeft: '박스 밖 왼쪽',
    outBoxCentreLeft: '박스 밖 중앙 왼쪽',
    outBoxCentre: '박스 밖 중앙',
    outBoxCentreRight: '박스 밖 중앙 오른쪽',
    outBoxRight: '박스 밖 오른쪽',
    left35: '+35 왼쪽',
    centreLeft35: '+35 중앙 왼쪽',
    centre35: '+35 중앙',
    centreRight35: '+35 중앙 오른쪽',
    right35: '+35 오른쪽',
    head: '헤딩',
    rightFooted: '오른발',
    leftFooted: '왼발',
    otherBodyPart: '기타 신체 부위',
    chart: {
      shots: '슛',
      xGPerShot: '슛당 xG',
      exceptionTextPenaltyGoals: '* 페널티 슛 = 0.765 xG',
      exceptionTextGKPenaltyGoals: '* 페널티 슛 = 0.765 xGOT',
      exceptionTextOwnGoals: '* 자책골은 고려하지 않음',
      og: '자책골',
      penaltiesExcluded: '페널티 골 제외',
      ownGoalsExcluded: '자책골 제외',
      sumOfxG: 'xG 합계',
      exceptionShotsOutOfRange: '* 범위 밖 슛은 표시하지 않음'
    },
    inGoal: '골 안',
    outOfGoal: '골 밖',
    highLeft: '높은 왼쪽',
    highCenter: '높은 중앙',
    highRight: '높은 오른쪽',
    lowLeft: '낮은 왼쪽',
    lowCenter: '낮은 중앙',
    lowRight: '낮은 오른쪽',
    outHighLeft: '골 밖 높은 왼쪽',
    high: '골 밖 높은 중앙',
    outHighRight: '골 밖 높은 오른쪽',
    closeHighLeft: '가까운 높은 왼쪽',
    closeHigh: '가까운 높은 중앙',
    closeHighRight: '가까운 높은 오른쪽',
    closeLeft: '가까운 낮은 왼쪽',
    closeRight: '가까운 낮은 오른쪽',
    finishingTable: '피니싱 테이블',
    onGoal: '골대 안',
    distributionFilters: '분포 필터',
    penalty: '페널티',
    penaltyShootout: '페널티 승부차기',
    onlyPercentage: '비율 표시',
    showAll: '전체 표시',
    chanceMissed: '놓친 기회'
  },
  keyPassMap: {
    chart: {
      keyPasses: '키패스',
      xAPerPass: '패스당 xA',
      xAOpenPlay: 'xA 오픈 플레이',
      xASetPiece: 'xA 세트피스'
    }
  },
  beeswarm: {
    template: '템플릿',
    templates: {
      Goalkeeper: '골키퍼',
      Defender: '수비수',
      'Full-Back': '풀백',
      FullBack: '풀백',
      'Wing-Back': '윙백',
      WingBack: '윙백',
      Midfielder: '미드필더',
      AttackingMidfielder: '공격형 미드필더',
      Winger: '윙어',
      Forward: '공격수',
      Physical: '신체'
    },
    compareWith: '비교 대상',
    highlightPlayersOf: '다음의 선수 강조',
    highlightPlayers: '선수 강조',
    per90: '90분당 데이터',
    highlightTeams: '팀 강조',
    filterTeams: '팀 필터',
    warningZeros: '역순 통계가 아닌 경우에만 사용'
  },
  collections: {
    newCollection: '새 컬렉션',
    editCollection: '컬렉션 편집',
    name: '이름',
    visibility: '공개 범위',
    privacity: {
      publicTitle: '공개',
      publicDescription: '본인과 클럽에서 볼 수 있음',
      privateTitle: '비공개',
      privateDescription: '본인만 볼 수 있음',
      supervisedTitle: '감독',
      supervisedDescription: '본인과 감독만 볼 수 있음'
    },
    addSuccess: '성공적으로 추가됨',
    createAddSuccess: '성공적으로 생성 및 추가됨',
    editSuccess: '성공적으로 업데이트됨',
    deleteSuccess: '성공적으로 삭제됨',
    title: '선수 컬렉션',
    publics: '공개',
    privates: '비공개',
    supervised: '감독',
    totalMarketValue: '총 시장 가치',
    avgMarketValue: '평균 시장 가치',
    avgAge: '평균 나이',
    searchBarPlaceholder: '컬렉션에 추가하려면 검색하여 선수를 선택하세요',
    deleteCollection: '컬렉션 삭제',
    deleteCollectionMessage: '컬렉션이 제거됩니다. 정말로 진행하시겠습니까?',
    removePlayer: '선수 제거',
    removePlayerMessage: '선수가 컬렉션에서 제거됩니다. 정말로 진행하시겠습니까?',
    subtitle: '스카우팅을 정리하세요',
    notExitingTemplate: '아직 템플릿이 없습니다'
  },
  searchbar: {
    placeholder: '검색어를 입력하세요 (예: `david arsenal`)',
    players: '선수',
    teams: '팀',
    games: '경기',
    leagues: '리그',
    explore: '더 많은 결과 탐색',
    placeholderNoResults: '템플릿에 대한 결과 없음',
    teamPlaceholder: '팀을 비교하려면 검색하여 선택하세요'
  },
  favorites: {
    showOnly: '다음만 표시',
    selfFavorites: '내 즐겨찾기',
    clubFavorites: '클럽 즐겨찾기',
    contractExpiration: '계약 만료',
    groupBy: '그룹화',
    noGrouped: '없음',
    maxSelection: '최대 선택 가능',
    selectAtleastOne: '최소 하나 선택',
    comparePlayers: '선수 비교',
    selectedPlayers: '명의 선수 선택됨',
    subtitle: '즐겨찾기를 관리하세요',
    generateXlsx: 'XLSX 생성',
    generating: '생성 중...',
    subscribed: '구독됨',
    subscribedTooltip: '경기가 진행되면 이메일을 받으려면 구독하세요',
    deleteSelected: '선택 항목 삭제'
  },
  expiration: {
    summer: '여름',
    winter: '겨울'
  },
  positions: {
    noposition: '포지션 없음',
    goalkeeper: '골키퍼',
    goalkeepers: '골키퍼',
    defender: '수비수',
    defenders: '수비수',
    defenses: '수비수',
    fullback: '풀백',
    fullbacks: '풀백',
    midfielder: '미드필더',
    midfielders: '미드필더',
    winger: '윙어',
    wingers: '윙어',
    forward: '공격수',
    forwards: '공격수',
    wingback: '윙백',
    wingbacks: '윙백'
  },
  dPos: {
    1: {
      name: '골키퍼',
      alias: ''
    },
    2: {
      name: '오른쪽 풀백',
      alias: 'RFB'
    },
    3: {
      name: '오른쪽 센터백',
      alias: 'RCB'
    },
    4: {
      name: '왼쪽 센터백',
      alias: 'LCB'
    },
    5: {
      name: '왼쪽 풀백',
      alias: 'LFB'
    },
    6: {
      name: '수비형 미드필더',
      alias: 'DM'
    },
    7: {
      name: '오른쪽 윙어',
      alias: 'RW'
    },
    8: {
      name: '중앙 미드필더',
      alias: 'CM'
    },
    9: {
      name: '스트라이커',
      alias: 'ST'
    },
    10: {
      name: '공격형 미드필더',
      alias: 'AM'
    },
    11: {
      name: '왼쪽 윙어',
      alias: 'LW'
    }
  },
  charts: {
    seasonsCompareSelectLabel: '비교 대상',
    lastSeasonSelectText: '지난 시즌',
    lastAndCurrentSeasonSelectText: '지난 시즌 + 현재 시즌',
    currentSeasonSelectText: '현재 시즌',
    lastNgamesSelectText: '지난 {x} 게임',
    npgVsXGTitle: '페널티 제외 골 VS xG',
    totalXGLabel: '총 xG',
    xGLabel: 'xG',
    totalNPGLabel: '총 페널티 제외 골',
    xGAgainstvsNPGAgainstTitle: '대면 xG VS 페널티 제외 실점',
    totalXGAgainstLabel: '총 대면 xG',
    xGAgainstLabel: '대면 xG',
    totalNPGAgainstLabel: '총 페널티 제외 실점',
    xGvsxGAgainstTitle: 'xG VS 대면 xG',
    pointsVsXPointsTitle: '승점 VS 예상 승점',
    xTTitle: '경기 흐름',
    totalXPoints: '총 예상 승점',
    totalPoints: '총 승점',
    requestedReports: '요청된 리포트',
    playersScouted: '스카우트된 선수',
    performanceVSAverageChart: '성과 VS 평균',
    perPositions: '포지션별',
    perLeagues: '리그별',
    perMonths: '월별',
    perClients: '클라이언트별',
    ofPreposition: '중',
    idJChartTitle: '경기 주도권',
    idJChartLabel: '주도권 지수',
    vJOChartTitle: '공격 게임 볼륨',
    vJOChartLabel: '공격 볼륨 지수',
    preJOChartTitle: '공격 게임 정확도',
    preJOChartLabel: '공격 정확도 지수',
    proJOChartTitle: '공격 게임 진행',
    proJOChartLabel: '공격 진행 지수',
    chart: '차트',
    table: '테이블',
    showLeaguesWithAtLeast: '최소',
    playersScoutedSuffix: '스카우트된 선수',
    last20gamesSelectText: '최근 20경기',
    last10gamesSelectText: '최근 10경기'
  },
  table: {
    history: {
      season: '시즌',
      team: '팀',
      position: '포지션',
      side: '측면',
      games: '경기',
      minutes: '분',
      goals: '페널티 제외 골 (G)',
      assists: '어시스트',
      yellowCards: '옐로카드',
      redCards: '레드카드',
      gameLost: '경기 누락',
      gamesMissed: '누락된 경기',
      goalsReceived: 'NPGC (GC)'
    },
    injury: {
      season: '시즌',
      team: '팀',
      injury: '부상',
      dateFrom: '시작일',
      dateTo: '종료일',
      daysLost: '손실 일수',
      gamesLost: '누락된 경기',
      allInjuries: '모든 부상'
    },
    transfers: {
      season: '시즌',
      date: '날짜',
      teamFrom: '출발 팀',
      teamTo: '도착 팀',
      marketValue: '시장 가치',
      fee: '이적료',
      type: '유형'
    },
    caps: {
      team: '팀',
      debut: '데뷔',
      games: '경기',
      goals: '골',
      coachDuringDebut: '데뷔 당시 감독',
      debutAge: '데뷔 나이'
    },
    roster: {
      country: '국가',
      player: '선수',
      positions: '포지션',
      minutes: '분',
      games: '경기',
      goals: '골',
      assists: '어시스트',
      cards: '카드',
      gamesExplicit: '출전 경기'
    },
    league: {
      title: '리그 시트',
      subtitle: '리그 순위와 통계를 더 깊이 살펴보세요',
      team: '팀',
      games: '경기 수',
      gamesExplicit: '경기 수',
      gamesRanking: '경기 수',
      gamesRankingExplicit: '경기 수',
      points: '승점',
      pointsExplicit: '승점',
      expectedPoints: '예상 승점',
      expectedPointsExplicit: '예상 승점',
      goalsScored: '페널티 제외 골',
      goalsScoredExplicit: '페널티 제외 골',
      xG: 'xG',
      xGExplicit: '예상 골',
      goalsAgainst: '페널티 제외 실점',
      goalsAgainstExplicit: '페널티 제외 실점',
      xGAgainst: '대면 xG',
      xGAgainstExplicit: '대면 예상 골',
      xGAgainstDiff: '대면 xG 차이',
      xGAgainstDiffExplicit: '대면 예상 골 차이',
      form: '폼',
      sos: '일정 강도',
      sosExplicit: '일정 강도',
      sosHfa: '홈 어드밴티지 일정 강도',
      sosHfaExplicit: '홈 어드밴티지',
      difficultyAboveAvg: '평균보다 어려운 난이도',
      differentGames: '* 서로 다른 경기 수',
      berth: '순위'
    },
    usersOfClient: {
      userName: '이름',
      userRole: '사용자',
      devRole: '개발자',
      adminRole: '관리자',
      servicesRole: '서비스',
      xgRole: 'XG',
      radarRole: '레이더',
      beeswarmRole: '순위',
      elevenRole: '일레븐',
      similarityRole: '유사도',
      gameAnalysisRole: '경기 분석',
      clientStatsRole: '클라이언트 통계',
      created: '생성일',
      type: '유형',
      logins: '로그인',
      lastLogin: '마지막 로그인',
      trialDate: '체험 기간'
    },
    clientLeagues: {
      league: '리그',
      area: '지역',
      tier: '티어',
      seasons: '시즌',
      currentMatchDay: '경기일',
      regular: '정규',
      youthLeague: '유스',
      clientActive: '활성',
      visibleLeagues: '표시되는 리그',
      male: '남자 리그',
      female: '여자 리그'
    },
    connections: {
      title: '일반적인 조합',
      playerFrom: '출발 선수',
      playerTo: '도착 선수',
      passes: '패스',
      passesTooltip: '성공한 패스 총 수',
      passesFinalThird: '최종 3분의 1 패스',
      passesFinalThirdTooltip: '최종 3분의 1 패스'
    },
    playerPassMapData: {
      title: '패스 통계',
      player: '선수',
      passes: '패스',
      passesPct: '패스 성공률',
      xA: 'xA',
      xG: 'xG',
      xT: '예상 위협',
      playerTooltip: '선수 이름',
      passesTooltip: '패스 총 수',
      passesPctTooltip: '성공한 패스 비율',
      xATooltip: '예상 어시스트',
      xGTooltip: '예상 골',
      xTTooltip: '예상 위협'
    },
    playerAllGames: {
      gameDate: '날짜',
      game: '경기',
      team: '팀',
      positionsPlayed: '포지션',
      minsPlayed: '분',
      gameActions: '액션',
      gameDateTooltip: '경기 날짜',
      gameTooltip: '경기',
      positionsPlayedTooltip: '출전 포지션',
      minsPlayedTooltip: '출전 시간',
      gameActionsTooltip: '골, 어시스트, 카드',
      from: '시작',
      to: '종료',
      goalText: '골',
      assistText: '어시스트',
      penaltyText: '페널티',
      ownGoalText: '자책골',
      yellowCardText: '옐로카드',
      secondYellowCardText: '두 번째 옐로카드',
      redCardText: '레드카드',
      substitutionIN: '교체 투입',
      substitutionOUT: '교체 아웃',
      suspendedText: '징계',
      Team: '장비'
    },
    gameFlow: {
      phase: '단계 ',
      mins: '분',
      team: '팀',
      period: '시간',
      possession: '점유율',
      possessionTooltip: '점유율',
      xT: '예상 위협',
      xTTooltip: '예상 위협',
      pft: '최종 3분의 1 패스',
      pftTooltip: '최종 3분의 1 패스',
      xG: 'xG',
      xGTooltip: '예상 골'
    }
  },
  game: {
    title: '경기 시트',
    subtitle: '경기의 특성과 통계를 더 깊이 살펴보세요',
    header: {
      gameDetails: '세부정보',
      gameStats: '통계',
      gameFinishingMap: '피니싱 맵',
      gameKeyPassMap: '키패스 맵',
      gamePassMap: '패스 맵',
      gameThreat: '경기 위협',
      gameFlow: '경기 흐름',
      gameAnalysis: '경기 분석',
      gamePhysicalStats: '신체 통계',
      possessions: '볼 소유',
      bench: '벤치',
      video: '동영상 하이라이트',
      preGame: '경기 전',
      postGame: '경기 후',
      areaCoverage: '지역 범위'
    },
    passMap: {
      typeOfPlay: '플레이 유형:',
      passes: '패스:',
      team: '팀',
      minutes: '분:',
      select: '선택',
      all: '전체',
      attacking: '공격',
      defending: '수비',
      forwards: '전진',
      backwards: '후진',
      sideways: '측면',
      longBall: '롱볼',
      successfullPasses: '성공한 패스',
      homeTeam: '홈',
      awayTeam: '원정',
      passingMatrix: '패스 매트릭스',
      passer: '패스 제공자',
      receiver: '패스 수신자',
      passOutcome: '패스 결과',
      passDirection: '패스 방향',
      half: '하프',
      offensive: '공격',
      defensive: '수비',
      passingConnections: '패스 연결',
      pitchView: '피치',
      passSingular: '패스',
      passPlural: '패스',
      playerLocation: '플레이어 위치',
      passLegend: '평균 터치 위치',
      minuteRange: '분 범위'
    },
    stats: {
      summary: '요약',
      attacking: '공격',
      defending: '수비',
      contribution: '기여',
      possession: '점유',
      expectedPoints: '예상 승점',
      directness: '직접성',
      ppda: 'PPDA',
      xg: 'xG',
      xG: 'xG',
      xGSetPiece: 'xG 세트피스',
      xA: 'xA',
      xASetPiece: 'xA 세트피스',
      xT: 'xT',
      xTSetPiece: 'xT 세트피스',
      touchesInOppBox: '상대 박스 내 터치',
      passesFinalThird: '최종 3분의 1 패스',
      interceptions: '인터셉트',
      recoveries: '볼 회수',
      recoveriesOppHalf: '상대 진영 볼 회수',
      tackles: '태클',
      tacklesWasDribbled: '수비 1대1 승리',
      fouls: '파울',
      yellowCards: '옐로카드',
      redCards: '레드카드',
      passes: '패스',
      passing: '패스 성공률',
      crosses: '크로스',
      crossing: '크로스 성공률',
      shots: '슛',
      shotsOnTarget: '유효 슛',
      ppdaExplicit: '수비 액션당 허용 패스',
      xgExplicit: '예상 골',
      xp: 'xP',
      ExpectedPassing: 'xP 성공률',
      seasonAvg: '대회 평균',
      winChanceTooltip: '승리 확률 생성 및 허용된 xG 기반',
      drawChance: '무승부',
      xgAgainst: '대면 xG',
      averagePossession: '점유율',
      averageShots: '슛',
      averagexG: '예상 골',
      fieldTilt: '필드 틸트',
      fieldTiltExplicit: '필드 틸트',
      recoveriesRate: '회수율',
      turnoversRate: '이직률'
    },
    detail: {
      halfTime: '전반 종료',
      overTime: '연장',
      showStats: '통계 표시',
      hideStats: '통계 숨기기',
      bench: '벤치',
      showShotOptions: '슛 옵션 표시',
      hideShotOptions: '슛 옵션 숨기기',
      showPassOptions: '패스 옵션 표시',
      hidePassOptions: '패스 옵션 숨기기',
      endGame: '전반 종료',
      penalties: '페널티'
    },
    timeline: {
      events: {
        goal: '골',
        goal_ownGoal: '자책골',
        goal_penalty: '페널티킥 골',
        card: '카드',
        card_yellowCard: '옐로카드',
        card_secondYellowCard: '두 번째 옐로카드',
        card_redCard: '레드카드',
        formationChange: '포메이션 변경',
        substitution: '교체',
        saveShot: '막힌 슛',
        saveShot_penalty: '막힌 페널티킥',
        missedShot: '빗나간 슛',
        missedShot_penalty: '빗나간 페널티킥',
        shotOnPost: '골대 맞춘 슛',
        shotOnPost_penalty: '골대 맞춘 페널티킥',
        drinksBreak_startDrinksBreak: 'Start Cooling Break',
        drinksBreak_endDrinksBreak: 'End Cooling Break',
        assist: 'Assist'
      },
      gameTimeline: 'Game Timeline'
    },
    gameFlow: {
      goalOf: '골',
      redCardTo: '레드카드',
      missedPenalty: '빗나간 페널티'
    },
    gameThreat: {
      typeOfPlay: '액션 유형',
      regularPlay: '일반 플레이',
      setPiece: '세트피스',
      setPiecePlay: '세트피스',
      throwInSetPiecePlay: '스로인 플레이',
      throwInPlay: '스로인 플레이',
      gkThrow: '골키퍼 스로',
      gkKick: '골키퍼 킥',
      kickOff: '킥오프',
      actionEnding: '액션 종료',
      pass: '패스',
      shot: '슛',
      foul: '파울',
      other: '기타',
      threat: '위협',
      legendSumOfXT: 'xT 합계',
      legendPass: '패스',
      legendShot: '슛',
      legendCarryAndAction: '볼 운반 및 액션',
      legendCarryAndPass: '볼 운반 및 패스',
      legendOnlyShowing: 'xT > 인 개별 액션만 표시',
      legendOnlyShowingPart1: '개별만 표시',
      legendOnlyShowingPart2: 'xT > 인 액션',
      legendOnlyShowingSetPiece: 'xT > 인 세트피스 액션만 표시',
      legendOnlyShowingOpenPlay: 'xT > 인 오픈 플레이 액션만 표시',
      legendPlays: '액션',
      legendPerPlay: '액션당',
      legendCarry: '볼 운반',
      penaltyPlay: '페널티',
      freeKickTakenPlay: '프리킥 플레이',
      cornerTakenPlay: '코너킥 플레이',
      fromCornerPlay: '코너킥 플레이',
      keeperThrowPlay: '골키퍼 스로 플레이',
      fastBreakPlay: '빠른 역습 플레이',
      indirectPlay: '간접 플레이',
      minutes: '분',
      games: '경기',
      xT: 'xT',
      xTPer90: '90분당 xT'
    },
    gameAnalysis: {
      next: '다음',
      previous: '이전',
      phaseLabel: '단계',
      phasesLabel: '단계',
      dot: '. ',
      comma: ', ',
      from: '부터',
      to: '까지',
      and: ' 및 ',
      steps: {
        finishingMapFullGame: '피니싱 맵',
        keyPassMapFullGame: '키패스 맵',
        gameFlow: '경기 흐름',
        finishingMapPerPhases: '단계별 피니싱 맵',
        keyPassMapPerPhases: '단계별 키패스 맵',
        passMapPerPhases: '단계별 패스 맵'
      },
      step1: {
        table: {
          draw: '무승부',
          win: '승리',
          lose: '패배',
          possession: '점유율',
          xP: '예상 승점',
          directness: '직접성',
          ppda: 'PPDA',
          xG: 'xG',
          xGOpenPlay: 'xG 오픈 플레이',
          xGSetPiece: 'xG 세트피스',
          xA: 'xA',
          xAOpenPlay: 'xA 오픈 플레이'
        },
        text: {
          firstParagraph: {
            1: '오른쪽 맵은 home_team_name과 away_team_name이 생성한 예상 골을 표시합니다. 채워진 원은 골로 연결된 슛입니다. 원의 크기는 각 슛의 xG 값에 따라 결정됩니다. '
          },
          lastParagraph: {
            1: '결과의 확률 비율과 예상 승점 수는 슛 시뮬레이션을 통해 계산됩니다 (슛에 대한 100,000회 시뮬레이션이 수행되며 결과와 승점 획득 가능성이 예측 방식으로 평가됩니다). '
          },
          targetHighTeamXG: {
            1: 'target_team_name과 rival_team_name 모두 높은 양의 예상 골을 만들어냈습니다'
          },
          targetHighTeamOpenPlayXG: {
            1: '이 경기에서 target_team_name의 대부분의 기회가 오픈 플레이에서 나왔습니다'
          },
          targetHighTeamOpenPlayXGvsGameRival: {
            1: '이 경기에서 target_team_name의 대부분의 기회가 오픈 플레이에서 시작되었습니다 (rival_team_name과 달리)'
          },
          targetHighTeamSetPieceXG: {
            1: '이 경기에서 target_team_name의 대부분의 기회가 세트피스 플레이에서 나왔습니다'
          },
          targetHighTeamSetPieceXGvsGameRival: {
            1: '이 경기에서 target_team_name의 대부분의 기회가 세트피스 플레이에서 시작되었습니다 (rival_team_name과 달리)'
          },
          targetHighTeamCornerXG: {
            1: '이 경기에서 target_team_name의 대부분의 기회가 코너킥에서 나왔습니다'
          },
          targetLowTeamGoalConversion: {
            1: ' 하지만 골 전환율이 낮았습니다'
          },
          dot: {
            1: '. '
          },
          targetHighTeamXGOPandSP: {
            1: 'target_team_name은 오픈 플레이와 세트피스 모두에서 높은 양의 예상 골을 만들어냈습니다'
          },
          targetHighTeamGoalConversion: {
            1: ' 높은 골 전환율도 보였습니다. '
          },
          targetLowTeamGoalConversionZeroGoals: {
            1: ', 만들어진 기회 중 어떤 것도 골로 연결하지 못했습니다'
          },
          targetLowTeamGoalConversionScoringGoals: {
            1: ' 하지만 더 많은 골을 넣을 수 있는 위험을 만들었습니다'
          },
          targetHighTeamXGvsGameRival: {
            1: '이 경기에서 target_team_name은 rival_team_name보다 더 많은 위험을 만들어냈습니다'
          },
          targetLowTeamGoalConversionScoringGoals2: {
            1: ' 그리고 더 많은 골을 넣을 수 있었습니다. '
          },
          targetHighTeamXGZeroGoals: {
            1: ' 하지만 만들어진 기회 중 어떤 골도 넣지 못했습니다. '
          },
          targetHighTeamXGGoalDiff: {
            1: ' 경기 후 시뮬레이션에 따르면 team_winning_chance의 승리 확률과 일치합니다. '
          },
          startTargetHighTeamOpenPlayXG: {
            1: ' target_team_name의 대부분의 기회가 오픈 플레이에서 나왔습니다. '
          },
          startTargetHighTeamSetPieceXG: {
            1: ' target_team_name의 대부분의 기회가 세트피스 플레이에서 시작되었습니다. '
          },
          startTargetHighTeamCornerXG: {
            1: ' 대부분의 기회가 코너킥에서 나왔습니다. '
          },
          targetSimilarTeamXG: {
            1: '이 경기에서 양 팀 모두 xG 측면에서 상대에게 유사한 양의 위험을 만들어냈습니다, '
          },
          targetSimilarTeamXGGoalDiff: {
            1: '하지만 target_team_name은 기회 마무리에서 더 좋은 성과를 보였습니다. '
          },
          targetLowTeamXGGoalDiff: {
            1: '결과와 관계없이, target_team_name은 예상 골 측면에서 상대에게 많은 위험을 만들지 못했습니다. '
          },
          targetLowTeamXGZeroGoalDiff: {
            1: 'target_team_name은 경기에서 승리하기에 충분한 예상 골 측면에서 상대에게 위험을 만들지 못했습니다'
          },
          rivalHighTeamXG: {
            1: '그리고 rival_team_name이 너무 많은 위험을 만들도록 허용했습니다. '
          },
          rivalHighTeamXGGoalDiff: {
            1: ' 이러한 생성으로, 경기 후 시뮬레이션에 따르면 target_team_name은 team_winning_chance의 확률로만 승리할 수 있는 경기입니다. '
          },
          targetHighTeamGoalConversion2: {
            1: ' 높은 골 전환율을 보였습니다'
          },
          winningChance: {
            1: '양 팀의 슛 수와 xG를 고려하면, target_team_name은 이 경기에서 team_winning_chance의 확률로 승리했어야 합니다. '
          },
          highPlayerXGManyShots: {
            1: 'player_name이 shots_value개의 슛에서 xg_value xG를 생성한 것은 주목할 만합니다'
          },
          highPlayerXGMoreThanOneGoal: {
            1: ' 골을 넣기 위해 xg_value xG가 필요했습니다. '
          },
          highPlayerXGOneGoal: {
            1: ' 골을 넣기 위해. '
          },
          highPlayerXGAnyGoal: {
            1: ', 하지만 어떤 골도 넣지 못했습니다. '
          },
          highPlayerXGNotManyShots: {
            1: 'player_name이 적은 슛에서 xg_value xG를 생성한 것은 언급할 가치가 있습니다'
          },
          highManyPlayerXG: {
            1: 'player_name과 player_name2가 각각 xg_value와 xg_value2 <b>xG</b>를 생성한 것은 주목할 만합니다. '
          },
          highTeamXGPerShot: {
            1: 'target_team_name이 선택한 슛에 관해서는, 골이 될 확률 측면에서 매우 좋았으며, 슛당 평균 xG는 xg_per_shot_value였습니다. '
          },
          highTeamXGPerShotVSGameRival: {
            1: 'target_team_name의 슛 선택은 rival_team_name보다 훨씬 좋았으며, 슛당 평균 xg_per_shot_value xG를 기록했습니다. '
          },
          xGTimesNotAfter70xG: {
            1: '높은 xG를 생성했음에도 불구하고, target_team_name은 경기 말미에 위험을 만드는 데 문제가 있었습니다. '
          },
          xGTimesBefore25xG: {
            1: 'target_team_name은 특히 전반과 후반 시작 부분에서 많은 위험을 만들었습니다. '
          },
          xGTimesAfter25xG: {
            1: 'target_team_name은 특히 전반과 후반 말미에 많은 위험을 만들었습니다. '
          },
          xGTimesBefore25xGvsItself: {
            1: 'target_team_name은 전반 시작 부분에서 대부분의 위험을 만들었습니다. '
          },
          xGTimesAfter25xGvsItself: {
            1: 'target_team_name은 전반 말미에 대부분의 위험을 만들었습니다. '
          },
          xGTimesBefore70xGvsItself: {
            1: 'target_team_name은 후반 시작 부분에서 대부분의 위험을 만들었습니다. '
          },
          xGTimesAfter70xGvsItself: {
            1: 'target_team_name은 후반 말미에 대부분의 위험을 만들었습니다. '
          },
          xGTimesBefore25xG2: {
            1: 'target_team_name은 xg_value 예상 골을 만든 기회로 경기를 매우 견고하게 시작했습니다. '
          },
          xGTimesAfter25xG2: {
            1: 'target_team_name은 xg_value 예상 골을 만든 기회로 전반을 마쳤습니다. '
          },
          xGTimesBefore70xG: {
            1: 'target_team_name은 xg_value 예상 골을 만든 기회로 하프타임 휴식 후 경기를 재개했습니다. '
          },
          xGTimesAfter70xG: {
            1: 'target_team_name은 xg_value 예상 골을 만든 기회로 후반을 마쳤습니다. '
          },
          xGTimesAfter70xGOverOneDotTwo: {
            1: 'target_team_name은 후반 말미에 많은 위험을 만들었습니다. '
          },
          xGTimesBefore70xGOverOneDotTwo: {
            1: 'target_team_name은 후반 시작 부분에서 많은 위험을 만들었습니다. '
          },
          xGTimesAfter25xGOverOneDotTwo: {
            1: 'target_team_name은 전반 말미에 많은 위험을 만들었습니다. '
          },
          xGTimesBefore25xGOverOneDotTwo: {
            1: 'target_team_name은 전반 시작 부분에서 많은 위험을 만들었습니다. '
          },
          xGTimesFirstHalfXGSecondHalfXGRival: {
            1: 'target_team_name은 전반에 대부분의 위험을 만들었고, rival_team_name은 후반에 그렇게 했습니다. '
          },
          xGTimesSecondHalfXGFirstHalfXGRival: {
            1: 'target_team_name은 후반에 대부분의 위험을 만들었고, rival_team_name은 전반에 그렇게 했습니다. '
          },
          xGTimesFirstHalfXGFirstHalfXGRival: {
            1: '예상 골 측면에서 대부분의 위험이 전반에 생성된 경기입니다. '
          },
          xGTimesSecondHalfXGSecondHalfXGRival: {
            1: '예상 골 측면에서 대부분의 위험이 후반에 생성된 경기입니다. '
          },
          xGTimesFirstHalfXG: {
            1: 'target_team_name은 전반에 대부분의 위험을 만드는 데 성공했습니다. '
          },
          xGTimesSecondHalfXG: {
            1: 'target_team_name은 후반에 대부분의 위험을 만드는 데 성공했습니다. '
          },
          xGTimesFirstHalfXGRival: {
            1: 'target_team_name은 전반에 예상 골 측면에서 대부분의 위험을 허용했습니다. '
          },
          xGTimesSecondHalfXGRival: {
            1: 'target_team_name은 후반에 예상 골 측면에서 대부분의 위험을 허용했습니다. '
          },
          highInBoxXG: {
            1: '슛 맵은 대부분의 위험이 박스 안 슛에서 나왔음을 보여줍니다. '
          },
          highOutOfBoxXG: {
            1: '슛 맵에서 이 경기에서 target_team_name이 박스 밖에서 많은 위험을 만들었음을 관찰할 수 있습니다. '
          },
          highInBoxXGRival: {
            1: 'target_team_name이 허용한 대부분의 위험이 박스 안 슛에서 나왔음을 지적하고 싶습니다. '
          },
          highInBoxXGRival2: {
            1: ' target_team_name이 허용한 대부분의 위험이 박스 안 슛에서 나왔다는 것도 강조할 만합니다. '
          },
          highOutOfBoxXGRival: {
            1: 'target_team_name은 박스 안 위험을 잘 피했습니다. '
          },
          highTeamChancesHighPPDARival: {
            1: 'target_team_name의 압박 부족, ppda_value 수비 액션당 패스 허용은 rival_team_name이 많은 기회를 만드는 데 핵심 중 하나였습니다. '
          },
          lowPPDAWithGoalDiff: {
            1: 'target_team_name은 ppda_value 수비 액션당 패스만 허용했으며, 이것이 승리의 핵심 중 하나였습니다. '
          },
          lowPPDA: {
            1: 'target_team_name은 rival_team_name의 플레이를 방해하는 데 훌륭한 일을 했으며, 평균 ppda_value 수비 액션당 패스만 허용했습니다. '
          },
          highPossession: {
            1: 'target_team_name은 possession_value의 점유율로 볼을 통제했습니다'
          },
          highPPDARival: {
            1: ' 그리고 유동적인 볼 배급'
          },
          chancesCreated: {
            1: ', 이는 많은 오픈 플레이 기회(chances_value)를 갖게 했습니다. '
          },
          chancesCreatedRival: {
            1: ', 하지만 rival_team_name은 많은 오픈 플레이 기회(chances_value)를 만들 수 있었습니다. '
          },
          xGPerShotRival: {
            1: ', 하지만 rival_team_name은 슛당 xg_per_shot_value xG로 더 위험한 기회를 만들 수 있었습니다. '
          },
          winGame: {
            1: ' 경기 승리의 핵심 중 하나였습니다. '
          },
          notEnoughWinGame: {
            1: ' 경기에서 승리하기에는 충분하지 않았습니다. '
          },
          goalsFromErrorsFirstGoal: {
            1: '첫 골은 player_error_name의 실수에서 나왔고 player_name이 이를 활용했습니다'
          },
          goalsFromErrorsFirstGoalFinalResult: {
            1: '첫 골이자 유일한 골은 player_error_name의 실수에서 나왔고 player_name이 이를 활용했습니다'
          },
          lastPhaseOfGame: {
            1: ' 경기 마지막 단계에서. '
          },
          goalsFromErrorsFinalResultGoalToLead: {
            1: '경기 승리를 결정한 마지막 골은 player_error_name의 실수에서 나왔고 player_name의 골로 이어졌습니다. '
          },
          goalsFromErrorsFinalResultGoalToTie: {
            1: '경기를 동점으로 만든 마지막 골은 player_error_name의 실수에서 나왔고 player_name의 골로 이어졌습니다. '
          },
          goalsFromErrorsGoalToTie: {
            1: 'player_error_name의 실수가 target_team_name에게 경기를 동점으로 만들 기회를 제공했습니다. '
          },
          goalsFromErrorsGoalToLead: {
            1: 'target_team_name은 player_error_name의 실수를 활용하여 리드를 잡았습니다'
          },
          xGChance: {
            1: ' xg_value xG의 기회로. '
          },
          rivalGoalsFromErrorsFinalResultGoalToLead: {
            1: 'rival_team_name의 경기 승리를 결정한 마지막 골은 player_error_name의 실수에서 나왔고 player_name의 골로 이어졌습니다. '
          },
          rivalGoalsFromErrorsGoalToTie: {
            1: 'player_error_name의 실수가 rival_team_name에게 경기를 동점으로 만들 기회를 제공했습니다. '
          },
          rivalGoalsFromErrorsGoalToLead: {
            1: 'rival_team_name은 player_error_name의 실수를 활용하여 리드를 잡았습니다'
          },
          hugeChancesMissedOneScored: {
            1: 'target_team_name은 경기 중 만든 유일한 큰 기회를 골로 연결했으며, xG 맵에서 xg_value xG를 가진 player_name의 골입니다. '
          },
          hugeChancesMissedMoreThanOneScored: {
            1: 'target_team_name은 경기 중 만든 모든 큰 기회를 골로 연결했습니다'
          },
          hugeChancesMissedZeroGoalsOneChance: {
            1: 'player_name은 xg_value xG를 가진 target_team_name의 유일한 큰 골 기회를 가졌습니다. '
          },
          hugeChancesMissedZeroGoalsMoreChances: {
            1: 'target_team_name은 골이 될 가능성이 40% 이상인 chances_value개의 기회 중 어떤 것도 골로 연결하지 못했습니다. '
          },
          oneHugeChancesBeforeFirstGameGoal: {
            1: 'player_name은 점수에서 앞서 나갈 큰 기회를 xg_value xG로 가졌습니다. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoal: {
            1: 'target_team_name은 점수에서 앞서 나갈 40% 이상 xG를 가진 chances_value개의 기회를 가졌습니다. '
          },
          moreThanOneBigChancesBeforeFirstGameGoal: {
            1: 'target_team_name은 점수에서 앞서 나갈 높은 xG를 가진 chances_value개의 기회를 가졌습니다. '
          },
          shotOnPostBeforeFirstGameGoal: {
            1: 'player_name은 점수에서 앞서 나갈 xg_value xG의 기회를 가졌지만 골대를 맞췄습니다. '
          },
          beforeEndOfGame: {
            1: '경기 종료 전, '
          },
          oneHugeChancesAfterFirstGameGoal: {
            1: 'player_name은 경기에서 승리할 xg_value xG의 기회를 가졌습니다. '
          },
          moreThanOneHugeChancesAfterFirstGameGoal: {
            1: 'target_team_name은 경기에서 승리할 40% 이상 xG를 가진 chances_value개의 기회를 가졌습니다. '
          },
          moreThanOneBigChancesAfterFirstGameGoal: {
            1: 'target_team_name은 경기에서 승리할 높은 xG를 가진 chances_value개의 기회를 가졌습니다. '
          },
          oneHugeChancesBeforeFirstGameGoalRival: {
            1: 'player_name은 점수에서 앞서 나갈 큰 기회를 xg_value xG로 가졌습니다. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name은 점수에서 앞서 나갈 40% 이상 xG를 가진 chances_value개의 기회를 가졌습니다. '
          },
          moreThanOneBigChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name은 점수에서 앞서 나갈 높은 xG를 가진 chances_value개의 기회를 가졌습니다. '
          },
          shotOnPostBeforeFirstGameGoalRival: {
            1: 'player_name은 점수에서 앞서 나갈 xg_value xG의 기회를 가졌지만 골대를 맞췄습니다. '
          },
          bigChancesMissedWhenLosingByOne: {
            1: 'player_name은 운이 없게도 경기를 동점으로 만들 xg_value xG의 기회를 가졌습니다. '
          },
          moreThanOneBigChancesMissedWhenLosingByOne: {
            1: 'target_team_name은 30% 이상의 골 확률을 가진 chances_value개의 기회로 경기를 동점으로 만들 수 있었습니다. '
          },
          shotOnPostWhenLosingByOne: {
            1: 'player_name은 경기를 동점으로 만들 xg_value xG의 기회를 가졌지만 골대를 맞췄습니다. '
          }
        }
      },
      step2: {
        table: {
          draw: '무승부',
          win: '승리',
          possession: '점유율',
          xP: '예상 승점',
          directness: '직접성',
          ppda: 'PPDA',
          xA: 'xA',
          xAOpenPlay: 'xA 오픈 플레이',
          xASetPiece: 'xA 세트피스',
          chancesCreated: '만들어진 기회',
          shotsOnTarget: '유효 슛'
        },
        text: {
          firstParagraph: {
            1: '이 이미지는 <b style=\'color:home_color\'>home_team_name</b>과 <b>away_team_name</b>의 예상 어시스트를 보여줍니다.'
          },
          xAPerKeyPass: {
            1: ' 키패스당 xA. '
          },
          keyPassesGeneratedFrom: {
            1: ', 특히 다음에서 생성된 키패스 '
          },
          highTeamXAvsXG: {
            1: 'xA 맵이 보여주듯이, target_team_name이 만든 대부분의 위험은 개인 액션보다 조합 플레이에서 나왔습니다'
          },
          openPlay: {
            1: '오픈 플레이'
          },
          setPiece: {
            1: '세트피스 플레이'
          },
          cornerKicks: {
            1: '코너킥'
          },
          combinationPlays: {
            1: '조합 플레이'
          },
          dot: {
            1: '. '
          },
          comma: {
            1: ', '
          },
          averageTeamXAvsXG: {
            1: '이 경기에서 target_team_name은 조합 플레이와'
          },
          individualActions: {
            1: ' 개인 액션 모두에서 위험을 만들었습니다. '
          },
          dangerFromIndividualActions: {
            1: '이 경기에서 target_team_name이 만든 대부분의 위험은 개인 액션에서 나왔습니다.'
          },
          highTeamXAvsXGRival: {
            1: ' target_team_name이 경기 중 허용한 기회는 xA 맵이 보여주듯이 조합 플레이에서 나왔습니다.'
          },
          rivalStrongKeyPassesFrom: {
            1: ' rival_team_name은 다음에서 나온 키패스에서 강했습니다 '
          },
          manyPlayerKeyPasses: {
            1: 'player_name이 key_passes개의 키패스에서 xa_value xA를 만든 것은 주목할 만합니다'
          },
          playerAssists: {
            1: ' 어시스트당 xa_per_assist xA가 필요했습니다.'
          },
          giveAssist: {
            1: ' 어시스트를 제공하기 위해.'
          },
          noAssists: {
            1: ', 하지만 그의 패스 중 어떤 것도 어시스트로 연결되지 않았습니다.'
          },
          highXANotManyShots: {
            1: 'player_name이 적은 패스에서 xa_value xA를 만든 것은 주목할 만합니다'
          },
          manyPlayersHighXA: {
            1: 'player_name과 player_name2가 각각 xa_value와 xa_value2 xA를 생성한 것은 주목할 만합니다.'
          },
          xATimes: {
            1: 'target_team_name은 전반에 대부분의 위험을 만들었고, rival_team_name은 '
          },
          firstHalf: {
            1: ' 전반에 그렇게 했습니다. '
          },
          secondHalf: {
            1: ' 후반에 그렇게 했습니다. '
          },
          left: {
            1: '왼쪽 '
          },
          center: {
            1: '중앙 '
          },
          right: {
            1: '오른쪽 '
          },
          xAFirstHalfFirstHalfRival: {
            1: '예상 골 측면에서 대부분의 위험이 '
          },
          xAFirstHalf: {
            1: 'target_team_name은 '
          },
          xATimesXARival: {
            1: 'target_team_name은 '
          },
          xASides: {
            1: ' target_team_name의 대부분의 위험이 side_name에서 만들어졌습니다 (xa_value <b>xA</b>)'
          },
          xASidesRival: {
            1: '반면 rival_team_name은 대부분을 side_name에서 만들었습니다 (xa_value <b>xA</b>)'
          },
          dangerCreationRival: {
            1: 'rival_team_name의 위험 생성은 특히 side_name에서 나왔습니다 (xa_value <b>xA</b>). '
          },
          speciallyEffective: {
            1: 'target_team_name은 특히 다음에서 효과적이었습니다 '
          },
          xAPerChanceCreated: {
            1: ' 평균 xa_value로'
          },
          speciallyEffectiveRival: {
            1: 'rival_team_name은 특히 다음에서 효과적이었습니다 '
          }
        }
      },
      step3: {
        text: {
          chance: ' 기회',
          chances: ' 기회',
          goal: ' 골',
          goals: ' 골',
          home: '홈',
          away: '원정',
          last: '마지막',
          first: '첫',
          goalScorer: '득점자',
          goalScorers: '득점자',
          lastPhase: '경기 마지막 단계, ',
          phase: {
            1: '이 경기의 phase_position 단계에서, '
          },
          moreXT: {
            1: '<b style=\'color:more_color\'>more_xt_team_name</b>이 <b style=\'color:less_color\'>less_xt_team_name</b> (<b style=\'color:less_color\'>less_xt_team_value xT</b>)보다 더 많은 예상 위협 (<b style=\'color:more_color\'>more_xt_team_value xT</b>)을 만들었습니다'
          },
          sameTeamMoreMinutes: {
            1: '그리고 이 기간 동안 더 많은 시간 동안 그렇게 했습니다 (<b style=\'color:more_color\'>more_time_xt_minutes분</b> vs 상대의 <b style=\'color:less_color\'>less_time_xt_minutes분</b>)'
          },
          rivalTeamMoreMinutes: {
            1: '하지만 이 경기 기간 동안 상대가 더 오래 위험을 만들었습니다 (<b style=\'color:more_color\'>more_time_xt_minutes분</b> vs 상대의 <b style=\'color:less_color\'>less_time_xt_minutes분</b>)'
          },
          maxXTValue: {
            1: '<b style=\'color:max_color\'>max_xt_team_name</b>은 <b style=\'color:max_color\'>max_xt_team_minute분</b>에 가장 많은 위험 (<b style=\'color:max_color\'>max_xt_team_value xT</b>)을 만든 팀이었습니다'
          },
          maxXTValueRival: {
            1: ', 반면 <b style=\'color:max_rival_color\'>max_xt_rival_team_name</b>은 <b style=\'color:max_rival_color\'>max_xt_rival_team_minute분</b>에 가장 많은 위험 (<b style=\'color:max_rival_color\'>max_xt_rival_team_value xT</b>)을 만들었습니다'
          },
          bothTeamsScoreButDraw: {
            1: '양 팀 모두 상대 골키퍼를 <b>number_of_goals_each_team</b>골씩 넣었습니다. 홈팀은 <b style=\'color:#3366FF\'>home_player_name_goals</b>를 통해, 원정팀은 <b>away_player_name_goals</b>를 통해'
          },
          oneTeamTakesTheLead: {
            1: '골 측면에서, <b style=\'color:replace_color\'>goal_scored_team_name</b>은 <b style=\'color:replace_color\'>difference_number_of_goals</b>골 차이로 상대를 앞섰으며, <b style=\'color:replace_color\'>home_player_name_goals</b>가 goal_scorer_word로 골키퍼를 이겼습니다'
          }
        }
      },
      step4: {
        table: {
          team: '팀',
          period: '시간',
          possession: '점유율',
          ppda: 'PPDA',
          xGOpenPlay: 'xG 오픈 플레이',
          tooltip: {
            team: '팀',
            period: '시간',
            possession: '점유율',
            ppda: '수비 액션당 허용 패스',
            xGOpenPlay: 'xG 오픈 플레이'
          }
        },
        text: {
          clearly: '명확히',
          very: '매우 ',
          haveGotText1: '단지 얻었습니다',
          haveGotText2: '더 많이 얻었어야 했습니다',
          gaveUpPoss: '점유를 포기했습니다',
          lostPoss: '볼 점유를 잃었습니다',
          too: '너무 ',
          possession: {
            1: '이 경기 단계 동안 <b style=\'color:team_color\'>team_name</b>은 clearly_text 볼 점유를 통제했습니다'
          },
          equalPossession: {
            1: '이 경기 단계에서, 볼 처리가 상당히 균형 잡혀 있어 누구도 상대를 지배하지 못했지만, 수치를 보면 <b style=\'color:team_color\'>team_name</b>이 <b style=\'color:team_color\'>possession_value%</b>의 점유율로 약간 앞섰습니다'
          },
          lowPossessionHighPPDA: {
            1: '. <b style=\'color:target_team_color\'>target_team_name</b>은 나쁜 볼 압박으로 <b style=\'color:rival_team_color\'>rival_team_name</b>이 <b style=\'color:target_team_color\'>ppda_value 수비 액션당 패스</b>를 하도록 허용했습니다'
          },
          lowPossessionLowPPDA: {
            1: ', 하지만 <b style=\'color:target_team_color\'>target_team_name</b>은 rival_team_name이 볼을 소유했을 때 <b>PPDA</b> <b>ppda_value</b>로 볼 압박을 잘했습니다'
          },
          highPossessionLowPPDA: {
            1: ' 그리고 rival_team_name의 very_text낮은 압박 강도 덕분에 플레이할 수 있었습니다'
          },
          highPossessionHighPPDA: {
            1: ' 하지만 rival_team_name의 압박 강도가 very_text높았습니다'
          },
          highPossessionHighPFT: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b>은 높은 점유율을 잡아 필드의 <b>최종 3분의 1</b>에서 <b>pft_value</b>개의 <b>패스</b>를 했습니다. '
          },
          highPossessionMidLowPFT: {
            1: '높은 점유율에도 불구하고, <b style=\'color:target_team_color\'>target_team_name</b>은 have_got_text <b>최종 3분의 1</b>에서 <b>pft_value</b>개의 <b>패스</b>를 했습니다. '
          },
          lowPossessionHighPFT: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b>이 이 단계 동안 possession_text했지만, <b>최종 3분의 1</b>에서 <b>pft_value</b>개의 <b>패스</b>를 할 수 있었습니다. '
          },
          midPossessionHighPFT: {
            1: '이 단계 동안 상당히 균등한 점유율이 <b style=\'color:target_team_color\'>target_team_name</b>이 <b>최종 3분의 1</b>에서 <b>pft_value</b>개의 <b>패스</b>를 하는 것을 막지 못했습니다. '
          },
          highPFTHighTouchesIOB: {
            1: ' 최종 3분의 1에서 경기를 통제하는 것 외에도, <b style=\'color:target_team_color\'>target_team_name</b>은 상대 박스에서도 많은 존재감을 보였습니다. '
          },
          highPFTLowTouchesIOB: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b>은 최종 3분의 1에서 볼을 통제했지만, 상대 박스에 많은 볼을 넣지 못했습니다'
          },
          highPFTMidTouchesIOB: {
            1: '<b>최종 3분의 1 패스</b> 수를 고려하면, <b style=\'color:target_team_color\'>target_team_name</b>은 상대 박스에서 더 많은 위험을 만들었어야 했습니다'
          },
          lowPFTHighTouchesIOB: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b>이 최종 3분의 1에서 많은 패스를 완료하지 못했지만, 상대 박스에 여러 번 도달할 수 있었습니다. '
          },
          midPFTHighTouchesIOB: {
            1: '최종 3분의 1에서 완료한 패스 수를 고려하면, <b style=\'color:target_team_color\'>target_team_name</b>은 상대 박스에 여러 번 도달하는 데 성공했습니다. '
          },
          maxDirectness: {
            1: '이것이 <b style=\'color:max_dir_color\'>target_team_name</b>이 <b>직접성</b> <b>directness_value</b>로 더 공격적으로 플레이한 경기 단계임을 지적할 가치가 있습니다. '
          },
          maxXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b>은 경기의 다른 단계보다 더 많은 xG를 생성할 수 있었습니다 '
          },
          highXGFifthQuintile: {
            1: ' <b style=\'color:target_team_color\'>target_team_name</b>은 높은 양의 예상 골을 만드는 데 성공했습니다'
          },
          highXG: {
            1: '좋은 양의 예상 골을 만들었습니다'
          },
          highXGLowPossession: {
            1: ' 볼 통제를 갖지 못했음에도 불구하고'
          },
          highXGLowShots: {
            1: ' 적은 슛에서만, <b>슛당 xG</b>가 <b>xg_per_shot_value</b>였습니다'
          },
          highXGLowXGPerShot: {
            1: ' 하지만 슛당 xG가 too_text낮았습니다. '
          },
          lowXGZeroXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b>은 상대에게 어떤 위험도 만들지 못했습니다'
          },
          lowXGMinXG: {
            1: '예상 골 생성 측면에서, 이것은 <b style=\'color:target_team_color\'>target_team_name</b>에게 불리한 단계였습니다'
          },
          lowXGFirstQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b>은 매우 낮은 양의 예상 골을 만들었습니다'
          },
          lowXGSecondQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b>은 좋은 양의 예상 골을 만들지 못했습니다'
          },
          lowXGHighPossession: {
            1: ' 볼 통제를 갖고 있었음에도 불구하고. '
          },
          lowXGHighShots: {
            1: ' 여러 번 슛을 했음에도 불구하고'
          },
          lowXGHighPFT: {
            1: ' 필드의 <b>최종 3분의 1</b>에서 <b>pft_value</b>개의 <b>패스</b>를 완료했음에도 불구하고. '
          },
          midXGQuintileMinXG: {
            1: 'xG 생성이 나쁘지 않았지만, 이것은 그 측면에서 <b style=\'color:target_team_color\'>target_team_name</b>에게 가장 약한 경기 단계였습니다'
          },
          midXGQuintileMaxXG: {
            1: '이것은 <b style=\'color:target_team_color\'>target_team_name</b>이 가장 높은 <b>xG (xg_value)</b>를 생성할 수 있었던 단계였습니다'
          }
        }
      },
      step5: {
        table: {
          team: '팀',
          period: '시간',
          possession: '점유율',
          directness: '직접성',
          passesFinalThird: '최종 3분의 1 패스',
          tooltip: {
            team: '팀',
            period: '시간',
            possession: '점유율',
            directness: '직접성',
            passesFinalThird: '최종 3분의 1 패스'
          }
        },
        text: {
          last: '마지막',
          goal: '골',
          goals: '골',
          chance: '기회',
          chances: '기회',
          first: '첫',
          homeTeam: '홈팀',
          awayTeam: '원정팀',
          home: '홈',
          away: '원정',
          clearly: '명확히',
          slightly: '약간',
          firstOrLastPhase: {
            1: '이 경기의 phase_position 단계에서, ',
            2: '이 경기의 phase_position 시간에, '
          },
          phase: {
            1: '이 경기 시간 동안, '
          },
          bothZeroGoalsScored: {
            1: '양 팀 모두 점수판을 바꿀 수 없었습니다.'
          },
          equalGoalsScored: {
            1: '<b>number_goals</b>골을 넣었습니다'
          },
          differentGoalsScored: {
            1: '<b>number_goals</b>골을 넣었습니다'
          },
          equalPossesion: {
            1: '양 팀 모두 정확히 <b>poss_value%</b>의 시간 동안 볼을 소유했습니다'
          },
          morePossesion: {
            1: '<b style=\'color:more_color\'>more_poss_team_name</b>이 상대 <b style=\'color:less_color\'>less_poss_team_name</b> (<b style=\'color:less_color\'>less_poss_team_value%</b>의 시간)보다 더 많은 시간 (<b style=\'color:more_color\'>more_poss_team_value%</b>의 시간) 동안 볼을 소유했습니다'
          },
          equalDirectness: {
            1: '양 팀 모두 같은 직접성 (<b>directness_value</b> 각각)으로 경기를 플레이했습니다'
          },
          moreDirectnessSameTeam: {
            1: '그들은 또한 상대보다 더 수직적으로 플레이했으며, <b style=\'color:more_color\'>more_dir_team_value</b> vs <b style=\'color:less_color\'>less_dir_team_value</b>의 직접성으로 경기를 플레이했습니다'
          },
          moreDirectnessDifferentTeam: {
            1: '하지만 home_away 팀이 상대 (<b style=\'color:less_color\'>less_dir_team_value</b>)보다 더 높은 직접성 (<b style=\'color:more_color\'>more_dir_team_value</b>)으로 플레이했습니다'
          },
          equalChancesCreated: {
            1: '양 팀 모두 같은 수의 기회를 만들었으며, 정확히 <b>chances_created_value</b>개의 chance_text입니다.'
          },
          moreChancesCreated: {
            1: '<b style=\'color:less_color\'>less_cc_team_name</b>은 단지 <b style=\'color:less_color\'>less_cc_team_value less_chance_text</b>만 만들었고 adverb_text 상대 (<b style=\'color:more_color\'>more_cc_team_value more_chance_text</b> 생성)에게 뒤졌습니다. '
          },
          equalXA: {
            1: '양 팀 모두 동등한 기회를 가졌으며, <b>xa_value 예상 어시스트</b>에 반영되었습니다, '
          },
          moreXA: {
            1: 'home_away 팀은 상대보다 <b>diff_xa_team_value 예상 어시스트</b> (<b style=\'color:more_color\'>more_xa_team_value</b> vs <b style=\'color:less_color\'>less_xa_team_value</b>)를 더 많이 만들었습니다, '
          },
          xAOpenPlay: {
            1: '각각 <b style=\'color:more_color\'>more_xa_op_value</b>와 <b style=\'color:less_color\'>less_xa_op_value xA 오픈 플레이</b>를 만들었습니다.'
          }
        }
      },
      step6: {
        text: {
          eachOne: ' 각각 ',
          respectively: ', 각각',
          with: ' (<b style=\'color:replace_color\'>other_player_name</b>와 함께)',
          playerWas: '선수는',
          playerWere: '선수들은',
          firstPhase: {
            1: '이 경기의 첫 부분에서, 가장 중요한 player_text ',
            2: '경기의 첫 부분에 관해서는, 두각을 나타낸 것은 '
          },
          otherPhase: {
            1: '<b style=\'color:replace_color\'>min_from분</b>과 <b style=\'color:replace_color\'>min_to분</b> 사이에 언급해야 할 것은 '
          },
          lastPhase: {
            1: '경기의 마지막 부분에서, 언급할 것은 ',
            2: '경기의 마지막 단계에 관해서는, '
          },
          playerMaxSuccessfullPasses: {
            1: '<b style=\'color:replace_color\'>player_name</b>으로, 팀에서 가장 많은 성공한 패스를 수행했으며, 정확히 <b style=\'color:replace_color\'>successfull_passes_value개의 패스</b>입니다 '
          },
          playerMaxTotalPasses: {
            1: '그가 또한 가장 많은 시도한 패스를 한 것으로 수치가 보여줄 때 더욱 가치가 있습니다'
          },
          playerMaxTotalPasses2: {
            1: 'with_text 가장 많은 시도한 패스를 한 선수 (<b style=\'color:replace_color\'>total_passes_value개의 패스</b>)입니다. '
          },
          playerNotMaxTotalPasses: {
            1: '하지만 가장 많은 패스를 시도하지는 않았습니다 (<b style=\'color:replace_color\'>player_name</b>이 <b style=\'color:replace_color\'>total_passes_value개의 패스</b>). '
          },
          playersMaxSuccessfullPassesTotalPasses: {
            1: '이 기간 동안 각각 <b style=\'color:replace_color\'>total_passes_value개의 패스</b>를 시도했습니다. '
          },
          playerMaxPctPasses: {
            1: '<b style=\'color:replace_color\'>패스 성공률</b> 측면에서, <b style=\'color:replace_color\'>player_name</b>은 높은 <b style=\'color:replace_color\'>max_pct_passes_value%</b>를 보였습니다. ',
            2: '패스 성공률에 관해서는, <b style=\'color:replace_color\'>max_pct_passes_value%</b>의 패스 성공률을 가진 <b style=\'color:replace_color\'>player_name</b>을 언급할 가치가 있습니다. '
          },
          playerSumTotalXG: {
            1: '이 시간대에 팀은 총 <b style=\'color:replace_color\'>sum_xg_value xG</b>를 생성했습니다, ',
            2: '이 기간 동안, <b style=\'color:replace_color\'>team_name</b>은 <b style=\'color:replace_color\'>sum_xg_value</b>의 <b style=\'color:replace_color\'>xG</b>를 만들었습니다, '
          },
          ZeroSumXG: {
            1: '전체 팀이 총 <b style=\'color:replace_color\'>all_team_total_passes</b>개의 패스를 했음에도 불구하고, 단 하나의 기회도 만들지 못해 헛수고였습니다. ',
            2: '이 기간에 만든 <b style=\'color:replace_color\'>all_team_total_passes</b>개의 패스는 단 하나의 득점 기회도 만들지 못했습니다. '
          },
          playerMaxXGMaxXADiffPlayer: {
            1: '<b style=\'color:replace_color\'>xg_value xG</b>를 가진 <b style=\'color:replace_color\'>player_xg_name</b>과 <b style=\'color:replace_color\'>xa_value xA</b>를 가진 <b style=\'color:replace_color\'>player_xa_name</b>이 기회 생성 측면에서 가장 위험한 선수였습니다. '
          },
          playerMaxXGMaxXASamePlayer: {
            1: '<b style=\'color:replace_color\'>xg_value xG</b>와 <b style=\'color:replace_color\'>xa_value xA</b>를 가진 <b style=\'color:replace_color\'>player_name</b>이 팀의 대부분의 기회의 원천이었습니다. '
          },
          playersMaxXGMaxXA: {
            1: '특히 <b style=\'color:replace_color\'>players_name</b>이 각각 키패스로 <b style=\'color:replace_color\'>xa_value xA</b>를 만들어낸 것에 감사합니다. '
          },
          playerMaxXGZeroXA: {
            1: '<b style=\'color:replace_color\'>xg_value xG</b>를 가진 <b style=\'color:replace_color\'>player_xg_name</b>이 기회의 전부를 담당했으며, 키패스를 받지 못해 스스로 만들어야 했습니다. '
          },
          playersMaxXGZeroXA: {
            1: '<b style=\'color:replace_color\'>xg_value xG</b>를 가진 <b style=\'color:replace_color\'>player_xg_name</b>이 기회를 가졌으며, 키패스를 받지 못해 스스로 만들어야 했습니다. '
          },
          oneMaxConnections: {
            1: '이 경기 구간에서 서로 가장 많은 패스를 한 조합은 <b style=\'color:replace_color\'>couple_name</b>이었으며, 총 <b style=\'color:replace_color\'>connections_value개의 패스</b>였습니다. ',
            2: '<b style=\'color:replace_color\'>couple_name</b>으로 구성된 듀오는 <b style=\'color:replace_color\'>connections_value</b>번 볼을 교환했습니다. ',
            3: '<b style=\'color:replace_color\'>couple_name</b> 듀오가 이 경기 구간에서 가장 많은 볼 패스를 한 조합이었으며, <b style=\'color:replace_color\'>connections_value</b>번의 기회에서 그렇게 했습니다. '
          },
          twoMaxConnections: {
            1: '<b style=\'color:replace_color\'>couple_name</b>과 <b style=\'color:replace_color\'>couple_name2</b>으로 구성된 두 조합이 이 기간 동안 가장 반복된 연결이었으며, 서로 <b style=\'color:replace_color\'>connections_value</b>번 볼을 패스했습니다. '
          },
          moreThanTwoMaxConnections: {
            1: '<b style=\'color:replace_color\'>couple_name</b>과 같은 선수 조합이 서로 <b style=\'color:replace_color\'>connections_value개의 패스</b>를 했습니다. '
          },
          oneMinConnections: {
            1: '반면에, 서로 가장 적게 패스를 한 것은 <b style=\'color:replace_color\'>couple_name</b>이었으며, 단지 <b style=\'color:replace_color\'>connections_value개의 패스</b>였습니다. ',
            2: '다른 극단으로, <b style=\'color:replace_color\'>couple_name</b>으로 구성된 탠덤은 단지 <b style=\'color:replace_color\'>connections_value</b>번만 연결했습니다. '
          },
          twoMinConnections: {
            1: '반면에, <b style=\'color:replace_color\'>couple_name</b>과 <b style=\'color:replace_color\'>couple_name2</b>은 서로 거의 패스를 교환하지 않았습니다 (<b style=\'color:replace_color\'>connections_value개의 패스</b>). '
          },
          moreThanTwoMinConnections: {
            1: '여러 조합이 충분히 연결하지 못했으며, <b style=\'color:replace_color\'>connections_value개의 패스</b>를 가진 <b style=\'color:replace_color\'>couple_name</b> 듀오와 같은 조합이 가장 드문 조합 중 하나입니다. '
          }
        }
      },
      step7: {
        ballPossession: '볼 소유',
        gamePossessionDist: '볼 점유율 분포'
      }
    },
    gamePossessionMap: {
      of: '의',
      to: '로',
      and: '및',
      endsWith: '종료',
      time: '시간',
      touches: '터치',
      passes: '패스',
      threat: '위협',
      xG: 'xG',
      xT: 'xT',
      minutes: '분',
      duration: '지속 시간',
      endsGoal: '골로 종료',
      endsInBox: '박스에서 종료',
      withShot: '슛 포함',
      withCross: '크로스 포함',
      possession: '볼 소유',
      events: '이벤트',
      filters: '필터',
      filtersWarning: '위협은 슛이 없는 볼 소유에만 적용됩니다',
      sumWarning: '필터는 시퀀스의 모든 슛의 xG 합계에 적용되므로 1보다 클 수 있습니다',
      show: '표시',
      sequenceNumbers: '시퀀스 번호',
      jerseyNumbers: '등번호',
      pass: '패스',
      carryAndPass: '볼 운반 및 패스',
      carryAndAction: '볼 운반 및 액션',
      carryAndShot: '볼 운반 및 슛',
      shotFailed: '실패한 슛',
      goal: '골',
      savedShot: '막힌 슛',
      missedShot: '빗나간 슛',
      shotOnPost: '골대 맞춘 슛',
      headerGoal: '헤딩 골',
      headerFailed: '실패한 헤딩',
      failed: '실패',
      with: '~와 함께'
    },
    report: {
      title: '경기 리포트',
      maps: '맵',
      xGRace: 'xG 레이스',
      lineups: '라인업',
      button: '경기의 전체 PDF 리포트 생성',
      mobileButton: 'PDF 리포트',
      most: '최다',
      topXPlayers: '상위 {x}명 선수',
      mobileButtonXY: 'XY report',
      mobileButtonPD: 'PD report',
      pDReportTitle: '게임 물리적 데이터 보고서'
    },
    avgScoreTooltip: '분당 평균 점수',
    status: {
      scheduled: '예정됨',
      postponed: '연기됨',
      cancelled: '취소',
      inPlay: '살다',
      finished: '완성된',
      awarded: '수상',
      dataAvailable: '다음 시간 내에 데이터를 사용할 수 있습니다.'
    },
    preGameAnalysis: {
      showExpectations: '기대를 보여주세요',
      hideExpectations: '기대 숨기기',
      goalsPeriods: '목표 기간',
      synergyIndex: '시너지지수',
      synergyIndexSubtitle: '통행인과 피니셔 연결의 전반적인 강도'
    }
  },
  general: {
    1: '하나',
    2: '둘',
    3: '셋',
    4: '넷',
    5: '다섯',
    8: '왼쪽',
    9: '양쪽',
    10: '오른쪽',
    create: '생성',
    save: '저장',
    cancel: '취소',
    delete: '삭제',
    edit: '편집',
    reset: '다시 놓기',
    go: '이동',
    formErrors: {
      required: '필드는 필수입니다',
      passwordMatch: '비밀번호가 일치하지 않습니다',
      minLength: '최소 길이',
      maxLength: '최대 길이',
      emailValid: '이메일이 유효해야 합니다',
      youthAge: '나이는 10세와 23세 사이여야 합니다',
      seasonYear: '연도는 2016년과 2050년 사이여야 합니다',
      integer: '소수는 허용되지 않습니다'
    },
    confirmationTitle: '확실합니까?',
    confirmationMessage: '작업을 수행하려면 확인해주세요',
    yes: '예',
    no: '아니오',
    search: '검색',
    clearFilters: '필터 지우기',
    minimum: '최소',
    maximum: '최대',
    minimumPercent: '(%)최소 비율',
    period: '시간',
    exclude: '제외',
    team: '팀',
    clear: '지우기',
    all: '전체',
    ground1: '전체',
    ground2: '홈',
    ground3: '원정',
    filter: '필터',
    noData: '결과를 찾을 수 없습니다',
    noDataGivenFilters: '주어진 필터로 결과를 찾을 수 없습니다',
    similarityMinutesWarning: '450분 미만 출전으로 데이터가 없습니다',
    templateOnlyEditable: '템플릿은 다음 사용자만 편집할 수 있습니다 ',
    close: '닫기',
    load: '로드',
    filters: '필터',
    players: '선수',
    teams: '팀',
    compare: '비교',
    seeMore: '더보기',
    seeLess: '간략히',
    request: '요청',
    notes: '메모',
    closeSession: '종료',
    settings: '설정',
    player: '선수',
    state: '상태',
    updated: '업데이트됨',
    file: '파일',
    uploadFile: '파일 업로드',
    reports: '리포트',
    download: '다운로드',
    new: '새로 만들기',
    comparison: '비교',
    scout: '스카우트',
    favorites: '즐겨찾기',
    moreOptions: '더 많은 옵션',
    lessOptions: '더 적은 옵션',
    today: '오늘',
    home: '홈',
    away: '원정',
    until: '까지',
    firstHalf: '전반',
    secondHalf: '후반',
    firstPeriodOT: '연장 전반',
    secondPeriodOT: '연장 후반',
    postponed: '연기됨',
    stats: '통계',
    yesterday: '어제',
    last: '마지막',
    startDate: '시작일',
    active: '활성',
    playerLimit: '선수 제한',
    type: '유형',
    successMessage: '작업이 성공했습니다',
    failMessage: '작업이 실패했습니다',
    by: '작성자',
    checkYourInbox: '받은편지함을 확인하세요',
    faq: '용어집',
    globalSearch: '전역 검색',
    gamesLost: '누락된 경기',
    outOf: '중',
    avgSeason: '시즌 평균',
    leftDays: '남은 일수',
    notifyError: '오류 알림',
    notify: '알림',
    comments: '댓글',
    searches: '검색',
    now: '지금',
    twoHoursAgo: '2시간 전',
    incomings: '입단',
    departures: '이적',
    transferLoans: '임대',
    transfers: '이적',
    movements: '이동',
    incomes: '수입',
    expenditures: '지출',
    action: '액션',
    target: '대상',
    uses: '사용',
    users: '사용자',
    since: '부터',
    mediaMode: '미디어 모드',
    white: '흰색',
    enabled: '활성화됨',
    disabled: '비활성화됨',
    left: '왼쪽',
    right: '오른쪽',
    both: '양쪽',
    'left-both': '왼쪽 양쪽',
    'right-both': '오른쪽 양쪽',
    'left foot': '왼발',
    'right foot': '오른발',
    files: '파일',
    confirm: '확인',
    currentStep: '현재 단계',
    phases: '단계',
    entries: '항목',
    none: '없음',
    times: '회',
    darkMode: '다크 모드',
    client: '클라이언트',
    visits: '방문',
    lastVisit: '마지막 방문',
    strong: '강함',
    medium: '중간',
    weak: '약함',
    goal: '골',
    list: '목록',
    map: '맵',
    copiedToClipboard: '클립보드에 복사됨',
    division: '디비전',
    many: '많음',
    few: '적음',
    median: '중앙값',
    topRight: '상단 오른쪽',
    topLeft: '상단 왼쪽',
    bottomRight: '하단 오른쪽',
    bottomLeft: '하단 왼쪽',
    library: '라이브러리',
    mediaLibrary: '미디어 라이브러리',
    for: '대상',
    stat: '통계',
    position: '포지션',
    order: '순서',
    add: '추가',
    visualization: '시각화',
    basic: '기본',
    selectAll: '전체 선택',
    unselectAll: '전체 선택 해제',
    distribution: '분포',
    end: '종료',
    accuracy: '정확도',
    opponent: '상대',
    ownTeam: '자신의 팀',
    center: '중앙',
    line: '라인',
    live: '라이브',
    unavailable: '사용 불가',
    calendar: '캘린더',
    activeLeague: '진행 중인 리그',
    similarity: '유사도',
    emptyForSelectAll: '전체 선택하려면 비워두세요',
    size: '크기',
    selectPlayersRestriction: '1명과 {x}명 사이의 선수를 선택하세요',
    group: '그룹',
    alerts: '알림',
    shortcuts: '단축키',
    share: '공유',
    dataAvailable: '데이터가 곧 제공됩니다',
    someStatsAvailableSoon: '일부 통계가 곧 제공됩니다',
    monthGamesWarning: '선택한 월의 경기가 곧 제공됩니다',
    metrics: '지표',
    competition: '대회',
    code: '코드',
    alias: '별칭',
    never: '없음',
    unlimited: '무제한',
    user: '사용자',
    warning: '경고',
    requests: '요청',
    contactSales: '영업팀 문의',
    comingSoon: '곧 출시 예정!',
    firstPost: '1번 포스트',
    secondPost: '2번 포스트',
    dZone: 'D 존',
    penaltySpot: '페널티 스팟',
    secondPlay: '2차 플레이',
    otherZone: '기타 존',
    baseline: '베이스라인',
    youth: '유스',
    male: '남성',
    direct: '직접',
    indirect: '간접',
    processing: '처리 중',
    addNew: '새로 추가',
    createdBy: '작성자',
    downloading: '다운로드 중',
    displayType: '표시 유형',
    alreadyExists: '이미 존재합니다',
    aggregation: '집계',
    unavailableLeagues: '선수가 출전한 리그 중 접근할 수 있는 리그가 없습니다',
    meters: '미터',
    quantity: '수량',
    allTime: '전체 시간',
    games: '경기',
    unit: '단위',
    categories: '카테고리',
    maintenanceWarning: '유지보수 진행 중',
    maintenanceMessage: '일부 업데이트를 진행 중입니다. 지금 변경한 내용은 저장되지 않습니다. 양해해 주셔서 감사합니다!',
    seeAll: '전체 보기',
    from: '에서',
    to: '에게',
    showFilters: '필터 표시',
    hideFilters: '필터 숨기기',
    horizontal: '수평의',
    vertical: '수직의',
    drop: '떨어지다',
    orientation: '정위',
    goalProbability: '골 확률',
    assistProbability: '어시스트 확률',
    attackingDirection: '공격 방향',
    currentTeam: '현재 팀',
    expectations: '기대',
    sideBySide: '나란히',
    teamValue: '팀 가치',
    fieldLayout: '필드 레이아웃',
    searchPlaceholder: 'Type {x} letters at least to search',
    crests: '문장',
    pcts: 'PCT'
  },
  playerScout: {
    dlabDatabase: '드리블랩 데이터베이스',
    league: '리그',
    top5: '상위 5개',
    topCountries: '국가',
    tier: '티어',
    division1: '1부 리그',
    division2: '2부 리그',
    division3: '3부 리그',
    division4: '4부 리그',
    division5: '5부 리그',
    division6: '6부 리그',
    summary: '요약',
    offensive: '공격',
    defensive: '수비',
    gk: 'GK',
    all: '전체',
    physical: '신체',
    arrigo: '아리고',
    yearTooltip: '한 해만 허용됨',
    expectedThreat: '예상 위협',
    expectedThreatTooltip: '모든 볼 소유에 추가된 위협',
    expectedThreatOP: '예상 위협 오픈 플레이',
    expectedThreatOPTooltip: '오픈 플레이 볼 소유에 추가된 위협',
    expectedThreatInTeam: '팀 내 예상 위협 비율',
    expectedThreatInTeamTooltip: '선수가 팀에 추가한 위협 비율',
    ballProgression: '볼 진행',
    ballProgressionTooltip: '+10미터 진행',
    deepProgression: '깊은 진행',
    deepProgressionTooltip: '마지막 5분의 1로의 볼 진행',
    ballRetention: '볼 보유 비율',
    ballRetentionTooltip: '볼이 성공적으로 보유된 액션 비율',
    ballRetentionOppHalf: '상대 진영 볼 보유 비율',
    ballRetentionOppHalfExplicit: '볼을 소유하고 상대 진영에서 잃지 않은 시간 비율',
    finishing: '피니싱',
    finishingTooltip: '골로 연결된 슛 비율',
    scoringContribution: '득점 기여',
    scoringContributionTooltip: '어시스트 + 골',
    xgPerShot: '슛당 xG',
    xgPerGoal: '골당 xG',
    headerPerCross: '크로스당 헤딩',
    completedCrosses: '성공한 크로스',
    crossingPct: '크로스 성공률',
    crossingEfficiency: '크로스 효율',
    crossingEfficiencyTooltip: '크로스 효율 (품질과 수량 측정)',
    longBalls: '롱볼',
    longPassing: '롱볼 성공률',
    dribblingPct: '드리블 성공률',
    throughBalls: '스루패스',
    oppBoxTouches: '상대 박스 터치',
    oppBoxTouchesTooltip: '상대 박스 내 터치',
    openPlayKeyPasses: '오픈 플레이 키패스',
    openPlayKeyPassesTooltip: '슛으로 연결된 오픈 플레이 패스',
    xGBuildup: 'xG 빌드업',
    xGBuildupTooltip: '선수가 관여한 슛으로 끝난 시퀀스의 xG (슛과 키패스의 xG 제외)',
    Assists: '어시스트',
    passPercentage: '패스 성공률',
    passPerLongBall: '롱볼당 패스',
    passPerLongBallExplicit: '롱볼당 패스',
    nonPenaltyGoals: '페널티 제외 골',
    xG: 'xG',
    xGExplicit: '예상 골',
    shots: '슛',
    xGShot: '슛당 xG',
    xGChain: 'xG 체인',
    xGChainTooltip: '선수가 관여한 슛으로 끝난 시퀀스의 xG',
    chancesCreated: '슛으로 연결된 패스',
    chances: '기회',
    dribbles: '드리블',
    dribblesSuccessfull: '성공한 드리블',
    touches: '상대 박스 터치',
    xA: 'xA',
    xAExplicit: '예상 어시스트',
    xAOpenPlay: 'xA 오픈 플레이',
    xAOpenPlayExplicit: '예상 어시스트 오픈 플레이',
    passesOpponentBox: '상대 박스 내 패스',
    passesOB: '상대 박스 내 패스',
    passesFinalThirdTooltip: '최종 3분의 1 패스',
    passesSuccessful: '성공한 패스',
    passesSuccessfulTooltip: '성공한 패스',
    ballProgressionPassing: '패스로 볼 진행',
    ballProgressionPassingTooltip: '패스로 볼 진행',
    ballProgressionDribbling: '볼 운반으로 진행',
    ballProgressionDribblingTooltip: '볼 운반으로 진행',
    passesTotal: '패스',
    passesTotalTooltip: '시도한 패스 총 수',
    shortPassesSuccessful: '성공한 짧은 패스',
    shortPassesSuccessfulTooltip: '완료한 짧은 패스 수',
    shortPassesTotal: '짧은 패스 총 수',
    shortPassesTotalTooltip: '시도한 짧은 패스 수',
    tackles: '태클 *',
    adjustedTackles: '점유율 기준 조정 태클',
    interceptions: '인터셉트 *',
    adjustedInterceptions: '점유율 기준 조정 인터셉트',
    aerials: '공중볼 경합',
    aerialsPercent: '공중볼 성공률',
    aerialEfficiency: '공중볼 효율',
    aerialEfficiencyTooltip: '공중볼 효율 (품질과 수량 측정)',
    twd: 'TwD',
    tacklesWasDribbled: '수비 1대1 승리',
    fouls: '파울',
    indPressure: '개인 압박',
    pressure: '압박',
    dispossessed: '볼 소유권 이탈',
    recoveries: '볼 회수',
    primary: '주 포지션',
    secondary: '보조 포지션',
    position: '포지션',
    nationality: '국적',
    height: '키 (cm)',
    minHeight: '최소 키',
    maxHeight: '최대 키',
    age: '나이',
    minAge: '최소 나이',
    maxAge: '최대 나이',
    games: '경기',
    minGames: '최소 경기',
    maxGames: '최대 경기',
    minutes: '분',
    minMinutes: '최소 분',
    maxMinutes: '최대 분',
    minPercentMinutes: '최소 분 비율',
    dates: '날짜',
    marketValue: '(유로) 시장 가치',
    teams: '팀',
    contractEnd: '계약 종료',
    minValue: '최소 가치',
    maxValue: '최대 가치',
    excludeTeams: '팀 제외',
    recentSearches: '최근 검색',
    saveSearch: '검색 저장',
    loadSearch: '검색 로드',
    loadCollection: '컬렉션 로드',
    collection: '컬렉션',
    search: '검색',
    searchesList: '검색 목록',
    mySearches: '내 검색',
    mySearchesDescription: '이전에 저장한 검색',
    recentSearchesDescription: '최근 10개 검색',
    searchToLoad: '로드할 검색',
    recentSearch: '최근 검색',
    saveSearchSuccess: '검색이 성공적으로 저장되었습니다',
    removeSearch: '검색 삭제',
    removeSearchMessage: '검색을 삭제하시겠습니까?',
    updateSearch: '검색 업데이트',
    updateSearchMessage: '검색을 업데이트하시겠습니까?',
    deleteSearchSuccess: '검색이 삭제되었습니다',
    playersFound: '명의 선수 발견',
    addToCollection: '컬렉션에 추가',
    npg: '페널티 제외 골',
    goals: '골',
    value: '가치',
    nationalTeams: '국가대표',
    gbeScore: 'GBE',
    dlIndex: '점수',
    minGbe: '최소 GBE',
    goalsConceded: '실점',
    npgConceded: '페널티 제외 실점',
    npgConcededTooltip: '페널티 제외 실점',
    xGOTConceded: '대면 유효 슛 xG',
    xGOTConcededTooltip: '대면 유효 슛의 xG',
    goalsPrevented: '방어한 골',
    xGFacedPerShotOnTarget: '슛당 대면 유효 슛 xG',
    xGFacedPerShotOnTargetTooltip: '허용한 슛당 대면 유효 슛 xG',
    xGSavedPerxGFacedOnTarget: 'xG 세이빙',
    xGSavedPerxGFacedOnTargetTooltip: 'xG를 고려한 세이브 비율',
    savesPct: '세이브 성공률',
    savesOutOfBoxPct: '박스 밖 세이브 성공률',
    savesInBoxPct: '박스 안 세이브 성공률',
    xGFacedPerGoal: '골당 대면 xG',
    xGFacedPerGoalTooltip: '골을 넣기 위해 필요한 xG',
    catchingPct: '캐칭 성공률',
    catchingTooltip: '잡은 세이브 비율',
    passingOwnHalfPct: '자신 진영 패스 성공률',
    passingOwnHalfPctTooltip: '자신 진영에서 성공한 패스 비율',
    passingOppHalfPct: '상대 진영 패스 성공률',
    passingOppHalfPctTooltip: '상대 진영에서 성공한 패스 비율',
    passingContribution: '패스 기여 비율',
    passingContributionTooltip: '패스로 추가한 위협 기여 - 평균 이상',
    shotsPerGoal: '골당 슛',
    passesFinalThird: '최종 3분의 1 패스',
    passingFinalThird: '최종 3분의 1 패스 성공률',
    claimAccuracy: '클레임 정확도',
    claimAccuracyTooltip: '평균 이상으로 클레임한 볼',
    highTurnovers: '높은 볼 소유권 이탈',
    highTurnoversTooltip: '골에서 40미터 이내 볼 소유권 이탈',
    shotEndingHighTurnovers: '슛으로 끝난 높은 볼 소유권 이탈',
    shotEndingHighTurnoversTooltip: '슛으로 끝난 높은 볼 소유권 이탈',
    goalEndingHighTurnovers: '골로 끝난 높은 볼 소유권 이탈',
    goalEndingHighTurnoversTooltip: '골로 끝난 높은 볼 소유권 이탈',
    avgCarriesProgress: '평균 진행',
    avgCarriesProgressTooltip: '볼을 수직으로 이동한 평균 거리 (미터)',
    carriesChance: '기회로 끝난 볼 운반',
    carriesChanceTooltip: '키패스로 연결된 볼 운반',
    carriesAssist: '어시스트로 끝난 볼 운반',
    carriesAssistTooltip: '어시스트로 연결된 볼 운반',
    carriesShot: '슛으로 끝난 볼 운반',
    carriesShotTooltip: '슛으로 연결된 볼 운반',
    carriesGoal: '골로 끝난 볼 운반',
    carriesGoalTooltip: '골로 연결된 볼 운반',
    shotEndingSequence: '슛으로 끝난 시퀀스',
    shotEndingSequenceTooltip: '선수가 관여한 슛으로 끝난 시퀀스 수',
    goalEndingSequence: '골로 끝난 시퀀스',
    goalEndingSequenceTooltip: '선수가 관여한 골로 끝난 시퀀스 수',
    gbeScoreTooltip: 'FA 축구 관리 기관 승인',
    goalsPreventedTooltip: '골키퍼가 방어한 페널티 제외 골 (대면 xG - 페널티 제외 실점)',
    freePlayers: '자유 계약 선수',
    index: '지수',
    playerName: '이름',
    teamName: '팀',
    secondPos: '보조 포지션',
    side: '측면',
    onlyOnLoan: '임대만',
    dob: '생년월일',
    countryName: '국가',
    secondCountryName: '두 번째 국가',
    seasonYear: '시즌',
    assists: '어시스트',
    placeholder: '리그 필터를 추가하기 시작할 수 있습니다',
    placeholder2: '검색 버튼을 클릭하여 결과 표시',
    passesPct: '패스 성공률',
    passingPct: '패스 성공률',
    oppBoxPasses: '상대 박스 내 패스',
    adjustedClearances: '조정된 클리어런스',
    aerialsPct: '공중볼 성공률',
    leagueCountryCode: '리그 국가 코드',
    shooting: '유효 슛 비율',
    xtPassing: '패스로 추가한 위협',
    xtPassingTooltip: '패스로 추가한 위협',
    xtDribbling: '볼 운반으로 추가한 위협',
    xtDribblingTooltip: '볼 운반으로 추가한 위협',
    foot: '주발',
    aggressiveActions: '공격적 액션',
    aggressiveActionsTooltip: '볼 소유권을 잃은 후 다음 2초 내에 시도한 태클 수',
    tacklesAttempted: '시도한 태클 총 수',
    highDefensiveActionPct: '높은 수비 액션 비율',
    highDefensiveActionPctTooltip: '상대 골에서 40미터 이내에서 한 수비 액션 비율',
    individualPressureOppHalf: '상대 진영 압박',
    individualPressureOppHalfTooltip: '상대 진영에서 상대를 압박할 때 선수가 한 성공적인 노력(볼 회수) 수를 측정하는 지표',
    xGBuildUp5Pass: 'xG 빌드업 5패스',
    xGBuildUp5PassTooltip: '선수가 관여한 xG 양, 마지막 5개 패스만 (슛과 슛으로 연결된 패스 제외)',
    chancesCreatedOpenPlay: '오픈 플레이에서 만든 기회',
    chancesCreatedOpenPlayTooltip: '오픈 플레이 중 슛으로 연결된 패스 수',
    fmf: {
      Defender: '수비수',
      aerial: '공중볼',
      goodDefender: '좋은 수비수',
      goodPresence: '좋은 존재감',
      playmaking: '플레이메이킹',
      Fullback: '풀백',
      defensiveness: '수비성',
      offensiveness: '공격성',
      fast: '빠름',
      Forward: '공격수',
      goalChances: '골 기회',
      goodDecissions: '좋은 판단',
      individualTechnique: '개인 기술',
      Goalkeeper: '골키퍼',
      footWork: '발 기술',
      leadership: '리더십',
      Midfielder: '수비형 미드필더',
      balance: '균형',
      ballRetention: '볼 보유 비율',
      offensivePasses: '공격 패스',
      recoveries: '볼 회수',
      shotToGoal: '슛 대 골',
      'Attacking-Midfielder': '공격형 미드필더',
      defensiveGame: '수비 게임',
      offensiveGame: '공격 게임',
      Winger: '윙어',
      crossing: '크로스',
      deepProgressions: '깊은 진행',
      defendingEffort: '수비 노력',
      facing: '대면'
    },
    yellowCards: '옐로카드',
    redCards: '레드카드',
    alert: '알림',
    yearOfBirth: '출생 연도',
    minYearOfBirth: '최소 출생 연도',
    maxYearOfBirth: '최대 출생 연도',
    women: '여자',
    continental: '대륙',
    countryCup: '국가 컵',
    statsName: '통계 이름',
    abbreviation: '약어',
    abbr: {
      position: 'POS',
      secondPos: 'SP',
      seasonYear: 'SY',
      marketValue: 'MV(€)',
      contractEnd: 'CE',
      height: 'H(cm)',
      side: 'SD',
      strongFoot: 'SF',
      games: 'G'
    },
    warningRegularSeason: '마지막 정규 시즌 플레이만 표시',
    gamesWith60PlusMinsTooltip: '60분 이상 플레이하는 최소 게임 수',
    starts: '시작',
    minGPI: 'Min. GPI',
    maxGPI: 'Max. GPI',
    tertiary: 'Tertiary'
  },
  playerComparison: {
    upTo5Players: '최대 5명의 선수 비교',
    requestReport: '리포트 요청',
    searchBarPlaceholder: '선수 또는 팀 검색',
    allStats: '모든 통계',
    placeholder: '선수를 추가하기 시작할 수 있습니다'
  },
  reports: {
    detailedInsights: '상세한 인사이트 얻기',
    features: '리포트 기능',
    performance: '성과',
    evolution: '진화',
    compareWithMyTeam: '내 팀과 비교',
    similarPlayers: '유사한 선수',
    potentialTeams: '잠재적 팀',
    requestSuccess: '요청이 성공적으로 전송되었습니다',
    requestAt: '요청됨',
    reportConversation: '리포트 대화',
    writeYourMessage: '메시지를 작성하세요...',
    you: '당신'
  },
  state: {
    requested: '요청됨',
    inProgress: '진행 중',
    delivered: '전달됨'
  },
  langs: {
    es: '스페인어',
    en: '영어',
    fr: '프랑스어',
    de: '독일어',
    it: '이탈리아어',
    pt: '포르투갈어',
    tr: '터키어',
    jp: '일본어',
    cn: '중국어',
    sa: '아랍어',
    nl: '넷어',
    pl: '피썬어',
    sv: '스위스어',
    cs: '쇼구어',
    ko: '코어',
    hu: '휘어',
    ru: '루시아어'
  },
  langsArea: {
    europe: '유럽',
    asia: '아시아',
    arabic: '아라비아 말'
  },
  inbox: {
    subtitle: '최신 정보 유지',
    new_injury_alert: '새 부상 알림',
    new_contract_alert: '새 계약 알림',
    new_team_alert: '새 이적 알림',
    new_marketValue_alert: '새 시장 가치 알림',
    new_game_alert: '새 경기 출전 알림',
    receive_mail: '이메일 수신',
    receive_mail_subtitle: '필터를 만족하는 선수와 함께 일일 이메일 수신',
    receive_notifications: '알림',
    receive_notifications_subtitle: '필터를 만족하는 선수와 함께 앱에서 알림 수신',
    changedTo: '변경됨',
    alerts: '알림',
    includedIn: '포함됨',
    noContract: '계약 없음',
    newMessages: '새 메시지',
    reply: {
      reply: '답장',
      replyTitle: '클라이언트에게 피드백 제공:',
      replyPlaceholder: '사용자는 상태 업데이트와 함께 답장을 받게 됩니다'
    }
  },
  gameAnalysis: {
    subtitle: '최근 경기에서 인사이트 얻기',
    subtitle2: '다음 7일간의 경기 표시',
    subtitle3: '최근 경기에서 인사이트를 얻고 다음 경기를 탐색하세요',
    seeDetail: '자세히 보기'
  },
  statsNaming: {
    Possession: '볼 소유율',
    TimePossession: '볼 소유 시간',
    PassesPerShots: '슛당 패스',
    PPDA: 'PPDA',
    ExpectedPoints: '예상 득점',
    Points: '득점',
    Directness: '직접성',
    PassesPerLongBall: '롱볼당 패스',
    CrossingPerXG: 'xG당 크로스',
    PenaltySavedPenaltyFaced: '페널티 세이브/페널티 대면',
    Goals: '골',
    PenaltyShots: '페널티 슛',
    PenaltyGoals: '페널티 골',
    NonPenaltyGoals: '페널티 제외 골',
    NPGOpenPlay: '페널티 제외 골 오픈 플레이',
    NPGSetPiece: '페널티 제외 골 세트피스',
    Shooting: '슈팅',
    Finishing: '피니싱',
    xGEfficiency: 'xG 효율',
    HeaderPerShot: '슛당 헤딩',
    HeaderPerCross: '크로스당 헤딩',
    HeadedGoals: '헤딩 목표',
    GoalsConceded: '실점한 골',
    SavesInBox: '상자에 저장',
    SavesOutBox: '즉시 사용 가능',
    Assists: '어시스트',
    ThroughBalls: '스루패스',
    CrossEfficiency: '크로스 효율',
    ScoringContribution: '득점 기여',
    xAssistsOpenPlay: '예상 어시스트 오픈 플레이',
    xAssistsSetPiece: '예상 어시스트 세트피스',
    xAssistsOpenPlayInTeam: '팀 내 예상 어시스트 오픈 플레이',
    xAssistsSetPieceInTeam: '팀 내 예상 어시스트 세트피스',
    xGBuildupFinalThird: 'xG 빌드업 최종 3분의 1',
    xGChainFinalThird: 'xG 체인 최종 3분의 1',
    BallProgressionPassing: '패스로 볼 진행',
    BallProgressionDribbling: '볼 운반으로 진행',
    TacklesWasDribbled: '태클/드리블 허용',
    TacklesSuccessful: '성공한 태클',
    Interceptions: '인터셉트',
    Clearances: '클리어런스',
    Fouls: '파울',
    Recoveries: '볼 회수',
    Shots: '슛',
    ShotsPerGoal: '골당 슛',
    ShortPassesSuccessful: '성공한 짧은 패스',
    PassingSuccessForwardPct: '전진 패스 성공률',
    PassingSuccessBackwardPct: '후진 패스 성공률',
    PassingForwardBackwardPct: '전진 패스 대 후진 패스 비율',
    LongBallPerPassesPct: '패스당 롱볼 비율',
    LongBallReceived: '받은 롱볼',
    LongBallReceivedOppHalf: '상대 진영에서 받은 롱볼',
    OffensiveActions: '공격 액션',
    DribblesAttempted: '시도한 드리블',
    SuccessfulDribblesPct: '드리블 성공률',
    OffensiveTouchesOutBoxPct: '박스 밖 공격 터치 비율',
    BallRetention: '볼 보유 비율',
    PassingPct: '패스 성공률',
    PassingOwnHalfPct: '자신 진영 패스 성공률',
    PassingOppHalfPct: '상대 진영 패스 성공률',
    PassingFinalThird: '최종 3분의 1 패스',
    PassesFinalThirdTotal: '총 패스 결승 ⅓',
    PassingFinalThirdPct: '최종 3분의 1 패스 성공률',
    LongBallSuccessful: '성공한 롱볼',
    LongBallPct: '롱볼 성공률',
    LongBallTotal: '총 긴 공',
    SavesPct: '세이브 성공률',
    SavesInBoxPct: '박스 안 세이브 성공률',
    SavesOutOfBoxPct: '박스 밖 세이브 성공률',
    xGSavedPerXGFacedOnTarget: '대면 유효 슛 xG 세이브/대면 xG',
    xGFacedOnTargetPerGoalReceived: '골당 대면 xG',
    xGFacedOnTargetEfficiency: '방어한 예상 실점',
    xGFacedOnTarget: '대면 유효 슛 xG',
    IndividualPressure: '개인 압박',
    AerialEfficiency: '공중볼 효율',
    AerialWins: '공중볼 승리',
    AerialWinsPct: '공중볼 승리 비율',
    xG: '예상 골',
    xGDiff: 'xG 차이',
    xGOpenPlay: '예상 골 오픈 플레이',
    xGSetPiece: '예상 골 세트피스',
    xGPerShot: '슛당 xG',
    ChancesCreated: '만든 기회',
    CompletedCrosses: '성공한 크로스',
    Crossing: '크로스 성공률',
    OpenPlayKeyPasses: '오픈 플레이 키패스',
    OpenPlayKeyPassesInTeam: '팀 내 오픈 플레이 키패스 비율',
    OpenPlayPassesIntoOpponentBox: '오픈 플레이 상대 박스 내 패스 총 수',
    OpenPlayPassesIntoOpponentBoxSuccessful: '오픈 플레이 상대 박스 내 패스',
    xAssists: '예상 어시스트',
    xGChain: 'xG 체인',
    xGBuildup: 'xG 빌드업',
    xGBuildupInTeam: '팀 내 xG 빌드업',
    BallProgression: '볼 진행',
    SuccessfulDribbles: '성공한 드리블',
    Dispossessed: '볼 소유권 이탈',
    TouchesInOpponentBox: '상대 박스 내 터치',
    xGSavedPerShot: '슛당 xG 세이브',
    BallRetentionOppHalf: '상대 진영 볼 보유 비율',
    DeepProgression: '깊은 진행',
    DeepProgressionFinalThird: '최종 3분의 1 깊은 진행',
    FoulsTaken: '받은 파울',
    PenaltiesTaken: '받은 페널티',
    BlockedCrosses: '막힌 크로스',
    BlockedShots: '막힌 슛',
    Blocks: '블록',
    NonPenaltyGoalsAgainst: '페널티 제외 실점',
    Headers: '헤딩',
    AveragePassDistance: '평균 패스 거리',
    ProgressiveRuns: '진행 볼 운반',
    xT: '예상 위협 (xT)',
    xTOpenPlay: '예상 위협 오픈 플레이',
    xTSetPiece: '예상 위협 세트피스',
    xGOT: '대면 유효 슛 예상 골',
    BadActions: '나쁜 액션',
    BadActionsOwnHalf: '자신 진영 나쁜 액션',
    AerialsWonOwnBox: '자신 박스 내 공중볼 승리',
    AerialsWonOppBox: '상대 박스 내 공중볼 승리',
    AerialsTotalOppBox: '상대 박스 내 총 공중볼 경합',
    AerialsTotalOwnBox: '자신 박스 내 총 공중볼 경합',
    FoulsOwnHalfPct: '자신 진영 반칙 비율',
    RecoveriesOppHalf: '상대 진영 볼 회수',
    DuelsPct: '경합 성공률',
    TacklesUnsuccessful: '실패한 태클',
    TacklesWasDribbledFirstThird: '1/3 수비 1대1 승리',
    TacklesWasDribbledSecondThird: '2/3 수비 1대1 승리',
    TacklesWasDribbledFinalThird: '최종 1/3 수비 1대1 승리',
    BallProgressionFinalThird: '최종 1/3 볼 전진',
    DuelsTotal: '총 경합',
    QuickRecoveries: '빠른 볼 회수',
    ShotsPerNPG: '논페널티골당 슛',
    ShotsOutBox: '박스 밖 슛',
    GoalsOutBox: '박스 밖 골',
    ShootingOutBox: '박스 밖 슈팅 비율',
    HandPassing: '핸드 패스 성공률',
    Catching: '캐치 성공률',
    Caught: '적발 저장',
    ClaimAccuracy: '공 차지 정확도',
    HighTurnovers: '하이 턴오버',
    ShotEndingHighTurnovers: '슛으로 마무리된 하이 턴오버',
    GoalEndingHighTurnovers: '골로 마무리된 하이 턴오버',
    AverageCarriesProgress: '평균 볼 운반 진척',
    ChanceEndingCarries: '찬스로 끝난 볼 운반',
    AssistEndingCarries: '어시스트로 끝난 볼 운반',
    ShotEndingCarries: '슛으로 끝난 볼 운반',
    GoalEndingCarries: '골로 끝난 볼 운반',
    ShotEndingSequence: '슛으로 끝난 시퀀스',
    GoalEndingSequence: '골로 끝난 시퀀스',
    xGPerNPG: '논페널티골당 xG',
    AerialWonOffensive: '공격 시 공중볼 승리',
    AerialWonDefensive: '수비 시 공중볼 승리',
    xGAgainst: '실점 xG',
    xGDiffAgainst: '실점 xG 차이',
    xGPerNPGAgainst: '실점 논페널티골당 xG',
    xGSetPieceAgainst: '실점 세트피스 xG',
    xGOpenPlayAgainst: '실점 오픈플레이 xG',
    xGPerShotAgainst: '실점 슛당 xG',
    ShotsAgainst: '허용 슛',
    ShotsOnTargetAgainst: '허용 유효슛',
    ShotsOnTargetInBoxAgainst: '박스 안의 유효 슛 허용',
    ShotsOnTargetOutBoxAgainst: '아웃 오브 박스 유효 슈팅',
    RivalPossession: '상대팀 점유율',
    AerialDefensivePct: '수비 공중볼 성공률',
    HighRecoveries: '하이 리커버리',
    HighDefensiveActions: '하이 수비 액션',
    HighDefensiveActionPct: '하이 수비 액션 성공률',
    HighDefensiveDistance: '하이 수비 거리',
    PassesPerPossession: '점유당 패스 수',
    LengthPerPossession: '점유당 이동 거리',
    xTNet: '순 xT',
    AvgCarriesDistance: '평균 볼 운반 거리',
    PassesForwardPct: '전방 패스 비율',
    PassesForwardSuccessful: '성공적인 포워드 패스',
    PassesForwardTotal: '총 포워드 패스',
    TacklesAttempted: '시도된 태클',
    DuelsLost: '패한 경합',
    Carries: '볼 운반',
    CarriesPct: '볼 운반 비율',
    Aerials: '공중볼 경합',
    ProgressivePassesReceivedIntoBox: '박스 내 전진 패스 수신',
    PassesOppHalf: '상대 진영 패스',
    ShotsOnTarget: '유효 슛',
    AggressiveActions: '공격적인 액션',
    Crosses: '크로스',
    xGBuildup5pass: 'xG 빌드업 5회 패스',
    SpeedSequence: '시퀀스 속도',
    Touches: '터치 수',
    AerialsTotalOppHalf: '상대 진영 총 공중볼 경합',
    AerialsWonOppHalf: '공중선 원 Opp. 반',
    AerialsWonOppHalfPct: '상대 진영 공중볼 승리 비율',
    AerialsPctOppBox: '상대 박스 내 공중볼 승리 비율',
    AerialsPctOwnBox: '자신 박스 내 공중볼 승리 비율',
    AerialDefensive: '수비 공중볼',
    AerialOffensive: '공격 공중볼',
    AerialOffensivePct: '공격 공중볼 성공률',
    IndividualPressureOppHalf: '상대 진영 개인 압박',
    ChancesCreatedOP: '오픈플레이 만든 찬스',
    TouchesPerShot: '슛당 터치',
    PassesFinalThirdTotalPct: '최종 1/3 패스 비율',
    xACrosses: '크로스 xA',
    Passes: '패스',
    PassesSuccessful: '성공한 패스',
    TacklesWasDribbledFouls: '지상 경합 비율',
    OffsidesCaught: '오프사이드 적발',
    ProgressivePassesReceivedFinalThird: '최종 1/3 전진 패스 수신',
    ProgressivePassesReceived: '전진 패스 수신',
    Breadth: '공간 넓이',
    DuelsDefTotal: '수비 경합',
    DefensiveActions: '수비 액션',
    ProgressivePassesReceivedOppHalf: '상대 진영 전진 패스 수신',
    CompletedCrossesOP: '오픈플레이 성공 크로스',
    CrossingOP: '오픈플레이 크로스 성공률',
    CrossesOP: '총 크로스 오픈 플레이',
    PassingContribution: '패스 기여도',
    BallProgressionOppHalfInTeam: '팀 내 상대 진영 볼 전진 비율',
    PassesOPIntoBoxInTeam: '팀 내 오픈플레이 박스 내 패스 비율',
    TouchesOppBoxInTeam: '팀 내 상대 박스 내 터치 비율',
    xGOPInTeam: '팀 내 오픈플레이 xG 비율',
    DeepPasses: '딥 패스',
    DeepPassesTotal: '딥 패스',
    DefensiveDuelsPct: '수비 경합 성공률',
    DefensiveDistance: '수비 거리',
    QuickRecoveriesPct: '빠른 볼 회수 비율',
    DiffDefensiveDistanceTeam: '팀 수비 거리 차이',
    xTPassing: 'xT 패싱',
    xTPassing100Passes: 'xT 100패스당 패싱',
    ProgressivePassesAccurate: '정확한 전진 패스',
    PassAbility: '패스 능력',
    OPPassesIntoOppBoxPct: '오픈플레이 상대 박스 내 패스 비율',
    EntriesOppBox: '상대 박스 진입',
    Crosses6yardBox: '6야드 박스 크로스',
    Cutbacks: '컷백',
    xTDribbling: 'xT 드리블링',
    AvgShotDistance: '평균 슛 거리',
    xGOnTarget: '유효슈팅 xG',
    FinishingxGOT: '피니싱 xGOT',
    DribblesWonOwnHalf: '자신 진영 드리블 성공',
    DribblesOwnHalf: '자신 진영 드리블',
    DribblesOwnHalfPct: '자신 진영 드리블 비율',
    DribblesWonOppHalf: '상대 진영 드리블 성공',
    DribblesOppHalf: '상대 진영 드리블',
    DribblesOppHalfPct: '상대 진영 드리블 비율',
    DribblesWonFinalThird: '최종 1/3 드리블 성공',
    DribblesFinalThird: '최종 1/3 드리블',
    DribblesFinalThirdPct: '최종 1/3 드리블 비율',
    ShotEndingHighRecoveries: '슛으로 끝난 하이 리커버리',
    PassingFinalThirdAgainst: '허용 최종 1/3 패스',
    OpenPlayPassesIntoOpponentBoxAgainst: '허용 오픈플레이 박스 내 패스 총 수',
    EntriesOppBoxAgainst: '허용 상대 박스 진입',
    DeepProgressionAgainst: '허용 딥 프로그레션',
    TouchesInOpponentBoxAgainst: '허용 상대 박스 내 터치',
    Score: '점수',
    PDScore: '피지컬 점수',
    OrlegiScore: '올레기 점수',
    SirScore: '시리우스 점수',
    ExcScore: '점수',
    xTOPInTeam: '팀 내 오픈플레이 xT 비율',
    YellowCards: '경고 카드',
    RedCards: '퇴장 카드',
    xTOpenPlayAgainst: '허용 오픈플레이 xT',
    xTSetPieceAgainst: '허용 세트피스 xT',
    NPGOpenPlayAgainst: '허용 오픈플레이 논페널티골',
    NPGSetPieceAgainst: '허용 세트피스 논페널티골',
    PassesOppHalfPerPossession: '점유당 상대 진영 패스 수',
    AverageTimeRecovery: '평균 볼 회수 시간',
    ExpectedPassing: '예상 패스 성공률',
    NumPossession10Passes: '10패스 이상 점유 수',
    PassesReceived: '받은 패스',
    PassesReceivedFinalThird: '최종 1/3 받은 패스',
    ProgressivePassesTotalPct: '전진 패스 비율',
    ShortPassesPct: '짧은 패스 비율',
    TouchesOppBoxOppTeam: '상대팀 상대 박스 터치',
    ShotsOnTargetOppTeam: '상대팀 유효슈팅',
    NPGOppTeam: '상대팀 논페널티골',
    ShotsOpenPlay: '오픈플레이 슛',
    xGSetPiecePerxG: '전체 xG 중 세트피스 xG 비율',
    ShotsOpenPlayAgainst: '허용 오픈플레이 슛',
    ShotsFromDribble: '드리블 후 슈팅',
    GoalsFromDribble: '드리블 후 득점',
    PassesIntoFinalThird: '파이널 서드로의 패스',
    PassesIntoFinalThirdTotal: '파이널 써드까지의 총 패스 수',
    PassesInsideFinalThird: '파이널 서드 내부 패스',
    PassesInsideFinalThirdTotal: '결승전 내 총 패스 ⅓',
    PassesFinalThirdNoArea: '파이널 3번째 통과(박스 없음)',
    PassesIntoOppBox: '상대 박스로의 패스',
    CarriesFinalThird: '파이널 서드로의 드리블',
    CarriesInsideFinalThird: '파이널 서드 내부 드리블',
    CarriesFinalThirdNoBox: 'Final Third 운반(박스 없음)',
    CarriesIntoOppBox: '상대 박스로의 드리블',
    TimePossessionAgainst: '상대팀 점유 시간',
    TimePossessionTotal: '전체 점유 시간',
    PassesInBox: '자기 박스 내 패스',
    LongThrowInSuccessful: '성공적인 롱 스로인',
    LongThrowInTotal: '총 롱 스로인 수',
    LongThrowInPct: '롱 스로인 성공률 (%)',
    Games: '플레이한 게임',
    PointsPerGame: '게임당 포인트',
    ExpectedPointsDiff: '기대 포인트 차이',
    PassesTotalOwnHalf: '총 패스 수 자신의 하프',
    PassesOwnHalf: '자기 하프 패스',
    PassesTotalOppHalf: '총 기회 절반 통과',
    ProgressivePassesTotal: '총 프로그레시브 패스',
    DuelsWon: '결투 승리',
    NonPenaltySaves: '비페널티 세이브',
    BadActionsOppHalf: '나쁜 행동 Opp Half',
    CarriesSuccessful: '성공적으로 수행',
    ShotsOnTargetOutBox: '박스에서 나온 목표물에 대한 샷',
    TotalDistance: '총 이동 거리',
    DistanceIP: 'TIP 거리',
    DistanceOOP: 'OTIP 거리',
    SprintsNumber: '스프린트 횟수',
    SprintsDistance: '스프린트 거리',
    WalkingDistance: '걷기 거리',
    JoggingDistance: '조깅 거리',
    RunningDistance: '달리기 거리',
    ExtremeAccelerations: '극심한 가속',
    NumberOfRuns: '런 횟수',
    HsrNumber: 'HSR 횟수',
    HsrDistance: 'HSR 거리',
    SprintNumberDeclinePct: '스프린트 횟수 감소 비율',
    SprintDistanceDeclinePct: '스프린트 거리 감소 비율',
    SprintNumberDecline: '스프린트 횟수 감소',
    SprintDistanceDecline: '스프린트 거리 감소',
    HsrDistancePct: 'HSR 거리 비율',
    SprintDistancePct: '스프린트 거리 비율',
    Accelerations: '가속',
    ExplosiveDistance: '폭발적 거리',
    MaxSpeed: '최대 속도',
    AvgMaxSpeed: '평균 최대 속도',
    MaxAccelerations: '최대 가속',
    BypassedPlayersByPasses: '패스로 우회한 선수',
    BypassedDefendersByPasses: '패스로 우회한 수비수',
    PassesBypassingPlayers: '선수를 우회한 패스',
    PassesBypassingDefenders: '수비수를 우회한 패스',
    BypassedPlayersPerPass: '패스당 우회한 선수',
    BypassedDefendersPerPass: '패스당 우회한 수비수',
    LineBreakingPasses: '라인 돌파 패스',
    LineBreakingPassesMD: '라인 돌파 패스 MD',
    LineBreakingPassesM: '라인 돌파 패스 M',
    LineBreakingThroughBalls: '라인 돌파 스루볼',
    LineBreakingPassesPerPass: '패스당 라인 돌파 패스 비율',
    TotalPassesUnderStrongPressure: '강한 압박 하 총 패스',
    TotalPassesUnderLightPressure: '압박 하 총 패스',
    SuccessfulPassesUnderStrongPressure: '강한 압박 하 성공한 패스',
    SuccessfulPassesUnderLightPressure: '압박 하 성공한 패스',
    PassingUnderStrongPressure: '강한 압박 하 패스 성공률',
    PassingUnderLightPressure: '압박 하 패스 성공률',
    PassReceiptsInSpaceCompleted: '공간에서 받은 패스 성공',
    PassReceiptsInSpace: '공간에서 받은 패스',
    PassReceiptsInSpaceCompletedFirstThird: '공간에서 받은 패스 완료 (1/3)',
    PassReceiptsInSpaceCompletedSecondThird: '공간에서 받은 패스 완료 (2/3)',
    PassReceiptsInSpaceCompletedFinalThird: '공간에서 받은 패스 완료 (3/3)',
    PassReceiptsInSpaceCompletedOppHalfRight: '상대 진영 오른쪽 공간 패스 완료',
    PassReceiptsInSpaceCompletedOppHalfCenter: '상대 진영 중앙 공간 패스 완료',
    PassReceiptsInSpaceCompletedOppHalfLeft: '상대 진영 왼쪽 공간 패스 완료',
    PassReceiptsInSpaceFirstThird: '공간에서 받은 패스 (1/3)',
    PassReceiptsInSpaceSecondThird: '공간에서 받은 패스 (2/3)',
    PassReceiptsInSpaceFinalThird: '공간에서 받은 패스 (3/3)',
    PassReceiptsInSpaceOppHalfRight: '상대 오른쪽 진영에서 받은 패스',
    PassReceiptsInSpaceOppHalfCenter: '상대 중앙 진영에서 받은 패스',
    PassReceiptsInSpaceOppHalfLeft: '상대 왼쪽 진영에서 받은 패스',
    TotalStrongOnBallPressures: '강한 볼 압박 총 수',
    TotalLightOnBallPressures: '볼 압박 총 수',
    SuccessfulStrongOnBallPressures: '성공한 강한 볼 압박',
    SuccessfulLightOnBallPressures: '성공한 볼 압박',
    StrongOnBallPressuresPct: '강한 볼 압박 성공률',
    LightOnBallPressuresPct: '볼 압박 성공률',
    TimesBypassedByPasses: '패스로 우회당한 횟수',
    TimesBypassedByCarries: '볼 운반으로 우회당한 횟수',
    TimesBypassedByActions: '액션으로 우회당한 횟수',
    BypassedPlayersByCarries: '볼 운반으로 우회한 선수',
    BypassedDefendersByCarries: '볼 운반으로 우회한 수비수',
    BypassedPlayersByActions: '액션으로 우회한 선수',
    BypassedDefendersByActions: '액션으로 우회한 수비수',
    CarriesBypassingPlayers: '선수를 우회한 볼 운반',
    CarriesBypassingDefenders: '수비수를 우회한 볼 운반',
    BypassedPlayersPerCarry: '볼 운반당 우회한 선수',
    BypassedDefendersPerCarry: '볼 운반당 우회한 수비수',
    LineBreakingCarries: '라인 돌파 볼 운반',
    LineBreakingCarriesMD: '라인 돌파 볼 운반 MD',
    LineBreakingCarriesM: '라인 돌파 볼 운반 M',
    LineBreakingCarriesD: '라인 돌파 볼 운반 D',
    LineBreakingCarriesPerCarry: '볼 운반당 라인 돌파 볼 운반 비율',
    LineBreakingActions: '라인 돌파 액션',
    LineBreakingActionsMD: '라인 돌파 액션 MD',
    LineBreakingActionsM: '라인 돌파 액션 M',
    LineBreakingActionsD: '라인 돌파 액션 D',
    PassesPerLineBreakingPass: '라인 돌파 패스당 패스',
    CarriesPerLineBreakingCarry: '라인 돌파 볼 운반당 볼 운반',
    LinesBrokenByPasses: '패스로 돌파한 라인',
    LinesBrokenByCarries: '볼 운반으로 돌파한 라인',
    LinesBrokenByActions: '액션으로 돌파한 라인',
    LinesBrokenPerPass: '패스당 돌파한 라인',
    LinesBrokenPerCarry: '볼 운반당 돌파한 라인',
    AvgLastDefenderDistanceIP: '마지막 수비수 거리 IP',
    AvgLastDefenderDistanceOOP: '마지막 수비수 거리 OOP',
    AvgDefensiveLineDistanceIP: '수비 라인 거리 IP',
    AvgDefensiveLineDistanceOOP: '수비 라인 거리 OOP',
    AvgRBDistanceIP: '우측 풀백 거리 IP',
    AvgRBDistanceOOP: '우측 풀백 거리 OOP',
    AvgLBDistanceIP: '좌측 풀백 거리 IP',
    AvgLBDistanceOOP: '좌측 풀백 거리 OOP',
    AvgBlockDistanceIP: '블록 거리 IP',
    AvgBlockDistanceOOP: '블록 거리 OOP',
    AvgBlockAreaIP: '블록 영역 IP',
    AvgBlockAreaOOP: '블록 영역 OOP',
    AvgDefensiveLineWidthOOP: '수비 라인 폭 OOP',
    AvgOffensiveLineLastThirdWidthIP: '공격 라인 최종 3분의 1 폭 IP',
    AvgLByIP: '좌측 풀백 위치 IP',
    AvgRByIP: '우측 풀백 위치 IP',
    AvgOffensiveLineDistanceIP: '공격 라인 거리 IP',
    AvgOffensiveLineLastThirdDistanceIP: '공격 라인 최종 3분의 1 거리 IP',
    AvgOffensiveLineWidthIP: '공격 라인 폭 IP',
    OffBallRuns: '오프볼 런 총 수',
    OffBallRunsOverlap: '오프볼 런 오버랩',
    OffBallRunsUnderlap: '오프볼 런 언더랩',
    OffBallRunsRunAhead: '오프볼 런 앞으로',
    OffBallRunsRunBehind: '오프볼 런 뒤로',
    OffBallRunsCrossReceiver: '오프볼 런 크로스 수신',
    OffBallRunsSupport: '오프볼 런 지원',
    OffBallRunsComingShort: '오프볼 런 짧게 들어오기',
    description: {
      Possession: '팀의 볼 소유율',
      TimePossession: '팀의 볼 소유 시간',
      PassesPerShots: '슛당 평균 패스 수',
      PPDA: '수비 액션당 허용한 패스. PPDA는 상대 선수들이 볼을 소유하고 있을 때 팀이 가하는 압박을 측정합니다. 이 값은 상대가 중단되기 전에 연속으로 완료할 수 있었던 평균 패스 수에 해당합니다. 값이 높을수록 상대가 더 많은 패스를 완료할 수 있었음을 의미합니다',
      Directness: '팀의 직접성을 측정합니다. 높은 직접성 값은 측면 패스에 비해 전진 패스의 양이 더 많다는 것과 관련이 있습니다',
      ExpectedPoints: '팀이 예상한 점수로, 생성하고 허용한 예상 골을 기반으로 계산됩니다. 이 지표는 실제로 달성한 점수와 비교하여 경기(또는 일련의 경기) 동안 팀의 성과를 더 잘 평가할 수 있게 해줍니다',
      PassesPerLongBall: '완료한 패스 총 수 중 성공한 롱패스 비율',
      CrossingPerXG: '크로스에서 나온 예상 골 비율',
      PenaltySavedPenaltyFaced: '모든 페널티 슛 중 세이브한 페널티 슛 비율',
      Goals: '경기 득점 수',
      PenaltyShots: '페널티킥에서 시도한 총 슛 수',
      PenaltyGoals: '페널티킥에서 득점한 총 골 수',
      NonPenaltyGoals: '페널티 골을 제외한 경기 득점 수',
      NPGOpenPlay: '페널티 골을 제외한 오픈 플레이 액션으로 경기 득점 수',
      NPGSetPiece: '페널티 골을 제외한 세트피스 액션으로 경기 득점 수',
      Shooting: '유효 슛 비율',
      Finishing: '골로 연결된 슛 비율',
      xGEfficiency: '선수가 골을 넣기 위해 필요한 예상 골 수',
      HeaderPerShot: '경기 헤딩 슛 수',
      HeaderPerCross: '팀이 완료한 크로스 총 수 중 선수가 헤딩한 크로스 비율',
      Assists: '경기 어시스트 수',
      ThroughBalls: '공격 런을 하는 선수를 위한 스루볼로 경기 골 찬스를 만든 수',
      CrossEfficiency: '성공한 크로스 비율과 성공한 크로스 양을 결합한 지표',
      ScoringContribution: '경기 어시스트와 골 수',
      xAssistsOpenPlay: '오픈 플레이로 생성한 경기 예상 어시스트 수',
      xAssistsSetPiece: '세트피스로 생성한 경기 예상 어시스트 수',
      xAssistsOpenPlayInTeam: '팀 내 오픈 플레이로 생성한 예상 어시스트 수',
      xAssistsSetPieceInTeam: '팀 내 세트피스로 생성한 예상 어시스트 수',
      xGChainFinalThird: '선수가 최종 3분의 1에서 참여한 xG 양',
      xGBuildupFinalThird: '선수가 최종 3분의 1에서 참여한 xG 양 (슛과 슛으로 이어지는 패스 제외)',
      BallProgressionPassing: '선수가 패스로 볼을 10미터 이상 진행한 횟수',
      BallProgressionDribbling: '선수가 볼 운반으로 볼을 10미터 이상 진행한 횟수',
      TacklesWasDribbled: '선수가 태클로 볼을 회수한 횟수 대비 패스/런으로 허용한 횟수의 비율을 고려한 지표. 값이 높을수록 좋습니다',
      TacklesSuccessful: '선수가 성공한 태클 수',
      Interceptions: '경기 선수가 패스를 가로채 목표 지점에 도달하지 못하게 한 횟수',
      Clearances: '경기 선수가 수비 지역 밖으로 볼을 걷어낸 횟수',
      Fouls: '경기 선수가 범한 파울 수',
      Recoveries: '경기 선수가 회수한 볼 수',
      Shots: '경기 총 슛 수',
      ShotsPerGoal: '골키퍼에게 페널티 제외 골을 넣기 위해 필요한 유효 슛 수',
      ShortPassesSuccessful: '경기 완료한 짧은 패스 수 (12미터 미만)',
      PassingSuccessForwardPct: '전진 방향으로 성공한 패스 비율',
      PassingSuccessBackwardPct: '후진 방향으로 성공한 패스 비율',
      PassingForwardBackwardPct: '후진 패스 대비 전진 패스 비율',
      LongBallPerPassesPct: '선수가 완료한 모든 패스 중 완료한 롱패스 비율 (>32미터)',
      LongBallReceived: '선수가 받은 롱패스 (>32미터)',
      LongBallReceivedOppHalf: '상대 진영에서 선수가 받은 롱패스 (>32미터)',
      OffensiveActions: '공격 액션',
      DribblesAttempted: '경기 시도한 드리블 수',
      SuccessfulDribblesPct: '성공한 드리블/드리블 시도 총 수',
      OffensiveTouchesOutBoxPct: '박스 밖 공격 터치 비율',
      BallRetention: '볼을 소유하고 있을 때 잃지 않는 시간 비율',
      PassingPct: '선수가 시도한 모든 패스 중 완료한 패스 비율',
      PassingOwnHalfPct: '선수가 시도한 모든 패스 중 완료한 패스 비율 (자신 진영 패스만)',
      PassingOppHalfPct: '선수가 시도한 모든 패스 중 완료한 패스 비율 (상대 진영 패스만)',
      PassingFinalThird: '경기 최종 3분의 1로 성공한 패스',
      PassesFinalThirdTotal: '크로스, 세트피스, 코너킥, 스로인을 제외하고 파이널 써드에서 끝나는 총 패스 시도 횟수',
      PassingFinalThirdPct: '선수가 시도한 모든 패스 중 완료한 패스 비율 (최종 3분의 1 패스만)',
      LongBallSuccessful: '32미터 이상 완료한 패스',
      LongBallPct: '32미터 이상 완료한 패스/32미터 이상 시도한 패스 총 수',
      LongBallTotal: '32미터 이상의 총 패스 횟수',
      SavesPct: '허용한 슛 총 수 중 세이브 비율',
      SavesInBoxPct: '박스 안에서 나온 세이브한 슛 비율',
      SavesOutOfBoxPct: '박스 밖에서 나온 세이브한 슛 비율',
      xGSavedPerXGFacedOnTarget: '골키퍼가 세이브한 예상 xG 비율을 나타내는 계수. 이 지표에서 값 1은 골키퍼가 팀이 허용한 슛의 모든 예상 골을 세이브했다는 의미이고, 값 0은 상대가 생성한 모든 예상 골이 골로 연결되었다는 의미입니다',
      xGFacedOnTargetPerGoalReceived: '특정 골키퍼에게 골을 넣기 위해 필요한 예상 골 수를 나타내는 지표. 이 지표에서 높은 점수는 이 골키퍼에게 골을 넣으려면 많은 xG를 생성해야 한다는 의미입니다',
      xGFacedOnTargetEfficiency: '골키퍼가 방어한 페널티 제외 골 수. 이는 골키퍼가 대면한 유효 슛 예상 골 수에서 (페널티 제외) 실점 수를 뺀 값입니다. 골키퍼 덕분에 상대가 넣지 못한 골 수를 나타냅니다',
      xGFacedOnTarget: '골키퍼가 대면한 총 xG (세이브 및 실점)',
      IndividualPressure: '선수가 상대를 압박할 때 성공한 노력(볼 소유 회수) 수를 측정하는 지표',
      AerialEfficiency: '성공한 공중볼 경합 비율과 공중볼 경합 승리 양을 결합한 지표',
      AerialWins: '경기 선수가 승리한 공중볼 수',
      AerialWinsPct: '선수가 참여한 공중볼 경합 총 수 중 선수가 승리한 공중볼 수',
      xG: '경기 생성한 예상 골. 이 지표는 다양한 변수(거리, 각도, 플레이 유형, 신체 부위 등)를 기반으로 슛이 골로 연결될 확률을 측정합니다',
      xGDiff: 'xG와 골의 차이',
      xGOpenPlay: '오픈 플레이로 생성한 예상 골',
      xGSetPiece: '세트피스로 생성한 예상 골',
      xGPerShot: '선수가 시도한 슛의 평균 xG. 이 지표는 시도한 슛의 평균 위험도를 측정합니다. 값이 높을수록 슛이 골로 연결될 가능성이 높습니다. 높은 슛당 xG는 선수가 슛을 잘 선택한다는 의미입니다',
      ChancesCreated: '슛으로 이어지는 패스 수',
      CompletedCrosses: '경기 완료한 크로스 수',
      Crossing: '시도한 크로스 중 완료한 크로스 비율',
      OpenPlayKeyPasses: '경기 오픈 플레이 중 완료한 패스 수',
      OpenPlayKeyPassesInTeam: '팀 내 오픈 플레이 중 완료한 패스 비율',
      OpenPlayPassesIntoOpponentBox: '경기 오픈 플레이 중 상대 박스로 시도한 패스 총 수',
      OpenPlayPassesIntoOpponentBoxSuccessful: '경기 오픈 플레이 중 상대 박스로 완료한 패스 수',
      xAssists: '경기에서 생성된 기회의 질을 분석하는 지표. 각 슈팅 어시스트는 슛이 골로 연결될 확률을 기반으로 한 값을 가집니다. 이 값은 패스 위치, 유형(크로스, 스루볼, 세트피스 등), 경기 상황 등에 따라 할당됩니다. xG와 달리 xA는 이상적으로 선수의 어시스트 수보다 높아야 하는 지표입니다. 왜냐하면 크리에이터는 자신의 질 좋은 패스(xA)만 통제할 수 있지만, 어시스트 수는 피니셔에 달려있기 때문입니다',
      xGChain: '선수가 참여한 xG 양',
      xGBuildup: 'xG Chain과 유사하지만 시퀀스의 마지막 2명의 선수는 고려하지 않음 (슛과 슛으로 이어지는 패스 제외)',
      xGBuildupInTeam: '팀 내 xG Chain과 유사하지만 시퀀스의 마지막 2명의 선수는 고려하지 않음 (슛과 슛으로 이어지는 패스 제외)',
      BallProgression: '선수가 패스, 볼 운반 또는 둘의 조합으로 10미터 이상 전진한 횟수 (경기)',
      SuccessfulDribbles: '경기 성공적으로 완료한 드리블 수',
      Dispossessed: '경기 선수가 태클을 당해 볼 소유권을 잃은 횟수',
      TouchesInOpponentBox: '경기 상대 박스에서 볼 소유 횟수',
      xGSavedPerShot: '허용한 유효 슛의 평균 골 확률',
      BallRetentionOppHalf: '상대 진영에서 볼을 소유하고 있을 때 잃지 않는 시간 비율',
      DeepProgression: '볼 운반으로 피치의 마지막 5분의 1에 도달한 횟수 더하기 마지막 5분의 1에서 볼 소유 횟수',
      DeepProgressionFinalThird: '볼 운반으로 피치의 최종 3분의 1에 도달한 횟수 더하기 최종 3분의 1에서 볼 소유 횟수',
      FoulsTaken: '경기 선수가 파울을 당한 횟수',
      PenaltiesTaken: '경기 상대 박스에서 선수가 파울을 당한 횟수',
      BlockedCrosses: '경기 막힌 크로스 수',
      BlockedShots: '경기 막힌 슛 수',
      NonPenaltyGoalsAgainst: '경기 허용한 페널티 제외 골 수',
      GoalsConceded: '경기당 실점한 골 수',
      Headers: '헤딩으로 시도한 슛 수',
      HeadedGoals: '경기당 헤딩으로 득점한 골 수',
      Points: '팀이 획득한 포인트 수',
      SavesInBox: '경기 박스 안의 슛을 막아낸 횟수',
      SavesOutBox: '경기 박스 밖에서 슛을 막아낸 횟수',
      ShotsOnTargetInBoxAgainst: '플레이당 박스 내부에서 허용된 유효 슈팅 수',
      ShotsOnTargetOutBoxAgainst: '경기당 박스 밖에서 유효 슈팅 횟수를 허용했습니다.',
      AveragePassDistance: '패스의 평균 거리 (미터)',
      ProgressiveRuns: '볼 소유를 상대 골대에 20% 더 가깝게 만든 성공한 볼 운반',
      xT: '예상 위협(xT)은 선수가 볼을 운반하거나 패스하여 골로 연결될 확률이 높은 영역으로 이동시켜 상대에게 만드는 위협을 측정하는 지표입니다',
      xTOpenPlay: '경기 오픈 플레이 중 생성한 예상 위협',
      xTSetPiece: '경기 세트피스로 생성한 예상 위협',
      xGOT: '대면 유효 슛 예상 골. 골키퍼가 대면한 예상 골 수. 이 지표는 유효 슛만 고려합니다 (빗나간 슛과 골대 맞춘 슛 제외)',
      BadActions: '범한 모든 나쁜 액션의 합 (실패한 패스, 실패한 드리블, 볼 소유권 이탈, 오프사이드 패스, 실패한 볼 터치)',
      BadActionsOwnHalf: '자신 진영에서 범한 모든 나쁜 액션의 합 (실패한 패스, 실패한 드리블, 볼 소유권 이탈, 오프사이드 패스, 실패한 볼 터치)',
      AerialsWonOwnBox: '자신 박스 공중볼 경합 승리',
      AerialsWonOppBox: '상대 박스 공중볼 경합 승리',
      AerialsTotalOppBox: '상대 박스 공중볼 경합 총 수',
      AerialsTotalOwnBox: '자신 박스 공중볼 경합 총 수',
      FoulsOwnHalfPct: '자신 진영에서 범한 파울 비율',
      RecoveriesOppHalf: '경기 상대 진영에서 선수가 회수한 볼 수',
      DuelsPct: '경합 승리 비율',
      TacklesUnsuccessful: '상대가 성공적으로 드리블로 통과할 때 선수가 볼을 획득하지 못한 횟수',
      TacklesWasDribbledFirstThird: '최종 3분의 1에서 대면했을 때 선수가 볼을 회수한 비율',
      TacklesWasDribbledSecondThird: '수비 1대1 승리 2/3',
      TacklesWasDribbledFinalThird: '수비 1대1 승리 끝 1/3“',
      BallProgressionFinalThird: '최종 3분의 1 볼 진행',
      DuelsTotal: '경기 범한 태클, 공중볼, 볼 터치, 드리블, 파울 총 수',
      QuickRecoveries: '자신 골대에서 40미터 이상 떨어진 곳에서 볼 소유권을 잃은 후 5초 이내에 한 볼 회수',
      ShotsPerNPG: '페널티 제외 골을 넣기 위한 평균 슛 수',
      ShotsOutBox: '경기 박스 밖에서 시도한 슛 수',
      GoalsOutBox: '경기 박스 밖에서 넣은 골 수',
      ShootingOutBox: '박스 밖에서 나온 유효 슛 비율',
      HandPassing: '손으로 한 패스 정확도',
      Catching: '골키퍼가 볼을 잡은 세이브 비율',
      Caught: '골키퍼가 공을 잡고 있는 위치를 저장하여 두 번째 플레이를 방지합니다.',
      ClaimAccuracy: '골키퍼가 공중볼을 잡거나 막는 능력을 측정합니다. 1보다 큰 수는 골키퍼가 예상보다 더 많은 공중볼을 잡았다는 것을 나타냅니다',
      HighTurnovers: '자신 골대에서 40미터 이내에서 발생한 볼 소유권 이탈',
      ShotEndingHighTurnovers: '높은 볼 소유권 이탈(자신 골대에서 40미터 이내)로 끝난 상대 팀의 슛',
      GoalEndingHighTurnovers: '높은 볼 소유권 이탈(자신 골대에서 40미터 이내)로 끝난 상대 팀의 골',
      AverageCarriesProgress: '선수가 볼 운반당 볼을 수직으로 이동한 평균 거리 (미터)',
      ChanceEndingCarries: '최소 7미터 볼 운반으로 끝난 슛으로 이어지는 패스',
      AssistEndingCarries: '최소 7미터 볼 운반으로 끝난 골로 이어지는 패스',
      ShotEndingCarries: '최소 7미터 볼 운반으로 끝난 슛',
      GoalEndingCarries: '최소 7미터 볼 운반으로 끝난 골',
      ShotEndingSequence: '선수가 참여한 슛으로 끝난 시퀀스 수',
      GoalEndingSequence: '선수가 참여한 골로 끝난 시퀀스 수',
      xGPerNPG: '페널티 제외 골을 넣기 위해 필요한 예상 골',
      AerialWonOffensive: '공격 공중볼 경합 승리',
      AerialWonDefensive: '수비 공중볼 경합 승리',
      xGAgainst: '실점 예상 골',
      xGDiffAgainst: '실점 예상 골과 실점 골의 차이',
      xGPerNPGAgainst: '페널티 제외 실점당 받은 예상 골',
      xGSetPieceAgainst: '세트피스로 허용한 예상 골',
      xGOpenPlayAgainst: '오픈 플레이로 허용한 예상 골',
      xGPerShotAgainst: '허용한 슛당 받은 예상 골',
      ShotsAgainst: '경기 허용한 슛 수',
      ShotsOnTargetAgainst: '경기 허용한 유효 슛 수',
      RivalPossession: '상대의 볼 소유',
      AerialDefensivePct: '볼 소유 없이 승리한 공중볼 경합 비율',
      HighRecoveries: '상대 골대에서 40미터 이내에서 한 볼 회수',
      HighDefensiveActions: '자신 골대 라인에서 40미터 이상 떨어진 곳에서 한 수비 액션 (태클, 인터셉트, 블록, 파울, 1대1)',
      HighDefensiveActionPct: '자신 골대 라인에서 40미터 이상 떨어진 곳에서 한 수비 액션 비율 (태클, 인터셉트, 블록, 파울, 1대1)',
      HighDefensiveDistance: '모든 수비 액션의 자신 골대로부터 평균 거리',
      PassesPerPossession: '볼 소유당 패스 수',
      LengthPerPossession: '볼 소유당 거리',
      xTNet: '순 예상 위협',
      AvgCarriesDistance: '평균 볼 운반 거리',
      PassesForwardPct: '전진 패스 비율',
      PassesForwardSuccessful: '성공적인 포워드 패스',
      PassesForwardTotal: '총 포워드 패스',
      TacklesAttempted: '시도한 태클 수',
      DuelsLost: '패배한 경합 수',
      Carries: '볼 운반',
      CarriesPct: '볼 운반 비율',
      Aerials: '공중볼 경합 총 수',
      ProgressivePassesReceivedIntoBox: '상대 박스로 받은 전진 패스',
      PassesOppHalf: '상대 진영으로 끝난 성공한 패스',
      ShotsOnTarget: '경기 유효 슛 수',
      AggressiveActions: '볼 소유권을 잃은 후 2초 이내에 시도한 태클 수',
      Crosses: '경기 크로스 총 수',
      xGBuildup5pass: '선수가 참여한 xG 양, 마지막 5개 패스만 (슛과 슛으로 이어지는 패스 제외)',
      DefensiveDistance: '수행한 수비 경합의 자신 골대로부터 평균 거리',
      SpeedSequence: '팀의 모든 볼 소유의 평균 속도 (이동한 거리/소요 시간)',
      Touches: '경기 선수가 볼을 소유한 횟수',
      AerialsTotalOppHalf: '경기 상대 진영으로 들어간 공중볼 경합 총 수',
      AerialsWonOppHalf: '플레이당 상대 진영으로 공중 결투 성공',
      AerialsWonOppHalfPct: '상대 진영에서 승리한 공중볼 경합 비율',
      AerialsPctOppBox: '상대 박스에서 승리한 공중볼 경합 비율',
      AerialsPctOwnBox: '자신 박스에서 승리한 공중볼 경합 비율',
      AerialDefensive: '상대 팀이 볼을 소유하고 있을 때 한 공중볼 경합 총 수',
      AerialOffensive: '자신 팀이 볼을 소유하고 있을 때 한 공중볼 경합 총 수',
      AerialOffensivePct: '자신 팀이 볼을 소유하고 있을 때 승리한 공중볼 경합 비율',
      IndividualPressureOppHalf: '상대 진영에서 상대를 압박할 때 선수가 한 성공한 노력(볼 회수) 수를 측정하는 지표',
      ChancesCreatedOP: '경기 오픈 플레이 중 슛으로 이어지는 패스 수',
      TouchesPerShot: '슛당 선수들이 볼을 터치한 횟수',
      PassesFinalThirdTotalPct: '최종 3분의 1로 들어간 패스 비율 (성공 및 실패 포함)',
      xACrosses: '경기 크로스에서 생성한 예상 어시스트',
      Passes: '경기 패스 총 수',
      PassesSuccessful: '경기 완료한 패스 수',
      TacklesWasDribbledFouls: '총 태클 및 파울 대비 승리한 태클 비율',
      OffsidesCaught: '오프사이드 적발',
      ProgressivePassesReceivedFinalThird: '최종 3분의 1에서 받은 전진 패스',
      ProgressivePassesReceived: '받은 전진 패스',
      Breadth: '필드 측면에서 한 태클, 챌린지, 인터셉트, 파울의 합',
      DuelsDefTotal: '총 태클, 수비 공중볼 경합, 파울의 합',
      DefensiveActions: '상대가 드리블을 시도할 때 한 수비 액션 (태클, 챌린지, 파울)',
      ProgressivePassesReceivedOppHalf: '상대 진영으로 받은 전진 패스',
      CompletedCrossesOP: '오픈 플레이 완료한 크로스',
      CrossingOP: '오픈 플레이에서 시도한 크로스 중 완료한 크로스 비율',
      CrossesOP: '오픈 플레이 중 총 크로스 수',
      PassingContribution: '수신자의 위치를 고려하여 패스의 위협을 측정하는 비율',
      BallProgressionOppHalfInTeam: '팀 내 상대 진영 볼 진행 비율',
      PassesOPIntoBoxInTeam: '팀 내 오픈 플레이 상대 박스 패스 비율',
      TouchesOppBoxInTeam: '팀 내 상대 박스 터치 비율',
      xGOPInTeam: '팀 내 오픈 플레이 xG 비율',
      DeepPasses: '상대 골대 반경 20미터 밖에서 시작하여 그 영역 안으로 끝난 패스',
      DeepPassesTotal: '상대 골대 반경 20m 밖에서 시도한 패스 중 해당 지역 안으로 끝나는 총 패스 수',
      DefensiveDuelsPct: '총 수비 경합 대비 승리한 수비 경합 비율',
      QuickRecoveriesPct: '인터셉트 및 시도한 태클 대비 빠른 볼 회수 비율',
      DiffDefensiveDistanceTeam: '선수의 수비 거리와 팀의 수비 거리 차이',
      xTPassing: '패스에서만 생성한 예상 위협',
      xTPassing100Passes: '패스에서만 생성한 예상 위협 및 100패스당',
      ProgressivePassesAccurate: 'X축에서 10미터 이상의 완료한 패스',
      PassAbility: '완료한 패스 대비 예상 패스(xP) 비율',
      OPPassesIntoOppBoxPct: '오픈 플레이에서 상대 박스로 완료한 패스 대비 시도한 패스 비율',
      EntriesOppBox: '상대 박스로 들어간 패스 및 볼 운반 수',
      Crosses6yardBox: '6야드 박스로 끝난 크로스 총 수',
      Cutbacks: '베이스라인에서 뒤로 그리고 상대 박스 안으로 한 패스',
      xTDribbling: '드리블에서만 생성한 예상 위협',
      AvgShotDistance: '시도한 총 슛의 평균 거리',
      xGOnTarget: '유효 슛에서 나온 예상 골. 슛의 종료 위치를 사용하여 슛이 골로 연결될 확률을 측정합니다',
      FinishingxGOT: '평균 이상으로 골로 끝난 유효 슛 비율. 이 지표는 공격수가 슛의 질로 추가하는 가치를 측정합니다',
      DribblesWonOwnHalf: '자신 진영에서 성공한 드리블',
      DribblesOwnHalf: '자신 진영에서 시도한 드리블 수',
      DribblesOwnHalfPct: '자신 진영에서 성공한 드리블 및 시도한 드리블 비율',
      DribblesWonOppHalf: '상대 진영에서 성공한 드리블',
      DribblesOppHalf: '상대 진영에서 시도한 드리블 수',
      DribblesOppHalfPct: '상대 진영에서 성공한 드리블 및 시도한 드리블 비율',
      DribblesWonFinalThird: '최종 3분의 1에서 성공한 드리블',
      DribblesFinalThird: '최종 3분의 1에서 시도한 드리블 수',
      DribblesFinalThirdPct: '최종 3분의 1에서 성공한 드리블 및 시도한 드리블 비율',
      ShotEndingHighRecoveries: '높은 볼 회수(상대 골대에서 40미터 이내)로 끝난 슛',
      PassingFinalThirdAgainst: '상대에서 최종 3분의 1로 한 성공한 패스',
      OpenPlayPassesIntoOpponentBoxAgainst: '오픈 플레이 중 상대에서 자신 박스로 시도한 패스 총 수',
      EntriesOppBoxAgainst: '상대에서 자신 박스로 들어간 패스 및 볼 운반 수',
      DeepProgressionAgainst: '상대가 볼 운반으로 피치의 마지막 5분의 1에 도달한 횟수 더하기 첫 번째 5분의 1에서 볼 소유 횟수',
      TouchesInOpponentBoxAgainst: '상대가 자신 박스에서 볼을 소유한 횟수',
      Score: '다양한 지표를 기반으로 한 선수 성과',
      PDScore: '다양한 신체 지표를 기반으로 한 선수 신체 성과',
      OrlegiScore: '오를레기 점수',
      SirScore: '시리우스 점수',
      ExcScore: '다양한 지표를 기반으로 한 선수 성과',
      xTOPInTeam: '팀 내 오픈 플레이 중 생성한 예상 위협',
      YellowCards: '받은 옐로우 카드',
      RedCards: '받은 레드 카드',
      xTOpenPlayAgainst: '오픈 플레이로 허용한 예상 위협',
      xTSetPieceAgainst: '세트피스로 허용한 예상 위협',
      NPGOpenPlayAgainst: '페널티 골을 제외한 오픈 플레이 액션으로 허용한 골 수',
      NPGSetPieceAgainst: '페널티 골을 제외한 세트피스 액션으로 허용한 골 수',
      PassesOppHalfPerPossession: '볼 소유당 상대 진영 패스',
      AverageTimeRecovery: '평균 회수 시간',
      ExpectedPassing: '완료되어야 했던 패스 비율',
      NumPossession10Passes: '10개 이상의 패스로 생성한 볼 소유',
      PassesReceived: '받은 패스',
      PassesReceivedFinalThird: '최종 3분의 1에서 받은 패스',
      ProgressivePassesTotalPct: '전진 패스 비율',
      ShortPassesPct: '짧은 패스 비율',
      TouchesOppBoxOppTeam: '선수가 경기장에 있을 때 자신 박스 안에서 허용한 상대 액션 수',
      ShotsOnTargetOppTeam: '선수가 경기장에 있을 때 허용한 유효 슛',
      NPGOppTeam: '선수가 경기장에 있을 때 허용한 페널티 제외 골',
      xGSetPiecePerxG: '예상 골 하나를 생성하기 위해 필요한 세트피스로 생성한 예상 골',
      ShotsOpenPlay: '오픈 플레이로 생성한 슛 수',
      ShotsOpenPlayAgainst: '오픈 플레이로 허용한 슛 수',
      ShotsFromDribble: '상대를 드리블로 제친 후 시도한 슈팅',
      GoalsFromDribble: '상대를 드리블로 제친 후 기록한 득점',
      PassesIntoFinalThird: '파이널 서드에서 시작된 성공적인 패스',
      PassesIntoFinalThirdTotal: '외부에서 시작하여 파이널 써드 내부에서 끝나는 총 패스 시도 횟수',
      PassesInsideFinalThird: '파이널 서드 내에서 시작되고 종료된 성공적인 패스',
      PassesInsideFinalThirdTotal: '파이널 서드 내에서 시도된 총 패스 횟수(파이널 서드에서 시작 및 종료)',
      PassesFinalThirdNoArea: '파이널 3번째 통과(박스 없음)',
      PassesIntoOppBox: '상대 박스 내에서 종료된 성공적인 패스',
      CarriesFinalThird: '파이널 서드에서 종료된 최소 7미터 이상의 드리블',
      CarriesInsideFinalThird: '파이널 서드 내에서 이루어진 최소 7미터 이상의 드리블',
      CarriesFinalThirdNoBox: 'Final Third 운반(박스 없음)',
      CarriesIntoOppBox: '상대 박스 내에서 종료된 최소 7미터 이상의 드리블',
      TimePossessionAgainst: '상대 팀의 공 점유 시간',
      TimePossessionTotal: '양 팀의 총 공 점유 시간',
      PassesInBox: '자기 진영 박스 내에서의 성공적인 패스',
      LongThrowInSuccessful: '20미터 이상을 목표로 한 성공적인 롱 스로인',
      LongThrowInTotal: '20미터 이상 롱 스로인의 총 횟수',
      LongThrowInPct: '성공적인 롱 스로인의 비율 (20미터 이상)',
      Games: '플레이한 게임',
      PointsPerGame: '게임당 포인트',
      ExpectedPointsDiff: '기대 포인트 차이',
      PassesTotalOwnHalf: '자기 진영에서 패스한 총 횟수',
      PassesOwnHalf: '자기 진영에서 성공한 패스 수',
      PassesTotalOppHalf: '상대 진영에서 이루어진 총 패스 수',
      ProgressivePassesTotal: 'X축에서 10미터 이상의 총 패스 수',
      DuelsWon: '성공적인 결투(태클, 에어리얼, 볼 터치, 드리블 및 파울 범함)',
      NonPenaltySaves: '페널티킥을 제외한 세이브',
      BadActionsOppHalf: '상대 진영에서 행해진 모든 나쁜 행동의 합(패스 실패, 실패, 빼앗김, 오프사이드 패스, 볼 터치 실패)',
      CarriesSuccessful: '성공적인 이벤트로 끝나는 최소 7m의 운반 수',
      ShotsOnTargetOutBox: '박스 밖에서 목표물을 향해 시도한 슛',
      TotalDistance: '경기 중 선수가 이동한 총 거리',
      WalkingDistance: '경기 중 선수가 2 m/s (7.2 km/h) 미만의 속도로 이동한 총 거리',
      JoggingDistance: '경기 중 선수가 2 m/s (7.2 km/h) 이상 4 m/s (14.4 km/h) 미만의 속도로 이동한 총 거리',
      RunningDistance: '경기 중 선수가 4 m/s (14.4 km/h) 이상 5.5 m/s (19.8 km/h) 미만의 속도로 이동한 총 거리',
      ExtremeAccelerations: '선수가 3 m/s<sup>2</sup> 이상으로 가속한 횟수',
      NumberOfRuns: '4 m/s (14.4 km/h) 이상 5.5 m/s (19.8 km/h) 미만의 속도로 완료한 런 수',
      DistanceIP: '경기 중 볼 소유 시 선수가 이동한 거리 (팀 볼 소유)',
      DistanceOOP: '경기 중 볼 미소유 시 선수가 이동한 거리 OTIP (상대팀 볼 소유)',
      HsrNumber: '선수가 최소 1초 동안 5.5 m/s (19.8 km/h) 이상 7 m/s (25.2 km/h) 미만의 속도로 이동한 횟수',
      HsrDistance: '경기 중 선수가 5.5 m/s (19.8 km/h) 이상 7 m/s (25.2 km/h) 미만의 속도로 이동한 총 거리',
      HsrDistancePct: '총 이동 거리 대비 HSR (고속 런) 거리 비율',
      SprintsNumber: '선수가 최소 1초 동안 7 m/s (25.2 km/h) 이상의 속도로 이동한 횟수',
      SprintsDistance: '경기 중 선수가 7 m/s (25.2 km/h) 이상의 속도로 이동한 총 거리',
      SprintNumberDeclinePct: '후반 대비 스프린트 수행 횟수 감소 비율',
      SprintDistanceDeclinePct: '후반 대비 스프린트 중 이동 거리 감소 비율',
      SprintNumberDecline: '후반 대비 스프린트 수행 횟수 감소',
      SprintDistanceDecline: '후반 대비 스프린트 중 이동 거리 감소',
      SprintDistancePct: '총 이동 거리 대비 스프린트 거리 비율',
      Accelerations: '선수가 1.5 m/s<sup>2</sup> 이상 3 m/s<sup>2</sup> 미만으로 가속한 횟수',
      ExplosiveDistance: '폭발적 거리',
      MaxSpeed: '선수가 달성한 최대 속도',
      AvgMaxSpeed: '선수가 달성한 최대 속도의 평균',
      MaxAccelerations: '선수가 달성한 최대 미터/초<sup>2</sup>',
      BypassedPlayersByPasses: '패스를 통해 우회한 상대 선수 (수비수 및 미드필더) 총 수',
      BypassedDefendersByPasses: '패스를 통해 우회한 상대 선수 (수비수) 총 수',
      PassesBypassingPlayers: '선수를 우회한 패스 수',
      PassesBypassingDefenders: '수비수를 우회한 패스 수',
      BypassedPlayersPerPass: '패스당 우회한 선수 총 수',
      BypassedDefendersPerPass: '패스당 우회한 수비수 총 수',
      LineBreakingPasses: '하나 이상의 수비 라인을 성공적으로 돌파한 완료된 패스 수',
      LineBreakingPassesMD: '미드필더 및 수비 라인을 성공적으로 돌파한 완료된 패스 수',
      LineBreakingPassesM: '미드필더 라인을 성공적으로 돌파한 완료된 패스 수',
      LineBreakingThroughBalls: '수비 라인을 성공적으로 돌파한 완료된 패스 수',
      LineBreakingPassesPerPass: '패스당 라인 돌파 패스 비율',
      TotalPassesUnderStrongPressure: '강한 압박 하에서 시도한 패스 총 수 (가장 가까운 상대로부터 0-2미터 이내)',
      TotalPassesUnderLightPressure: '압박 하에서 시도한 패스 총 수 (가장 가까운 상대로부터 2-4미터 이내)',
      SuccessfulPassesUnderStrongPressure: '강한 압박 하에서 성공한 패스 수 (가장 가까운 상대로부터 0-2미터 이내)',
      SuccessfulPassesUnderLightPressure: '압박 하에서 성공한 패스 수 (가장 가까운 상대로부터 2-4미터 이내)',
      PassingUnderStrongPressure: '강한 압박 하에서 성공한 패스 및 총 패스 비율 (가장 가까운 상대로부터 0-2미터 이내)',
      PassingUnderLightPressure: '압박 하에서 성공한 패스 및 총 패스 비율 (가장 가까운 상대로부터 2-4미터 이내)',
      PassReceiptsInSpaceCompleted: '수신자가 공격 진영에 있고 골 방향으로 5미터 반경 내에 수비수가 없는 패스',
      PassReceiptsInSpace: '공격 진영에서 수신했고 골 방향으로 5미터 반경 내에 수비수가 없는 패스',
      PassReceiptsInSpaceCompletedFirstThird: '공격 방향 5미터 이내에 수비수가 없는 상태에서, 1/3 지역에서 받은 패스',
      PassReceiptsInSpaceCompletedSecondThird: '공격 방향 5미터 이내에 수비수가 없는 상태에서, 2/3 지역에서 받은 패스',
      PassReceiptsInSpaceCompletedFinalThird: '공격 방향 5미터 이내에 수비수가 없는 상태에서, 파이널 서드에서 받은 패스',
      PassReceiptsInSpaceCompletedOppHalfRight: '상대 진영 오른쪽에서 수비수 없이 받은 패스',
      PassReceiptsInSpaceCompletedOppHalfCenter: '상대 진영 중앙에서 수비수 없이 받은 패스',
      PassReceiptsInSpaceCompletedOppHalfLeft: '상대 진영 왼쪽에서 수비수 없이 받은 패스',
      PassReceiptsInSpaceFirstThird: '1/3 지역에서 수비수 없이 받은 패스',
      PassReceiptsInSpaceSecondThird: '2/3 지역에서 수비수 없이 받은 패스',
      PassReceiptsInSpaceFinalThird: '파이널 서드에서 수비수 없이 받은 패스',
      PassReceiptsInSpaceOppHalfRight: '상대 진영 오른쪽에서 수비수 없이 받은 패스',
      PassReceiptsInSpaceOppHalfCenter: '상대 진영 중앙에서 수비수 없이 받은 패스',
      PassReceiptsInSpaceOppHalfLeft: '상대 진영 왼쪽에서 수비수 없이 받은 패스',
      TotalStrongOnBallPressures: '강한 볼 압박 수 (볼 소유자로부터 0-2미터 이내)',
      TotalLightOnBallPressures: '볼 압박 수 (볼 소유자로부터 2-4미터 이내)',
      SuccessfulStrongOnBallPressures: '성공한 강한 볼 압박 수 (0-2미터 이내)',
      SuccessfulLightOnBallPressures: '성공한 볼 압박 수 (2-4미터 이내)',
      StrongOnBallPressuresPct: '성공한 강한 볼 압박 및 총 강한 볼 압박 비율 (가장 가까운 상대로부터 0-2미터 이내)',
      LightOnBallPressuresPct: '성공한 볼 압박 및 총 볼 압박 비율 (가장 가까운 상대로부터 2-4미터 이내)',
      TimesBypassedByPasses: '패스로 우회당한 총 횟수',
      TimesBypassedByCarries: '볼 운반으로 우회당한 총 횟수',
      TimesBypassedByActions: '패스 및 볼 운반으로 우회당한 총 횟수',
      BypassedPlayersByCarries: '볼 운반을 통해 우회한 상대 선수 (수비수 및 미드필더) 총 수',
      BypassedDefendersByCarries: '볼 운반을 통해 우회한 상대 선수 (수비수) 총 수',
      BypassedPlayersByActions: '패스 및 볼 운반을 통해 우회한 상대 선수 (수비수 및 미드필더) 총 수',
      BypassedDefendersByActions: '패스 및 볼 운반을 통해 우회한 상대 선수 (수비수) 총 수',
      CarriesBypassingPlayers: '선수를 우회한 볼 운반 수',
      CarriesBypassingDefenders: '수비수를 우회한 볼 운반 수',
      BypassedPlayersPerCarry: '볼 운반당 우회한 상대 선수 평균 수',
      BypassedDefendersPerCarry: '볼 운반당 우회한 수비수 평균 수',
      LineBreakingCarries: '하나 이상의 수비 라인을 성공적으로 돌파한 볼 운반 수',
      LineBreakingCarriesMD: '미드필더 및 수비 라인을 성공적으로 돌파한 볼 운반 수',
      LineBreakingCarriesM: '미드필더 라인을 성공적으로 돌파한 볼 운반 수',
      LineBreakingCarriesD: '수비 라인을 성공적으로 돌파한 볼 운반 수',
      LineBreakingCarriesPerCarry: '볼 운반당 라인 돌파 볼 운반 비율',
      LineBreakingActions: '하나 이상의 수비 라인을 성공적으로 돌파한 패스 및 볼 운반 합계',
      LineBreakingActionsMD: '미드필더 및 수비 라인을 성공적으로 돌파한 패스 및 볼 운반 합계',
      LineBreakingActionsM: '미드필더 라인을 성공적으로 돌파한 패스 및 볼 운반 합계',
      LineBreakingActionsD: '수비 라인을 성공적으로 돌파한 패스 및 볼 운반 합계',
      PassesPerLineBreakingPass: '라인 돌파 패스당 총 패스 수 비율',
      CarriesPerLineBreakingCarry: '라인 돌파 볼 운반당 총 볼 운반 수 비율',
      LinesBrokenByPasses: '패스를 통해 돌파한 라인 총 수',
      LinesBrokenByCarries: '볼 운반을 통해 돌파한 라인 총 수',
      LinesBrokenByActions: '패스 및 볼 운반을 통해 돌파한 라인 총 수',
      LinesBrokenPerPass: '패스당 돌파한 라인 총 수 비율',
      LinesBrokenPerCarry: '볼 운반당 돌파한 라인 총 수 비율',
      AvgLastDefenderDistanceIP: '볼 소유 시 마지막 수비수 (자신 골대에 가장 가까운)와 골 라인 사이의 거리',
      AvgLastDefenderDistanceOOP: '볼 미소유 시 마지막 수비수 (자신 골대에 가장 가까운)와 골 라인 사이의 거리',
      AvgDefensiveLineDistanceIP: '볼 소유 시 가장 깊은 수비 라인의 위치와 골 사이의 거리',
      AvgDefensiveLineDistanceOOP: '볼 미소유 시 가장 깊은 수비 라인의 위치와 골 사이의 거리',
      AvgRBDistanceIP: '볼 소유 시 우측 풀백과 자신 골대 사이의 거리',
      AvgRBDistanceOOP: '볼 미소유 시 우측 풀백과 자신 골대 사이의 거리',
      AvgLBDistanceIP: '볼 소유 시 좌측 풀백과 자신 골대 사이의 거리',
      AvgLBDistanceOOP: '볼 소유 시 좌측 풀백과 자신 골대 사이의 거리',
      AvgBlockDistanceIP: '볼 소유 시 가장 깊은 선수와 가장 앞선 선수 사이의 거리',
      AvgBlockDistanceOOP: '볼 미소유 시 가장 깊은 선수와 가장 앞선 선수 사이의 거리',
      AvgBlockAreaIP: '볼 소유 시 모든 선수를 둘러싼 경계 상자의 면적 (팀이 차지하는 공간의 측정)',
      AvgBlockAreaOOP: '볼 미소유 시 모든 선수를 둘러싼 경계 상자의 면적 (팀이 차지하는 공간의 측정)',
      AvgDefensiveLineWidthOOP: '볼 미소유 시 가장 뒤쪽 선수 라인의 폭 (자신 골대에서 가장 먼)',
      AvgOffensiveLineLastThirdWidthIP: '볼 소유 시 최종 3분의 1에서 공격 라인의 수평 폭',
      AvgLByIP: '볼 소유 시 좌측 풀백의 위치',
      AvgRByIP: '볼 소유 시 우측 풀백의 위치',
      AvgOffensiveLineDistanceIP: '볼 소유 시 자신 골대와 공격 라인 사이의 거리',
      AvgOffensiveLineLastThirdDistanceIP: '볼 소유 시 자신 골대와 최종 3분의 1에서 공격 라인 사이의 거리',
      AvgOffensiveLineWidthIP: '볼 소유 시 공격 라인의 수평 폭',
      OffBallRuns: '공격 단계를 지원하기 위한 의도적인 오프볼 움직임 (런)',
      OffBallRunsOverlap: '팀원이 볼을 소유하고 있을 때 선수가 팀원의 바깥쪽 (터치라인에 더 가까운)으로 이동하는 런',
      OffBallRunsUnderlap: '선수가 팀원의 안쪽으로 이동하여 내부 경로 (피치 중앙에 더 가까운)를 취하는 런',
      OffBallRunsRunAhead: '볼 소유자를 넘어서지만 마지막 수비수 앞에 머무는 전진 런',
      OffBallRunsRunBehind: '마지막 수비 라인을 돌파하여 수비수와 골키퍼 사이로 들어가는 전진 런',
      OffBallRunsCrossReceiver: '선수가 박스로 달려가 팀원의 크로스를 받을 위치를 잡음',
      OffBallRunsSupport: '선수가 볼 소유자와 정렬되도록 달려가 공격에서 가까운 패스 옵션을 제공',
      OffBallRunsComingShort: '선수가 볼 소유자 쪽으로 이동하여 가까운 지원 또는 골에서 멀리 떨어진 패스 옵션을 제공',
      AerialsOppHalf: '경기 상대 진영에서 성공한 공중볼 경합 수',
      CarriesIntoFinalThird: '최종 3분의 1 외부에서 내부까지 최소 7미터의 파이프라인',
      SpeedScore: '다양한 속도 지표를 기반으로 한 플레이어의 물리적 성능',
      EnduranceScore: '다양한 지표를 기반으로 한 플레이어 지구력 물리적 성능',
      SwitchPlaySuccessful: '공의 측면 변위가 상대 골문을 향한 변위보다 더 큰 32미터 이상의 완료된 패스 수',
      SwitchPlayTotal: '공의 측면 변위가 상대 골문을 향한 변위보다 더 큰 32미터 이상의 총 패스 시도 횟수',
      PassesInsideOppHalf: '상대 진영에서 시작하고 끝나는 총 패스 수',
      PassesInsideOppHalfSuccessful: '상대 진영에서 시작하고 끝나는 패스의 수',
      TacklesAttemptedFirstThird: '경기장의 첫 1/3 구간에서 시도된 태클의 총 횟수',
      TacklesAttemptedSecondThird: '경기장의 2/3 지점에서 시도된 태클의 총 횟수',
      TacklesFirstThird: '경기장의 첫 1/3 지점에서 성공한 태클 횟수',
      TacklesSecondThird: '경기장의 2/3 지점에서 성공한 태클 횟수',
      FoulsOwnHalf: '자신의 진영에서 범한 파울 수',
      TouchesOppHalf: '상대 진영의 볼 터치 횟수',
      TacklesAttemptedNotAdjusted: '소유권 조정 없이 태클을 시도한 총 횟수',
      TacklesSuccessfulNotAdjusted: '소유권 조정 없이 태클에 성공한 총 횟수',
      AvgTop5MaxSpeed: '플레이어의 최고 속도 5개 평균',
      LBPReceived: '라인 브레이크 패스를 받은 횟수입니다. 이는 공을 상대 골문에 최소 10% 더 가깝게 이동시키고 가까운 거리에 있는 한 쌍의 수비수와 교차하거나 수비 라인을 넘어 이동하는 완료된 패스입니다.',
      LBPMReceived: '상대 미드필더 라인을 돌파한 패스 수',
      LBPMDReceived: '상대 미드필더와 수비 라인을 모두 돌파한 패스 수',
      ThroughBallReceived: '상대팀의 마지막 수비라인을 돌파하는 패스를 받은 횟수',
      HsrDistanceIP: '스프린트 거리 >21km/h 소유',
      HsrDistanceOOP: '스프린트 거리 >21km/h의 소유권 없음',
      JoggingDistanceIP: '보유 조깅 거리',
      JoggingDistanceOOP: '점유 상태에서 조깅 거리',
      RunningDistanceIP: '보유 주행거리',
      RunningDistanceOOP: '점유 없는 주행 거리',
      SprintsDistanceIP: '스프린트 거리 >24km/h 소유',
      SprintsDistanceOOP: '스프린트 거리 >24km/h 소유권 없음',
      WalkingDistanceIP: '보유 도보거리',
      WalkingDistanceOOP: '소유물에서 도보 거리',
      RunningNumberIP: 'Number of times that the Player is moving at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h) for a time period of at least 1 second with possession',
      RunningNumberOOP: 'Number of times that the Player is moving at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h) for a time period of at least 1 second without possession',
      RunningDistancePctIP: 'Percentage of Running Distance with respect to total distance travelled with possession',
      RunningDistancePctOOP: 'Percentage of Running Distance with respect to total distance travelled without possession',
      RunningDistancePct: 'Percentage of Running Distance with respect to total distance travelled',
      HsrNumberIP: 'Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second with possession',
      HsrNumberOOP: 'Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second without possession',
      SprintsNumberIP: 'Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second with possession',
      SprintsNumberOOP: 'Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second without possession',
      SprintsDistancePctIP: 'Percentage of Sprint Distance with respect to total distance travelled with possession',
      SprintsDistancePctOOP: 'Percentage of Sprint Distance with respect to total distance travelled without possession',
      SprintsDistancePct: 'Percentage of Sprint Distance with respect to total distance travelled',
      PossessionRegain: '상대방이 점유권을 잃게 만든 횟수',
      HandPassesSuccessful: '손으로 패스 성공(골키퍼 또는 세트피스에서 던지기)',
      HandPassesTotal: '손으로 패스한 총 횟수(골키퍼 또는 세트피스에서 던지기)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player'
    },
    subtitles: {
      Possession: '팀의 볼 소유 비율',
      TimePossession: '팀의 볼 소유 시간',
      PassesPerShots: '슛당 평균 패스 수',
      PPDA: '상대가 볼을 소유하고 있을 때 팀이 상대 선수에게 가하는 압박',
      Directness: '옆으로 가는 패스 대비 전진 패스의 높은 양',
      ExpectedPoints: '예상 골을 기반으로 계산된 팀의 예상 점수',
      PassesPerLongBall: '완료된 패스 총 수 대비 성공한 롱 패스 비율',
      CrossingPerXG: '크로스에서 나온 예상 골 비율',
      PenaltySavedPenaltyFaced: '모든 페널티 슛 대비 세이브한 페널티 슛 비율',
      Goals: '경기 득점 수',
      PenaltyShots: '페널티 킥에서 시도한 슛 총 수',
      PenaltyGoals: '페널티 킥에서 득점한 골 총 수',
      NonPenaltyGoals: '경기 골 수 (페널티 제외)',
      AerialWins: '경기 공중볼 경합 승리',
      AerialEfficiency: '경기 공중볼 경합 승리와 공중볼 경합 총 수를 결합한 지표',
      AerialWinsPct: '공중볼 경합 승리 비율',
      Assists: '경기 어시스트',
      Catching: '골키퍼가 볼을 잡은 세이브 비율',
      Caught: '골키퍼가 공을 잡고 있는 위치를 저장하여 두 번째 플레이를 방지합니다.',
      ChancesCreated: '경기 슛으로 이어지는 패스 수',
      ClaimAccuracy: '평균 이상으로 획득한 볼',
      CompletedCrosses: '경기 성공적으로 완료한 크로스',
      Crossing: '성공한 크로스 비율',
      Dispossessed: '경기 턴오버',
      Finishing: '골로 끝난 슛 비율',
      xGEfficiency: '선수가 골을 넣기 위해 필요한 예상 골 수',
      Fouls: '경기 파울',
      DeepProgression: '볼 운반으로 피치의 마지막 5분의 1에 도달한 횟수 더하기 마지막 5분의 1에서 볼 소유 횟수',
      DeepProgressionFinalThird: '경기 선수가 최종 3분의 1에서 볼을 소유한 횟수',
      FoulsTaken: '경기 받은 파울',
      IndividualPressure: '경기 성공한 노력 (볼 회수)',
      Interceptions: '경기 볼 인터셉트',
      LongBallPct: '최소 32미터의 완료된 패스 비율',
      LongBallTotal: '32미터 이상의 총 패스 횟수',
      LongBallSuccessful: '경기 최소 32미터의 완료된 패스',
      NPGOpenPlay: '경기 오픈 플레이 액션으로 득점한 골 (페널티 제외)',
      NPGSetPiece: '경기 세트피스 액션으로 득점한 골 (페널티 제외)',
      OpenPlayKeyPasses: '경기 오픈 플레이에서 슛으로 끝난 패스 (어시스트 제외)',
      OpenPlayKeyPassesInTeam: '팀 내 오픈 플레이에서 슛으로 끝난 패스 비율 (어시스트 제외)',
      PassingFinalThird: '경기 최종 3분의 1로 성공한 패스',
      PassesFinalThirdTotal: '크로스, 세트피스, 코너킥, 스로인을 제외하고 파이널 써드에서 끝나는 총 패스 시도 횟수',
      PassingFinalThirdPct: '최종 3분의 1에서 성공한 패스 비율',
      PassingOppHalfPct: '상대 진영으로 성공한 패스 비율',
      PassingOwnHalfPct: '자신 진영으로 성공한 패스 비율',
      PassingPct: '성공한 패스 비율',
      Recoveries: '경기 볼 회수 (태클 또는 인터셉트를 통해)',
      SavesInBoxPct: '경기 박스 안에서 나온 슛의 세이브 비율',
      SavesOutOfBoxPct: '경기 박스 밖에서 나온 슛의 세이브 비율',
      SavesPct: '세이브 비율',
      ScoringContribution: '경기 어시스트 및 골 수',
      xAssistsOpenPlay: '경기 오픈 플레이로 생성한 예상 어시스트 수',
      xAssistsSetPiece: '경기 세트피스로 생성한 예상 어시스트 수',
      xAssistsOpenPlayInTeam: '경기 팀 내 오픈 플레이로 생성한 예상 어시스트 수',
      xAssistsSetPieceInTeam: '경기 팀 내 세트피스로 생성한 예상 어시스트 수',
      xGChainFinalThird: '선수가 최종 3분의 1에서 참여한 xG 양',
      xGBuildupFinalThird: '선수가 최종 3분의 1에서 참여한 xG 양 (슛 및 슛으로 이어지는 패스 제외)',
      BallProgressionPassing: '선수가 패스로 볼을 10미터 이상 전진시킨 횟수',
      BallProgressionDribbling: '선수가 볼 운반으로 볼을 10미터 이상 전진시킨 횟수',
      Shooting: '유효 슛 비율 (페널티 제외)',
      Shots: '경기 시도한 슛 수',
      ShotsPerGoal: '골을 넣기 위해 시도한 평균 슛 수',
      SuccessfulDribbles: '경기 성공한 드리블',
      TacklesSuccessful: '경기 태클 총 수',
      TacklesWasDribbled: '태클을 통해 승리한 경합 비율',
      ThroughBalls: '경기 수비 라인을 돌파한 패스 수',
      TouchesInOpponentBox: '경기 상대 박스에서 볼 컨트롤 횟수',
      xAssists: '경기 생성한 예상 어시스트',
      xG: '경기 생성한 예상 골',
      xGDiff: 'xG와 골의 차이',
      xGOpenPlay: '경기 오픈 플레이로 생성한 예상 골',
      xGSetPiece: '경기 세트피스로 생성한 예상 골',
      xGBuildup: '경기 xG 빌드 참여',
      xGBuildupInTeam: '경기 팀 내 xG 빌드 참여',
      BallProgression: '경기 패스 또는 볼 운반으로 최소 10미터 전진',
      xGChain: '경기 xG 체인 참여',
      xGPerNPG: '경기 페널티 제외 골을 넣기 위해 필요한 예상 골',
      xGPerShot: '슛당 평균 xG',
      xGSavedPerShot: '맞은 슛당 평균 세이브된 xG',
      xGSavedPerXGFacedOnTarget: '유효 슛으로 맞은 xG당 평균 세이브된 xG',
      xGFacedOnTargetPerGoalReceived: '특정 골키퍼에게 골을 넣기 위해 필요한 예상 골',
      xGFacedOnTargetEfficiency: '경기 골키퍼가 막은 페널티 제외 골 수',
      xGFacedOnTarget: '경기 골키퍼가 맞은 총 xG (세이브 및 득점)',
      HighTurnovers: '자신 골대에서 40미터 이내에서 발생한 볼 소유권 이탈',
      OpenPlayPassesIntoOpponentBox: '경기 상대 박스로 들어간 오픈 플레이 패스 총 수',
      OpenPlayPassesIntoOpponentBoxSuccessful: '경기 상대 박스로 들어간 오픈 플레이 완료 패스',
      ChancesCreatedOP: '경기 오픈 플레이 중 슛으로 이어지는 패스 수',
      PenaltiesTaken: '경기 선수가 상대 박스에서 파울을 당한 횟수',
      BlockedCrosses: '경기 차단된 크로스',
      BlockedShots: '경기 차단된 슛',
      NonPenaltyGoalsAgainst: '경기 허용한 페널티 제외 골 수',
      Headers: '헤더로 시도한 슛 수',
      AveragePassDistance: '패스의 평균 거리 (미터)',
      ProgressiveRuns: '볼 소유를 상대 골대에 20% 더 가깝게 만든 성공한 볼 운반',
      xT: '경기 위험한 지역으로 볼을 이동시켜 생성한 위협',
      xTOpenPlay: '경기 오픈 플레이 중 생성한 예상 위협',
      xTSetPiece: '경기 세트피스로 생성한 예상 위협',
      xGOT: '골키퍼가 맞은 예상 골 수',
      BadActions: '범한 모든 나쁜 액션의 합',
      BadActionsOwnHalf: '자신 진영에서 범한 모든 나쁜 액션의 합',
      AerialsWonOwnBox: '자신 박스에서 공중볼 경합 승리',
      AerialsWonOppBox: '상대 박스에서 공중볼 경합 승리',
      AerialsTotalOppBox: '상대 박스에서 공중볼 경합 총 수',
      AerialsTotalOwnBox: '자신 박스에서 공중볼 경합 총 수',
      FoulsOwnHalfPct: '자신 진영에서 범한 파울 비율',
      RecoveriesOppHalf: '경기 선수가 상대 진영에서 회수한 볼 수',
      DuelsPct: '성공한 경합 비율',
      TacklesUnsuccessful: '상대가 성공적으로 드리블로 통과할 때 선수가 볼을 획득하지 못한 횟수',
      TacklesWasDribbledFirstThird: '최종 3분의 1에서 대면했을 때 선수가 볼을 회수한 비율',
      TacklesWasDribbledSecondThird: '수비 1대1 승리 2/3',
      TacklesWasDribbledFinalThird: '수비 1대1 승리 끝 1/3',
      BallProgressionFinalThird: '선수가 최종 3분의 1에서 10미터 이상 전진한 횟수',
      DuelsTotal: '경기 시도한 태클, 공중볼, 볼 터치, 드리블 및 파울 총 수',
      QuickRecoveries: '볼 소유권을 잃은 후 5초 이내에 자신 골대에서 40미터 이상 떨어진 곳에서 한 회수',
      ShotsPerNPG: '페널티 제외 골을 넣기 위한 평균 슛 수',
      ShotsOutBox: '경기 박스 밖에서 시도한 슛 수',
      GoalsOutBox: '경기 박스 밖에서 넣은 골 수',
      ShootingOutBox: '박스 밖에서 나온 유효 슛 비율',
      HandPassing: '손으로 한 패스 정확도',
      ShotEndingHighTurnovers: '높은 턴오버 (자신 골대에서 40미터 이내의 턴오버)로 끝난 상대팀의 슛',
      GoalEndingHighTurnovers: '높은 턴오버 (자신 골대에서 40미터 이내의 턴오버)로 끝난 상대팀의 골',
      AverageCarriesProgress: '선수가 볼 운반당 볼을 수직으로 이동한 평균 거리 (미터)',
      ChanceEndingCarries: '최소 7미터 볼 운반으로 끝난 슛으로 이어지는 패스',
      AssistEndingCarries: '최소 7미터 볼 운반으로 끝난 골로 이어지는 패스',
      ShotEndingCarries: '최소 7미터 볼 운반으로 끝난 슛',
      GoalEndingCarries: '최소 7미터 볼 운반으로 끝난 골',
      ShotEndingSequence: '선수가 참여한 슛으로 끝난 시퀀스 수',
      GoalEndingSequence: '선수가 참여한 골로 끝난 시퀀스 수',
      AerialWonOffensive: '경기 공격 공중볼 경합 승리',
      AerialWonDefensive: '경기 수비 공중볼 경합 승리',
      xGAgainst: '허용한 예상 골',
      xGDiffAgainst: '허용한 예상 골과 허용한 골의 차이',
      xGPerNPGAgainst: '허용한 페널티 제외 골당 받은 예상 골',
      xGOpenPlayAgainst: '오픈 플레이로 생성한 예상 골 허용',
      xGSetPieceAgainst: '세트피스로 생성한 예상 골 허용',
      xGPerShotAgainst: '허용한 슛당 받은 예상 골',
      ShotsAgainst: '경기 허용한 슛',
      ShotsOnTargetAgainst: '경기 허용한 유효 슛',
      RivalPossession: '상대의 볼 소유',
      AerialDefensivePct: '볼 미소유 시 공중볼 승리 비율',
      HighRecoveries: '상대 골대에서 40미터 가까운 곳에서 한 회수',
      HighDefensiveActions: '자신 골대 라인에서 40미터 이상 떨어진 곳에서 한 수비 액션 (태클, 인터셉트, 블록, 파울, 1대1)',
      HighDefensiveActionPct: '자신 골대 라인에서 40미터 이상 떨어진 곳에서 한 수비 액션 비율 (태클, 인터셉트, 블록, 파울, 1대1)',
      HighDefensiveDistance: '모든 수비 액션의 자신 골대로부터 평균 거리',
      PassesPerPossession: '볼 소유당 패스 수',
      LengthPerPossession: '볼 소유당 거리',
      xTNet: '순 예상 위협',
      AvgCarriesDistance: '평균 볼 운반 거리',
      PassesForwardPct: '전진 패스 비율',
      PassesForwardSuccessful: '성공적인 포워드 패스',
      PassesForwardTotal: '총 포워드 패스',
      TacklesAttempted: '시도한 태클 수',
      DuelsLost: '패배한 경합 수',
      Carries: '볼 운반',
      CarriesPct: '볼 운반 비율',
      Aerials: '경기 공중볼 경합 총 수',
      ProgressivePassesReceivedIntoBox: '상대 박스로 받은 전진 패스',
      PassesOppHalf: '상대 진영으로 끝난 성공한 패스',
      LongBallReceived: '받은 롱 패스 수 (>32미터)',
      ShotsOnTarget: '경기 유효 슛 수',
      AggressiveActions: '볼 소유권을 잃은 후 2초 이내에 시도한 태클 수',
      Crosses: '경기 크로스 총 수',
      xGBuildup5pass: '선수가 참여한 xG 양, 마지막 5개 패스만 (슛과 슛으로 이어지는 패스 제외)',
      DefensiveDistance: '수행한 수비 경합의 자신 골대로부터 평균 거리',
      SpeedSequence: '팀의 모든 볼 소유의 평균 속도 (이동한 거리/소요 시간)',
      Touches: '경기 선수가 볼을 소유한 횟수',
      AerialsTotalOppHalf: '경기 상대 진영으로 들어간 공중볼 경합 총 수',
      AerialsWonOppHalf: '플레이당 상대 진영으로 공중 결투 성공',
      AerialsWonOppHalfPct: '상대 진영에서 승리한 공중볼 경합 비율',
      AerialsPctOppBox: '상대 박스로 들어간 공중볼 경합 승리 비율',
      AerialsPctOwnBox: '자신 박스로 들어간 공중볼 경합 승리 비율',
      AerialDefensive: '상대 팀이 볼을 소유하고 있을 때 공중볼 경합 총 수',
      AerialOffensive: '자신 팀이 볼을 소유하고 있을 때 공중볼 경합 총 수',
      AerialOffensivePct: '자신 팀이 볼을 소유하고 있을 때 공중볼 승리 비율',
      IndividualPressureOppHalf: '선수가 상대 진영에서 상대를 압박할 때 회수한 볼 소유',
      TouchesPerShot: '슛당 선수들이 볼을 터치한 횟수',
      PassesFinalThirdTotalPct: '최종 3분의 1로 들어간 패스 비율 (성공 및 실패 포함)',
      xACrosses: '경기 크로스에서 생성한 예상 어시스트',
      Passes: '경기 패스 총 수',
      PassesSuccessful: '경기 완료한 패스 수',
      TacklesWasDribbledFouls: '총 태클 및 파울 대비 승리한 태클 비율',
      OffsidesCaught: '오프사이드 적발',
      ProgressivePassesReceivedFinalThird: '최종 3분의 1로 받은 전진 패스',
      ProgressivePassesReceived: '받은 전진 패스',
      Breadth: '경기 필드 측면에서 시도한 태클, 챌린지, 인터셉트 및 파울의 합',
      DuelsDefTotal: '시도한 태클, 수비 공중볼 경합 및 파울의 총 합',
      DefensiveActions: '상대가 드리블을 시도할 때 한 수비 액션 (태클, 챌린지, 파울)',
      ProgressivePassesReceivedOppHalf: '상대 진영으로 받은 전진 패스',
      CompletedCrossesOP: '오픈 플레이 완료한 크로스',
      CrossingOP: '오픈 플레이에서 시도한 크로스 중 완료한 크로스 비율',
      CrossesOP: '오픈 플레이 중 총 크로스 수',
      PassingContribution: '수신자의 위치를 고려하여 패스의 위협을 측정하는 비율',
      BallProgressionOppHalfInTeam: '% 팀 내 상대 진영 볼 전진',
      PassesOPIntoBoxInTeam: '% 팀 내 오픈 플레이 박스로 패스',
      TouchesOppBoxInTeam: '% 팀 내 상대 박스 터치',
      xGOPInTeam: '% 팀 내 오픈 플레이 xG',
      DeepPasses: '상대 골대 반경 20미터 밖에서 시작하여 그 영역 안으로 끝난 패스',
      DeepPassesTotal: '상대 골대 반경 20m 밖에서 시도한 패스 중 해당 지역 안으로 끝나는 총 패스 수',
      DefensiveDuelsPct: '총 수비 경합 대비 승리한 수비 경합 비율',
      QuickRecoveriesPct: '인터셉트 및 시도한 태클 대비 빠른 볼 회수 비율',
      DiffDefensiveDistanceTeam: '선수의 수비 거리와 팀의 수비 거리 차이',
      xTPassing: '패스에서만 생성한 예상 위협',
      xTPassing100Passes: '패스에서만 생성한 예상 위협 및 100패스당',
      ProgressivePassesAccurate: 'X축에서 10미터 이상의 완료한 패스',
      PassAbility: '완료한 패스 대비 예상 패스(xP) 비율',
      OPPassesIntoOppBoxPct: '오픈 플레이에서 상대 박스로 완료한 패스 대비 시도한 패스 비율',
      EntriesOppBox: '상대 박스로 들어간 패스 및 볼 운반 수',
      Crosses6yardBox: '6야드 박스로 끝난 크로스 총 수',
      Cutbacks: '베이스라인에서 뒤로 그리고 상대 박스 안으로 한 패스',
      xTDribbling: '드리블에서만 생성한 예상 위협',
      AvgShotDistance: '시도한 총 슛의 평균 거리',
      xGOnTarget: '유효 슛에서 나온 예상 골',
      FinishingxGOT: '평균 이상으로 골로 끝난 유효 슛 비율',
      DribblesWonOwnHalf: '자신 진영에서 성공한 드리블',
      DribblesOwnHalf: '자신 진영에서 시도한 드리블 수',
      DribblesOwnHalfPct: '자신 진영에서 성공한 드리블 및 시도한 드리블 비율',
      DribblesWonOppHalf: '상대 진영에서 성공한 드리블',
      DribblesOppHalf: '상대 진영에서 시도한 드리블 수',
      DribblesOppHalfPct: '상대 진영에서 성공한 드리블 및 시도한 드리블 비율',
      DribblesWonFinalThird: '최종 3분의 1에서 성공한 드리블',
      DribblesFinalThird: '최종 3분의 1에서 시도한 드리블 수',
      DribblesFinalThirdPct: '최종 3분의 1에서 성공한 드리블 및 시도한 드리블 비율',
      ShotEndingHighRecoveries: '높은 볼 회수(상대 골대에서 40미터 이내)로 끝난 슛',
      PassingFinalThirdAgainst: '상대에서 최종 3분의 1로 한 성공한 패스',
      OpenPlayPassesIntoOpponentBoxAgainst: '오픈 플레이 중 상대에서 자신 박스로 시도한 패스 총 수',
      EntriesOppBoxAgainst: '상대에서 자신 박스로 들어간 패스 및 볼 운반 수',
      DeepProgressionAgainst: '상대가 볼 운반으로 피치의 마지막 5분의 1에 도달한 횟수 더하기 첫 번째 5분의 1에서 볼 소유 횟수',
      TouchesInOpponentBoxAgainst: '상대가 자신 박스에서 볼을 소유한 횟수',
      Score: '다양한 지표를 기반으로 한 선수 성과',
      PDScore: '다양한 신체 지표를 기반으로 한 선수 신체 성과',
      OrlegiScore: '오를레기 점수',
      SirScore: '시리우스 점수',
      ExcScore: '다양한 지표를 기반으로 한 선수 성과',
      xTOPInTeam: '팀 내 오픈 플레이 중 생성한 예상 위협',
      YellowCards: '경기 받은 옐로우 카드',
      RedCards: '경기 받은 레드 카드',
      xTOpenPlayAgainst: '경기 오픈 플레이 중 허용한 예상 위협',
      xTSetPieceAgainst: '경기 세트피스로 허용한 예상 위협',
      NPGOpenPlayAgainst: '경기 오픈 플레이 액션으로 허용한 페널티 제외 골 수',
      NPGSetPieceAgainst: '경기 세트피스 액션으로 허용한 페널티 제외 골 수',
      PassesOppHalfPerPossession: '볼 소유당 상대 진영 패스',
      AverageTimeRecovery: '평균 회수 시간',
      ExpectedPassing: '완료되어야 했던 패스 비율',
      NumPossession10Passes: '10개 이상의 패스로 생성한 볼 소유',
      PassesReceived: '받은 패스',
      PassesReceivedFinalThird: '최종 3분의 1에서 받은 패스',
      ProgressivePassesTotalPct: '전진 패스 비율',
      ShortPassesPct: '짧은 패스 비율',
      TouchesOppBoxOppTeam: '선수가 경기장에 있을 때 자신 박스 안에서 허용한 상대 액션 수',
      ShotsOnTargetOppTeam: '선수가 경기장에 있을 때 허용한 유효 슛',
      NPGOppTeam: '선수가 경기장에 있을 때 허용한 페널티 제외 골',
      xGSetPiecePerxG: '예상 골 하나를 생성하기 위해 필요한 세트피스로 생성한 예상 골',
      ShotsOpenPlay: '오픈 플레이로 생성한 슛 수',
      ShotsOpenPlayAgainst: '오픈 플레이로 허용한 슛 수',
      ShotsFromDribble: '상대를 드리블로 제친 후 시도한 슈팅',
      GoalsFromDribble: '상대를 드리블로 제친 후 기록한 득점',
      PassesIntoFinalThird: '파이널 서드에서 시작된 성공적인 패스',
      PassesIntoFinalThirdTotal: '외부에서 시작하여 파이널 써드 내부에서 끝나는 총 패스 시도 횟수',
      PassesInsideFinalThird: '파이널 서드 내에서 시작되고 종료된 성공적인 패스',
      PassesInsideFinalThirdTotal: '파이널 서드 내에서 시도된 총 패스 횟수(파이널 서드에서 시작 및 종료)',
      PassesFinalThirdNoArea: '파이널 3번째 통과(박스 없음)',
      PassesIntoOppBox: '상대 박스 내에서 종료된 성공적인 패스',
      CarriesFinalThird: '파이널 서드에서 종료된 최소 7미터 이상의 드리블',
      CarriesInsideFinalThird: '파이널 서드 내에서 이루어진 최소 7미터 이상의 드리블',
      CarriesFinalThirdNoBox: 'Final Third 운반(박스 없음)',
      CarriesIntoOppBox: '상대 박스 내에서 종료된 최소 7미터 이상의 드리블',
      TimePossessionAgainst: '상대 팀의 공 점유 시간',
      TimePossessionTotal: '양 팀의 총 공 점유 시간',
      PassesInBox: '자기 진영 박스 내에서의 성공적인 패스',
      LongThrowInSuccessful: '20미터 이상을 목표로 한 성공적인 롱 스로인',
      LongThrowInTotal: '20미터 이상 롱 스로인의 총 횟수',
      LongThrowInPct: '성공적인 롱 스로인의 비율 (20미터 이상)',
      Games: '플레이한 게임',
      PointsPerGame: '게임당 포인트',
      ExpectedPointsDiff: '기대 포인트 차이',
      PassesTotalOwnHalf: '자기 진영에서 패스한 총 횟수',
      PassesOwnHalf: '자기 진영에서 성공한 패스 수',
      PassesTotalOppHalf: '상대 진영에서 이루어진 총 패스 수',
      ProgressivePassesTotal: 'X축에서 10미터 이상의 총 패스 수',
      DuelsWon: '성공적인 결투(태클, 에어리얼, 볼 터치, 드리블 및 파울 범함)',
      NonPenaltySaves: '페널티킥을 제외한 세이브',
      BadActionsOppHalf: '상대 진영에서 저지른 모든 나쁜 행동의 합',
      CarriesSuccessful: '성공적인 이벤트로 끝나는 최소 7m의 운반 수',
      ShotsOnTargetOutBox: '박스 밖에서 목표물을 향해 시도한 슛',
      TotalDistance: '총 거리',
      WalkingDistance: '경기 중 선수가 2 m/s (7.2 km/h) 미만의 속도로 이동한 총 거리',
      JoggingDistance: '경기 중 선수가 2 m/s (7.2 km/h) 이상 4 m/s (14.4 km/h) 미만의 속도로 이동한 총 거리',
      RunningDistance: '경기 중 선수가 4 m/s (14.4 km/h) 이상 5.5 m/s (19.8 km/h) 미만의 속도로 이동한 총 거리',
      ExtremeAccelerations: '선수가 3 m/s<sup>2</sup> 이상으로 가속한 횟수',
      NumberOfRuns: '14.4 km/h 이상 19.8 km/h 미만의 속도로 완료한 런 수',
      HsrDistance: '고속 런 거리 > 19.8 km/h',
      HsrNumber: '고속 런 횟수 > 19.8 km/h',
      HsrDistancePct: '% HSR 거리',
      SprintsNumber: '스프린트 횟수 > 25.2 km/h',
      SprintsDistance: '스프린트 거리 > 25.2 km/h',
      SprintNumberDeclinePct: '% 스프린트 횟수 감소',
      SprintDistanceDeclinePct: '% 스프린트 거리 감소',
      SprintNumberDecline: '후반 대비 스프린트 횟수 감소',
      SprintDistanceDecline: '후반 대비 스프린트 중 이동 거리 감소',
      SprintDistancePct: '% 스프린트 거리',
      Accelerations: '가속 횟수',
      MaxSpeed: '최대 속도',
      AvgMaxSpeed: '선수가 달성한 최대 속도의 평균',
      MaxAccelerations: '선수가 달성한 최대 미터/초<sup>2</sup>',
      BypassedPlayersByPasses: '패스를 통해 우회한 상대 선수 (수비수 및 미드필더) 총 수',
      BypassedDefendersByPasses: '패스를 통해 우회한 상대 선수 (수비수) 총 수',
      PassesBypassingPlayers: '선수를 우회한 패스 수',
      PassesBypassingDefenders: '수비수를 우회한 패스 수',
      BypassedPlayersPerPass: '패스당 우회한 선수 총 수',
      BypassedDefendersPerPass: '패스당 우회한 수비수 총 수',
      LineBreakingPasses: '하나 이상의 수비 라인을 성공적으로 돌파한 패스 수',
      LineBreakingPassesMD: '미드필더 및 수비 라인을 성공적으로 돌파한 패스 수',
      LineBreakingPassesM: '미드필더 라인을 성공적으로 돌파한 패스 수',
      LineBreakingThroughBalls: '수비 라인을 성공적으로 돌파한 패스 수',
      LineBreakingPassesPerPass: '패스당 라인 돌파 패스 비율',
      TotalPassesUnderStrongPressure: '강한 압박 하에서 시도한 패스 총 수 (가장 가까운 상대로부터 0-2미터 이내)',
      TotalPassesUnderLightPressure: '압박 하에서 시도한 패스 총 수 (가장 가까운 상대로부터 2-4미터 이내)',
      SuccessfulPassesUnderStrongPressure: '강한 압박 하에서 성공한 패스 수 (가장 가까운 상대로부터 0-2미터 이내)',
      SuccessfulPassesUnderLightPressure: '압박 하에서 성공한 패스 수 (가장 가까운 상대로부터 2-4미터 이내)',
      PassingUnderStrongPressure: '강한 압박 하에서 성공한 패스 및 총 패스 비율 (가장 가까운 상대로부터 0-2미터 이내)',
      PassingUnderLightPressure: '압박 하에서 성공한 패스 및 총 패스 비율 (가장 가까운 상대로부터 2-4미터 이내)',
      PassReceiptsInSpaceCompleted: '수신자가 공격 진영에 있고 골 방향으로 5미터 반경 내에 수비수가 없는 패스',
      PassReceiptsInSpace: '공격 진영에서 수신했고 골 방향으로 5미터 반경 내에 수비수가 없는 패스',
      PassReceiptsInSpaceCompletedFirstThird: '공격 방향 5미터 이내에 수비수가 없는 상태에서, 1/3 지역에서 받은 패스',
      PassReceiptsInSpaceCompletedSecondThird: '공격 방향 5미터 이내에 수비수가 없는 상태에서, 2/3 지역에서 받은 패스',
      PassReceiptsInSpaceCompletedFinalThird: '공격 방향 5미터 이내에 수비수가 없는 상태에서, 파이널 서드에서 받은 패스',
      PassReceiptsInSpaceCompletedOppHalfRight: '상대 진영 오른쪽에서 수비수 없이 받은 패스',
      PassReceiptsInSpaceCompletedOppHalfCenter: '상대 진영 중앙에서 수비수 없이 받은 패스',
      PassReceiptsInSpaceCompletedOppHalfLeft: '상대 진영 왼쪽에서 수비수 없이 받은 패스',
      PassReceiptsInSpaceFirstThird: '1/3 지역에서 수비수 없이 받은 패스',
      PassReceiptsInSpaceSecondThird: '2/3 지역에서 수비수 없이 받은 패스',
      PassReceiptsInSpaceFinalThird: '파이널 서드에서 수비수 없이 받은 패스',
      PassReceiptsInSpaceOppHalfRight: '상대 진영 오른쪽에서 수비수 없이 받은 패스',
      PassReceiptsInSpaceOppHalfCenter: '상대 진영 중앙에서 수비수 없이 받은 패스',
      PassReceiptsInSpaceOppHalfLeft: '상대 진영 왼쪽에서 수비수 없이 받은 패스',
      TotalStrongOnBallPressures: '강한 볼 압박 수 (볼 소유자로부터 0-2미터 이내)',
      TotalLightOnBallPressures: '볼 압박 수 (볼 소유자로부터 2-4미터 이내)',
      SuccessfulStrongOnBallPressures: '성공한 강한 볼 압박 수 (0-2미터 이내)',
      SuccessfulLightOnBallPressures: '성공한 볼 압박 수 (2-4미터 이내)',
      StrongOnBallPressuresPct: '성공한 강한 볼 압박 및 총 강한 볼 압박 비율 (가장 가까운 상대로부터 0-2미터 이내)',
      LightOnBallPressuresPct: '성공한 볼 압박 및 총 볼 압박 비율 (가장 가까운 상대로부터 2-4미터 이내)',
      TimesBypassedByPasses: '패스로 우회당한 총 횟수',
      TimesBypassedByCarries: '볼 운반으로 우회당한 총 횟수',
      TimesBypassedByActions: '패스 및 볼 운반으로 우회당한 총 횟수',
      BypassedPlayersByCarries: '볼 운반을 통해 우회한 상대 선수 (수비수 및 미드필더) 총 수',
      BypassedDefendersByCarries: '볼 운반을 통해 우회한 상대 선수 (수비수) 총 수',
      BypassedPlayersByActions: '패스 및 볼 운반을 통해 우회한 상대 선수 (수비수 및 미드필더) 총 수',
      BypassedDefendersByActions: '패스 및 볼 운반을 통해 우회한 상대 선수 (수비수) 총 수',
      CarriesBypassingPlayers: '선수를 우회한 볼 운반 수',
      CarriesBypassingDefenders: '수비수를 우회한 볼 운반 수',
      BypassedPlayersPerCarry: '볼 운반당 우회한 상대 선수 평균 수 (최소 7미터)',
      BypassedDefendersPerCarry: '볼 운반당 우회한 수비수 평균 수 (최소 7미터)',
      LineBreakingCarries: '하나 이상의 수비 라인을 성공적으로 돌파한 볼 운반 수',
      LineBreakingCarriesMD: '미드필더 및 수비 라인을 성공적으로 돌파한 볼 운반 수',
      LineBreakingCarriesM: '미드필더 라인을 성공적으로 돌파한 볼 운반 수',
      LineBreakingCarriesD: '수비 라인을 성공적으로 돌파한 볼 운반 수',
      LineBreakingCarriesPerCarry: '볼 운반당 라인 돌파 볼 운반 비율',
      LineBreakingActions: '하나 이상의 수비 라인을 성공적으로 돌파한 패스 및 볼 운반 합계',
      LineBreakingActionsMD: '미드필더 및 수비 라인을 성공적으로 돌파한 패스 및 볼 운반 합계',
      LineBreakingActionsM: '미드필더 라인을 성공적으로 돌파한 패스 및 볼 운반 합계',
      LineBreakingActionsD: '수비 라인을 성공적으로 돌파한 패스 및 볼 운반 합계',
      PassesPerLineBreakingPass: '라인 돌파 패스당 총 패스 수 비율',
      CarriesPerLineBreakingCarry: '라인 돌파 볼 운반당 총 볼 운반 수 비율',
      LinesBrokenByPasses: '패스를 통해 돌파한 라인 총 수',
      LinesBrokenByCarries: '볼 운반을 통해 돌파한 라인 총 수',
      LinesBrokenByActions: '패스 및 볼 운반을 통해 돌파한 라인 총 수',
      LinesBrokenPerPass: '패스당 돌파한 라인 총 수 비율',
      LinesBrokenPerCarry: '볼 운반당 돌파한 라인 총 수 비율',
      AvgLastDefenderDistanceIP: '볼 소유 시 마지막 수비수 (자신 골대에 가장 가까운)와 골 라인 사이의 거리',
      AvgLastDefenderDistanceOOP: '볼 미소유 시 마지막 수비수 (자신 골대에 가장 가까운)와 골 라인 사이의 거리',
      AvgDefensiveLineDistanceIP: '볼 소유 시 가장 깊은 수비 라인의 위치와 골 사이의 거리',
      AvgDefensiveLineDistanceOOP: '볼 미소유 시 가장 깊은 수비 라인의 위치와 골 사이의 거리',
      AvgRBDistanceIP: '볼 소유 시 우측 풀백과 자신 골대 사이의 거리',
      AvgRBDistanceOOP: '볼 미소유 시 우측 풀백과 자신 골대 사이의 거리',
      AvgLBDistanceIP: '볼 소유 시 좌측 풀백과 자신 골대 사이의 거리',
      AvgLBDistanceOOP: '볼 소유 시 좌측 풀백과 자신 골대 사이의 거리',
      AvgBlockDistanceIP: '볼 소유 시 가장 깊은 선수와 가장 앞선 선수 사이의 거리',
      AvgBlockDistanceOOP: '볼 미소유 시 가장 깊은 선수와 가장 앞선 선수 사이의 거리',
      AvgBlockAreaIP: '볼 소유 시 모든 선수를 둘러싼 경계 상자의 면적 (팀이 차지하는 공간의 측정)',
      AvgBlockAreaOOP: '볼 미소유 시 모든 선수를 둘러싼 경계 상자의 면적 (팀이 차지하는 공간의 측정)',
      AvgDefensiveLineWidthOOP: '볼 미소유 시 가장 뒤쪽 선수 라인의 폭 (자신 골대에서 가장 먼)',
      AvgOffensiveLineLastThirdWidthIP: '볼 소유 시 최종 3분의 1에서 공격 라인의 수평 폭',
      AvgLByIP: '볼 소유 시 좌측 풀백의 위치',
      AvgRByIP: '볼 소유 시 우측 풀백의 위치',
      AvgOffensiveLineDistanceIP: '볼 소유 시 자신 골대와 공격 라인 사이의 거리',
      AvgOffensiveLineLastThirdDistanceIP: '볼 소유 시 자신 골대와 최종 3분의 1에서 공격 라인 사이의 거리',
      AvgOffensiveLineWidthIP: '볼 소유 시 공격 라인의 수평 폭',
      OffBallRuns: '공격 단계를 지원하기 위한 의도적인 오프볼 움직임 (런)',
      OffBallRunsOverlap: '팀원이 볼을 소유하고 있을 때 선수가 팀원의 바깥쪽 (터치라인에 더 가까운)으로 이동하는 런',
      OffBallRunsUnderlap: '선수가 팀원의 안쪽으로 이동하여 내부 경로 (피치 중앙에 더 가까운)를 취하는 런',
      OffBallRunsRunAhead: '볼 소유자를 넘어서지만 마지막 수비수 앞에 머무는 전진 런',
      OffBallRunsRunBehind: '마지막 수비 라인을 돌파하여 수비수와 골키퍼 사이로 들어가는 전진 런',
      OffBallRunsCrossReceiver: '선수가 박스로 달려가 팀원의 크로스를 받을 위치를 잡음',
      OffBallRunsSupport: '선수가 볼 소유자와 정렬되도록 달려가 공격에서 가까운 패스 옵션을 제공',
      OffBallRunsComingShort: '선수가 볼 소유자 쪽으로 이동하여 가까운 지원 또는 골에서 멀리 떨어진 패스 옵션을 제공',
      AerialsOppHalf: '경기 상대 진영에서 성공한 공중볼 경합 수',
      CarriesIntoFinalThird: '최종 3분의 1 외부에서 내부까지 최소 7미터의 파이프라인',
      DribblesAttempted: '드리블 시도 횟수',
      SpeedScore: '다양한 속도 지표를 기반으로 한 플레이어의 물리적 성능',
      EnduranceScore: '다양한 지표를 기반으로 한 플레이어 지구력 물리적 성능',
      GoalsConceded: '실점한 골 수',
      HeadedGoals: '머리로 득점한 골 수',
      SavesInBox: '박스 안의 슛으로 인한 세이브 횟수',
      SavesOutBox: '박스 밖에서 슛을 막아낸 횟수',
      ShotsOnTargetInBoxAgainst: '박스 내부에서 유효 슈팅 횟수 허용',
      ShotsOnTargetOutBoxAgainst: '박스 밖에서 유효 슈팅 횟수 허용',
      SwitchPlaySuccessful: '공의 측면 변위가 상대 골문을 향한 변위보다 더 큰 32미터 이상의 완료된 패스 수',
      SwitchPlayTotal: '공의 측면 변위가 상대 골문을 향한 변위보다 더 큰 32미터 이상의 총 패스 시도 횟수',
      PassesInsideOppHalf: '상대 진영에서 시작하고 끝나는 총 패스 수',
      PassesInsideOppHalfSuccessful: '상대 진영에서 시작하고 끝나는 패스의 수',
      TacklesAttemptedFirstThird: '경기장의 첫 1/3 구간에서 시도된 태클의 총 횟수',
      TacklesAttemptedSecondThird: '경기장의 2/3 지점에서 시도된 태클의 총 횟수',
      TacklesFirstThird: '경기장의 첫 1/3 지점에서 성공한 태클 횟수',
      TacklesSecondThird: '경기장의 2/3 지점에서 성공한 태클 횟수',
      FoulsOwnHalf: '자신의 진영에서 범한 파울 수',
      TouchesOppHalf: '상대 진영의 볼 터치 횟수',
      TacklesAttemptedNotAdjusted: '소유권 조정 없이 태클을 시도한 총 횟수',
      TacklesSuccessfulNotAdjusted: '소유권 조정 없이 태클에 성공한 총 횟수',
      AvgTop5MaxSpeed: '플레이어의 최고 속도 5개 평균',
      LBPReceived: '라인 브레이크 패스를 받은 횟수',
      LBPMReceived: '상대 미드필더 라인을 돌파한 패스 수',
      LBPMDReceived: '상대 미드필더와 수비 라인을 모두 돌파한 패스 수',
      ThroughBallReceived: '상대팀의 마지막 수비라인을 돌파하는 패스를 받은 횟수',
      ShortPassesSuccessful: '짧은 패스(12미터 미만) 완료 횟수',
      PassingSuccessForwardPct: '성공적인 전진패스 비율',
      PassingSuccessBackwardPct: '성공적인 역방향 패스 비율',
      PassingForwardBackwardPct: '전진 패스와 역전 패스의 비율',
      LongBallPerPassesPct: '총 패스 대비 긴 공의 비율',
      LongBallReceivedOppHalf: '라이벌 필드에서 롱볼을 받은 횟수',
      OffensiveActions: '공격적인 행동',
      SuccessfulDribblesPct: '성공적인 드리블/총 드리블 시도 횟수',
      OffensiveTouchesOutBoxPct: '박스 밖의 공격적인 터치 %',
      HsrDistanceIP: '스프린트 거리 >21km/h 소유',
      HsrDistanceOOP: '스프린트 거리 >21km/h의 소유권 없음',
      JoggingDistanceIP: '보유 조깅 거리',
      JoggingDistanceOOP: '점유 상태에서 조깅 거리',
      RunningDistanceIP: '보유 주행거리',
      RunningDistanceOOP: '점유 없는 주행 거리',
      SprintsDistanceIP: '스프린트 거리 >24km/h 소유',
      SprintsDistanceOOP: '스프린트 거리 >24km/h 소유권 없음',
      WalkingDistanceIP: '보유 도보거리',
      WalkingDistanceOOP: '소유물에서 도보 거리',
      PossessionRegain: '상대방이 점유권을 잃게 만든 횟수',
      HandPassesSuccessful: '손으로 패스 성공(골키퍼 또는 세트피스에서 던지기)',
      HandPassesTotal: '손으로 패스한 총 횟수(골키퍼 또는 세트피스에서 던지기)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      Clearances: 'Number of times the player hits the ball clear of the defensive zone',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player (via Tackles or Interceptions)'
    },
    abbr: {
      Possession: 'POS%',
      TimePossession: 'TP',
      PassesPerShots: 'PPS',
      PPDA: 'PPDA',
      ExpectedPoints: 'XP',
      Points: 'P',
      Directness: 'DIR',
      PassesPerLongBall: 'PPLB',
      CrossingPerXG: 'CPxG',
      PenaltySavedPenaltyFaced: 'PSPF',
      Goals: 'GOA',
      PenaltyShots: 'PS',
      PenaltyGoals: 'PG',
      NonPenaltyGoals: 'NPG',
      NPGOpenPlay: 'NPGOP',
      NPGSetPiece: 'NPGSP',
      Shooting: 'SHO%',
      Finishing: 'FIN%',
      xGEfficiency: 'xGE',
      HeaderPerShot: 'HPS',
      HeaderPerCross: 'HPC',
      Assists: 'ASS',
      ThroughBalls: 'TB',
      CrossEfficiency: 'CE',
      ScoringContribution: 'SC',
      xAssistsOpenPlay: 'xAOP',
      xAssistsSetPiece: 'xASP',
      xAssistsOpenPlayInTeam: 'xAOPiT',
      xAssistsSetPieceInTeam: 'xASPiT',
      xGBuildupFinalThird: 'xGBUPFT',
      xGChainFinalThird: 'xGCFT',
      BallProgressionPassing: 'BPP',
      BallProgressionDribbling: 'BPD',
      TacklesWasDribbled: 'TWD%',
      TacklesSuccessful: 'STA',
      Interceptions: 'INT',
      Clearances: 'CLE',
      Fouls: 'FOU',
      Recoveries: 'REC',
      Shots: 'SHO',
      ShotsPerGoal: 'SPG',
      ShortPassesSuccessful: 'SPS',
      PassingSuccessForwardPct: 'PSF%',
      PassingSuccessBackwardPct: 'PSB%',
      PassingForwardBackwardPct: 'PFB%',
      LongBallPerPassesPct: 'LBP%',
      LongBallReceived: 'LBR',
      LongBallReceivedOppHalf: 'LBROH',
      OffensiveActions: 'OA',
      DribblesAttempted: 'DAT',
      SuccessfulDribblesPct: 'SD%',
      OffensiveTouchesOutBoxPct: 'OTOB%',
      BallRetention: 'BR',
      PassingPct: 'PA%',
      PassingOwnHalfPct: 'POH%',
      PassingOppHalfPct: 'POPH%',
      PassingFinalThird: 'PFT',
      PassesFinalThirdTotal: 'PFTT',
      PassingFinalThirdPct: 'PT%',
      LongBallSuccessful: 'LBS',
      LongBallPct: 'LB%',
      LongBallTotal: 'TLB',
      SavesPct: 'S%',
      SavesInBoxPct: 'SIB%',
      SavesOutOfBoxPct: 'SOOB%',
      xGSavedPerXGFacedOnTarget: 'xGSPFOT',
      xGFacedOnTargetPerGoalReceived: 'xGFOTPGR',
      xGFacedOnTargetEfficiency: 'xGFOTE',
      xGFacedOnTarget: 'xGFOT',
      IndividualPressure: 'IP',
      AerialEfficiency: 'AE',
      AerialWins: 'AEW',
      AerialWinsPct: 'AE%',
      xG: 'xG',
      xGDiff: 'xGD',
      xGOpenPlay: 'xGOP',
      xGSetPiece: 'xGSP',
      xGPerShot: 'xGPS',
      ChancesCreated: 'CC',
      CompletedCrosses: 'SCR',
      Crossing: 'CR%',
      OpenPlayKeyPasses: 'OPKP',
      OpenPlayKeyPassesInTeam: 'OPKPiT%',
      OpenPlayPassesIntoOpponentBox: 'OPPOPPB',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'OPPOPPBS',
      xAssists: 'xA',
      xGChain: 'xGC',
      xGBuildup: 'xGBUP',
      xGBuildupInTeam: 'xGBUPiT',
      BallProgression: 'BP',
      SuccessfulDribbles: 'SDR',
      Dispossessed: 'TOV',
      TouchesInOpponentBox: 'TOB',
      xGSavedPerShot: 'xGSS',
      BallRetentionOppHalf: 'BROPPH',
      DeepProgression: 'DP',
      DeepProgressionFinalThird: 'DPFT',
      FoulsTaken: 'FOUR',
      PenaltiesTaken: 'PT',
      BlockedCrosses: 'BC',
      BlockedShots: 'BS',
      Blocks: 'BLO',
      NonPenaltyGoalsAgainst: 'NPGC',
      Headers: 'HEA',
      AveragePassDistance: 'APD',
      ProgressiveRuns: 'PRC',
      xT: 'xT',
      xTOpenPlay: 'xTOP',
      xTSetPiece: 'xTSP',
      xGOT: 'xGOT',
      BadActions: 'BA',
      BadActionsOwnHalf: 'BAOH',
      AerialsWonOwnBox: 'AWOB',
      AerialsWonOppBox: 'AWOPPB',
      AerialsTotalOppBox: 'ATOPPB',
      AerialsTotalOwnBox: 'ATOB',
      FoulsOwnHalfPct: 'FOH%',
      RecoveriesOppHalf: 'ROH',
      DuelsPct: 'D%',
      TacklesUnsuccessful: 'UTA',
      TacklesWasDribbledFirstThird: 'TWDFT',
      TacklesWasDribbledSecondThird: 'TWDST',
      TacklesWasDribbledFinalThird: 'TWDFT',
      BallProgressionFinalThird: 'BPFT',
      DuelsTotal: 'DT',
      QuickRecoveries: 'QR',
      ShotsPerNPG: 'SPNPG',
      ShotsOutBox: 'SOB',
      GoalsOutBox: 'GOB',
      ShootingOutBox: 'SOB%',
      HandPassing: 'HP',
      Catching: 'CAT',
      Caught: 'CAU',
      ClaimAccuracy: 'CA',
      HighTurnovers: 'HTOV',
      ShotEndingHighTurnovers: 'SEHT',
      GoalEndingHighTurnovers: 'GEHT',
      AverageCarriesProgress: 'ACP',
      ChanceEndingCarries: 'CEC',
      AssistEndingCarries: 'AEC',
      ShotEndingCarries: 'SEC',
      GoalEndingCarries: 'GEC',
      ShotEndingSequence: 'SES',
      GoalEndingSequence: 'GES',
      xGPerNPG: 'xGPNPG',
      AerialWonOffensive: 'AWO',
      AerialWonDefensive: 'AWD',
      xGAgainst: 'xGC',
      xGDiffAgainst: 'xGDC',
      xGPerNPGAgainst: 'xGPNPGA',
      xGOpenPlayAgainst: 'xGOPC',
      xGSetPieceAgainst: 'xGSPC',
      xGPerShotAgainst: 'xGSC',
      ShotsAgainst: 'STC',
      ShotsOnTargetAgainst: 'SOTC',
      RivalPossession: 'RP',
      AerialDefensivePct: 'AD%',
      HighRecoveries: 'HR',
      HighDefensiveActions: 'HDA',
      HighDefensiveActionPct: 'HDA%',
      HighDefensiveDistance: 'HDD',
      PassesPerPossession: 'PPP',
      LengthPerPossession: 'LPP',
      xTNet: 'xTN',
      AvgCarriesDistance: 'ACD',
      PassesForwardPct: 'PF%',
      PassesForwardSuccessful: 'SFP',
      PassesForwardTotal: 'TFP',
      TacklesAttempted: 'ATA',
      DuelsLost: 'DL',
      Carries: 'CARR',
      CarriesPct: 'CARR%',
      Aerials: 'AER',
      ProgressivePassesReceivedIntoBox: 'PPRIB',
      PassesOppHalf: 'POPH',
      ShotsOnTarget: 'SOT',
      AggressiveActions: 'AA',
      Crosses: 'CRO',
      xGBuildup5pass: 'xGBUP5',
      DefensiveDistance: 'DD',
      SpeedSequence: 'SS',
      Touches: 'TOU',
      AerialsTotalOppHalf: 'ATOPPH',
      AerialsWonOppHalf: 'AWOPPH',
      AerialsWonOppHalfPct: 'AWOH%',
      AerialsPctOppBox: 'AOPPB%',
      AerialsPctOwnBox: 'AOB%',
      AerialDefensive: 'AD',
      AerialOffensive: 'AO',
      AerialOffensivePct: 'AO%',
      IndividualPressureOppHalf: 'IPOPPH',
      ChancesCreatedOP: 'CCOP',
      TouchesPerShot: 'TPS',
      PassesFinalThirdTotalPct: 'PFT%',
      xACrosses: 'xAC',
      Passes: 'PAS',
      PassesSuccessful: 'SPA',
      TacklesWasDribbledFouls: 'TWDF',
      OffsidesCaught: 'OC',
      ProgressivePassesReceivedFinalThird: 'PPRFT',
      ProgressivePassesReceived: 'PPR',
      Breadth: 'BRD',
      DuelsDefTotal: 'DDT',
      DefensiveActions: 'DA',
      ProgressivePassesReceivedOppHalf: 'PPROH',
      CompletedCrossesOP: 'CCOP',
      CrossingOP: 'COP',
      CrossesOP: 'COP',
      PassingContribution: 'PC',
      BallProgressionOppHalfInTeam: 'BPOPPHiT',
      PassesOPIntoBoxInTeam: 'POBIT',
      TouchesOppBoxInTeam: 'TOBIT',
      xGOPInTeam: 'xGOPiT',
      DeepPasses: 'DP',
      DeepPassesTotal: 'DPCT',
      DefensiveDuelsPct: 'DD%',
      QuickRecoveriesPct: 'QR%',
      DiffDefensiveDistanceTeam: 'DDDT',
      xTPassing: 'xTP',
      xTPassing100Passes: 'xTP100',
      ProgressivePassesAccurate: 'APP',
      xP: 'xP',
      PassAbility: 'PA',
      OPPassesIntoOppBoxPct: 'OPPIOB%',
      EntriesOppBox: 'EOPPB',
      Crosses6yardBox: 'C6YB',
      Cutbacks: 'CUT',
      xTDribbling: 'xTD',
      AvgShotDistance: 'ASD',
      xGOnTarget: 'xGOT',
      FinishingxGOT: 'FxGOT',
      DribblesWonOwnHalf: 'DWOH',
      DribblesOwnHalf: 'DOH',
      DribblesOwnHalfPct: 'DOH%',
      DribblesWonOppHalf: 'DWOPH',
      DribblesOppHalf: 'DOPH',
      DribblesOppHalfPct: 'DOPH%',
      DribblesWonFinalThird: 'DWFT',
      DribblesFinalThird: 'DFT',
      DribblesFinalThirdPct: 'DFT%',
      ShotEndingHighRecoveries: 'SEHR',
      PassingFinalThirdAgainst: 'PFTC',
      OpenPlayPassesIntoOpponentBoxAgainst: 'OPPOBC',
      EntriesOppBoxAgainst: 'EOBC',
      DeepProgressionAgainst: 'DPC',
      TouchesInOpponentBoxAgainst: 'TOBC',
      Score: 'SCO',
      PDScore: 'SCO',
      OrlegiScore: 'SCO',
      SirScore: 'SCO',
      ExcScore: 'SCO',
      xTOPInTeam: 'xTOPiT',
      YellowCards: 'YC',
      RedCards: 'RC',
      xTOpenPlayAgainst: 'xTOPC',
      xTSetPieceAgainst: 'xTSPC',
      NPGOpenPlayAgainst: 'NPG OPC',
      NPGSetPieceAgainst: 'NPG SPC',
      PassesOppHalfPerPossession: 'POHP',
      AverageTimeRecovery: 'ATR',
      ExpectedPassing: 'xP%',
      NumPossession10Passes: 'P10P',
      PassesReceived: 'PR',
      PassesReceivedFinalThird: 'PRLFT',
      ProgressivePassesTotalPct: 'PP%',
      ShortPassesPct: 'SP%',
      TouchesOppBoxOppTeam: 'TOBOT',
      ShotsOnTargetOppTeam: 'SOTOT',
      NPGOppTeam: 'NPGOT',
      xGSetPiecePerxG: 'xGSPPxG',
      ShotsOpenPlay: 'SOP',
      ShotsOpenPlayAgainst: 'SOPA',
      ShotsFromDribble: 'SFD',
      GoalsFromDribble: 'GFD',
      PassesIntoFinalThird: 'PIFT',
      PassesIntoFinalThirdTotal: 'PIFTT',
      PassesInsideFinalThird: 'PINSFT',
      PassesInsideFinalThirdTotal: 'PINSFTT',
      PassesFinalThirdNoArea: 'PFTNA',
      PassesIntoOppBox: 'PIOB',
      CarriesFinalThird: 'CFT',
      CarriesInsideFinalThird: 'CINSFT',
      CarriesFinalThirdNoBox: 'CFTNB',
      CarriesIntoOppBox: 'CIOB',
      TimePossessionAgainst: 'TPA',
      TimePossessionTotal: 'TPT',
      PassesInBox: 'PIB',
      LongThrowInSuccessful: 'LTInS',
      LongThrowInTotal: 'LTInT',
      LongThrowInPct: 'LTIn%',
      Games: 'GAM',
      PointsPerGame: 'PPG',
      ExpectedPointsDiff: 'XPD',
      PassesTotalOwnHalf: 'PTOH',
      PassesOwnHalf: '포',
      PassesTotalOppHalf: '프토프',
      ProgressivePassesTotal: 'TPP',
      DuelsWon: 'DW',
      NonPenaltySaves: 'NPS',
      BadActionsOppHalf: '바오프',
      CarriesSuccessful: 'CS',
      ShotsOnTargetOutBox: '소토브',
      TotalDistance: 'DST',
      WalkingDistance: 'WLKD',
      JoggingDistance: 'JOGD',
      RunningDistance: 'RUND',
      ExtremeAccelerations: 'XACC',
      NumberOfRuns: 'RUNQ',
      HsrDistance: 'HSRD',
      HsrNumber: 'HSRQ',
      HsrDistancePct: 'HSRD%',
      SprintsNumber: 'SPRQ',
      SprintsDistance: 'SPRD',
      SprintNumberDeclinePct: 'SQD%',
      SprintDistanceDeclinePct: 'SDD%',
      SprintNumberDecline: 'SQD',
      SprintDistanceDecline: 'SDD',
      SprintDistancePct: 'SPRD%',
      Accelerations: 'ACC',
      MaxSpeed: 'MS',
      AvgMaxSpeed: 'AvgMS',
      MaxAccelerations: 'MACC',
      HeadedGoals: 'HG',
      GoalsConceded: 'GC',
      SavesInBox: 'SIB',
      SavesOutBox: '흐느낌',
      BypassedPlayersByPasses: 'ByPP',
      BypassedDefendersByPasses: 'ByPD',
      PassesBypassingPlayers: 'PByPP',
      PassesBypassingDefenders: 'PByPD',
      BypassedPlayersPerPass: 'ByPPPP',
      BypassedDefendersPerPass: 'ByPDPP',
      LineBreakingPasses: 'LBP',
      LineBreakingPassesMD: 'LBPMD',
      LineBreakingPassesM: 'LBPM',
      LineBreakingThroughBalls: 'LBTB',
      LineBreakingPassesPerPass: 'LBPP%',
      TotalPassesUnderStrongPressure: 'TPUSP',
      TotalPassesUnderLightPressure: 'TPUP',
      SuccessfulPassesUnderStrongPressure: 'SPUSP',
      SuccessfulPassesUnderLightPressure: 'SPULP',
      PassingUnderStrongPressure: 'PUSP%',
      PassingUnderLightPressure: 'PULP%',
      PassReceiptsInSpaceCompleted: 'PRSC',
      PassReceiptsInSpace: 'PRS',
      PassReceiptsInSpaceCompletedFirstThird: 'PRSC1T',
      PassReceiptsInSpaceCompletedSecondThird: 'PRSC2T',
      PassReceiptsInSpaceCompletedFinalThird: 'PRSC3T',
      PassReceiptsInSpaceCompletedOppHalfRight: 'PRSCOHR',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'PRSCOHC',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'PRSCOHL',
      PassReceiptsInSpaceFirstThird: 'PRS1T',
      PassReceiptsInSpaceSecondThird: 'PRS2T',
      PassReceiptsInSpaceFinalThird: 'PRS3T',
      PassReceiptsInSpaceOppHalfRight: 'PRSOHR',
      PassReceiptsInSpaceOppHalfCenter: 'PRSOHC',
      PassReceiptsInSpaceOppHalfLeft: 'PRSOHL',
      TotalStrongOnBallPressures: 'TSBP',
      TotalLightOnBallPressures: 'TBP',
      SuccessfulStrongOnBallPressures: 'SSBP',
      SuccessfulLightOnBallPressures: 'SLBP',
      StrongOnBallPressuresPct: 'SBP%',
      LightOnBallPressuresPct: 'BP%',
      TimesBypassedByPasses: 'ByPPAS',
      TimesBypassedByCarries: 'ByPC',
      TimesBypassedByActions: 'ByPA',
      BypassedPlayersByCarries: 'ByPPC',
      BypassedDefendersByCarries: 'ByPDC',
      BypassedPlayersByActions: 'ByPPA',
      BypassedDefendersByActions: 'ByPDA',
      CarriesBypassingPlayers: 'CByPP',
      CarriesBypassingDefenders: 'CByPD',
      BypassedPlayersPerCarry: 'ByPPPC',
      BypassedDefendersPerCarry: 'ByPDPC',
      LineBreakingCarries: 'LBC',
      LineBreakingCarriesMD: 'LBCMD',
      LineBreakingCarriesM: 'LBCM',
      LineBreakingCarriesD: 'LBCD',
      LineBreakingCarriesPerCarry: 'LBCC%',
      LineBreakingActions: 'LBA',
      LineBreakingActionsMD: 'LBAMD',
      LineBreakingActionsM: 'LBAM',
      LineBreakingActionsD: 'LBAD',
      PassesPerLineBreakingPass: 'PPLBP',
      CarriesPerLineBreakingCarry: 'CPLBC',
      LinesBrokenByPasses: 'LBByP',
      LinesBrokenByCarries: 'LBByC',
      LinesBrokenByActions: 'LBByA',
      LinesBrokenPerPass: 'LBPP',
      LinesBrokenPerCarry: 'LBPC',
      AvgLastDefenderDistanceIP: 'ALDDIP',
      AvgLastDefenderDistanceOOP: 'ALDDIP',
      AvgDefensiveLineDistanceIP: 'ALDDIP',
      AvgDefensiveLineDistanceOOP: 'ALDDIP',
      AvgRBDistanceIP: 'ARBDIP',
      AvgRBDistanceOOP: 'ARBDOOP',
      AvgLBDistanceIP: 'ALBDIP',
      AvgLBDistanceOOP: 'ALBDOOP',
      AvgBlockDistanceIP: 'ABDIP',
      AvgBlockDistanceOOP: 'ABDOOP',
      AvgBlockAreaIP: 'ABAIP',
      AvgBlockAreaOOP: 'ABAOOP',
      AvgDefensiveLineWidthOOP: 'ADLWOOP',
      AvgOffensiveLineLastThirdWidthIP: 'AOLLTWIP',
      AvgLByIP: 'ALBIP',
      AvgRByIP: 'ARBIP',
      AvgOffensiveLineDistanceIP: 'AOLDIP',
      AvgOffensiveLineLastThirdDistanceIP: 'AOLTDIP',
      AvgOffensiveLineWidthIP: 'AOLWIP',
      OffBallRuns: 'OBR',
      OffBallRunsOverlap: 'OBRO',
      OffBallRunsUnderlap: 'OBRU',
      OffBallRunsRunAhead: 'OBRA',
      OffBallRunsRunBehind: 'OBRB',
      OffBallRunsCrossReceiver: 'OBRCR',
      OffBallRunsSupport: 'OBRS',
      OffBallRunsComingShort: 'OBRCS',
      AerialsOppHalf: 'AOPPH',
      SpeedScore: 'SSCO',
      EnduranceScore: 'ESCO',
      HeadedShots: 'HS',
      CarriesIntoFinalThird: 'CIF⅓',
      SwitchPlaySuccessful: 'SPS',
      SwitchPlayTotal: 'SPT',
      PassesInsideOppHalf: 'PiOH',
      PassesInsideOppHalfSuccessful: 'PiOHS',
      TacklesAttemptedFirstThird: 'TAF⅓',
      TacklesAttemptedSecondThird: 'TAS⅓',
      TacklesFirstThird: 'TF⅓',
      TacklesSecondThird: 'TS⅓',
      FoulsOwnHalf: 'FOH',
      TouchesOppHalf: 'TOPPH',
      TacklesAttemptedNotAdjusted: 'TANA',
      TacklesSuccessfulNotAdjusted: 'TSNA',
      AvgTop5MaxSpeed: 'AT5MS',
      LBPReceived: 'LBPR',
      LBPMReceived: 'LBPMR',
      LBPMDReceived: 'LBPMDR',
      ThroughBallReceived: 'TBR',
      DistanceIP: 'DST IP',
      WalkingDistanceIP: 'WLKD IP',
      JoggingDistanceIP: 'JOGD IP',
      RunningDistanceIP: 'RUND IP',
      HsrDistanceIP: 'HSRD IP',
      SprintsDistanceIP: 'SPRD IP',
      RunningNumberIP: 'RUNQ IP',
      HsrNumberIP: 'HSRQ IP',
      SprintsNumberIP: 'SPRQ IP',
      DistanceOOP: 'DST OOP',
      WalkingDistanceOOP: 'WLKD OOP',
      JoggingDistanceOOP: 'JOGD OOP',
      RunningDistanceOOP: 'RUND OOP',
      HsrDistanceOOP: 'HSRD OOP',
      SprintsDistanceOOP: 'SPRD OOP',
      RunningNumberOOP: 'RUNQ OOP',
      HsrNumberOOP: 'HSRQ OOP',
      SprintsNumberOOP: 'SPRQ OOP',
      PossessionRegain: 'PR',
      HandPassesSuccessful: 'SHP',
      HandPassesTotal: 'THP',
      InterceptionsNotAdjusted: 'INT',
      ClearancesNotAdjusted: 'CLE',
      RecoveriesNotAdjusted: 'REC'
    },
    AerialsOppHalf: '상대 진영 공중볼 경합',
    CarriesIntoFinalThird: '마지막 ⅓까지 드라이브',
    scoreDifference: '점수 차이: 해당 게임의 성적이 시즌 평균보다 높거나 낮았는지 표시합니다.',
    SpeedScore: '스피드 파워 점수',
    EnduranceScore: '지구력 점수',
    HeadedShots: '헤딩슛',
    HeadedXG: '향하는 xG',
    HeadedSetPieceTooltip: '세트피스에서 헤딩을 기록한 선수만 표시',
    SwitchPlaySuccessful: '스위치 플레이 성공',
    SwitchPlayTotal: '스위치 플레이 합계',
    PassesInsideOppHalf: 'Opp Half 내부 패스',
    PassesInsideOppHalfSuccessful: 'Opp Half 내부 패스 성공',
    TacklesAttemptedFirstThird: '태클이 먼저 시도됨 ⅓',
    TacklesAttemptedSecondThird: '두 번째 태클 시도 ⅓',
    TacklesFirstThird: '첫 번째 성공 태클 ⅓',
    TacklesSecondThird: '성공적인 두 번째 태클 ⅓',
    FoulsOwnHalf: '파울 자신의 절반',
    TouchesOppHalf: '상대 하프에 닿다',
    TacklesAttemptedNotAdjusted: '태클 시도가 조정되지 않음',
    TacklesSuccessfulNotAdjusted: '태클 성공 미조정',
    AvgTop5MaxSpeed: '평균 Top5 최대 속도',
    LBPReceived: '라인 브레이킹 패스를 받았습니다.',
    LBPMReceived: '라인브레이킹 패스(M라인) 수신',
    LBPMDReceived: '라인브레이킹 패스(MD 라인) 수신',
    ThroughBallReceived: '스루패스 받은 공',
    recoveriesRate: '회수율',
    turnoversRate: '손실률',
    HsrDistanceIP: 'HSR 거리 IP',
    HsrDistanceOOP: 'HSR 거리 OOP',
    JoggingDistanceIP: '조깅 거리 IP',
    JoggingDistanceOOP: '조깅 거리 OOP',
    RunningDistanceIP: '주행 거리 IP',
    RunningDistanceOOP: '주행 거리 OOP',
    SprintsDistanceIP: '스프린트 거리 IP',
    SprintsDistanceOOP: '스프린트 거리 OOP',
    WalkingDistanceIP: '도보 거리 IP',
    WalkingDistanceOOP: '도보 거리 OOP',
    PossessionRegain: '소유권 회복',
    HandPassesSuccessful: '성공적인 핸드 패스',
    HandPassesTotal: '핸드 패스',
    SprintsNumberIP: '스프린트 수량 IP',
    SprintsNumberOOP: '스프린트 수량 OOP',
    RunningNumberIP: '실행 수량 IP',
    RunningNumberOOP: '실행 수량 OOP',
    HsrNumberIP: 'HSR 수량 IP',
    HsrNumberOOP: 'HSR 수량 OOP',
    InterceptionsNotAdjusted: 'Interceptions',
    ClearancesNotAdjusted: '',
    RecoveriesNotAdjusted: 'Recoveries'
  },
  team: {
    title: '팀 시트',
    subtitle: '팀의 특성과 통계를 더 깊이 살펴보세요',
    averageAge: '평균 연령',
    transferBalance: '이적 잔액',
    roster: '로스터',
    stadium: '경기장',
    coach: '감독',
    transfers: '이적',
    trends: '트렌드',
    loans: '임대',
    loanFrom: '임대 출처',
    loanTo: '임대 대상',
    latestGames: '최근 경기',
    latestXGames: '최근 {0}경기',
    playingFor: '소속',
    overview: '개요',
    visualization: '시각화',
    location: '위치',
    outcome: '결과',
    beeswarm: '순위',
    parentTeam: '상위 팀',
    childTeam: '유스 팀',
    preferredFormation: '선호 포메이션',
    mostFrecuentFormations: '가장 빈번한 포메이션',
    viewType: '보기 유형',
    overviewTab: {
      axisXTotal: '총계',
      axisXper90: '90분당',
      dataPerGameText: '경기당 데이터',
      season: '시즌',
      last: '이전',
      current: '현재',
      TeamStyle: '스타일',
      TeamDefensive: '수비형',
      TeamOffensive: '공격형',
      TeamCustom1: '커스텀 1',
      TeamCustom2: '커스텀 2',
      TeamCustom3: '커스텀 3',
      TeamCustom4: '커스텀 4',
      coach: '감독',
      groups: {
        Goals: {
          name: '골',
          desc: '페널티 골 및 페널티 제외 골 (오픈 플레이 및 세트피스)을 표시합니다.'
        },
        Assists: {
          name: '어시스트',
          desc: '이번 시즌 어시스트 (오픈 플레이 및 세트피스)가 많은 선수들.'
        },
        xG: {
          name: '예상 골',
          desc: '오픈 플레이 및 세트피스에서 나온 예상 골'
        },
        xA: {
          name: '예상 어시스트',
          desc: '오픈 플레이 및 세트피스에서 나온 예상 어시스트.'
        },
        Finishing: {
          name: '마무리',
          desc: '골로 끝난 슛 비율.'
        },
        ScoringContribution: {
          name: '득점 기여',
          desc: '팀의 어시스트 및 골 수.'
        },
        xT: {
          name: '예상 위협',
          desc: '오픈 플레이, 세트피스 및 음수 xT에서 생성된 예상 위협.'
        }
      },
      stats: {
        openPlay: '오픈 플레이',
        setPiece: '세트피스',
        negative: '음수',
        npg: '페널티 제외 골',
        goalsPenalty: '페널티 골',
        npgOpenPlay: 'NPG 오픈 플레이',
        npgSetPiece: 'NPG 세트피스',
        assists: '어시스트',
        assistsConceded: '어시스트 허용',
        assistsOpenPlay: '어시스트 오픈 플레이',
        assistsSetPiece: '어시스트 세트피스',
        xGOpenPlay: 'xG 오픈 플레이',
        xGSetPiece: 'xG 세트피스',
        xAOpenPlay: 'xA 오픈 플레이',
        xASetPiece: 'xA 세트피스',
        xAConceded: 'xA 실점',
        nonPenaltyShots: '페널티 제외 슛',
        penaltyShots: '페널티 슛',
        xT: '예상 위협',
        xTOpenPlay: 'xT 오픈 플레이',
        xTSetPiece: 'xT 세트피스',
        xTNeg: '음수 xT',
        totalFinishing: '마무리',
        nonPenaltyFinishing: '페널티 제외 마무리',
        goalsPenaltyFinishing: '페널티 마무리',
        goal: '골',
        notGoal: '골 아님',
        chance: '찬스',
        finished: '완료',
        notFinished: '미완료',
        walkingDistance: '걷기',
        joggingDistance: '조깅',
        runningDistance: '달리기',
        hsrDistance: 'HSR',
        sprintsDistance: '스프린트',
        runningNumber: '런',
        hsrNumber: 'HSR 스프린트',
        sprintsNumber: '스프린트',
        maxSpeed: '최대 속도',
        accelerations: '가속',
        extremeAccelerations: '극한 가속',
        maxAcceleration: '최대 가속'
      }
    },
    teamAnalysis: '팀 분석',
    agentView: {
      positions: {
        gk: 'GK',
        leftFullback: '좌측 풀백',
        centralDefender: '중앙 수비',
        rightFullback: '우측 풀백',
        midfielder: '미드필더',
        attackingMidfielder: '공격형 미드필더',
        leftWinger: '좌측 윙어',
        rightWinger: '우측 윙어',
        fw: 'FW'
      },
      groups: {
        contractEnd: '개월',
        age: '세',
        availability: '가용성'
      },
      placer: {
        legend: '연령, 계약, 가용성 및 성과를 기반으로 한 강도'
      }
    },
    transfersTab: {
      valueMovements: '이동 가치',
      valueTransfers: '이적 가치',
      valueLoans: '임대 가치',
      avgAgeMovements: '이동 평균 연령',
      avgAgeTransfers: '이적 평균 연령',
      avgAgeLoans: '임대 평균 연령',
      operations: {
        buys: {
          buy: '구매',
          loan: '임대',
          'end of loan': '임대 종료',
          'free transfer': '무료',
          free: '무료',
          'loan transfer': '임대',
          other: '기타'
        },
        sells: {
          buy: '판매',
          loan: '임대',
          'end of loan': '임대 종료',
          'free transfer': '무료',
          free: '무료',
          'loan transfer': '임대',
          other: '기타',
          retired: '은퇴'
        }
      }
    },
    trendsTab: {
      streaks: '연승',
      wins: '승리',
      cleanSheets: '무실점',
      goalPeriods: '득점 기간',
      concededGoalPeriods: '실점 기간',
      comebacks: '역전승',
      avgTime: '평균 시간',
      kindOfGoals: '골 유형',
      percentWinning: '% 승리',
      percentDrawing: '% 무승부',
      percentLosing: '% 패배',
      totalOf: '총',
      minutes: '분',
      before: '이전',
      after: '이후',
      playedOn: '경기일',
      scored: '득점',
      conceded: '실점',
      ownGoals: '자책골',
      phasesOfGame: '경기 단계',
      intensityLabel: '존 강도',
      intensityByTeam: '팀별 %',
      intensityByLeagueAvg: '리그 평균별 %',
      buildup: '빌드업',
      midfieldProgression: '미드필드 전진',
      attackOpposition: '상대 공격',
      attackingTransition: '공격 전환',
      highPress: '하이 프레스',
      midBlock: '미드 블록',
      lowBlock: '로우 블록',
      defensiveTransition: '수비 전환',
      draws: '무승부',
      losts: '패배',
      chokes: '결정적인 순간 패배',
      zoneTooltip: '각 블록의 색상 그라데이션에 사용되는 기준을 결정합니다.',
      teamPctTooltip: '각 구역에서 팀이 플레이한 총 시간의 비율을 기준으로 합니다.',
      leagueAvgPctTooltip: '각 영역의 리그 평균과 팀의 비율을 비교합니다.',
      leagueAvgMinsTooltip: '리그에 대해 동일한 비교 기준을 적용하지만 백분율 대신 분 단위로 총 시간을 평가합니다.',
      losses: '사상자 수',
      results: '결과',
      kindOfConcededGoals: '실점한 골 유형',
      showMinutes: '회의록 표시'
    },
    onOff: '온/오프',
    dragUpToXPlayers: '최대 5명의 선수를 드래그하세요{x}',
    selectUpToXPlayers: '최대 5명의 선수를 선택하세요{x}',
    onOffTab: {
      G90: '골 90',
      GA90: '실점 90',
      diffG90: '골 차이 90',
      XG90: 'xG 90',
      XGA90: 'xG 실점 90',
      diffXG90: 'xG 차이 90',
      playersOn: '콤보 ON',
      playersOff: '콤보 OFF',
      ground: '경기장',
      playersOnThePitch: '경기장의 선수들',
      playersOffThePitch: '경기장 밖의 선수들',
      attackTitle: '공격',
      attackSubTitle: '공격 통계',
      defenseTitle: '수비',
      defenseSubTitle: '수비 통계',
      associationTitle: '연계',
      associationSubTitle: '연계 통계',
      comboOn: '활성 콤보',
      comboOff: '기타',
      diffGoals90: 'G 차이 90',
      goals90: '페널티 제외 골 90',
      goalsAgainst90: '페널티 제외 실점 90',
      xgAgainstPer90: 'xG 실점 90',
      xgDiffPer90: 'xG 차이 90',
      xgPer90: 'xG 90',
      xt90: 'xT 90',
      shotsOnTarget90: '유효 슛 90',
      touchesOppBox90: '상대 박스 터치 90',
      shotsOnTargetAgainst90: '유효 슛 실점 90',
      ppda90: 'PPDA 90',
      xa90: 'xA 90',
      directness90: '직선성 90',
      possession: '볼 소유 %',
      pctPasses: '패스 %',
      pctPassesFinalThird: '최종 3분의 1 패스 %',
      placeholder: '팀을 선택하여 시작하세요',
      subtitle: '라인업에 선수를 추가하거나 제거하여 팀 지표를 최적화하세요'
    },
    terms: {
      short: '단기',
      mid: '중기',
      long: '장기'
    },
    report: {
      title: '팀 리포트',
      selectedPeriod: '선택된 기간',
      stackedCharts: '스택 차트',
      radars: '레이더',
      generalData: '일반 데이터',
      scoringChances: '득점 찬스',
      areasReport: '영역 리포트',
      setPieceReport: '세트피스 리포트',
      corners: '코너킥',
      cornersAgainst: '코너킥 실점',
      indirectFreeKicks: '간접 프리킥',
      indirectFreeKicksAgainst: '간접 프리킥 실점',
      freeKicks: '프리킥',
      freeKicksAgainst: '프리킥 실점',
      penaltys: '페널티',
      freeKicksContribution: '프리킥 기여',
      shotsContribution: '슛 기여',
      topXPlayersByStats: '통계별 상위 {x}명 선수',
      lastShotZone: '마지막 존 슛',
      throwSide: '스로우 사이드',
      kindOfThrow: '스로우 유형',
      scored: '득점',
      against: '실점',
      perGame: '경기당',
      total: '총계',
      efficiency: '효율',
      organizedAttack: '정형화된 공격',
      offTransition: '공격 전환',
      chances: '찬스',
      chancesScored: '찬스 득점',
      chancesAgainst: '찬스 실점',
      goalsScored: '득점',
      goalsAgainst: '실점',
      goalsOrganizedAttack: '정형화된 공격 골',
      goalsOffTransition: '공격 전환 골',
      goalsSetPiece: '세트피스 골',
      goalsOrganizedAttackScored: '정형화된 공격 득점',
      goalsOrganizedAttackAgainst: '정형화된 공격 실점',
      goalsOffTransitionScored: '공격 전환 득점',
      goalsOffTransitionAgainst: '공격 전환 실점',
      goalsSetPieceScored: '세트피스 득점',
      goalsSetPieceAgainst: '세트피스 실점',
      crossSide: '크로스 사이드',
      externalShot: '외곽 슛',
      innerPlay: '내부 플레이',
      throwIn: '스로우인',
      box: '박스',
      zone2: '존 2',
      goalsPerPhases: '단계별 골'
    },
    minutesAlert: '*450분 이상 출전한 선수만 표시',
    minutesException: '450분 이상 출전한 선수가 없습니다. 모든 선수를 표시합니다',
    analysis: '분석',
    substitutions: '교체',
    attackZones: '공격 존',
    formations: '포메이션',
    shotZones: '슛 존',
    crossings: '크로스',
    byTime: '시간별',
    byPosition: '포지션별',
    byPlayer: '선수별',
    W: '승리',
    D: '무승부',
    L: '패배',
    substitutionsByGame: '경기별 교체',
    substitutionsShort: '교체',
    avgSeasonShort: '평균 시즌',
    startingAt: '시작 위치',
    endingAt: '종료 위치',
    startingAtInfo: '첫 번째 이벤트의 위치를 기반으로 볼 소유 비율을 표시합니다',
    endingAtInfo: '마지막 이벤트의 위치를 기반으로 볼 소유 비율을 표시합니다',
    endingWithShot: '슛으로 종료',
    endingInBox: '박스에서 종료',
    pfX: 'PF {x}',
    bySide: '사이드별',
    cornerKicks: '코너킥',
    included: '포함',
    excluded: '제외',
    onlyCorner: '코너만',
    sizeByMarketValue: '시장 가치별 크기',
    timeInTeam: '팀 내 시즌',
    newSignings: '신규 영입',
    sizeBy: '크기 기준',
    connections: '연결',
    assistant: '패서',
    finisher: '피니셔',
    playersMinutesAlert: '선택된 시즌에 출전 시간이 있는 선수만 표시',
    strategyFilterTooltip: '세트 피스나 오픈 플레이 중에 발생한 이벤트를 표시합니다.',
    sideFilterTooltip: '선택한 쪽(왼쪽 또는 오른쪽)부터 시작하는 세트피스만 표시',
    teamMinutesAlert: '*450분 이상 플레이한 팀만 표시',
    homeCoach: '홈 코치',
    awayCoach: '원정 코치'
  },
  leagueTable: {
    subtitle: '리그 진행 상황을 확인하세요'
  },
  leagueMatchdays: {
    byRound: '라운드별',
    byDate: '날짜별',
    byTeam: '팀별'
  },
  teamStats: {
    subtitle: '팀들의 성과를 비교하세요',
    xGDiffPerGame: 'xGD',
    xGDiffPerGameExplicit: '예상 골과 골의 차이',
    expectedPointsDiff: 'xPD',
    expectedPointsDiffExplicit: '예상 점수와 점수의 차이',
    games: 'GAM',
    gamesExplicit: '경기 수',
    pointsPerGame: 'PPG',
    pointsPerGameExplicit: '경기당 점수'
  },
  roles: {
    ROLE_USER: '사용자',
    ROLE_ADMIN: '관리자',
    ROLE_REPORTS: 'Driblab Reports',
    ROLE_API: 'Driblab API',
    ROLE_PHYSICAL_DATA: 'Driblab Physical Data',
    ROLE_VIDEO: 'Capture',
    ROLE_EVENTING_DATA: 'Driblab XY',
    ROLE_DRIBLAB_HUB: 'Driblab Hub',
    ROLE_TRACKING: 'Tracking',
    ROLE_ARRIGO: 'Arrigo',
    ROLE_API_description: 'JSON 형식으로 선수, 팀, 경기 및 리그 정보를 쉽게 추출하세요.',
    ROLE_EVENTING_DATA_description: '레이더 차트, 선수 순위, 지도 등을 통해 100개 이상의 성과 지표를 기반으로 통계를 깊이 있게 분석하세요.',
    ROLE_PHYSICAL_DATA_description: '피트니스 데이터에 액세스하고 다양한 성과 지표(거리, 속도, 스프린트, 가속 등)로 선수를 필터링하세요.',
    ROLE_VIDEO_description: '동영상과 라인업을 제공하고 이벤트와 통계가 태그된 경기를 받아 심층 분석을 수행하세요.',
    ROLE_DRIBLAB_HUB_description: '캘린더, 메모, 알림 및 문서 공유를 통해 스카우팅 작업을 효율적으로 추적하고 관리하세요.',
    ROLE_TRACKING_description: 'API를 통해 경기의 모든 선수 위치 데이터를 받아 포괄적인 분석을 수행하세요.',
    ROLE_ARRIGO_description: '이벤팅 및 추적 데이터를 결합하여 전통적인 것을 넘어서는 혁신적인 지표를 만들어 모든 액션에 가치를 더하세요.',
    ROLE_REPORTS_description: '분석가 팀으로부터 상세한 스카우팅 리포트를 요청하여 완벽한 팀이나 선수를 찾으세요.',
    ROLE_RAW_EVENTING: '원시 이벤트'
  },
  administration: {
    pageSubtitle: '애플리케이션 운영 관리',
    newClient: '신규 클라이언트',
    clientDuplicateName: '동일한 이름의 클라이언트가 이미 있습니다. 목록에서 해당 클라이언트를 선택한 뒤 «신규 사용자»로 사용자를 추가하세요.',
    newUser: '신규 사용자',
    editClient: '클라이언트 편집',
    editUser: '사용자 편집',
    clientName: '이름',
    permissions: '권한',
    releaseUser: '사용자 해제',
    connectAsUser: '사용자로 연결',
    releaseModalTitle: '사용자 해제 확인',
    releaseModalMessage: '사용자는 새 계정에 대한 이메일을 받게 됩니다. 알림을 보내시겠습니까?',
    clientType: {
      Driblab: 'Driblab',
      Team: '팀',
      Brand: '브랜드',
      Federation: '연맹',
      Media: '미디어',
      Agency: '에이전시',
      Individual: '개인'
    },
    userType: {
      Ownership: '소유권',
      SportingDirector: '스포팅 디렉터',
      Brand: '브랜드',
      Federation: '연맹',
      Media: '미디어',
      Agency: '에이전시',
      Individual: '개인',
      Scout: '스카우트',
      Coach: '코치',
      supervision: {
        title: '감독 계층',
        subtitle: '감독은 아래쪽으로만 흐릅니다. 동일한 수준의 감독은 허용되지 않습니다.',
        supervisesLowerLevels: '아래의 모든 역할을 감독합니다.',
        ruleNoSameLevel: '동일한 수준의 역할은 서로를 감독할 수 없습니다.',
        ruleOnlyDownwards: '감독은 높은 역할에서 낮은 역할로만 허용됩니다.',
        ruleLevel3NoSupervision: '가장 낮은 수준에는 감독 권한이 없습니다.',
        currentUserType: '현재 사용자 유형'
      }
    },
    visibleYears: '표시 연도',
    areaModalTitle: '리그 활성화/비활성화 확인',
    areaModalMessage: '선택한 지역의 모든 리그를 활성화/비활성화하시겠습니까?',
    countStats: '통계 수',
    userClientModalTitle: '사용자가 다른 클라이언트에 이미 존재합니다',
    eventing: '이벤팅',
    hub: '허브',
    contract: '계약',
    contracts: '계약서',
    invoiceName: '인보이스 이름',
    contractFee: '계약 수수료',
    renewal: '갱신',
    consultancy: '컨설팅',
    deleteContract: '클라이언트 계약 삭제',
    deleteContractMessage: '계약이 영구적으로 제거됩니다. 계속하시겠습니까?',
    activeVsHired: '활성 vs 고용',
    requestedVsHired: '요청 vs 고용',
    activeVsHiredWithPlaceholder: '{0} 활성 대 {1} 고용됨',
    requestedVsHiredWithPlaceholder: '{0} 요청됨 대 {1} 고용됨',
    salesRepresentative: '영업 담당자',
    periodicities: {
      periodicity: '주기',
      annual: '연간',
      biannual: '반기',
      quarterly: '분기',
      monthly: '월간',
      bimonthly: '격월',
      onePayment: '일시불',
      fourmonthly: '4개월마다'
    },
    paymentMethods: {
      payment: '결제',
      method: '방법',
      transfer: '이체',
      mandate: '위임'
    },
    marketingOptions: {
      marketing: '마케팅',
      socialMediaAdd: '소셜 미디어 광고',
      videoWithFeedback: '피드백이 있는 동영상'
    },
    status: {
      status: '상태',
      pending: '대기 중',
      active: '활성',
      expiringSoon: '곧 만료',
      expired: '만료됨',
      expiringSoonWithDays: '계약이 곧 만료됩니다. {0}일 남았습니다.'
    },
    updates: {
      roleAdded: '<b>{0}</b>이(가) <b>{2}</b>에 <b>{1}</b> 역할을 추가했습니다.',
      roleRemoved: '<b>{0}</b>이(가) <b>{2}</b>에서 <b>{1}</b> 역할을 삭제했습니다.',
      leagueAdded: '<b>{0}</b>이 <b>{2}</b> 리그에 <b>{1}</b>을(를) 추가했습니다.',
      leagueRemoved: '<b>{0}</b>이 <b>{2}</b> 리그에서 <b>{1}</b>을(를) 삭제했습니다.',
      seasonAdded: '<b>{0}</b>님이 <b>{2}</b> 시즌에 <b>{1}</b>을(를) 추가했습니다.',
      seasonRemoved: '<b>{0}</b>이 <b>{2}</b> 시즌에서 <b>{1}</b>을(를) 삭제했습니다.',
      updateNotesPlaceholder: '변경 내용에 대한 일부 내용을 포함하거나 여기에 관련 메모를 추가하세요...',
      updates: '업데이트',
      products: '제품'
    },
    clients: '클라이언트',
    trials: '시험',
    activeClients: '활성 클라이언트',
    activeTrials: '활성 평가판',
    activeTrialUsers: '활성 평가판 사용자',
    activeContracts: '활성 계약',
    expiration: '만료',
    clientWarnings: {
      activeContractInactiveClient: '활성 계약이 있지만 활성화된 사용자가 없는 클라이언트',
      activeContractTrialUsers: '계약 기간 중 평가판 사용자가 있는 고객',
      activeUsersWithoutContract: '평가판이 아닌 활성 사용자가 있지만 활성 계약이 없는 클라이언트',
      upcomingExpirations: '다가오는 만료',
      renewedContracts: '재계약 고객',
      clientsWithWarnings: '주의가 필요한 고객',
      enabledUsersWithoutContract: '\'활성 계약 없이 평가판이 아닌 사용자 활성화\'',
      trialUsersWithContract: '활성 계약에도 불구하고 평가판 모드를 사용하는 사용자',
      activeContractInactiveUsers: '클라이언트는 모든 사용자가 비활성 상태인 활성 계약을 보유하고 있습니다.',
      activeContract: '이 고객은 유효한 계약을 갖고 있습니다.',
      noEnabledUsers: '이 클라이언트에는 활성화된 사용자가 없습니다.',
      ongoingTrialInactiveUsers: '평가판을 진행 중이지만 활성화된 사용자가 없는 클라이언트',
      neverLoggedIn: '로그인한 적이 없는 고객'
    },
    daysLeft: '남은 일수',
    expiringSoon: '곧 만료됨',
    loggedThisWeek: '이번 주에 로그인했습니다',
    withWarnings: '경고 포함',
    ofActiveClients: '활성 클라이언트의',
    endingIn30Days: '30일 안에 종료',
    neverLogged: '로그인한 적 없음',
    ofActiveTrials: '활성 시험 중',
    activeClientsWithoutTrial: '활성 클라이언트(평가판 제외)',
    renewals: '갱신',
    ofActiveContracts: '활성 계약의'
  },
  dashboards: {
    lastGame: '최근 경기 분석',
    lastGameSimple: '최근 경기',
    seeAllGameInfo: '모든 경기 정보 보기',
    nextGame: '다음 경기 미리보기',
    myTeam: '내 팀',
    lastMatchdayGames: '최근 경기일',
    lastAdded: '최근 추가됨',
    myFavorites: '내 즐겨찾기',
    seeAllFavorites: '모든 즐겨찾기 보기',
    placeholderFavorites: '선수 상세에서 즐겨찾기를 추가할 수 있습니다',
    placeholderTeamFavorites: '팀 상세에서 즐겨찾기를 추가할 수 있습니다',
    placeholderLeagueFavorites: '리그 상세에서 즐겨찾기를 추가할 수 있습니다',
    myCollections: '내 컬렉션',
    placeholderCollections: '아직 컬렉션이 없습니다',
    lastCreated: '최근 생성됨',
    seeAllCollections: '모든 컬렉션 보기',
    seeRival: '상대 보기',
    seeMyTeam: '내 팀 보기',
    title: '대시보드 개요',
    subtitle: '다시 오신 것을 환영합니다',
    recentPlayers: '최근 선수',
    lastScouted: '최근 스카우트',
    scout: '스카우트',
    reportsRequested: '리포트',
    lastRequested: '최근 요청',
    goInbox: '받은편지함으로 이동',
    placeholderLastScouted: '왼쪽 바 또는 스카우트 도구에서 선수를 검색할 수 있습니다',
    placeholderReports: '선수 상세에서 리포트를 요청할 수 있습니다',
    nationalPlayers: '다른 국가에서 가장 가치 있는 국적 선수',
    lastGames: '최근 경기',
    nationalPlayersShort: '다른 국가의 국적 선수',
    nextMatchdayGames: '다음 경기일',
    injuredPlayers: '부상 선수',
    atPresent: '현재',
    seeAllPlayers: '모든 선수 보기',
    suspendedPlayers: '출장 정지 선수',
    placeholderInjured: '부상 선수가 없습니다',
    teamValueImpacted: '팀 가치 영향',
    placeholderSuspended: '출장 정지 선수가 없습니다',
    placeholderNextGame: '사용 가능한 경기가 없습니다',
    placeholderNoGames: '아직 사용 가능한 경기가 없습니다',
    placeholderLastMatchDayNotFound: '최근 경기일을 사용할 수 없습니다',
    placeholderNextMatchDayNotFound: '다음 경기일을 사용할 수 없습니다',
    usersMostSearch: '검색이 가장 많은 사용자',
    lastTwoDays: '최근 이틀',
    searchesHistory: '검색 기록',
    dayByDay: '일별',
    activeUsersTitle: '활성 사용자',
    activeUsersSubtitle: '지난 달에 최소 한 번 로그인',
    onlineUsersTitle: '온라인 사용자',
    onlineUsersSubtitle: '지난 한 시간 동안 검색함',
    searchesPerformed: '수행된 검색',
    onlyClients: '클라이언트만',
    activeClientsTitle: '활성 클라이언트',
    activeClientsSubtitle: '최소 한 명의 활성 사용자 보유',
    last24Hours: '최근 24시간',
    activityHistory: '활동 기록',
    loginHistory: '접근 기록',
    failLogins: '실패한 접근',
    successLogins: '성공한 접근',
    clientStats: '클라이언트 통계',
    playersMostSearch: '검색이 가장 많은 선수',
    toolsMoreUsed: '더 많이 사용된 도구',
    hotPlayers: '인기 선수',
    last_month: '지난 달',
    last_week: '지난 주',
    last_day: '지난 날',
    nClients: '클라이언트 수',
    userDashboard: '사용자 대시보드',
    userDashboardSubtitle: '계정 활동 요약',
    offlineDaysOfClient: '각 클라이언트의 오프라인 일수',
    hideNoConnected: '연결되지 않은 항목 숨기기',
    onlyTrial: '체험 클라이언트만',
    daysWithoutLogin: '로그인하지 않은 일수',
    trialDays: '체험 일수'
  },
  faq: {
    subtitle: 'Driblab PRO에 대해 자세히 알아보세요',
    categories: {
      playerMetrics: '선수 지표',
      teamMetrics: '팀 지표',
      positions: '팀 포지션',
      tools: '도구',
      api: 'API',
      videos: '튜토리얼',
      playerPositions: '선수 포지션',
      userTypes: '사용자 유형'
    },
    positions: {
      GK: '골키퍼',
      DR: '우측 수비수 / 우측 풀백 (RB)',
      DC: '중앙 수비수 / 센터백 (CB)',
      DL: '좌측 수비수 / 좌측 풀백 (LB)',
      DMR: '우측 윙백 (RWB)',
      DMC: '중앙 수비형 미드필더 (CDM)',
      DML: '좌측 윙백 (LWB)',
      MR: '우측 미드필더 (RM)',
      MC: '중앙 미드필더 (CM)',
      ML: '좌측 미드필더 (LM)',
      AMR: '공격형 미드필더 우측 / 우측 윙어 (RW)',
      AMC: '공격형 미드필더 중앙 / 공격형 미드필더',
      AML: '공격형 미드필더 좌측 / 좌측 윙어 (LW)',
      FWR: '우측 공격수 / 우측 스트라이커 (RS)',
      FW: '공격수 / 스트라이커 (ST)',
      FWL: '좌측 공격수 / 좌측 스트라이커 (LS)'
    },
    metrics: {
      categories: {
        Association: '연계',
        Saving: '세이브',
        Shooting: '슛',
        Defending: '수비',
        Passing: '패스',
        BallHandling: '볼 핸들링',
        Aerial: '공중볼',
        Physical: '신체',
        Predictive: '예측',
        Arrigo: 'Arrigo',
        Score: '점수',
        Turnovers: '턴오버',
        Carries: '볼 운반',
        SequenceInvolvement: '시퀀스 참여',
        Crosses: '크로스',
        Distance: '거리',
        Sprint: '스프린트',
        Acceleration: '가속',
        MaxAcceleration: '최대 가속',
        Speed: '속도',
        OutPlay: '아웃플레이',
        LineBreakingPasses: '라인 돌파 패스',
        LineBreakingCarries: '라인 돌파 볼 운반',
        LineBreakingActions: '라인 돌파 액션',
        PassUnderPressure: '압박 하 패스',
        BallReceived: '볼 수신',
        PassesUnderPressure: '압박감 속에서 패스',
        OnBallPressureReceived: '볼 압박 수신',
        OnBallPressure: '볼 압박',
        BallReceiptsInSpace: '공간에서의 볼 수신',
        SpatialCoverage: '공간 커버리지',
        OffBallPressure: '오프볼 압박',
        OffBallRuns: '오프볼 런',
        NoCategory: '기타',
        subcategories: {
          Quality: '품질',
          Quantity: '수량',
          TeamComparison: '팀 비교',
          Receptions: '수신',
          LongBalls: '롱 패스',
          Efficiency: '효율',
          Ratio: '비율',
          Defensive: '수비',
          Offensive: '공격',
          Foot: '발',
          Progression: '전진',
          TopValue: '최고 가치',
          Predictive: '예측',
          Distance: '거리',
          Aerial: '공중볼',
          Crosses: '크로스',
          NoCategory: '기타'
        },
        desc: {
          Association: '연계',
          Saving: '세이브',
          Shooting: '슛',
          Defending: '수비',
          Passing: '패스',
          BallHandling: '볼 핸들링',
          Aerial: '공중볼',
          Physical: '신체',
          Predictive: '예측',
          Arrigo: 'Arrigo',
          Score: '점수',
          Turnovers: '턴오버',
          Carries: '볼 운반',
          SequenceInvolvement: '시퀀스 참여',
          Crosses: '크로스',
          Distance: '다양한 속도로 이동한 거리',
          Sprint: '다양한 속도로 스프린트',
          Acceleration: '가속',
          Speed: '경기 중 선수가 달성한 속도',
          OutPlay: '아웃플레이',
          LineBreakingPasses: '라인 돌파 패스',
          LineBreakingCarries: '라인 돌파 볼 운반',
          LineBreakingActions: '라인 돌파 액션',
          PassUnderPressure: '압박 하 패스',
          BallReceived: '볼 수신',
          OnBallPressureReceived: '볼 압박 수신',
          OnBallPressure: '볼 압박',
          BallReceiptsInSpace: '공간에서의 볼 수신',
          SpatialCoverage: '공간 커버리지',
          OffBallPressure: '오프볼 압박',
          OffBallRuns: '오프볼 런',
          HandPassing: '골키퍼가 손으로 패스하거나 세트피스에서 던진 패스'
        },
        abbr: {
          Association: '연계',
          Saving: '세이브',
          Shooting: '슛',
          Defending: '수비',
          Passing: '패스',
          BallHandling: '볼 핸.',
          Aerial: '공중볼',
          Physical: '신체',
          Predictive: '예측',
          Arrigo: 'Arrigo',
          Score: '점수',
          Turnovers: 'TOV',
          Carries: '볼 운반',
          SequenceInvolvement: '시퀀스 참여',
          Crosses: '크로스',
          Distance: '거리',
          Sprint: '스프린트',
          Acceleration: '가속',
          MaxAcceleration: '최대 가속',
          Speed: '속도',
          OutPlay: '아웃플레이',
          LineBreakingPasses: '라인 돌파 패스',
          LineBreakingCarries: '라인 돌파 볼 운반',
          LineBreakingActions: '라인 돌파 액션',
          PassUnderPressure: '압박 하 패스',
          BallReceived: '볼 수신',
          OnBallPressureReceived: '볼 압박 수신',
          OnBallPressure: '볼 압박',
          BallReceiptsInSpace: '공간에서의 볼 수신',
          SpatialCoverage: '공간 커버리지',
          OffBallPressure: '오프볼 압박',
          OffBallRuns: '오프볼 런',
          HandPassing: '손으로 패스하기'
        },
        HandPassing: '손으로 패스하기'
      },
      types: {
        1: '90분당',
        2: '비율',
        3: '율',
        4: '효율',
        5: '평균',
        6: '경기당',
        7: '차이',
        8: '최대'
      },
      moreInfo: '여기서 더 자세히 읽을 수 있습니다'
    },
    api: {
      subtitle: '다양한 요청에서 데이터 가져오기',
      resourcesTitle: '리소스',
      authentication: '인증',
      authText: 'API를 호출하려면 모든 요청에 `Bearer {API_TOKEN}` 값을 가진 `Authorization` 헤더를 포함해야 합니다',
      generate: '생성',
      tokenPlaceholder: '토큰이 없거나 만료된 경우 \'생성\'을 클릭하세요',
      pathParameters: '경로 매개변수',
      queryParameters: '쿼리 매개변수',
      responseModel: '응답 모델',
      tokenWarning: '* API를 사용하려면 토큰을 생성하세요',
      pathParamsWarning: '* 채워지지 않은 경로 매개변수가 있습니다',
      genericDescription: 'API(애플리케이션 프로그래밍 인터페이스)를 통해 개발자는 자체 애플리케이션에 데이터나 기능을 액세스하고 통합할 수 있습니다. 우리의 축구 통계 API는 국가, 대회, 팀, 선수, 경기 등에 대한 다양한 데이터 포인트에 대한 포괄적인 액세스를 제공합니다. 이 API를 사용하면 분석, 시각화 또는 기타 혁신적인 솔루션을 위해 풍부한 축구 데이터를 활용하는 애플리케이션을 구축할 수 있습니다.',
      methods: {
        getAllCountries: '이 메서드는 API에서 사용 가능한 모든 국가의 전체 목록을 검색하며, 각 국가의 고유 식별자 및 이름과 같은 주요 세부 정보를 제공합니다. 이 엔드포인트는 지리적 축구 데이터가 필요한 애플리케이션에 이상적이며, 국가 선택, 필터링 및 분석과 같은 기능을 활성화합니다. 또한 `countryId` 매개변수에 의존하는 다른 엔드포인트와 상호 작용하기 위한 기본 리소스 역할을 하며, API의 더 넓은 데이터 세트와의 원활한 탐색 및 통합을 보장합니다.',
        getCountryDetail: '이 메서드는 API에서 사용 가능한 특정 국가에 대한 상세 정보를 제공합니다. 이 엔드포인트를 사용하여 국가 이름, 코드 및 관련된 모든 관련 메타데이터와 같은 데이터를 검색할 수 있습니다. 이 메서드는 컨텍스트 정보 표시 또는 지리적 데이터를 기반으로 맞춤형 인사이트 생성과 같이 사용자 경험을 향상시키기 위해 국가별 세부 정보가 필요한 애플리케이션에 특히 유용합니다. 선택한 국가를 더 깊이 탐색할 수 있도록 하여 다른 엔드포인트를 보완합니다.',
        getCountryCompetitions: '이 메서드는 특정 국가 내에서 사용 가능한 모든 대회 목록을 검색합니다. 사용자가 지역별로 대회를 탐색할 수 있는 기능을 구축하는 데 유용한 리소스이며, 국가 데이터를 관련 토너먼트와 연결하는 원활한 방법을 제공합니다. 이 엔드포인트는 현지화된 축구 콘텐츠 또는 지역 분석에 중점을 둔 애플리케이션에 필수적입니다.',
        getAllCompetitionTypes: '이 메서드는 리그, 컵 및 국제 토너먼트와 같이 API에서 사용 가능한 모든 대회 유형 목록을 반환합니다. 이 엔드포인트는 대회를 분류하고 사용자에게 다루는 다양한 유형의 이벤트에 대한 체계적인 보기를 제공하는 데 이상적입니다. 대회의 성격을 기반으로 축구 데이터를 탐색할 수 있는 필터 또는 드롭다운과 같은 기능을 구축하는 데 특히 유용합니다.',
        getAllCompetitions: '이 메서드는 유형이나 위치에 관계없이 API에서 사용 가능한 모든 대회의 포괄적인 목록을 검색합니다. 이 엔드포인트는 광범위한 축구 대회를 표시하거나 분석해야 하는 애플리케이션에 유용하며, 사용자가 관심 있는 이벤트를 탐색하고 선택할 수 있도록 합니다.',
        getCompetitionAvailable: '이 메서드는 현재 API에서 사용 가능한 것으로 표시된 대회 목록을 검색합니다. 이를 통해 반환된 데이터가 최신 상태이며 애플리케이션에서 사용할 준비가 되었음을 보장합니다. 활성 또는 접근 가능한 대회에 의존하는 기능을 구축하는 개발자에게 특히 유용하며, 사용자가 오래되거나 불완전한 데이터를 만나지 않고 관련 이벤트를 탐색할 수 있도록 합니다.',
        getCompetitionDetail: '이 메서드는 API에서 사용 가능한 특정 대회에 대한 상세 정보를 제공합니다. 대회에 대한 심층 정보가 필요한 애플리케이션에 특히 유용하며, 상세 보기, 컨텍스트 인사이트 또는 대회 특성을 기반으로 한 필터링 옵션과 같은 기능을 활성화합니다.',
        getCompetitionSeasons: '이 메서드는 특정 대회와 관련된 모든 시즌 목록을 검색합니다. 이 엔드포인트는 대회의 역사나 현재 상태에 대한 포괄적인 커버리지를 제공하는 것을 목표로 하는 애플리케이션에 필수적이며, 사용자가 시즌별로 데이터를 탐색할 수 있도록 합니다.',
        getSeasonAvailable: '이 메서드는 현재 API에서 사용 가능한 것으로 표시된 시즌 목록을 제공합니다. 라이브 또는 진행 중인 축구 이벤트에 중점을 둔 애플리케이션에 특히 유용하며, 사용자가 관련되고 현재의 시즌 데이터와 상호 작용할 수 있도록 합니다.',
        getSeasonDetail: '이 메서드는 타임라인, 관련 대회 및 주요 메타데이터를 포함하여 특정 시즌에 대한 상세 정보를 검색합니다. 이 엔드포인트는 특정 시즌에 대한 심층 인사이트가 필요한 애플리케이션에 필수적이며, 시즌 개요, 대회별 필터링 또는 사용자 상호 작용을 위한 상세 타임라인 표시와 같은 기능을 활성화합니다.',
        getSeasonTeams: '이 메서드는 특정 시즌에 참가하는 모든 팀 목록을 제공합니다. 로스터 관리, 팀 성과 분석 또는 사용자를 위한 시즌별 필터 생성과 같은 기능에 이상적입니다.',
        getSeasonPlayer: '이 메서드는 특정 시즌에 등록된 모든 선수 목록을 검색합니다. 선수 로스터, 성과 추적 또는 선택한 시즌을 기반으로 선수를 필터링하는 기능을 구축하는 데 이상적입니다.',
        getSeasonPlayerStats: '이 메서드는 특정 시즌의 모든 선수에 대한 상세 통계를 제공합니다. 분석, 선수 비교 또는 시즌 전체 선수 성과의 동적 시각화 생성에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getSeasonArrigoMetrics: '이 메서드는 특정 시즌의 모든 선수에 대한 결합 통계를 제공합니다. 분석, 선수 비교 또는 시즌 전체 선수 성과의 동적 시각화 생성에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getSeasonTeamStats: '이 메서드는 특정 시즌에 참가하는 모든 팀에 대한 포괄적인 통계를 제공합니다. 팀 분석, 시즌 요약 또는 시즌 전체 팀 성과 비교에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getSeasonCoaches: '이 메서드는 특정 시즌 동안 팀을 관리한 모든 코치 목록을 검색합니다. 시즌 인사이트, 코칭 분석 또는 시즌 동안 팀 관리의 변화 추적에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getSeasonGames: '이 메서드는 특정 시즌에 플레이된 모든 경기 목록을 제공합니다. 전체 시즌 일정 표시, 경기 결과 분석 또는 사용자에게 포괄적인 시즌 경기 데이터에 대한 액세스 제공이 필요한 애플리케이션에 이상적입니다.',
        getSeasonGamesMatchday: '이 메서드는 주어진 시즌 내에서 특정 경기일의 모든 경기를 검색합니다. 경기일 일정 표시, 특정 라운드 분석 또는 시즌 동안 특정 경기 세트에 대한 집중 인사이트 제공을 목표로 하는 애플리케이션에 특히 유용합니다.',
        getSeasonLeagueTable: '이 메서드는 각 팀의 순위, 점수, 승리, 무승부, 패배 및 기타 관련 통계를 포함하여 특정 시즌의 리그 테이블을 제공합니다. 이 엔드포인트는 팀 순위 추적, 리그 진행 분석 또는 시즌 전체 최신 순위를 사용자에게 제시하는 데 중점을 둔 애플리케이션에 필수적입니다.',
        getTeamDetail: '이 메서드는 이름, 설립 연도, 경기장 및 기타 메타데이터를 포함하여 특정 팀에 대한 상세 정보를 제공합니다. 이 엔드포인트는 팀별 인사이트가 필요한 애플리케이션에 이상적이며, 상세 팀 프로필, 역사적 맥락 또는 풍부한 팀 관련 데이터로 향상된 사용자 경험과 같은 기능을 활성화합니다.',
        getTeamLoans: '이 메서드는 특정 팀과 관련된 임대 거래에 대한 정보를 검색합니다. 이 엔드포인트는 이적 분석, 팀 로스터 관리 또는 시즌 동안 선수 이동 추적에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getTeamRoster: '이 메서드는 특정 팀의 로스터에 있는 모든 선수 목록을 제공합니다. 팀 라인업 표시, 선수 역할 분석 또는 팀의 로스터 관련 기능 관리가 필요한 애플리케이션에 이상적입니다.',
        getTeamGames: '이 메서드는 특정 팀이 플레이한 모든 경기 목록을 검색합니다. 팀 성과, 일정 추적 또는 사용자에게 팀의 완전한 경기 기록에 대한 액세스 제공에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getTeamGameStats: '이 메서드는 특정 경기에서 특정 팀에 대한 상세 통계를 제공합니다. 경기 분석, 성과 평가 또는 개별 경기에서 팀 성과의 심층 분석에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getTeamTransfers: '이 메서드는 특정 팀과 관련된 이적 거래에 대한 정보를 검색합니다. 이적 시장 분석, 팀 로스터 변경 또는 시간에 따른 선수 이동 추적에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getGameStatus: '이 메서드는 예정됨, 진행 중, 완료됨, 연기됨 또는 취소됨과 같이 API에서 사용 가능한 모든 가능한 경기 상태 목록을 제공합니다. 이 엔드포인트는 실시간 경기 추적, 상태별 경기 필터링 또는 경기 진행 또는 상태에 대한 명확한 업데이트를 사용자에게 제공하는 것이 필요한 애플리케이션에 특히 유용합니다.',
        getPlayerPositions: '이 메서드는 골키퍼, 수비수, 미드필더 및 공격수와 같이 가능한 모든 선수 포지션 목록을 반환합니다. 이 엔드포인트는 선수를 분류하고, 포지션 데이터를 분석하거나, 사용자가 필드에서의 역할을 기반으로 선수를 필터링할 수 있도록 하는 애플리케이션에 특히 유용합니다.',
        getGameDetail: '이 메서드는 참가 팀, 날짜 및 시간, 장소, 점수 및 기타 주요 메타데이터와 같은 세부 정보를 포함하여 특정 경기에 대한 포괄적인 정보를 제공합니다. 이 엔드포인트는 심층 경기 인사이트가 필요한 애플리케이션에 이상적이며, 상세 경기 미리보기, 리포트 또는 분석과 같은 기능을 활성화합니다.',
        getGameStats: '이 메서드는 골, 슛, 볼 소유 비율, 패스 및 수비 액션과 같은 지표를 포함하여 특정 경기에 대한 상세 통계를 제공합니다. 이 엔드포인트는 경기 분석, 경기 후 리포트 또는 경기 중 팀 성과 시각화에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getGamePlayerStats: '이 메서드는 특정 경기에 참가한 모든 선수에 대한 상세 성과 통계를 검색합니다. 개별 선수 성과 분석, 경기 리포트 생성 또는 단일 경기 컨텍스트 내에서 선수 비교를 수행하는 애플리케이션에 특히 유용합니다.',
        getGamePlayerPhysicalStats: '이 메서드는 특정 경기에서 선수에 대한 상세 신체 성과 지표를 제공합니다. 선수 피트니스 분석, 신체 성과 추적 또는 개별 선수에 대한 상세 경기 인사이트 생성에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getGameTeamPhysicalStats: '이 메서드는 특정 경기에서 팀에 대한 상세 신체 성과 지표를 제공합니다. 여기에는 총 이동 거리, 스프린트 수, 고강도 런 및 기타 신체 속성과 같은 데이터가 포함됩니다. 팀 피트니스 분석, 팀 간 신체 노력 비교 또는 경기에서 전반적인 성과 평가에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getGamePlayerArrigoMetrics: '이 메서드는 특정 경기에서 선수에 대한 상세 arrigo 지표를 제공합니다. 경기에서 선수에 대한 분석 및 상세 인사이트 생성에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getGameTeamArrigoMetrics: '이 메서드는 특정 경기에서 팀에 대한 상세 arrigo 지표를 제공합니다. 여기에는 우회당한 선수 및 기타 속성과 같은 데이터가 포함됩니다. 경기에서 전반적인 성과 분석 및 평가에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getGameLineup: '이 메서드는 선발 선수, 교체 선수 및 각각의 포지션을 포함하여 특정 경기의 라인업을 검색합니다. 이 엔드포인트는 경기 전 정보 표시, 팀 포메이션 분석 또는 특정 경기에 대해 팀이 내린 전술적 결정에 대한 인사이트 제공을 수행하는 애플리케이션에 특히 유용합니다.',
        getGameTimeline: '이 메서드는 특정 경기 중에 발생한 이벤트의 시간순 목록을 제공합니다. 라이브 경기 업데이트, 경기 후 요약 또는 경기 이벤트의 상세 분석을 제공하는 애플리케이션에 특히 유용합니다.',
        getGameTracking: '이 메서드는 특정 경기에 대한 추적 데이터 파일을 다운로드할 수 있는 링크를 제공합니다. 이 파일에는 경기 전체에 걸쳐 선수와 볼의 상세 이동 및 위치 데이터가 포함됩니다. 고급 분석, 전술 분석 또는 경기 중 선수 및 볼 이동 시각화 생성에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getTrackingStatus: '이 메서드는 각 상태의 고유 식별자 및 이름과 같은 주요 세부 정보를 제공하여 추적에서 사용 가능한 모든 상태의 전체 목록을 반환합니다. 이 엔드포인트는 경기 추적이 필요한 애플리케이션에 이상적이며, 상태 선택, 필터링 및 분석과 같은 기능을 활성화합니다. 또한 `statusId` 매개변수에 의존하는 다른 엔드포인트와 상호 작용하기 위한 중요한 리소스 역할을 하며, API의 더 넓은 데이터 세트와의 원활한 탐색 및 통합을 보장합니다.',
        getPlayerTransfersTypes: '이 메서드는 영구 이적, 임대, 무료 이적 또는 교환과 같은 가능한 선수 이적 유형 목록을 검색합니다. 이 엔드포인트는 이적 시장 트렌드 분석, 선수 이동 분류 또는 선수와 관련된 거래 유형에 대한 상세 인사이트를 사용자에게 제공하는 애플리케이션에 특히 유용합니다.',
        getPlayerDetail: '이 메서드는 개인 세부 정보, 경력 통계 및 현재 팀 소속을 포함하여 특정 선수에 대한 상세 정보를 제공합니다. 이 엔드포인트는 선수 프로필, 역사적 인사이트 또는 개별 선수 성과 및 경력 궤적에 대한 분석을 제공하는 애플리케이션에 이상적입니다.',
        getPlayerGames: '이 메서드는 특정 선수가 참가한 모든 경기 목록을 검색합니다. 선수 성과 추적, 경기 기록 분석 또는 사용자에게 개별 선수에 대한 포괄적인 경기 로그 제공에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getPlayerInjuries: '이 메서드는 특정 선수가 입은 부상에 대한 상세 기록을 제공합니다. 선수 건강 분석, 경력 영향 평가 또는 회복 타임라인 추적에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getPlayerNationalTeam: '이 메서드는 선수의 국가대표팀 경기 참가에 대한 상세 정보를 검색합니다. 국가 수준에서 선수 성과, 국제 경력 추적 또는 토너먼트 및 친선 경기 중 기여에 대한 인사이트 제공에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getPlayerSeasons: '이 메서드는 특정 선수가 참가한 모든 시즌 목록을 제공합니다. 선수의 경력 진행 추적, 시즌 간 성과 분석 또는 성과에 대한 역사적 맥락 제공을 수행하는 애플리케이션에 특히 유용합니다.',
        getPlayerTransfers: '이 메서드는 특정 선수와 관련된 이적 거래의 상세 기록을 검색합니다. 선수 경력 분석, 이적 시장 인사이트 또는 시간에 따른 팀 간 선수 이동 추적에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getPlayerSeasonTeamStats: '이 메서드는 특정 시즌 동안 팀과 함께 특정 선수에 대한 상세 성과 통계를 제공합니다. 시즌 전체 선수 분석, 팀 또는 시즌 간 비교 및 팀 성공에 대한 개별 기여 추적에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getPlayerSeasonPhysicalStats: '이 메서드는 시즌 전체에 걸쳐 특정 선수에 대한 상세 신체 성과 지표를 제공합니다. 선수 피트니스 추적, 신체 성과 분석 또는 시즌 동안 선수의 작업량 평가에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getPlayerSeasonGamePhysicalStats: '이 메서드는 시즌 내에서 경기별 기준으로 특정 선수에 대한 상세 신체 성과 지표를 제공합니다. 경기별 피트니스 분석, 선수 작업량 추적 또는 다양한 경기 간 신체 성과 비교에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getPlayerSeasonGameStats: '이 메서드는 시즌 내에서 경기별 기준으로 특정 선수에 대한 상세 성과 통계를 검색합니다. 경기별 선수 분석, 성과 트렌드 또는 시즌 내 경기 간 상세 비교에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getCoachDetail: '이 메서드는 이름, 경력 기록, 관리한 팀 및 주목할 만한 성과를 포함하여 특정 코치에 대한 상세 정보를 제공합니다. 이 엔드포인트는 코칭 프로필 강조, 관리 경력 추적 또는 팀 성과에 대한 코치의 영향 분석을 수행하는 애플리케이션에 특히 유용합니다.',
        getCoachHistory: '이 메서드는 관리한 팀, 참가한 대회 및 재직 기간을 포함하여 특정 코치의 경력에 대한 포괄적인 기록을 검색합니다. 이 엔드포인트는 코칭 경력 분석, 관리 변경 추적 또는 코치의 전문 여정 및 성과에 대한 인사이트 제공에 중점을 둔 애플리케이션에 특히 유용합니다.',
        getGameEventing: '이 방법은 모든 이벤트를 제공합니다',
        getLinkStream: '이 메소드는 게임 비디오를 시청하기 위한 링크를 검색합니다.',
        getLinkDownload: '이 메소드는 게임 비디오를 다운로드하기 위한 링크를 검색합니다.',
        getGameTs: '이 방법은 특정 일치 항목의 마지막 타임스탬프를 제공합니다.',
        getGameFileTypes: '이 방법은 일치하는 파일 형식을 제공합니다.',
        deletePlayer: 'This method delete a player',
        getGeneralPositions: '이 메소드는 골키퍼, 수비수, 미드필더, 포워드 등 가능한 일반 포지션 목록을 반환합니다.',
        getPercentiles: '이 방법은 사용 가능한 모든 백분위수를 제공합니다.',
        getPlayerPercentilesEventing: '이 방법은 특정 백분위수 및 위치에 대한 모든 통계를 제공합니다.'
      },
      responseCodes: '응답 코드',
      furtherInformation: '자세한 내용은 API 문서를 참조하세요',
      clipboard: '클립보드에 복사되었습니다!',
      limit50: '처음 50개의 결과만 표시'
    }
  },
  globalSearch: {
    subtitle: '심층 필터링'
  },
  global: {
    teamElos: {
      title: '팀 ELO',
      subtitle: '전 세계 팀 순위와 인사이트',
      team: '팀',
      teams: '팀',
      dates: '날짜',
      excludeInternational: '국제 팀 제외',
      elo: 'ELO',
      selectButton: '상단 선택',
      selectTeamFromTable: '팀을 테이블에서 선택하여 ELO 추세를 표시합니다.',
      showingTeamAveragesLastSeason: '최근 시즌 팀 평균 표시',
      showingTeamStatsLastSeason: '최근 시즌 팀 통계만 표시',
      searchToolTip: '팁: 검색창에 직접 액세스하려면 Ctrl + B를 누르세요.',
      selectTopTooltip: '비교를 위해 차트에 추가 팀을 표시합니다.',
      loadingPage: '데이터 준비 중...'
    },
    leagueElos: {
      title: '리그 ELO',
      subtitle: '전 세계 리그 순위와 분석',
      rankings: '순위',
      insights: '인사이트',
      filters: '필터',
      leagues: '리그',
      from: '시작',
      to: '종료',
      elo: 'ELO',
      change: '변동',
      league: '리그',
      excludeContinental: '국제 대회 제외',
      eloTrend: 'ELO 추세',
      eloRanking: 'ELO 순위',
      currentELOLabel: '(현재 ELO)',
      allTime: '전체 기간',
      average: '평균',
      noChartData: '선택한 필터에 대한 차트 데이터가 없습니다.',
      selectLeagueFromTable: '리그를 테이블에서 선택하여 ELO 추세를 표시합니다.',
      noInsightsData: '선택한 리그에 대한 인사이트 데이터가 없습니다. 해당 리그에 사용 가능한 시즌과 팀 인사이트 데이터가 있는지 확인하세요.',
      showingLeagueAveragesLastSeason: '각 리그의 마지막 활동 시즌의 평균만 표시합니다.',
      selectTopTooltip: '비교를 위해 차트에 추가 리그를 표시합니다.',
      confederations: {
        world: '월드',
        top5: 'TOP 5',
        uefa: 'UEFA',
        conmebol: 'CONMEBOL',
        concacaf: 'CONCACAF',
        caf: 'CAF',
        afc: 'AFC'
      },
      numberOfLeagues: '리그 수',
      minimumElo: '최소 ELO'
    },
    players: {
      title: '플레이어의 GPI',
      subtitle: '글로벌 플레이어 순위 및 통찰력',
      gpiRanking: 'GPI 순위',
      rankTooltip: '마우스를 올리면 글로벌 순위가 표시됩니다.',
      globalRanking: '글로벌 랭킹',
      player: '플레이어',
      players: '플레이어',
      gpiTrend: 'GPI 동향',
      currentGPILabel: '(현재 GPI)',
      nationality: '출생 국가',
      position: '위치',
      marketValue: '시장 가치',
      apply: '적용하다',
      marketValueAndAgeTooltip: '범위를 입력하고 적용을 클릭하거나 Enter를 누르십시오.',
      searchPlaceholder: '플레이어 검색...',
      selectTopTooltip: '비교를 위해 차트에 추가 플레이어를 표시합니다.',
      gpi: 'GPI',
      numberOfPlayers: '플레이어 수',
      showingPlayerStatsLastSeason: '마지막 활성 시즌의 플레이어 평균 통계만 표시',
      date: '날짜',
      showChartLabels: '라벨 표시',
      marketValueTooltip: '범위를 입력하고 적용을 클릭하거나 Enter를 누르십시오.',
      freeAgents: '무료 에이전트',
      selectPlayerFromTable: 'GPI 추세를 보려면 표에서 플레이어를 선택하세요.'
    }
  },
  iso: {
    AF: '아프가니스탄',
    DZ: '알제리',
    AO: '앙골라',
    AR: '아르헨티나',
    AU: '호주',
    AZ: '아제르바이잔',
    BH: '바레인',
    BB: '바베이도스',
    BE: '벨기에',
    BJ: '베냉',
    BO: '볼리비아',
    BW: '보츠와나',
    BN: '브루나이',
    BF: '부르키나파소',
    KH: '캄보디아',
    CA: '캐나다',
    CF: '중앙아프리카 공화국',
    CL: '칠레',
    CO: '콜롬비아',
    CD: '콩고 민주 공화국',
    CG: '콩고',
    CI: '코트디부아르',
    CU: '쿠바',
    CZ: '체코',
    DJ: '지부티',
    DO: '도미니카 공화국',
    EC: '에콰도르',
    SV: '엘살바도르',
    ER: '에리트레아',
    ET: '에티오피아',
    FI: '핀란드',
    PF: '프랑스령 폴리네시아',
    GM: '감비아',
    DE: '독일',
    GI: '지브롤터',
    GL: '그린란드',
    GP: '과들루프',
    GN: '기니',
    GY: '가이아나',
    HN: '온두라스',
    HU: '헝가리',
    IN: '인도',
    IR: '이란',
    IE: '아일랜드',
    IT: '이탈리아',
    JP: '일본',
    KZ: '카자흐스탄',
    KI: '키리바시',
    KR: '대한민국',
    KG: '키르기스스탄',
    LV: '라트비아',
    LS: '레소토',
    LY: '리비아',
    LT: '리투아니아',
    MO: '마카오 특별행정구',
    MG: '마다가스카르',
    MY: '말레이시아',
    ML: '말리',
    MH: '마셜 제도',
    MR: '모리타니',
    MX: '멕시코',
    MD: '몰도바',
    MN: '몽골',
    MA: '모로코',
    MM: '미얀마',
    NR: '나우루',
    NL: '네덜란드',
    NZ: '뉴질랜드',
    NE: '니제르',
    MP: '북마리아나 제도',
    OM: '오만',
    PW: '팔라우',
    PA: '파나마',
    PY: '파라과이',
    PH: '필리핀',
    PT: '포르투갈',
    QA: '카타르',
    RO: '루마니아',
    RW: '르완다',
    LC: '세인트루시아',
    SM: '산마리노',
    SA: '사우디아라비아',
    RS: '세르비아',
    SL: '시에라리온',
    SK: '슬로바키아',
    SB: '솔로몬 제도',
    ZA: '남아프리카 공화국',
    LK: '스리랑카',
    SD: '수단',
    SZ: '에스와티니',
    CH: '스위스',
    TW: '대만',
    TZ: '탄자니아',
    TG: '토고',
    TT: '트리니다드 토바고',
    TR: '터키',
    TV: '투발루',
    UA: '우크라이나',
    GB: '영국',
    UY: '우루과이',
    VU: '바누아투',
    VE: '베네수엘라',
    VG: '영국령 버진 제도',
    EH: '서사하라',
    ZM: '잠비아',
    AL: '알바니아',
    AD: '안도라',
    AG: '앤티가 바부다',
    AM: '아르메니아',
    AT: '오스트리아',
    BS: '바하마',
    BD: '방글라데시',
    BY: '벨라루스',
    BZ: '벨리즈',
    BT: '부탄',
    BA: '보스니아 헤르체고비나',
    BR: '브라질',
    BG: '불가리아',
    BI: '부룬디',
    CM: '카메룬',
    CV: '카보베르데',
    TD: '차드',
    CN: '중국',
    KM: '코모로',
    CR: '코스타리카',
    HR: '크로아티아',
    CY: '키프로스',
    DK: '덴마크',
    DM: '도미니카',
    TL: '동티모르',
    EG: '이집트',
    GQ: '적도 기니',
    EE: '에스토니아',
    FJ: '피지',
    FR: '프랑스',
    GA: '가봉',
    GE: '조지아',
    GH: '가나',
    GR: '그리스',
    GD: '그레나다',
    GT: '과테말라',
    GW: '기니비사우',
    HT: '아이티',
    HK: '홍콩 특별행정구',
    IS: '아이슬란드',
    ID: '인도네시아',
    IQ: '이라크',
    IL: '이스라엘',
    JM: '자메이카',
    JO: '요르단',
    KE: '케냐',
    KP: '조선민주주의인민공화국',
    KW: '쿠웨이트',
    LA: '라오스',
    LB: '레바논',
    LR: '라이베리아',
    LI: '리히텐슈타인',
    LU: '룩셈부르크',
    MK: '북마케도니아',
    MW: '말라위',
    MV: '몰디브',
    MT: '몰타',
    MQ: '마르티니크',
    MU: '모리셔스',
    FM: '미크로네시아',
    MC: '모나코',
    ME: '몬테네그로',
    MZ: '모잠비크',
    NA: '나미비아',
    NP: '네팔',
    NC: '뉴칼레도니아',
    NI: '니카라과',
    NG: '나이지리아',
    NO: '노르웨이',
    PK: '파키스탄',
    PS: '팔레스타인 영토',
    PG: '파푸아뉴기니',
    PE: '페루',
    PL: '폴란드',
    PR: '푸에르토리코',
    RE: '레위니옹',
    RU: '러시아 연방',
    KN: '세인트키츠 네비스',
    WS: '사모아',
    ST: '상투메 프린시페',
    SN: '세네갈',
    SC: '세이셸',
    SG: '싱가포르',
    SI: '슬로베니아',
    SO: '소말리아',
    ES: '스페인',
    VC: '세인트빈센트 그레나딘',
    SR: '수리남',
    SE: '스웨덴',
    SY: '시리아',
    TJ: '타지키스탄',
    TH: '태국',
    TO: '통가',
    TN: '튀니지',
    TM: '투르크메니스탄',
    UG: '우간다',
    AE: '아랍에미리트',
    US: '미국',
    UZ: '우즈베키스탄',
    VA: '바티칸 시국',
    VN: '베트남',
    VI: '미국령 버진아일랜드',
    YE: '예멘',
    ZW: '짐바브웨',
    EU: '유럽',
    INT: '국제',
    CW: '퀴라소',
    AFC: 'AFC',
    CONCACAF: 'CONCACAF',
    'GB-ENG': '잉글랜드',
    'GB-WLS': '웨일스',
    'GB-SCT': '스코틀랜드',
    LATAM: '남아메리카',
    CAF: 'CAF',
    XK: '코소보',
    AI: '앵귈라',
    AN: '네덜란드령 안틸레스',
    AS: '미국령 사모아',
    AW: '아루바',
    BM: '버뮤다',
    BQ: '보네르, 신트외스타티위스 및 사바',
    CK: '쿡 제도',
    FO: '페로 제도',
    GF: '프랑스령 기아나',
    GG: '건지',
    GU: '괌',
    IM: '맨 섬',
    JE: '저지',
    KY: '케이맨 제도',
    MF: '생마르탱',
    MS: '몬트세랫',
    NU: '니우에',
    OC: '오세아니아',
    RI: '인도네시아',
    SS: '남수단 공화국',
    TC: '터크스 케이커스 제도',
    YT: '마요트',
    SX: '신트마르턴'
  },
  loadingMessages: {
    players: '선수 준비 중',
    teams: '팀 정렬 중',
    games: '경기 가져오는 중',
    stats: '지표 계산 중',
    graphs: '그래프 그리는 중',
    gettingReady: '준비 중',
    placeholder: '준비하세요'
  },
  requestReport: {
    subtitle: '필요한 모든 것이 포함된 심층 리포트 받기',
    categories: {
      scouting: {
        title: '스카우팅',
        subtitle: '특정 리그의 최고 선수는 누구인가요? 여러 리그를 결합하면 어떨까요? 원하는 필터(연령, 키, 계약 종료 등)로 맞춤형 리포트를 요청하고 가장 적합한 선수를 찾아보세요'
      },
      coaches: {
        title: '코치',
        subtitle: '코치가 팀 시스템에 어떻게 적합할까요? 상세 정보를 얻거나 특정 프로필이 주어지면 어떤 코치가 가장 적합한지 알아보세요'
      },
      'team analysis': {
        title: '팀',
        subtitle: '팀을 지정하고 스타일, 수비 및 공격 성과, 약점, 최고 선수 등에 대한 유용한 인사이트가 포함된 시즌 요약을 얻으세요...'
      },
      'game analysis': {
        title: '경기 분석',
        subtitle: '경기가 주어지면 상세 정보가 포함된 심층 사전 경기 및 사후 경기 분석을 받으세요'
      },
      'special projects': {
        title: '특별 프로젝트',
        subtitle: '선수가 원정 경기에서 어떻게 성과를 내나요? 선수들이 리그 간에 어떻게 변화하나요? 어떤 선수들이 임대 가능한가요? 생각할 수 있는 모든 것을 물어보세요'
      },
      conversation: {
        title: '대화',
        subtitle: '우리 팀과 대화를 시작하세요'
      }
    },
    notesPlaceholder: '더 알고 싶은 리그, 프로필, 통계, 코치, 팀 또는 경기를 알려주세요',
    chooseType: '리포트 유형 선택',
    requestSummary: '요청 요약',
    reportType: '리포트 유형',
    reportLanguage: '리포트 언어',
    detailTitle: '리포트 후속 조치',
    detailSubtitle: '요청한 리포트의 모든 정보'
  },
  bugReport: {
    modalSubtitle: '개선에 도움을 주세요',
    about: '정보',
    sendSuccess: '성공적으로 알림을 보냈습니다. 받은편지함에서 업데이트를 확인하세요',
    bugs: '버그'
  },
  gbe: {
    autopass: '자동 패스',
    bandX: '밴드 {0}',
    bandXCont: '밴드 {0} 대륙 대회',
    points: '점수',
    titleWinner: '우승',
    qualifiedGroupsBandX: '밴드 {0} 대륙 대회 조별 리그 진출',
    qualifiedQualifiersBandX: '밴드 {0} 대륙 대회 예선 진출',
    midTable: '중위권',
    relegation: '강등',
    promotion: '승격',
    final: '결승',
    semifinal: '준결승',
    quarterfinal: '8강',
    round16: '16강',
    round32: '32강',
    groupstage: '조별 리그',
    firstRound: '1라운드',
    secondRound: '2라운드',
    thirdRound: '3라운드',
    fourthRound: '4라운드',
    preliminaryRound: '예비 라운드',
    other: '기타',
    score: '점수',
    totalSummary: '총 요약',
    currentlyPlayingInUK: '선수는 영국 또는 아일랜드 시민이거나 영국의 영주권자입니다',
    bandsAlert: '하나 이상의 밴드에서 출전 시간이 있으며, 총계는 최대값입니다',
    bandsAlertMax: '하나 이상의 밴드에서 출전 시간이 있으며, 총계는 최대값입니다',
    bandsAlertAvg: '하나 이상의 밴드에서 출전 시간이 있으며, 총계는 평균값입니다',
    generate: 'GBEApplicationForm',
    debutYouthPlayer: '유스 선수 데뷔',
    table1: {
      name: '선수의 국제 경기 출전',
      title1: '선수의 국가 협회 FIFA 월드 랭킹 집계',
      title2: '선수의 국제 경기 출전'
    },
    table2: {
      name: '선수의 국내 출전 시간',
      title1: '선수의 국내 출전 시간'
    },
    table3: {
      name: '선수의 대륙 대회 출전 시간',
      title1: '선수의 대륙 대회 출전 시간'
    },
    table4: {
      name: '선수의 마지막 클럽 최종 리그 순위',
      title1: '마지막 클럽의 최종 리그 순위'
    },
    table5: {
      name: '선수의 마지막 클럽 대륙 대회 진행',
      title1: '대륙 대회 진행'
    },
    table6: {
      name: '선수의 현재 클럽 리그 품질',
      title1: '선수의 현재 클럽 밴드'
    },
    table7: {
      name: '유스 - 데뷔',
      title1: '밴드'
    },
    table8: {
      name: '유스 - 최종 리그 순위',
      title1: '마지막 클럽의 최종 리그 순위'
    },
    table9: {
      name: '유스 - 대륙 대회 진행',
      title1: '대륙 대회 진행'
    },
    table10: {
      name: '유스 - 선수의 현재 리그 품질',
      title1: '선수의 현재 클럽 밴드'
    },
    table11: {
      name: '유스 - 선수의 현재 리그 품질',
      title1: '선수의 현재 클럽 밴드'
    },
    table12: {
      name: '유스 - 국제 경기 출전',
      title1: '선수의 국제 경기 출전'
    }
  },
  mediaMode: {
    borderColor: '테두리 색상',
    fillColor: '채우기 색상',
    bgColor: '배경 색상',
    upperText: '상단 텍스트',
    lowerText: '하단 텍스트',
    socialMedia: '소셜 미디어',
    textColor: '텍스트 색상',
    axisColor: '축 색상',
    logo: '로고',
    comparisonBorderColor: '비교 테두리 색상',
    comparisonFillColor: '비교 채우기 색상',
    comparisonUpperText: '비교 상단 텍스트',
    comparisonLowerText: '비교 하단 텍스트',
    homeFillColor: '홈 채우기 색상',
    homeBorderColor: '홈 테두리 색상',
    awayFillColor: '원정 채우기 색상',
    awayBorderColor: '원정 테두리 색상',
    face: '얼굴',
    nationalTeam: '국가대표팀',
    comparisonFace: '비교 얼굴',
    upperTextX: '상단 텍스트 {0}',
    lowerTextX: '하단 텍스트 {0}',
    borderColorX: '테두리 색상 {0}',
    fillColorX: '채우기 색상 {0}',
    homeFillColorX: '채우기 색상 (홈) {0}',
    homeBorderColorX: '테두리 색상 (홈) {0}',
    awayFillColorX: '채우기 색상 (원정) {0}',
    awayBorderColorX: '테두리 색상 (원정) {0}',
    faceX: '얼굴 {0}',
    selectField: '속성 선택',
    orientationX: '방향 {0}',
    searchBarPlaceholder: '선수 및/또는 경기 검색...',
    title: '미디어 대시보드',
    pageSubtitle: '지도 및 그래픽 탐색 및 다운로드',
    chooseChart: '차트 선택...',
    headerTextX: '헤더 텍스트 {0}',
    avatarLineLength: '아바타 선 길이',
    avatarLineWeight: '아바타 선 두께',
    avatarSize: '아바타 크기',
    chartX: '차트 {0}',
    chartHeaderFontSize: '차트 헤더 글꼴 크기',
    chartHeaderFontWeight: '차트 헤더 글꼴 두께',
    upperTextFontSize: '상단 텍스트 글꼴 크기',
    upperTextFontWeight: '상단 텍스트 글꼴 두께',
    lowerTextFontSize: '하단 텍스트 글꼴 크기',
    lowerTextFontWeight: '하단 텍스트 글꼴 두께',
    socialMediaFontSize: '소셜 미디어 글꼴 크기',
    socialMediaFontWeight: '소셜 미디어 글꼴 두께',
    subtitle: '부제목',
    subtitleFontSize: '부제목 글꼴 크기',
    subtitleFontWeight: '부제목 글꼴 두께',
    subtitleX: '부제목 {0}',
    subtitleFontSizeX: '부제목 ${0} 글꼴 크기',
    subtitleFontWeightX: '부제목 ${0} 글꼴 두께',
    titleX: '제목 {0}',
    titleFontSize: '제목 글꼴 크기',
    titleFontWeight: '제목 글꼴 두께',
    sponsor: '스폰서',
    fontFamily: '글꼴 패밀리'
  },
  documents: {
    types: {
      SCOUTING_REPORT: '스카우팅 리포트',
      GAME_REPORT: '경기 리포트',
      MEDICAL_REPORT: '의료 리포트',
      PHYSICAL_REPORT: '신체 리포트',
      PSYCHOLOGICAL_REPORT: '심리 리포트',
      OTHER: '기타',
      QUICK_NOTES: '빠른 메모',
      PLAYER_REPORT: '선수 리포트',
      GENERAL_COMMENTS: '일반 코멘트',
      PLAYER_ANALYSIS: '선수 분석'
    },
    uploadDocument: '문서 업로드',
    notesPlaceholder: '문서와 관련된 설명 메모 또는 코멘트를 입력하세요',
    notesPlaceholderAlt: '선수와 관련된 설명 메모 또는 코멘트를 입력하세요',
    uploadedBy: '업로드한 사람',
    updatedBy: '업데이트한 사람',
    seeNotes: '메모 보기',
    addNote: '메모 추가',
    rating: '평점',
    position: '최적 포지션',
    physical: '신체',
    onBall: '볼 소유',
    offBall: '볼 미소유',
    mental: '정신',
    potential: '잠재력',
    conclusion: '결론',
    recommendation: {
      1: '계약',
      2: '모니터링',
      3: '제외',
      4: '흥미로운',
      label: '추천'
    },
    match: '경기',
    deleteQuickNote: '메모 삭제',
    deleteQuickNoteMessage: '메모가 영구적으로 제거됩니다. 계속하시겠습니까?',
    noQuickNotes: '데이터가 없습니다. 빠른 메모를 추가하여 시작하세요!',
    deleteDocument: '문서 삭제',
    deleteDocumentMessage: '문서가 영구적으로 제거됩니다. 계속하시겠습니까?',
    noDocuments: '데이터가 없습니다. 문서를 추가하여 시작하세요!'
  },
  notifications: {
    newReportMessage: '리포트에 새 메시지가 있습니다'
  },
  blog: {
    subtitle: '최신 기사, 업데이트 및 뉴스',
    newEntry: '새 항목',
    title: '제목',
    text: '텍스트',
    link: '링크',
    image: '이미지',
    author: '작성자',
    date: '발행일',
    deleteEntry: '항목 삭제',
    deleteEntryMessage: '이 항목을 삭제하시겠습니까?',
    readMore: '더 보기'
  },
  positionsOrlegi: {
    GK: '골키퍼',
    DC: '수비수',
    DR: '풀백',
    MC: '미드필더',
    AMC: '공격형 미드필더',
    FW: '공격수',
    FWR: '윙어'
  },
  library: {
    subtitle: '업로드된 문서 보기 및 공유',
    mediaSubtitle: '내보낸 차트 보기 및 공유',
    charts: '차트',
    goToLibrary: '라이브러리로 이동'
  },
  scatterPlot: {
    bubbleSize: '버블 크기',
    byMinutes: '출전 시간별',
    byAge: '연령별',
    byMarketValue: '시장 가치별'
  },
  eventChart: {
    successfulEvent: '성공적인',
    unsuccessfulEvent: '실패',
    possessionLost: '성공했지만 복구되지 않았습니다.',
    successfulPass: '성공한 패스',
    unsuccessfulPass: '실패한 패스',
    successfulCarry: '성공한 볼 운반',
    unsuccessfulCarry: '실패한 볼 운반',
    carryAndKeyPass: '볼 운반 및 키 패스',
    carryAndAssist: '볼 운반 및 어시스트',
    carryAndShot: '볼 운반 및 슛',
    ballProgressionAndPass: '볼 전진 및 패스',
    ballProgression: '볼 전진',
    ballProgressionAndKeyPass: '볼 전진 및 키 패스',
    ballProgressionAndAssist: '볼 전진 및 어시스트',
    ballProgressionAndShot: '볼 전진 및 슛',
    ballProgressionAndGoal: '볼 전진 및 골',
    pass: '패스',
    carryAndPass: '볼 운반 및 패스',
    carryAndGoal: '볼 운반 및 골',
    totalTouches: '총 터치',
    totalPasses: '총 패스',
    successful: '성공',
    unsuccessful: '실패',
    tacklePossessionLost: '성공 - 소유권 상실',
    gamesSelected: '{count}경기 선택됨',
    allGamesOfSeason: '시즌 전체 경기',
    allGamesOfSeasons: '시즌별 전체 경기',
    allEvents: '모든 이벤트',
    eventTypesCount: '{count}개 이벤트 유형',
    totalEvents: '총 이벤트',
    zoneDominanceNote: '각 존에서 각 팀이 보여준 터치는 성공적인 터치만을 의미합니다.',
    selectedEvents: '선택된 이벤트'
  },
  event: {
    Pass: '패스',
    TakeOn: '드리블',
    Takeon: '드리블',
    Foul: '파울',
    Error: '실수',
    Tackle: '태클',
    Interception: '인터셉트',
    Clearance: '클리어런스',
    MissedShot: '빗나간 슛',
    ShotOnPost: '골대 맞춘 슛',
    SavedShot: '세이브된 슛',
    Goal: '골',
    Aerial: '공중볼',
    BallRecovery: '볼 회수',
    Dispossessed: '볼 소유권 상실',
    ChanceMissed: '찬스 놓침',
    BallTouch: '볼 터치',
    BlockedPass: '차단된 패스',
    Challenge: '챌린지',
    lossPossession: '볼 소유권 상실',
    OffsidePass: '오프사이드 패스',
    groundDuelsLost: '지상 결투 패배',
    'Ball touch': '볼 터치',
    Smother: '스머더',
    'Keeper pickup': '골키퍼 픽업',
    'Good skill': '좋은 기술',
    Punch: '펀치',
    'Saved shot': '세이브된 슛',
    'Shot on post': '골대 맞춘 슛',
    'Missed shot': '빗나간 슛',
    Save: '세이브',
    'Take on': '드리블',
    'Offside pass': '오프사이드 패스',
    Claim: '클레임',
    'Blocked pass': '차단된 패스',
    KeeperPickup: '키퍼 픽업',
    'Ball recovery': '볼 회수',
    'Ball Recovery': '볼 회수',
    'Chance missed': '찬스 놓침',
    'Loss possession': '볼 소유권 상실',
    Carries: '볼 운반',
    BallProgression: '볼 진행',
    MissedChance: '놓친 기회',
    Event: '이벤트',
    Shot: '슛',
    Assist: '어시스트',
    KeyPass: '키패스',
    'Foul taken': '파울을 받음'
  },
  leagueTab: {
    leagueTable: '리그 순위표',
    matchdays: '경기일',
    playerInsights: '선수 인사이트',
    onlyLocalPlayers: '로컬 플레이어만',
    teamInsights: '팀 인사이트',
    head2head: '맞대결',
    addNewChart: '새 차트 추가',
    rounds: {
      16: '16강',
      32: '32강',
      W: '우승',
      F: '결승',
      SF: '준결승',
      QF: '8강',
      GR: '조별 리그',
      '4R': '4라운드',
      '3R': '3라운드',
      '2R': '2라운드',
      '1R': '1라운드',
      PR: '예비 라운드',
      QPO1: '32강 티어 이하 만들기',
      QPO2: '16강 예선',
      QPO3: '32강 예선'
    },
    positions: '포지션',
    prediction: '예측',
    predicted: '예측',
    groups: '조',
    ranking: '순위',
    numberOfTeams: '팀 수',
    statsWithMinimum: {
      message: '선택된 시즌에서 {0} {1} 이상인 선수만 표시',
      dribblesTotal90: '90분당 드리블',
      crosses90: '90분당 크로스',
      tacklesAttempted90: '90분당 시도한 태클',
      aerialsTotal90: '90분당 공중볼 경합'
    },
    numberOfLeagues: '리그 수',
    position: {
      titleWinner: '타이틀 우승자',
      championsLeague: '챔피언스리그',
      qualifierChampionsLeague: '챔피언스리그 예선',
      europeLeague: '유럽리그',
      qualifierEuropeLeague: '유럽리그 예선',
      conferenceLeague: '컨퍼런스 리그',
      qualifierConferenceLeague: '예선 컨퍼런스 리그',
      midTable: '중간 테이블',
      relegation: '좌천',
      promotion: '홍보',
      relegationPlayoff: '강등 플레이오프',
      promotionPlayoff: '승격 플레이오프',
      championshipGroup: '챔피언십 그룹',
      relegationGroup: '강등 그룹',
      championshipPlayoffs: '챔피언십 플레이오프',
      preChampionshipPlayoffs2: '프리 챔피언십 플레이오프 2',
      preChampionshipPlayoffs3: '프리 챔피언십 플레이오프 3',
      playoffsQualifierBand3: '플레이오프 예선 밴드 3',
      continentalGroup: '콘티넨탈 그룹'
    },
    group: {
      1: '에이',
      2: '비',
      3: '기음',
      4: '디',
      5: '이자형',
      6: '에프',
      7: 'G',
      8: '시간',
      9: '나',
      10: '제이',
      11: '케이',
      12: '엘'
    }
  },
  similarity: {
    subtitle: '유사한 선수 찾기',
    searchBarPlaceholder: '유사한 선수를 찾기 위해 선수를 검색하고 선택하세요',
    radarFilters: '레이더 필터',
    similarityFilters: '유사도 필터',
    playersFilters: '선수 필터',
    similarPlayers: '유사한 선수',
    seasonWarning: '450분 이상 출전한 시즌만 유사도 도구에서 사용 가능합니다'
  },
  squadBuilder: {
    subtitle: '고유한 11명 스케치하기',
    playerSelector: '선수 선택기',
    loadSquad: '스쿼드 불러오기',
    yearsOld: '세',
    playersPerPosition: '포지션당 선수',
    custom: '커스텀',
    removeSquad: '스쿼드 삭제',
    removeSquadMessage: '스쿼드를 삭제하시겠습니까?',
    deleteSquadSuccess: '스쿼드가 성공적으로 삭제되었습니다',
    playerDetails: '선수 세부 정보 표시',
    ageFormat: '연령 형식',
    mainPlayer: '주요 선수',
    showDetails: '세부 정보 표시',
    all: '전체',
    squadPosition: '스쿼드 포지션',
    noData: '데이터가 없습니다. 경기장에 선수를 추가하여 시작하세요!'
  },
  tours: {
    buttons: {
      dontShowAgain: '다시 표시하지 않기',
      skipTour: '가이드 투어 건너뛰기',
      previous: '이전',
      next: '다음',
      finish: '완료'
    },
    playerRadar: {
      step1: {
        title: '개인 파일',
        message: '기본 선수 데이터 확인: 연령, 키 또는 계약 날짜'
      },
      step2: {
        title: 'GBE 필터',
        message: '선수가 영국에서 플레이하기에 충분한 GBE 점수를 가지고 있는지 알 수 있는 기능'
      },
      step3: {
        title: '가용성',
        message: '가용한 시간 비율 및 출전 시간 비율'
      },
      step4: {
        title: '포지션',
        message: '선수가 어떤 포지션에서 플레이했는지, 각 포지션에서 몇 분을 플레이했는지 알아보세요'
      },
      step5: {
        title: '표시 형식',
        message: '레이더, 폴라, 롤리팝 및 텍스트의 4가지 다른 시각화로 성과를 측정하여 포지션의 다른 선수들과 비교하세요'
      },
      step6: {
        title: '성과 레이더',
        message: '여기서 성과가 시각적으로 반영됩니다. 패널은 대화형이며, 각 지표에 마우스를 올리면 정의를 볼 수 있습니다'
      },
      step7: {
        title: '시즌 선택',
        message: '성과를 측정할 시즌을 선택하거나 추가하세요'
      },
      step8: {
        title: '커스텀 템플릿 선택',
        message: '생성한 커스텀 템플릿을 사용하여 표준 레이더와 다른 지표로 선수를 측정하세요'
      },
      step9: {
        title: '출전 포지션 선택',
        message: '다양한 포지션을 체크 및 체크 해제하여 측정하고 싶은 포지션에서 선수를 측정하세요'
      },
      step10: {
        title: '최소값 및 최대값 선택',
        message: '선수의 시즌, 상위 5개 리그 또는 사용자 계정의 자체 및 기본 시즌의 최고점과 최저점으로 선수를 측정하세요'
      },
      step11: {
        title: '비교',
        message: '선수를 이전 성과, 포지션의 다른 선수, 포지션 평균과 비교합니다'
      },
      step12: {
        title: '이미지 다운로드 형식',
        message: '세 가지 다운로드 형식이 제공됩니다: png, svg 및 embed'
      }
    },
    playerRanking: {
      step1: {
        title: '시즌, 스쿼드 및 포지션',
        message: '선수와 비교할 시즌, 스쿼드 및 포지션을 선택하세요'
      },
      step2: {
        title: '기본 필터',
        message: '연령, 출전 시간 또는 키로 선수를 필터링하세요'
      },
      step3: {
        title: '강조 및 제외',
        message: '원하는 선수를 강조하고 표시에서 팀을 제외하세요'
      },
      step4: {
        title: '카테고리별 필터',
        message: '카테고리별로 통계를 필터링하세요: 연계, 수비, 패스, 볼 핸들링 등'
      },
      step5: {
        title: '이미지 다운로드 형식',
        message: '세 가지 다운로드 형식이 제공됩니다: png, svg 및 embed'
      }
    },
    playerFinishing: {
      step1: {
        title: '표시 선택',
        message: '메인 보기, 골 보기 및 분포 테이블에서 마무리 지도를 볼 수 있습니다'
      },
      step2: {
        title: '시즌 선택',
        message: '슛 효율을 측정할 시즌을 추가하세요'
      },
      step3: {
        title: '슛 위치',
        message: '슛의 정확한 위치(원)를 보거나 박스와 피치의 영역별(영역)로 볼 수 있는 옵션을 선택하세요'
      },
      step4: {
        title: '유효 슛 xG',
        message: 'xG to Goal 및 xG Completion 체크박스를 선택하여 선수가 슛 후에 추가한 부가 가치를 확인하세요'
      },
      step5: {
        title: '슛 유형',
        message: '슛 유형, 전략, 영역 또는 신체 부위로 필터링하세요'
      },
      step6: {
        title: '시간 필터',
        message: '특정 경기 시간대별로 슛과 골을 선택하는 시간 바'
      },
      step7: {
        title: '이미지 다운로드 형식',
        message: '세 가지 다운로드 형식이 제공됩니다: png, svg 및 embed'
      },
      step8: {
        title: '슛 지도',
        message: '지도는 대화형입니다. 마우스로 각 원을 확인하여 각 슛의 xG를 알아보세요'
      }
    },
    playerKeyPass: {
      step1: {
        title: '시즌 선택',
        message: '슛 효율을 측정할 시즌을 추가하세요'
      },
      step2: {
        title: '키 패스 위치',
        message: '키 패스의 정확한 위치(원)를 보거나 영역과 필드의 영역별(영역)로 볼 수 있는 옵션을 선택하세요'
      },
      step3: {
        title: '키 패스 후 마무리 유형',
        message: '키 패스 후 수행한 슛 유형, 전략, 영역 또는 신체 부위로 필터링하세요'
      },
      step4: {
        title: '시간 필터',
        message: '특정 경기 시간대별로 슛과 골을 선택하는 시간 바'
      },
      step5: {
        title: '이미지 다운로드 형식',
        message: '세 가지 다운로드 형식이 제공됩니다: png, svg 및 embed'
      },
      step6: {
        title: '키 패스 지도',
        message: '지도는 대화형입니다. 마우스로 각 원을 확인하여 각 패스의 xA를 알아보세요'
      }
    },
    playerThreat: {
      step1: {
        title: '시즌 선택',
        message: '슛 효율을 측정할 시즌을 추가하세요'
      },
      step2: {
        title: '위협 위치',
        message: '키 패스의 정확한 위치(원)를 보거나 영역 및 필드 존별(영역)로 볼 수 있는 옵션을 선택하세요'
      },
      step3: {
        title: '액션 및 완료',
        message: '지도에 표시하고 싶은 액션 및 완료 유형에 따라 체크 및 체크 해제하세요'
      },
      step4: {
        title: '시간 및 위협',
        message: '기간, 시간 및 액션의 위협 값으로 필터링하세요'
      },
      step5: {
        title: '이미지 다운로드 형식',
        message: '세 가지 다운로드 형식이 제공됩니다: png, svg 및 embed'
      },
      step6: {
        title: '위협 지도',
        message: '지도는 대화형입니다. 마우스로 각 원을 확인하여 각 패스의 각 xT 플레이에서 생성된 위협을 알아보세요'
      }
    },
    playerTouches: {
      step1: {
        title: '경기 및 이벤트 선택',
        message: '지도에 표시할 경기와 이벤트를 선택하세요'
      },
      step2: {
        title: '이벤트 유형',
        message: '경기 전체에 걸쳐 선수 이벤트의 수비 또는 공격 성격에 따라 체크 및 체크 해제하세요'
      },
      step3: {
        title: '표시 필터',
        message: '기본 액션, 히트맵, 원 또는 박스로 지도를 필터링하세요'
      },
      step4: {
        title: '이미지 다운로드 형식',
        message: '세 가지 다운로드 형식이 제공됩니다: png, svg 및 embed'
      },
      step5: {
        title: '터치 지도',
        message: '지도는 대화형입니다. 각 이벤트를 클릭하여 각 이벤트를 볼 수 있습니다'
      }
    },
    playerAllGames: {
      step1: {
        title: '가용성',
        message: '경기별로 가용성 및 출전 시간을 확인하세요'
      },
      step2: {
        title: '포지션',
        message: '각 경기에서 플레이한 포지션을 확인하세요'
      }
    },
    playerInjuries: {
      step1: {
        title: '기록 및 손실 일수',
        message: '지난 해의 부상 또는 전체 기록을 확인하고 일수에 따른 부상 범위를 확인하세요'
      },
      step2: {
        title: '클럽별 부상',
        message: '시즌 및/또는 경력의 클럽별로 구분된 부상을 확인하세요'
      }
    },
    playerInfo: {
      step1: {
        title: '경력 및 이적',
        message: '클럽, 국가대표팀과의 출전 시간, 포지션 또는 가용성 기록과 경력 전체에 걸친 선수의 이적을 확인할 수 있습니다'
      }
    },
    teamOverview: {
      step1: {
        title: '팀 시트',
        message: '팀의 기본 데이터 확인: 평균 연령, 기본 포메이션, ELO 또는 이적 잔액'
      },
      step2: {
        title: '기본 통계',
        message: '볼 소유, xG, 슛, PPDA 또는 수직성 확인'
      },
      step3: {
        title: '레이더 및 시즌',
        message: '팀의 성과를 측정하기 위해 레이더, 시즌 및 홈 또는 원정 경기를 선택하세요'
      },
      step4: {
        title: '코치 및 경기별 필터',
        message: '각 코치의 단계별 성과를 선택하세요'
      },
      step5: {
        title: '성과 레이더',
        message: '패널은 대화형이며, 각 지표에 마우스를 올리면 정의를 볼 수 있습니다'
      },
      step6: {
        title: '이미지 다운로드 형식',
        message: '두 가지 다운로드 형식이 제공됩니다: png 및 svg'
      },
      step7: {
        title: '캘린더',
        message: '팀의 경기 일정 보기'
      },
      step8: {
        title: '지표별 최고 선수',
        message: '이 패널에서 다양한 지표를 선택하고 가장 중요한 선수가 누구인지 확인할 수 있습니다'
      },
      step9: {
        title: '다음 경기 및 부상',
        message: '다음 상대와 팀의 부상 및 출장 정지 선수를 확인하세요'
      },
      step10: {
        title: '그래프 및 트렌드',
        message: '최근 10경기 또는 20경기에 대한 다양한 그래프 보기'
      }
    },
    teamRoster: {
      step1: {
        title: '보기 유형',
        message: '6가지 다른 카테고리로 스쿼드 보기: 포지션별, 계약 종료, 연령, 가용성, 연령 프로필 및 경기장'
      }
    },
    teamLoans: {
      step1: {
        title: '임대 선수',
        message: '다른 팀에 임대된 선수와 그들이 플레이하는 포지션을 확인하세요'
      }
    },
    teamBeeswarm: {
      step1: {
        title: '시즌 및 스쿼드',
        message: '시즌, 레이더 스쿼드로 필터링하고 선택한 리그와 비교하세요'
      },
      step2: {
        title: '지표별 성과',
        message: '이전에 선택한 리그의 모든 팀과 비교하여 각 지표에서 팀의 위치를 확인하세요'
      },
      step3: {
        title: '이미지 다운로드 형식',
        message: '세 가지 다운로드 형식이 제공됩니다: png, svg 및 embed'
      }
    },
    teamFinishingMap: {
      step1: {
        title: '시즌 선택',
        message: '슛 효율을 측정할 시즌을 추가하세요'
      },
      step2: {
        title: '자신 또는 상대의 마무리',
        message: '팀의 마무리 지도 또는 모든 상대의 마무리 지도를 볼지 선택하세요'
      },
      step3: {
        title: '슛 배치',
        message: '팀의 슛을 원(원) 또는 영역(박스)으로 볼지 선택하세요'
      },
      step4: {
        title: '슛 유형',
        message: '슛 유형, 전략, 영역 또는 신체 부위로 필터링하세요'
      },
      step5: {
        title: '시간 필터',
        message: '특정 경기 시간대별로 슛과 골을 선택하는 시간 바'
      },
      step6: {
        title: '이미지 다운로드 형식',
        message: '세 가지 다운로드 형식이 제공됩니다: png, svg 및 embed'
      },
      step7: {
        title: '슛 지도',
        message: '지도는 대화형입니다. 마우스로 각 원을 확인하여 각 슛의 xG를 알아보세요'
      }
    },
    teamKeyPassMap: {
      step1: {
        title: '시즌 선택',
        message: '슛 효율을 측정할 시즌을 추가하세요'
      },
      step2: {
        title: '자신 또는 라이벌 키 패스',
        message: '팀의 키 패스 지도 또는 모든 라이벌의 키 패스 지도를 볼지 선택하세요'
      },
      step3: {
        title: '키 패스 위치',
        message: '키 패스의 정확한 위치(원)를 보거나 영역 및 필드별(박스)로 볼지 선택하세요'
      },
      step4: {
        title: '패스 후 마무리 유형',
        message: '키 패스 후 수행한 슛 유형, 전략, 영역 또는 신체 부위로 필터링하세요'
      },
      step5: {
        title: '시간 필터',
        message: '특정 경기 시간대별로 슛과 골을 선택하는 시간 바'
      },
      step6: {
        title: '이미지 다운로드 형식',
        message: '세 가지 다운로드 형식이 제공됩니다: png, svg 및 embed'
      },
      step7: {
        title: '슛 지도',
        message: '지도는 대화형입니다. 마우스로 각 원을 확인하여 각 패스의 xA를 알아보세요'
      }
    },
    teamLatestGames: {
      step1: {
        title: '최근 경기',
        message: '팀의 모든 경기 결과, 볼 소유, xG 및 승률 확인'
      }
    },
    teamTransfers: {
      step1: {
        title: '영입',
        message: '연도별 모든 영입(구매 + 이적) 확인'
      },
      step2: {
        title: '방출',
        message: '연도별 모든 방출(판매 + 이적) 확인'
      }
    },
    teamAnalysis: {
      step1: {
        title: '트렌드',
        message: '연승, 승리, 무실점, 역전승, 골이 있는 기간 또는 골 유형을 통해 팀의 폼을 조회하세요'
      },
      step2: {
        title: '세트피스',
        message: '세트피스 플레이와 오픈 플레이 간의 팀 성과를 비교하고 세트피스에 대한 상세 개요를 얻으세요'
      },
      step3: {
        title: '교체',
        message: '팀이 교체를 하는 시점과 가장 많이 교체되는 선수를 확인하세요'
      },
      step4: {
        title: '연결',
        message: '선수 간 가장 일반적인 연결을 확인하세요. 시즌 및 플레이 유형으로 필터링하세요'
      },
      step5: {
        title: '공격 존',
        message: '팀의 공격 존을 발견하고 시즌 또는 공격 유형으로 필터링하세요'
      },
      step6: {
        title: '포메이션',
        message: '가장 많이 사용된 포메이션과 각 포메이션의 승률, 무승부율 및 패배율을 확인하세요'
      },
      step7: {
        title: '슛 존',
        message: '시즌, 팀 또는 상대, 지도 시각화 방법, 슛 유형 또는 시간으로 필터링하세요'
      },
      step8: {
        title: '크로스',
        message: '시즌, 표시 유형, 성공 또는 실패, 시작 및 종료 위치 또는 코너킥 포함으로 조회 및 필터링하세요'
      },
      step9: {
        title: '선수',
        message: '시즌, 표시 유형, 성공 또는 실패, 시작 및 종료 위치 또는 코너킥 포함으로 필터링하세요'
      }
    },
    teamOnOff: {
      step1: {
        title: '시즌 및 경기',
        message: '시즌, 경기 또는 홈 또는 원정 경기로 필터링하세요'
      },
      step2: {
        title: '선수',
        message: '수많은 지표를 통해 스쿼드의 모든 선수 성과 보기'
      }
    }
  },
  alerts: {
    numPlayers: '선수 수',
    newPlayersLastWeek: '지난 주 신규 선수',
    subtitle: '검색 조건에 맞는 신규 선수가 있을 때 알림 받기',
    generalSubtitle: '기준에 따라 신규 선수에 대한 알림 및 즐겨찾는 선수 소식 받기',
    subtitlePlayer: '즐겨찾는 선수에 대한 소식이 있을 때 알림 받기',
    subtitleSearch: '검색 조건에 맞는 신규 선수가 있을 때 알림 받기',
    favorite: '즐겨찾기',
    newEventCalendar: '새 이벤트',
    updatedEventCalendar: '업데이트된 이벤트',
    newShareFrom: '새 공유',
    injuryAlert: '부상 알림',
    contractAlert: '계약 알림',
    teamAlert: '영입 알림',
    marketValueAlert: '시장 가치 알림',
    gameAlert: '경기 출전 알림'
  },
  videoEvents: {
    highlights: '하이라이트',
    fullGame: '전체 경기',
    autoplay: '자동 재생',
    searchBarPlaceholder: '선수, 경기 또는 팀 검색...',
    subtitle: '비디오를 통해 이벤트 분석',
    successful: '성공',
    unsuccessful: '실패',
    playing: '재생 중',
    games: '경기',
    moreFilters: '더 많은 필터...',
    startArea: '시작 영역',
    endArea: '종료 영역',
    select: '선택',
    selectLastXGames: '최근 {0}경기 선택',
    advancedFilters: '고급 필터',
    freeKicks: '프리킥',
    cornerKicks: '코너킥',
    allShots: '모든 슛',
    generateZip: '비디오 다운로드',
    zippedModalMessage: '비디오 목록을 생성 중이며 곧 이메일로 전송됩니다',
    clickToSeeVideo: '비디오 보기'
  },
  videoUpload: {
    subtitle: '비디오 업로드 및 새 경기 생성',
    uploadVideo: '비디오 업로드',
    selectPeriod: '기간 선택',
    gameData: '경기 데이터',
    venue: '경기장',
    matchType: '경기 유형',
    matchGroup: '경기 그룹',
    roundType: '라운드 유형',
    roundNumber: '라운드 번호',
    offsetFh: '전반 오프셋',
    offsetSh: '후반 오프셋',
    offsetFhOT: '연장전 전반 오프셋',
    offsetShOT: '연장전 후반 오프셋',
    homeLineup: '홈 라인업',
    awayLineup: '원정 라인업',
    existingPlayer: '기존 선수',
    newPlayer: '신규 선수',
    startingTeam: '선발',
    saveAndUpload: '저장 및 업로드',
    existingGame: '경기가 이미 존재합니다',
    sendToKora: '전송',
    invalidForm: '유효하지 않은 양식',
    warningModalTitle: '이상이 감지되었습니다',
    noScoreSheetWarning: '점수표가 첨부되지 않음',
    onlyOnePartUploadedWarning: '한 하프만 첨부됨',
    continueQuestion: '계속하시겠습니까?',
    slaLimit: '{1}로 {0}경기를 업로드했습니다. 한도는 {2}입니다',
    requestedGames: '요청한 경기',
    limitClose: '요청 가능한 경기가 {0}경기만 남았습니다',
    limitReached: '비디오 업로드 한도에 도달했습니다. 추가 경기를 업로드하면 추가 요금이 발생할 수 있습니다.',
    seasonFinishedWarning: '이미 종료된 시즌에 경기를 생성합니다. 올바른지 확인해주세요.',
    teamCountryWarning: '이 팀은 선택한 리그와 다른 국가의 팀입니다. 올바른지 확인해주세요.',
    uploading: '업로드 중',
    doNotNavigateAway: '업로드가 진행되는 동안 이 탭을 닫거나 페이지를 새로 고치거나 다른 곳으로 이동하지 마세요.',
    severalMinutes: '이 프로세스는 몇 분 정도 걸릴 수 있습니다.'
  },
  videoPlaylists: {
    subtitle: '비디오 하이라이트 필터 컬렉션',
    savePlaylist: '플레이리스트 저장',
    seeAllPlaylists: '모든 플레이리스트 보기'
  },
  videoHighlights: {
    recap: '요약',
    homeCondensed: '홈 압축 경기',
    awayCondensed: '원정 압축 경기',
    selectedActions: '선택된 액션',
    noActions: '지정된 필터 조건에 맞는 액션이 없습니다',
    noGames: '아직 업로드된 경기가 없습니다',
    attackingActions: '공격 액션',
    defensiveActions: '수비 액션',
    groundDuels: '지상 경합',
    penaltiesProvoked: '유발한 페널티',
    goalkeeperActions: '골키퍼 액션',
    addSomeGames: '경기를 추가하여 시작하세요!',
    goToVideoUploadTool: '비디오 업로드 도구로 이동',
    ballInPlay: '볼 인 플레이',
    filterSeasons: '시즌 필터',
    streaming: '스트리밍',
    clips: '클립',
    qualifiers: {
      Pass: '패스',
      Save: '세이브',
      'Saved Shot': '세이브된 슛',
      Shot: '슛',
      Goal: '골',
      'Missed Shot': '빗나간 슛',
      'Shot on Post': '골대 맞춘 슛',
      Error: '실수',
      Clearance: '클리어런스',
      Aerial: '공중볼',
      Challenge: '지상 경합 패배',
      Dispossessed: '볼 소유권 상실',
      Foul: '파울',
      Card: '카드',
      'Offside Pass': '오프사이드 패스',
      Claim: '크로스 클레임',
      'Keeper Pickup': '골키퍼 픽업',
      'Ball Touch': '볼 터치',
      Dribble: '드리블',
      Interception: '인터셉트',
      Tackle: '태클',
      'Ball Recovery': '볼 회수',
      Takeon: '드리블'
    },
    qualifierIds: {
      1: '롱볼',
      2: '크로스',
      5: '프리킥 시도',
      6: '코너킥 시도',
      9: '페널티',
      15: '헤딩',
      20: '오른발',
      21: '기타 신체 부위',
      22: '일반 플레이',
      23: '빠른 역습',
      24: '세트피스',
      25: '코너킥에서',
      26: '프리킥',
      28: '자책골',
      29: '어시스트',
      31: '옐로우 카드',
      32: '두 번째 옐로우 카드',
      33: '레드 카드',
      72: '왼발',
      73: '왼쪽',
      82: '세이브된 슛 (골키퍼 없음)',
      94: '수비 블록',
      123: '골키퍼 스로',
      124: '골킥',
      160: '스로인 세트피스',
      170: '골로 이어짐',
      173: '안전하게 막음',
      174: '위험하게 막음',
      177: '잡음',
      178: '서서',
      179: '다이빙',
      182: '손',
      183: '발',
      185: '차단된 크로스',
      210: '어시스트',
      215: '개인 플레이',
      279: '킥오프',
      285: '수비',
      286: '공격'
    },
    areas: {
      goalArea: '골 영역',
      boxLeft: '박스 왼쪽',
      boxCenter: '박스 중앙',
      boxRight: '박스 오른쪽',
      outBoxDeepLeft: '박스 밖 깊은 왼쪽',
      outBoxDeepRight: '박스 밖 깊은 오른쪽',
      outBoxLeft: '박스 밖 왼쪽',
      outBoxCentreLeft: '박스 밖 중앙 왼쪽',
      outBoxCentre: '박스 밖 중앙',
      outBoxCentreRight: '박스 밖 중앙 오른쪽',
      outBoxRight: '박스 밖 오른쪽',
      midfieldLeft35: '미드필드 왼쪽',
      midfieldCentreLeft35: '미드필드 중앙 왼쪽',
      midfieldCentre35: '미드필드 중앙',
      midfieldCentreRight35: '미드필드 중앙 오른쪽',
      midfieldRight35: '미드필드 오른쪽',
      ownGoalArea: '자신의 골 영역',
      ownBoxLeft: '자신의 박스 왼쪽',
      ownBoxCenter: '자신의 박스 중앙',
      ownBoxRight: '자신의 박스 오른쪽',
      ownFieldOutOfBoxDeepLeft: '자신의 필드 박스 밖 깊은 왼쪽',
      ownFieldOutOfBoxDeepRight: '자신의 필드 박스 밖 깊은 오른쪽',
      ownFieldOutOfBoxLeft: '자신의 필드 박스 밖 왼쪽',
      ownFieldOutOfBoxCentreLeft: '자신의 필드 박스 밖 중앙 왼쪽',
      ownFieldOutOfBoxCentre: '자신의 필드 박스 밖 중앙',
      ownFieldOutOfBoxCentreRight: '자신의 필드 박스 밖 중앙 오른쪽',
      ownFieldOutOfBoxRight: '자신의 필드 박스 밖 오른쪽',
      '6 YARD BOX': 'Goal area',
      'BOX RIGHT': 'Box right',
      'BOX CENTER': 'Box center',
      'BOX LEFT': 'Box left',
      'OUT BOX DEEP RIGHT': 'Out box deep right',
      'OUT BOX DEEP LEFT': 'Out box deep left',
      'OUT BOX RIGHT': 'Out box right',
      'OUT BOX LEFT': 'Out box left',
      'FINAL THIRD RIGHT': 'Final third right',
      'FINAL THIRD LEFT': 'Final third left',
      'FULL BOX': 'Full box',
      'OUT BOX DEEP RIGHT LARGE': 'Out box deep right large',
      'OUT BOX DEEP LEFT LARGE': 'Out box deep left large',
      'FINAL THIRD RIGHT LARGE': 'Final third right large',
      'FINAL THIRD LEFT LARGE': 'Final third left large',
      'OUT BOX CENTER RIGHT': 'Out box center right',
      'OUT BOX CENTER': 'Out box center',
      'OUT BOX CENTER LEFT': 'Out box center left',
      'FINAL THIRD CENTER RIGHT': 'Final third center right',
      'FINAL THIRD CENTER': 'Final third center',
      'FINAL THIRD CENTER LEFT': 'Final third center left',
      'OUT BOX CENTER RIGHT SMALL': 'Out box center right small',
      'OUT BOX CENTER SMALL': 'Out box center small',
      'OUT BOX CENTER LEFT SMALL': 'Out box center left small',
      'FINAL THIRD CENTER RIGHT LARGE': 'Final third center right large',
      'FINAL THIRD CENTER LARGE': 'Final third center large',
      'FINAL THIRD CENTER LEFT LARGE': 'Final third center left large',
      'OWN 6 YARD BOX': 'Own Goal area',
      'OWN BOX RIGHT': 'Own Box right',
      'OWN BOX CENTER': 'Own Box center',
      'OWN BOX LEFT': 'Own Box left',
      'OWN OUT BOX DEEP RIGHT': 'Own Out box deep right',
      'OWN OUT BOX DEEP LEFT': 'Own Out box deep left',
      'OWN OUT BOX RIGHT': 'Own Out box right',
      'OWN OUT BOX LEFT': 'Own Out box left',
      'OWN FINAL THIRD RIGHT': 'Own Final third right',
      'OWN FINAL THIRD LEFT': 'Own Final third left',
      'OWN FULL BOX': 'Own Full box',
      'OWN OUT BOX DEEP RIGHT LARGE': 'Own Out box deep right large',
      'OWN OUT BOX DEEP LEFT LARGE': 'Own Out box deep left large',
      'OWN FINAL THIRD RIGHT LARGE': 'Own Final third right large',
      'OWN FINAL THIRD LEFT LARGE': 'Own Final third left large',
      'OWN OUT BOX CENTER RIGHT': 'Own Out box center right',
      'OWN OUT BOX CENTER': 'Own Out box center',
      'OWN OUT BOX CENTER LEFT': 'Own Out box center left',
      'OWN FINAL THIRD CENTER RIGHT': 'Own Final third center right',
      'OWN FINAL THIRD CENTER': 'Own Final third center',
      'OWN FINAL THIRD CENTER LEFT': 'Own Final third center left',
      'OWN OUT BOX CENTER RIGHT SMALL': 'Own Out box center right small',
      'OWN OUT BOX CENTER SMALL': 'Own Out box center small',
      'OWN OUT BOX CENTER LEFT SMALL': 'Own Out box center left small',
      'OWN FINAL THIRD CENTER RIGHT LARGE': 'Own Final third center right large',
      'OWN FINAL THIRD CENTER LARGE': 'Own Final third center large',
      'OWN FINAL THIRD CENTER LEFT LARGE': 'Own Final third center left large'
    },
    outcomes: {
      success: '성공',
      fail: '실패',
      possessionWon: '볼 소유권 획득',
      possessionNotWon: '볼 소유권 미획득',
      received: '수신',
      provoked: '유발'
    },
    homePlayerHighlights: '홈선수 하이라이트',
    awayPlayerHighlights: '원정 선수 하이라이트'
  },
  share: {
    shareTo: '전송 대상',
    viaApp: '앱 (Driblab 메시지)',
    viaEmail: '이메일',
    description: '설명',
    titleTab: '공유',
    toMe: '받은 것',
    fromMe: '보낸 것',
    typeInternal: '내부',
    typeExternal: '외부',
    title: '공유됨',
    subtitle: '공유 목록의 항목 및 공유 개요',
    selectUser: '사용자 선택',
    expired: '만료됨',
    limitReached: '링크 사용 한도에 도달함'
  },
  homeStats: {
    data: '사용 가능한 데이터',
    players: '선수',
    totalPlayers: '전체 선수',
    teams: '팀',
    totalTeams: '전체 팀',
    leagues: '리그',
    totalLeagues: '전체 리그',
    seasons: '시즌',
    totalSeasons: '전체 시즌',
    games: '경기',
    totalGames: '전체 경기'
  },
  scoutingCalendar: {
    subtitle: '스카우팅 작업 생성 및 정리',
    myCalendars: '개인 캘린더',
    publicCalendars: '공개 캘린더',
    otherCalendars: '기타 캘린더',
    calendarSettings: '캘린더 설정',
    moreInfo: '더 많은 정보',
    individualScouting: '개별 스카우팅',
    matchScouting: '경기 스카우팅',
    calendarView: {
      type: '캘린더 유형',
      month: '월',
      week: '주',
      day: '일'
    },
    weekView: {
      type: '주 유형',
      monSun: '월요일 - 일요일',
      sunSat: '일요일 - 토요일',
      monFri: '월요일 - 금요일'
    },
    tasks: {
      addNew: '새 작업 추가',
      myTasks: '내 작업',
      filterTasks: '작업 필터',
      sharedWithMe: '나와 공유됨',
      createTask: '작업 생성',
      newTask: '새 작업',
      taskName: '작업 이름',
      allDay: '하루 종일',
      startDate: '시작 날짜',
      endDate: '종료 날짜',
      startHour: '시작 시간',
      endHour: '종료 시간',
      assignedTo: '담당자',
      assignedToMe: '나에게 할당됨',
      color: '색상',
      scoutingType: '스카우팅 유형',
      taskLocation: '작업 위치',
      selectLeague: '리그 선택',
      selectMatch: '경기 선택',
      useMatchdate: '경기 날짜를 날짜로 사용',
      stadium: '경기장',
      travel: '여행',
      hotel: '호텔',
      tickets: '티켓',
      taskNotes: '작업과 관련된 설명 메모 또는 코멘트를 입력하세요',
      states: {
        toDo: '할 일',
        inProgress: '진행 중',
        done: '완료'
      },
      type: {
        player: '선수 평가',
        team: '팀 평가',
        other: '기타'
      },
      location: {
        stadium: '경기장에서',
        video: '비디오'
      },
      accommodation: {
        accommodationDetails: '숙박 세부 정보',
        ownArrangement: '자체 준비',
        required: '필요',
        notRequired: '불필요',
        booked: '예약됨'
      },
      assignToMe: '나에게 할당',
      addOther: '기타 추가',
      deleteTask: '작업 삭제',
      deleteTaskMessage: '작업이 제거됩니다. 계속하시겠습니까?',
      cancelUpdate: '업데이트 취소',
      cancelUpdateMessage: '변경사항이 저장되지 않습니다. 계속하시겠습니까?',
      selectGame: '파일을 추가할 경기를 선택하세요',
      noData: '데이터가 없습니다. 작업을 추가하여 시작하세요!',
      widgetSubtitle: '다음 작업 확인',
      scoutingDetails: '스카우팅 세부 정보',
      taskDetails: '작업 세부 정보',
      playerDocuments: '선수 문서',
      teamDocuments: '팀 문서',
      gameDocuments: '경기 문서',
      taskDocuments: '작업 문서',
      task: '작업'
    },
    nextGames: '다음 경기'
  },
  scoutingTasksBoard: {
    period: {
      week: '이번 주',
      month: '이번 달',
      year: '올해'
    },
    noTasks: '새 작업을 생성하거나 여기로 드래그하세요!',
    goToBoard: '보드로 이동'
  },
  profile: {
    title: '프로필',
    subtitle: '계정 및 구독 세부 정보 사용자 지정'
  },
  hub: {
    onlyHub: 'Driblab Hub에서만 사용 가능',
    blue: '파란색',
    purple: '보라',
    orange: '주황색',
    grey: '회색',
    indigo: '남빛',
    teal: '물오리',
    lightBlue: '하늘색',
    brown: '갈색'
  },
  uploadedGames: {
    subtitle: '모든 업로드된 경기',
    timeRequested: '요청 시간',
    timeReceived: '수신 시간',
    diffHours: '시간 차이',
    collectionCompleted: '수집 완료',
    dateFrom: '시작 날짜',
    dateTo: '종료 날짜',
    goToUploadedGames: '업로드된 경기로 이동',
    sla: '서버 수준 협약',
    matchDate: '경기 날짜',
    rejectedGame: '거부됨',
    reviewed: '검토됨',
    requested: '요청됨',
    koraStatus: '코라현황',
    aws: 'AWS',
    fullVideo: '전체 비디오',
    offset: '오프셋',
    updateFullVideo: '전체 동영상을 업데이트하시겠습니까?'
  },
  gameMap: {
    title: '경기 지도',
    subtitle: '향후 며칠간의 경기 탐색',
    warning: '시간과 장소가 정확하지 않을 수 있습니다. 이 정보를 확인해주세요.',
    taskAdded: '작업이 성공적으로 생성되었습니다. 스카우팅 캘린더를 확인하세요.'
  },
  leagueRequestAccess: {
    sendSuccess: '성공적으로 알림 전송됨',
    notPermissions: '볼 권한이 없습니다',
    notPermissionsLeague: '이 리그를 볼 권한이 없습니다',
    notPermissionsGame: '이 경기를 볼 권한이 없습니다',
    requestAccessTo: '접근 권한 요청',
    sendRequest: '요청 전송'
  },
  videoTeams: {
    subtitle: '팀별로 태그된 최신 경기 찾기',
    noGamesUploaded: '아직 업로드된 경기가 없습니다'
  },
  scoutingAnalysis: {
    scoutingAnalysis: '스카우팅 분석',
    scoutingAnalyses: '스카우팅 분석',
    playerScoutingAnalyses: '선수 스카우팅 분석',
    gameScoutingAnalyses: '경기 스카우팅 분석',
    analyses: '분석',
    addReport: '분석 추가',
    technical: '기술',
    tactical: '전술',
    physical: '신체',
    mental: '정신',
    technicalNotes: '기술 노트',
    tacticalNotes: '전술 노트',
    physicalNotes: '신체 노트',
    mentalNotes: '정신 노트',
    conclusion: '결론',
    charactersMax: '최대 1000자',
    globalRating: '전체 평점',
    noData: '데이터가 없습니다. 스카우팅 분석을 추가하여 시작하세요!',
    deleteAnalysis: '스카우팅 분석 삭제',
    deleteAnalysisMessage: '분석이 영구적으로 제거됩니다. 계속하시겠습니까?',
    avgTooltip: '볼 수 있는 분석의 최종 평점 기반 평균',
    avgOverallScoreTooltip: '볼 수 있는 선수의 전체 점수 기반 평균',
    scouter: '스카우트',
    lastEdited: '마지막 수정',
    analysisFilters: '분석 필터',
    generalFilters: '일반 필터',
    widgetSubtitle: '최근 추가된 분석',
    addPlayerReport: '선수 스카우팅 분석 추가',
    seeReports: '리포트 보기',
    addGameReport: '경기 스카우팅 분석 추가',
    keyPlayers: '주요 선수',
    formation: '포메이션',
    inPossession: '볼 소유 시',
    notesIP: '볼 소유 시 노트',
    outOfPossession: '볼 미소유 시',
    notesOP: '볼 미소유 시 노트',
    transitions: '전환',
    notesTransitions: '전환 노트',
    notesSP: '세트피스 노트',
    finalRating: '최종 평점',
    gameNotesPlaceholder: '경기와 관련된 설명 메모 또는 코멘트를 입력하세요',
    avgPotentialTooltip: '귀하에게 표시되는 분석의 잠재력을 기반으로 한 평균',
    potential: '잠재적인',
    tags: '태그',
    tagsPlaceholder: '태그 추가',
    tagsHint: '태그를 추가하려면 입력하고 Enter를 누르세요.',
    exampleTags: {
      leadership: '지도',
      resilience: '회복력',
      competitiveMindset: '경쟁적 사고방식',
      calmUnderPressure: '압박감 속에서도 침착함',
      focus: '집중하다',
      discipline: '규율',
      coachability: '코칭 능력',
      poorBodyLanguage: '불쌍한 신체 언어',
      lowConfidence: '낮은 신뢰도',
      easilyFrustrated: '쉽게 좌절함'
    },
    totals: 'Totals',
    byPossession: 'By Possession'
  },
  addPlayerForm: {
    noLeague: '리그 없이 팀을 생성하면 인덱싱 및 애플리케이션 내 후속 검색에 부정적인 영향을 줄 수 있습니다.'
  },
  expenses: {
    expense: '비용',
    expenses: '비용',
    addExpense: '비용 추가',
    transportation: '교통',
    accommodation: '숙박',
    dietary: '식사',
    eventTicket: '이벤트 티켓',
    expenseType: '비용 유형',
    amount: '금액',
    expenseDate: '비용 날짜',
    expenseFilters: '비용 필터',
    noData: '데이터가 없습니다. 비용을 추가하여 시작하세요!',
    deleteExpense: '비용 삭제',
    deleteExpenseMessage: '비용이 영구적으로 제거됩니다. 계속하시겠습니까?'
  },
  disabledTooltips: {
    general: '이 기능은 현재 비활성화되어 있습니다',
    youth: '연령을 설정하려면 유소년이어야 합니다',
    unit: '통계는 Runs, HSR 또는 SPR이어야 합니다',
    seasonsWithout60MinsGames: '선수가 선택된 시즌에서 단일 경기에서 60분 이상 플레이하지 않았습니다',
    notEditable: '이것은 편집할 수 없습니다',
    noMatchdate: '경기 날짜를 사용할 수 없음',
    selectGame: '먼저 경기를 선택하세요',
    selectPlayer: '먼저 선수를 선택하세요',
    selectTeam: '먼저 팀을 선택하세요',
    selectBoxes: '박스 시각화를 선택해야 합니다',
    selectYear: '먼저 연도를 선택하세요',
    pdScoreNotAvailable: '경기에서 60분 이상 출전하지 않은 선수는 점수가 제공되지 않습니다',
    pdSeasonNotAvailable: '이 시즌에 대한 신체 데이터를 사용할 수 없습니다',
    pdGameNotAvailable: '이 경기에 대한 신체 데이터를 사용할 수 없습니다'
  },
  leagueTypes: {
    regular: '정규',
    continental: '대륙',
    nationalTeam: '국가대표팀',
    countryCup: '국가 컵',
    qualifier: '예선',
    playOff: '플레이오프',
    regionalLeague: '지역 리그',
    friendly: '친선',
    nationalFriendly: '국가대표 친선',
    nationaQualifier: '국가대표 예선'
  },
  playerSides: {
    'Left/Right': '왼쪽/오른쪽',
    'Left/Centre/Right': '왼쪽/중앙/오른쪽',
    Right: '오른쪽',
    Centre: '중앙',
    'Centre/Right': '중앙/오른쪽',
    Left: '왼쪽',
    'Left/Centre': '왼쪽/중앙'
  },
  areaSelector: {
    selectAreas: '영역 선택',
    filterAreas: '영역 필터'
  },
  spatialCoverage: {
    lastDefenderDist: '마지막 수비수 거리',
    defensiveLineDist: '수비 라인 거리',
    fullBackAvgDist: '풀백 평균 거리',
    offensiveLineDist: '공격 라인 거리',
    distanceToGoal: '골까지 거리',
    avgLineWidth: '평균 라인 너비',
    leagueAvgDistanceToGoal: '리그 평균 골 거리',
    leagueAvgLineWidth: '리그 평균 라인 너비',
    avgShort: '평균',
    meters: '미터',
    leagueAvgDist: '리그 평균 거리',
    distance: '거리',
    avgPositionYAxis: '경기장 평균 거리 (Y)',
    leagueAvgPositionYAxis: '리그 평균 경기장 거리 (Y)',
    lbRbDistanceSeparation: 'LB–RB 거리 차이',
    leagueAvgLbRbDistanceSeparation: '리그 평균 LB–RB 거리 차이',
    legendTeam: '팀',
    legendLeagueAvg: '리그 평균',
    maxLength: '최대 길이',
    maxWidth: '최대 너비',
    avgBlockDistance: '평균 블록 거리'
  },
  arrigo: {
    beta: 'BETA',
    subtitle: '지능형 데이터',
    passesUnderPressureSubtitle: '수비 압박 상황에서 패스 성공률 분석',
    onBallPressureSubtitle: '방어 압력 이벤트 및 성공률 필드 영역별 분석',
    ballReceiptsInSpaceSubtitle: '필드 존별로 공간에서 수신된 패스를 분석합니다.',
    ballReceipts: '영수증',
    totalBallReceipts: '총 볼 수신',
    totalBallReceiptsCompleted: '총 볼 수신 완료',
    completed: '완료',
    lineBreakingPassesSubtitle: '라인을 허물고 이점을 만드는 패스를 분석하세요',
    bypassed: '아웃플레이',
    oppsBypassed: '상대가 압도당함',
    passer: '패서',
    passedTo: '통과하다',
    receivedFrom: '받다',
    distanceToNearestDefender: '가장 가까운 수비수까지의 거리',
    lineBreaking: '줄 바꿈 {0}',
    keyPass: '키패스',
    receiver: '수화기',
    dynamicTracking: '동적 추적',
    eventLockTooltip: '플레이 도중 일부 플레이어가 보이지 않았습니다.',
    bypassedPlayers: '{0}명의 선수를 제침',
    playersCount: '{0}명의 선수',
    bothTeams: '양팀',
    matchesCount: '{0}경기',
    lbpType: {
      F: '공격 라인',
      M: '미드필드 라인',
      B: '수비 라인',
      MF: '미드필드 & 공격 라인',
      BM: '수비 & 미드필드 라인',
      BF: '수비 & 공격 라인',
      BMF: '수비, 미드필드 & 공격 라인'
    },
    lbpCategory: {
      'G-IN-T': '땅볼 안쪽 (수비 라인 돌파)',
      'G-IN-NT': '땅볼 안쪽 (수비 라인 미돌파)',
      'G-OUT-T': '땅볼 바깥쪽 (수비 라인 돌파)',
      'G-OUT-NT': '땅볼 바깥쪽 (수비 라인 미돌파)',
      'O-IN-T': '띄운 패스 안쪽 (수비 라인 돌파)',
      'O-IN-NT': '띄운 패스 안쪽 (수비 라인 미돌파)',
      'O-OUT-T': '띄운 패스 바깥쪽 (수비 라인 돌파)',
      'O-OUT-NT': '띄운 패스 바깥쪽 (수비 라인 미돌파)',
      ground: '땅볼',
      over: '위로',
      inside: '안쪽',
      outside: '바깥쪽',
      through: '수비 라인을 돌파',
      notThrough: '수비 라인을 돌파하지 않음',
      throughAbbr: '속보 def. 선',
      notThroughAbbr: 'def를 깨지 않습니다. 선'
    },
    lbpCategorySplit: {
      G: '접지: 패스가 접지되었습니다.',
      O: '오버: 공이 공중으로 날아갔습니다.',
      OUT: '외부 : 출입증이 외부로 나갔습니다.',
      IN: '내부: 패스가 내부로 들어갔습니다.',
      T: '수비 라인 돌파: 패스가 안쪽에서 수비 라인을 직접 돌파합니다',
      NT: '수비 라인 미돌파: 패스가 안쪽에서 돌파하지 않고 바깥에서 우회합니다'
    },
    obrType: {
      OL: '중복',
      UL: '언더랩',
      RA: '앞서 달려라',
      RB: '뒤쳐져라',
      CR: '크로스 리시버',
      SP: '지원하다',
      CS: '부족함'
    },
    visualization: '시각화',
    points: '원',
    zones: '히트맵',
    pressureIntensity: '압력 강도',
    pressureOutcome: '압력 결과',
    passesOutcome: '합격 결과',
    strong: '강한',
    light: '가벼운',
    normal: '보통',
    successful: '성공한',
    unsuccessful: '실패한',
    presses: '압력',
    passes: '패스',
    passUnder: '아래로 통과',
    successRate: '성공률',
    pressureOn: '압력 위치',
    pressureOf: '의 압박',
    pressure: '압력',
    totalLabel: '총',
    totalPasses: '총 패스',
    unknown: '알 수 없음',
    selectGameToViewMap: '압력 맵을 보려면 경기를 선택하세요',
    noEventsFoundForGame: '이 경기의 압력 이벤트를 찾을 수 없습니다',
    noEventsFoundForTeamAndSeason: '이 팀과 시즌의 압력 이벤트를 찾을 수 없습니다',
    noEventsFoundForPlayerAndSeason: '이 선수와 시즌의 압력 이벤트를 찾을 수 없습니다',
    noEventsMatchFilters: '현재 필터와 일치하는 이벤트를 찾을 수 없습니다',
    totalEventsAvailable: '총 이벤트 수',
    passType: {
      P: '통과하다',
      A: '돕다',
      KP: '키패스',
      PiOB: 'Opp에 전달하십시오. 상자',
      PiFT: '파이널 써드에 진출',
      SoPP: 'Play Pass 전환'
    },
    minFrom: '최소부터',
    minTo: '최소',
    secondFrom: '세그먼트 시작',
    secondTo: '세그먼트 대상',
    positionPlayed: '플레이한 포지션',
    highlight: '가장 밝은 부분',
    passTypeLabel: '패스 종류',
    offBallRunSubtitle: '오프 볼 런 분석',
    insights: '통찰력',
    insightsSubtitle: '고급 Arrigo Analytics로 최고 순위 매기기',
    pressurePassTypeLabel: 'Pressure On Pass Type'
  },
  driblabAI: {
    chatText: '오늘은 무엇을 도와드릴까요?',
    chatSubtext: '축구데이터에 대해 무엇이든 물어보세요!',
    thinking: '생각...',
    giveFeedback: '피드백 보내기',
    disclaimer: 'DriblabAI는 실수를 할 수 있습니다. 반드시 정보를 확인해 주시기 바랍니다.',
    recent: '최근의',
    noConversations: '여기에서 최근 대화를 볼 수 있습니다!',
    rename: '이름 바꾸기',
    deleteConversation: '대화 삭제',
    confirmDelete: '이 대화를 삭제하시겠습니까?',
    feedback: '피드백',
    feedbackQuestion: '이 답변이 도움이 되었나요?',
    feedbackComments: '추가 의견',
    feedbackPlaceholder: '도움이 된 점이나 개선할 점을 알려주세요.',
    errorMessage: '메시지를 처리할 수 없습니다. 다시 시도해 주세요.',
    newConversation: '새 채팅',
    write: '메시지를 작성하세요...'
  },
  periodId: {
    1: '전반전',
    2: '후반',
    3: '추가 시간 - 1°',
    4: '추가 시간 - 2°',
    5: '승부차기',
    6: '풀타임',
    7: '경기 전',
    8: '버려진',
    9: '살다',
    10: '0-15',
    11: '16-30',
    12: '31세 이상',
    13: '45-60',
    14: '61-75',
    15: '76세 이상',
    '-1': '다른'
  }
};
